(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var TwilioPasteNeutral = require("../style-guide-debt/app/img/icons/twilio-paste/Neutral.svg");
var TwilioPasteClose = require("../style-guide-debt/app/img/icons/twilio-paste/Close.svg");
var TwilioPasteAlert = require("../style-guide-debt/app/img/icons/twilio-paste/Alert.svg");

module.exports = (function () {
  function Banner(selector, makoHost, mcAutoHost) {
    _classCallCheck(this, Banner);

    this.selector = selector;
    this.makoHost = makoHost;
    this.mcAutoHost = mcAutoHost;

    this.billingLink = "" + this.makoHost + "/account/billing";
    this.billingUpgradeEmailApiLink = "" + this.makoHost + "/account/billing/choose_plan";
    this.billingUpgradeMarketingCampaignsLink = "" + this.makoHost + "/account/billing/choose_plan_marketing_campaigns";
    this.guideLink = "" + this.makoHost + "/guide";
    this.activityLink = "" + this.makoHost + "/email_activity";
    this.senderAuthLink = "" + this.makoHost + "/settings/sender_auth";
    this.supportPageLink = "https://support.sendgrid.com";
    this.consumerTrustSuspendedLink = "https://support.sendgrid.com/hc/en-us/requests/new#account-access-issue";
    this.supportTicketHistory = "https://support.sendgrid.com/hc/en-us/requests";
    this.billingSupportLink = "https://www.twilio.com/docs/sendgrid/ui/account-and-settings/billing#account-warning-states";
  }

  _createClass(Banner, {
    showEase: {
      value: function showEase(user_id) {
        if (window && window.SendGridTiara && window.SendGridTiara.analyticsTrackingWithUserInfo) {
          window.SendGridTiara.analyticsTrackingWithUserInfo("EASE_BANNER_SHOWN", {
            user_id: user_id });
        }

        var html = "<div id=\"alert-promo-ease\" class=\"alert alert-promo alert-promo-ease\"><p>\n      <strong>What happened to that email?</strong>\n      Putting out fires 🔥 is fast with our new email activity feed!\n      <a id=\"alert-promo-btn\" href=\"" + this.activityLink + "\" target=\"_self\" class=\"btn btn-small btn-secondary\">Check it Out</a>\n      <i id=\"alert-promo-close\" class=\"sg-icon sg-icon-x\"></i>\n    </p></div>";
        $(this.selector).prepend(html);
        $(this.selector).find("#alert-promo-btn").on("click", function () {
          $("#alert-promo-ease").fadeOut();
          setEaseBannerShownCookie();
          if (window && window.SendGridTiara && window.SendGridTiara.analyticsTrackingWithUserInfo) {
            window.SendGridTiara.analyticsTrackingWithUserInfo("EASE_BANNER_CLICKED", { user_id: user_id });
          }
        });
        $(this.selector).find("#alert-promo-close").on("click", function () {
          $("#alert-promo-ease").fadeOut();
          setEaseBannerShownCookie();
        });
      }
    },
    showAwsDeactivated: {
      value: function showAwsDeactivated() {
        var html = "<div class=\"alert alert-danger\"><p>\n      <i class=\"sg-icon sg-icon-warning\"></i>\n      <strong>Your account has been deactivated.</strong>\n      <a href=\"" + this.billingLink + "\" class=\"btn btn-small btn-primary\">Reactivate</a>\n    </p></div>";
        $(this.selector).prepend(html);
      }
    },
    showConsumerTrustSuspended: {
      value: function showConsumerTrustSuspended() {
        var consumerTrustSuspendedBanner = "consumerTrustSuspendedBanner";
        var closeConsumerTrustSuspendedBannerId = "closeConsumerTrustSuspendedBannerId";

        if (isBannerDismissed(consumerTrustSuspendedBanner)) {
          return;
        }

        var html = "\n      <div data-role=\"" + consumerTrustSuspendedBanner + "\" class=\"twilio-paste-alert warning hidden\">\n        <div class=\"icon\">\n          " + TwilioPasteAlert + "\n        </div>\n        <p>\n          <strong>Review.</strong> Your account is under review and we'd like to know a little more about you and how you intend to use Twilio SendGrid. <a href=\"" + this.consumerTrustSuspendedLink + "\" target=\"_blank\">Contact Us</a>\n        </p>\n        <button id=\"" + closeConsumerTrustSuspendedBannerId + "\">\n          " + TwilioPasteClose + "\n        </button>\n      </div>\n    ";
        $(this.selector).prepend(html);

        $(this.selector).find("#" + closeConsumerTrustSuspendedBannerId).on("click", function () {
          $("[data-role=" + consumerTrustSuspendedBanner + "]").fadeOut();
          dismissBanner(consumerTrustSuspendedBanner);
        });
      }
    },
    showComplianceSuspended: {
      value: function showComplianceSuspended() {
        var analyticsEventName = "compliance suspended contact support clicked";
        var analyticsProperties = JSON.stringify({
          elementType: "button",
          location: "Top Banner",
          section: "Right",
          subSection: "Compliance Suspended" });

        var complianceSuspendedBanner = "complianceSuspendedBanner";
        var closeComplianceSuspendedBannerId = "closeComplianceSuspendedBannerId";

        if (isBannerDismissed(complianceSuspendedBanner)) {
          return;
        }

        var html = "\n      <div data-role=\"" + complianceSuspendedBanner + "\" class=\"twilio-paste-alert warning hidden\">\n        <div class=\"icon\">\n          " + TwilioPasteAlert + "\n        </div>\n        <p>\n          <strong>Review.</strong> Your account is under review. Please check your <a href=\"" + this.supportTicketHistory + "\" target=\"_blank\">ticket history</a> for more information or contact us with questions. <a href=\"" + this.supportPageLink + "\" target=\"_blank\">Contact Us</a>\n        </p>\n        <button id=\"" + closeComplianceSuspendedBannerId + "\">\n          " + TwilioPasteClose + "\n        </button>\n      </div>\n    ";
        $(this.selector).prepend(html);
        var supportLink = $("" + this.selector).find("a");
        $(supportLink).attr("data-event-name", analyticsEventName);
        $(supportLink).attr("data-analytics-properties", analyticsProperties);

        $(this.selector).find("#" + closeComplianceSuspendedBannerId).on("click", function () {
          $("[data-role=" + complianceSuspendedBanner + "]").fadeOut();
          dismissBanner(complianceSuspendedBanner);
        });
      }
    },
    showComplianceBillingTerminated: {
      value: function showComplianceBillingTerminated() {
        var html = "<div class=\"alert alert-danger\"><p>\n      <i class=\"sg-icon sg-icon-warning\"></i>\n      <strong>Your account was terminated due to unpaid invoices.</strong>\n      Please contact Support to re-enable your account.\n      <a href=" + this.supportPageLink + " target=\"_blank\" class=\"btn btn-small btn-primary\">Contact Support</a>\n    </p></div>";
        $(this.selector).prepend(html);
      }
    },
    showComplianceBillingWarned: {
      value: function showComplianceBillingWarned() {
        var html = "<div class=\"alert alert-danger\"><p>\n      <i class=\"sg-icon sg-icon-warning\"></i>\n      <strong>You have unpaid invoices.</strong>\n      Please update your payment details or retry payment. Allow up to 20 minutes for your account to reflect successful payment once the outstanding balance has been paid in full. \n      For more information, please visit our <a href=\"" + this.billingSupportLink + "\" target=\"_blank\">billing support page</a>.\n      <a href=\"" + this.billingLink + "\" class=\"btn btn-small btn-primary\">Update</a>\n    </p></div>";
        $(this.selector).prepend(html);
      }
    },
    showComplianceBillingFrozen: {
      value: function showComplianceBillingFrozen() {
        var html = "<div class=\"alert alert-danger\"><p>\n      <i class=\"sg-icon sg-icon-warning\"></i>\n      <strong>Your account was frozen due to unpaid invoices.</strong>\n      Please update your payment details or retry payment. Allow up to 20 minutes for your account to reflect successful payment once the outstanding balance has been paid in full. \n      For more information, please visit our <a href=\"" + this.billingSupportLink + "\" target=\"_blank\">billing support page</a>.\n      <a href=\"" + this.billingLink + "\" class=\"btn btn-small btn-primary\">Update</a>\n    </p></div>";
        $(this.selector).prepend(html);
      }
    },
    showOverlimitUpgrade: {
      value: function showOverlimitUpgrade(params) {
        var credits = params.credits;
        var creditsTotal = credits.total.toLocaleString();
        var frequency = credits.reset_frequency.toLocaleString();
        var text = {
          "default": "<strong>You have used all " + creditsTotal + " " + frequency + " emails for your Email API free trial.</strong>\n                Upgrade to send more." };
        var html = "<div class=\"alert alert-danger\"><p>\n      <i class=\"sg-icon sg-icon-warning\"></i>\n      " + text["default"] + "\n      <a href=\"" + this.billingUpgradeEmailApiLink + "\" class=\"btn btn-small btn-primary\">Upgrade</a>\n    </p></div>";
        $(this.selector).prepend(html);
      }
    },
    showOverlimitVerify: {
      value: function showOverlimitVerify(params) {
        var credits = params.credits;
        var creditsTotal = credits.total.toLocaleString();
        var frequency = credits.reset_frequency.toLocaleString();
        var text = {
          "default": "<strong>You have used all " + creditsTotal + " " + frequency + " emails.</strong>\n                Verify your account to send more." };

        var html = "<div class=\"alert alert-danger\"><p>\n      <i class=\"sg-icon sg-icon-warning\"></i>\n      " + text["default"] + "\n      <a href=\"" + this.guideLink + "\" class=\"btn btn-small btn-primary\">Verify Account</a>\n    </p></div>";
        $(this.selector).prepend(html);
      }
    },
    showCreateSenderIdentity: {
      value: function showCreateSenderIdentity() {
        var antiSpoofBanner = "antiSpoofBanner";
        var closeAntiSpoofBannerId = "closeAntiSpoofBannerId";

        if (isBannerDismissed(antiSpoofBanner)) {
          return;
        }

        var html = "\n      <div class=\"twilio-paste-alert neutral\" data-role=\"" + antiSpoofBanner + "\">\n        <div class=\"icon\">\n          " + TwilioPasteNeutral + "\n        </div>\n        <p>\n          Before sending your first email, you'll need to create a sender identity. <a href=\"" + this.guideLink + "\">Create a sender identity</a>\n        </p>\n        <button id=\"" + closeAntiSpoofBannerId + "\">\n          " + TwilioPasteClose + "\n        </button>\n      </div>\n    ";

        $(this.selector).prepend(html);

        $(this.selector).find("#" + closeAntiSpoofBannerId).on("click", function () {
          $("[data-role=" + antiSpoofBanner + "]").fadeOut();
          dismissBanner(antiSpoofBanner);
        });
      }
    },
    showSendFirstEmail: {
      value: function showSendFirstEmail() {
        var sendFirstEmailBanner = "sendFirstEmailBanner";
        var closeSendFirstEmailBannerId = "closeSendFirstEmailBannerId";

        if (isBannerDismissed(sendFirstEmailBanner)) {
          return;
        }

        var html = "\n      <div class=\"twilio-paste-alert neutral\" data-role=\"" + sendFirstEmailBanner + "\">\n        <div class=\"icon\">\n          " + TwilioPasteNeutral + "\n        </div>\n        <p>\n          Ready to send your first email? Follow our guides for Email API or Marketing Campaigns. <a href=\"" + this.guideLink + "\">Return to Setup Guide</a>\n        </p>\n        <button id=\"" + closeSendFirstEmailBannerId + "\">\n          " + TwilioPasteClose + "\n        </button>\n      </div>\n    ";

        var isMako = this.makoHost.includes(window.location.host);
        if (!isMako) {
          return;
        }

        $(this.selector).prepend(html);

        $(this.selector).find("#" + closeSendFirstEmailBannerId).on("click", function () {
          $("[data-role=" + sendFirstEmailBanner + "]").fadeOut();
          dismissBanner(sendFirstEmailBanner);
        });
      }
    },
    showPaymentDeclined: {
      value: function showPaymentDeclined() {
        var html = "<div class=\"alert alert-danger\" data-role=\"paymentDeclinedBanner\"><p>\n      <i class=\"sg-icon sg-icon-warning\"></i>\n      <strong>We’re sorry, there was a problem processing your payment.</strong>\n      <a href=\"" + this.billingLink + "\">Please review your billing information</a>.<br>\n    </p></div>";
        // Not ideal to have this kind of logic here, if we end up needing to opt out
        // of persistent banners in specific apps often, need a better long term solution.
        var isMako = this.makoHost.includes(window.location.host);
        if (!isMako) {
          return;
        }
        $(this.selector).prepend(html);
      }
    },
    showSiteMaintenanceBanner: {
      value: function showSiteMaintenanceBanner() {
        var incidentPageLink = "https://status.sendgrid.com/incidents/hzn1f7yrtzfm";
        var html = "\n      <div class=\"alert alert-warning\" data-role=\"siteMaintenanceBanner\">\n        <p>\n          <i class=\"sg-icon sg-icon-warning\"></i>\n          <strong>Maintenance is coming.</strong>\n        </p>\n        <p>\n          We are performing scheduled maintenance on November 17th, from 6-8pm PT.\n          You may experience errors when attempting to perform signups and upgrades, \n          configuring 2FA and SSO, or make changes to teammates, subusers, and API \n          keys during this period. Scheduled MC Campaign Sends will also be delayed. \n          <a href=" + incidentPageLink + " target=\"_blank\" rel=\"noopener noreferrer\">Click here</a> \n          for updates or reach out to our \n          <a href=" + this.supportPageLink + " target=\"_blank\" rel=\"noopener noreferrer\">Support team</a> \n          if you have questions.\n        </p>\n      </div>";
        $(this.selector).prepend(html);
      }
    },
    showOnboardingChoosePlan: {
      value: function showOnboardingChoosePlan() {
        var onboardingChoosePlanBanner = "onboardingChoosePlanBanner";
        var closeChoosePlanBannerId = "closeChoosePlanBannerId";

        if (isBannerDismissed(onboardingChoosePlanBanner)) {
          return;
        }

        var html = "\n      <div class=\"twilio-paste-alert neutral\" data-role=\"" + onboardingChoosePlanBanner + "\">\n        <div class=\"icon\">\n          " + TwilioPasteNeutral + "\n        </div>\n        <p>\n          You are now eligible to choose a paid plan \n          (<a href=\"" + this.billingUpgradeEmailApiLink + "\">Email API</a> or <a href=\"" + this.billingUpgradeMarketingCampaignsLink + "\">Marketing Campaigns</a>) \n          and unlock the full potential of Twilio SendGrid. \n        </p>\n        <button id=\"" + closeChoosePlanBannerId + "\">\n          " + TwilioPasteClose + "\n        </button>\n      </div>\n    ";

        $(this.selector).prepend(html);

        $(this.selector).find("#" + closeChoosePlanBannerId).on("click", function () {
          $("[data-role=" + onboardingChoosePlanBanner + "]").fadeOut();
          dismissBanner(onboardingChoosePlanBanner);
        });
      }
    },
    showOnboardingFinishAccountSetup: {
      value: function showOnboardingFinishAccountSetup() {
        var finishAccountSetupBanner = "onboardingFinishAccountSetupBanner";
        var closeFinishAccountSetupBannerId = "closeFinishAccountSetupBannerId";

        var html = "\n      <div class=\"twilio-paste-alert neutral\" data-role=\"" + finishAccountSetupBanner + "\">\n        <div class=\"icon\">\n          " + TwilioPasteNeutral + "\n        </div>\n        <p>\n          Finish your account setup in order to select a paid plan and unlock the full potential of Twilio SendGrid. \n          <a href=\"" + this.guideLink + "\">Let's do it!</a>\n        </p>\n        <button id=\"" + closeFinishAccountSetupBannerId + "\">\n          " + TwilioPasteClose + "\n        </button>\n      </div>\n    ";

        $(this.selector).prepend(html);

        $(this.selector).find("#" + closeFinishAccountSetupBannerId).on("click", function () {
          $("[data-role=" + finishAccountSetupBanner + "]").fadeOut();
          dismissBanner(finishAccountSetupBanner);
        });
      }
    },
    showConsumerTrustTeamPending: {
      value: function showConsumerTrustTeamPending() {
        var consumerTrustTeamPendingBanner = "consumerTrustTeamPendingBanner";
        var closeConsumerTrustTeamPendingBannerId = "closeConsumerTrustTeamPendingBannerId";

        if (isBannerDismissed(consumerTrustTeamPendingBanner)) {
          return;
        }

        var html = "\n      <div data-role=\"" + consumerTrustTeamPendingBanner + "\">\n        <div class=\"twilio-paste-alert neutral\">\n          <div class=\"icon\">\n            " + TwilioPasteNeutral + "\n          </div>\n          <p>\n            Thank you for completing account setup, however your account requires additional review before you can upgrade to a paid plan. Our consumer trust team will reach out to you within the next three business days to confirm the identity of your account and gather more information about your intended usage.\n          </p>\n          <button id=\"" + closeConsumerTrustTeamPendingBannerId + "\">\n            " + TwilioPasteClose + "\n          </button>\n        </div>\n      </div>\n    ";

        $(this.selector).prepend(html);

        $(this.selector).find("#" + closeConsumerTrustTeamPendingBannerId).on("click", function () {
          $("[data-role=" + consumerTrustTeamPendingBanner + "]").fadeOut();
          dismissBanner(consumerTrustTeamPendingBanner);
        });
      }
    }
  });

  return Banner;
})();

function isStorageSupported() {
  return typeof Storage !== "undefined";
}

function dismissBanner(bannerName) {
  isStorageSupported() && window.sessionStorage.setItem("" + bannerName + ":dismissed", true);
}

function isBannerDismissed(bannerName) {
  return isStorageSupported() && window.sessionStorage.getItem("" + bannerName + ":dismissed") === "true";
}

function setEaseBannerShownCookie() {
  if (isStorageSupported()) {
    localStorage.setItem("easePromoShown", true);
  }
  document.cookie = "easePromoShown=true;path=/;domain=sendgrid.com";
}

},{"../style-guide-debt/app/img/icons/twilio-paste/Alert.svg":391,"../style-guide-debt/app/img/icons/twilio-paste/Close.svg":393,"../style-guide-debt/app/img/icons/twilio-paste/Neutral.svg":395}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _base64Fingerprint = undefined;

var getBrowserFingerprintHeader = function () {
  return _base64Fingerprint;
};

exports.getBrowserFingerprintHeader = getBrowserFingerprintHeader;
var createTalonInputElement = function () {
  var talonInputElement = document.createElement("input");
  talonInputElement.setAttribute("type", "hidden");
  talonInputElement.setAttribute("name", "talon");
  talonInputElement.setAttribute("value", "{\"version\": 6, \"status\": -1}");
  talonInputElement.setAttribute("id", "talon");
  if (!document.body) {
    throw new Error("failed to create talon input element");
  }
  document.body.append(talonInputElement);
  return talonInputElement;
};

var isFingerprintValid = function (fingerprint) {
  try {
    var fingerprintObj = JSON.parse(fingerprint);
    return fingerprintObj.status === 0;
  } catch (error) {
    return false;
  }
};

// https://ehawk.net/support/api.php#talon
// The eHawk script sets the value attribute of a hidden input element
// that represents the browser fingerprint. The browser needs a few ticks
// to write the talon value to the DOM, which is why this is async
var browserFingerprintReady = new Promise(function (resolve, reject) {
  try {
    (function () {
      var talonInput = document.getElementById("talon") || createTalonInputElement();
      // If the talon isn't generated for some reason, we need to bail out at some point
      var timeoutHandle = window.setTimeout(function () {
        return reject("timed out generating talon");
      }, 3000);
      // Watch for the value to be written to the input element.
      var observer = new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (mutation) {
          if (mutation.type === "attributes" && mutation.attributeName === "value") {
            if (!isFingerprintValid(talonInput.value)) {
              return;
            }
            clearTimeout(timeoutHandle);
            observer.disconnect();
            _base64Fingerprint = btoa(talonInput.value);
            return resolve(talonInput.value);
          }
        });
      });

      observer.observe(talonInput, {
        attributes: true,
        childList: false,
        subtree: false });

      // Generate the browser fingerprint (talon)
      window.eHawkTalon();
    })();
  } catch (error) {
    return reject("failed to generate browser fingerprint");
  }
});
exports.browserFingerprintReady = browserFingerprintReady;

},{}],3:[function(require,module,exports){
"use strict";

var Tiara = require("../tiara");

Tiara.run({
  api_key: "PxxE6QRKENlnTEG9w75maGwrGs8z3Ug1", // https://segment.com/sendgrid/mako-front-end
  labs_url: "https://labs.sendgrid.com",
  environment: "production" });

},{"../tiara":9}],4:[function(require,module,exports){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var _get = require("lodash/get");
var Templates = require("./templates");
var analytics = require("@sendgrid/bloodhound").analytics;

var billingSuspendedStatus = "suspended";
var billingTerminatedStatus = "billing terminated";
var billingWarnedStatus = "billing warned";
var billingFrozenStatus = "billing frozen";
var successResponse = "success";
var senderVerificationEligibleScope = "sender_verification_eligible";
var senderVerificationExemptScope = "sender_verification_exempt";

var Banner = {
  ONBOARDING_CREATE_SENDER_ID: "ONBOARDING_CREATE_SENDER_ID",
  ONBOARDING_SEND_FIRST_EMAIL: "ONBOARDING_SEND_FIRST_EMAIL",
  ONBOARDING_FINISH_ACCOUNT_SETUP: "ONBOARDING_FINISH_ACCOUNT_SETUP",
  ONBOARDING_CHOOSE_PLAN: "ONBOARDING_CHOOSE_PLAN",
  ONBOARDING_CONSUMER_TRUST_TEAM_PENDING: "ONBOARDING_CONSUMER_TRUST_TEAM_PENDING" };

module.exports = (function () {
  function DeferredHandlers(defs, helpers, banner, revealAllLinks, unifiedUserInfo, $) {
    _classCallCheck(this, DeferredHandlers);

    this.defs = defs;
    this.helpers = helpers;
    this.banner = banner;
    this.revealAllLinks = revealAllLinks;
    this.preventImpersonation = false;
    this.unifiedUserInfo = unifiedUserInfo;
    this.$ = $;
  }

  _createClass(DeferredHandlers, {
    disableDropdown: {
      value: function disableDropdown() {
        // disable dropdown by modifying styles
        this.$("[data-account-dropdown]").removeClass("dropdown");
        this.$("[data-account-dropdown]").css("cursor", "auto");
        this.$("[data-account-dropdown-icon]").hide();
      }
    },
    preventImpersonationIfNecessary: {
      value: function preventImpersonationIfNecessary() {
        var _this = this;

        this.$.when(this.defs.scopes).done(function (data) {
          if (!data.scopes.includes("teammates.create")) {
            _this.preventImpersonation = true;
          }
        });
      }
    },
    revealPagesViaFeatureTogglesAndScopes: {
      value: function revealPagesViaFeatureTogglesAndScopes() {
        var _this = this;

        // In case the scopes request fails, isolate the logic that needs both scope and feature toggles down here -
        // the above callback should still run if the scopes request fails.
        this.$.when(this.defs.feature_toggles, this.defs.scopes).done(function (featureToggles, scopes) {
          featureToggles = featureToggles[0];
          scopes = scopes[0].scopes;

          if (!_this.revealAllLinks) {
            // reveal links by feature toggles
            _this.helpers.revealLinksViaFeatureToggles(featureToggles);

            // reveal links by scopes
            _this.helpers.revealLinksViaScopes(scopes);
            // override Marketing [NEW] links that have been hidden for lack of the 'marketing.read' scope,
            // IMPORTANT! this is gross, but necessary for TNE Beta Users navigation requirements
            _this.helpers.revealMarketingNewLinks(scopes);
            _this.helpers.revealIpsPageForSubusers(featureToggles);
          }

          if (_this.helpers.hasScope("^marketing_campaigns\\.create$", scopes)) {
            _this.$("[role=nlvx]").parent().addBack().show();
          }
        }).fail(function () {
          console.error("NO FEATURE TOGGLES OR NO SCOPES");
        });
      }
    },
    revealPagesViaEntitlement: {
      value: function revealPagesViaEntitlement() {
        var _this = this;

        this.$.when(this.defs.userProducts).done(function () {
          var userProducts = arguments[0] === undefined ? {} : arguments[0];
          var _userProducts$entitlements = userProducts.entitlements;
          var entitlements = _userProducts$entitlements === undefined ? {} : _userProducts$entitlements;

          _this.helpers.revealLinksViaEntitlement(entitlements);
        }).fail(function () {
          // Makes sure to reveal entitlement_off by default
          _this.helpers.revealLinksViaEntitlement({});
          console.error("NO OES USER PRODUCTS");
        });
      }
    },
    revealPagesViaTransactionalTemplateType: {
      value: function revealPagesViaTransactionalTemplateType() {
        var _this = this;

        this.$.when(this.defs.transactional_templates).done(function (transactionalTemplates) {
          transactionalTemplates = transactionalTemplates.templates;

          if (!_this.revealAllLinks) {
            // reveal links by transactional template type/generation
            _this.helpers.revealLinksViaTransactionalTemplateType(transactionalTemplates);
          }
        }).fail(function () {
          console.error("NO TRANSACTIONAL TEMPLATES");
        });
      }
    },
    revealPagesViaAccount: {
      value: function revealPagesViaAccount() {
        var _this = this;

        this.$.when(this.defs.account).done(function (account) {
          var $link = _this.$("[data-tiara-nav] [data-subuser-restricted=true]");

          if (!_this.revealAllLinks) {
            if (account.is_reseller_customer) {
              $("[data-reseller-restricted=true]").addClass(Templates.resellerHiddenClass);
            }
            if (account.type !== "subuser") {
              // show whitelabel ips and subuser management
              $link.removeClass(Templates.subuserHiddenClass);
            } else {
              $link.addClass(Templates.subuserHiddenClass);
            }
          }
        }).fail(function () {
          console.error("NO ACCOUNT");
        });
      }
    },
    disablePagesViaRegion: {
      value: function disablePagesViaRegion(region) {
        this.helpers.disableLinksViaRegion(region);
      }
    },
    renderPages: {

      // After toggles and scopes have been fetched, show the markup.
      // Note: We're not waiting on defs.ips, since it's an unusually lengthy call

      value: function renderPages() {
        var _this = this;

        return this.$.when(this.defs.feature_toggles, this.defs.scopes).always(function () {
          if (_this.revealAllLinks) {
            _this.helpers.revealAllLinks();
          }
          _this.$("[role=show-after-fetched]").show();
        });
      }
    },
    showReputationBar: {
      value: function showReputationBar() {
        var _this = this;

        this.$.when(this.defs.account).done(function (account) {
          _this.helpers.showReputation(account.reputation);
        }).fail(function () {
          console.error("Could not render reputation meter");
        });
      }
    },
    showCreditsBar: {
      value: function showCreditsBar() {
        var _this = this;

        return this.$.whenAll([this.defs.credits, this.defs.pkg, this.defs.signup_status]).done(function (creditsDef, pkgDef, signupStatusDef) {
          var credits = undefined,
              signupStatus = undefined,
              isUnverified = undefined;

          credits = !(creditsDef == null) && creditsDef[1] === successResponse ? creditsDef[0] : {};
          signupStatus = !(signupStatusDef == null) && signupStatusDef[1] === successResponse ? signupStatusDef[0] : null;

          // get isUnverified
          if (signupStatus) {
            var progress = _this.signupProgress(signupStatus);
            isUnverified = progress !== "complete";
          }

          _this.helpers.showCredits(credits.used, credits.total, isUnverified);
        }).fail(function () {
          console.error("Could not render credits bar");
        });
      }
    },
    showUsage: {
      value: function showUsage() {
        var _this = this;

        this.$.when(this.defs.usage_stats, this.defs.scopes).done(function (usageStats, scopes) {
          var mayHaveSubusers = _this.helpers.hasScope(/^subusers\./, scopes[0].scopes);
          // Users with MC scopes should not be shown usage in the nav
          // because it does not aggregate MC sends and EI sends.
          // Instead, redirect them to mako to view their usage.
          var shouldShowUsage = !_this.helpers.hasScope(/^marketing\.read/i, scopes[0].scopes);
          if (shouldShowUsage) {
            var usage = usageStats[0].used;
            _this.helpers.showUsage(usage);
            var creditsResetFrequency = usageStats[0].reset_frequency;
            _this.helpers.showUsageLabels(creditsResetFrequency, mayHaveSubusers);
          } else {
            _this.helpers.showAccountUsageLink();
          }
        }).fail(function () {
          console.error("Could not render emails sent monthly");
        });
      }
    },
    showAccountName: {
      value: function showAccountName(impersonating, shouldShowGlobalNavBarUpdates) {
        var _this = this;

        if (shouldShowGlobalNavBarUpdates) {
          if (this.unifiedUserInfo) {
            this.helpers.hideTwilioSendgridBranding();
            return;
          }
        } else {
          if (!impersonating && this.unifiedUserInfo) {
            this.helpers.showAccount("" + this.unifiedUserInfo.given_name + " " + this.unifiedUserInfo.family_name);
          }
        }
        this.$.when(this.defs.profile, this.defs.username).done(function (profile, username) {
          var fullName = undefined;
          profile = profile[0];
          username = username[0].username;

          if (profile.first_name || profile.last_name) {
            fullName = "" + (profile.first_name || "") + " " + (profile.last_name || "");
          } else {
            fullName = username;
          }
          _this.helpers.showAccount(fullName);
        }).fail(function () {
          console.error("Could not render account menu");
        });
      }
    },
    showAdsTiara: {
      value: function showAdsTiara() {
        //hide ads tiara if user doesn't have ads entitlement
        var self = this;
        self.$.when(this.defs.userProducts).done(function (userProducts) {
          // if user doesn't have entitlement or if they don't have ads entitlement hide ads
          if (!("entitlements" in userProducts) || !userProducts.entitlements.compat_has_ads) {
            self.$("[role=ads]").addClass("hidden");
          }
        }).fail(function () {
          console.error("Exception querying for user products, hiding tiara");
          self.$("[role=ads]").addClass("hidden");
        });
      }
    },
    showImpersonationBanner: {
      value: function showImpersonationBanner(makoHost, backToParentCallback, impersonating, hasRestrictedSubuserAccess) {
        $(".tiara-headers").prepend(Templates.multisubuserImpersonationBanner(impersonating, hasRestrictedSubuserAccess));
        $("[role=change-account]").on("click", function () {
          // We make sure to allow the user to redirect back to the app (MC/Mako) and route from which they clicked the Change Account button
          window.location.href = "" + makoHost + "/subuser/access?redirect_to=" + encodeURIComponent(window.location.href);
        });

        if (!hasRestrictedSubuserAccess) {
          // users with restricted subuser access are not given this functionality as they are
          // restricted from accessing Mako on behalf of themselves
          // This button is hidden from users with restricted access
          $("[role=back-to-parent-account]").on("click", backToParentCallback);
        }
      }
    },
    handleSubuserImpersonation: {
      value: function handleSubuserImpersonation(impersonating, makoHost, backToParentCallback, shouldShowGlobalNavBarUpdates) {
        var _this = this;

        if (impersonating) {
          if (this.unifiedUserInfo && !shouldShowGlobalNavBarUpdates || !this.unifiedUserInfo) {
            this.$.when(this.defs.subuserAccess).done(function (subuserAccess) {
              var hasRestrictedSubuserAccess = subuserAccess.has_restricted_subuser_access;

              _this.showImpersonationBanner(makoHost, backToParentCallback, impersonating, hasRestrictedSubuserAccess);
            }).fail(function () {
              console.error("Could not render impersonation banner");
            });
          }
        } else {
          this.$.when(this.defs.subusers).done(function (subusers) {
            if (_this.preventImpersonation || subusers.length <= 0) {
              if (_this.unifiedUserInfo) {
                _this.disableDropdown();
              }
              return;
            }
            _this.$("[data-account-subuser-access]").show();
            if (_this.unifiedUserInfo) {
              subusers.forEach(function (subuser, index) {
                if (index >= 5) {
                  return;
                }
                _this.$("[data-account-subusers]").append("\n                <a class=\"dropdown-link\" style=\"overflow: hidden; text-overflow: ellipsis;\" href=\"" + makoHost + "/subuser/access?redirect_to=" + encodeURIComponent(window.location.href) + "\">" + subuser.username + "</a>\n              ");
              });
            }
          }).fail((function () {
            console.error("Could not render subusers");
            if (this.unifiedUserInfo) {
              this.disableDropdown();
            }
          }).bind(this));
        }
      }
    },
    hideLoadingScreen: {

      // hide the loading screen once we get back at least one 20x OR all requests have been resolved/rejected

      value: function hideLoadingScreen() {
        var _this = this;

        var $ = this.$;
        var defArray = [];
        Object.keys(this.defs).forEach(function (key) {
          var def = _this.defs[key];
          defArray.push(def);
          def.done(function (data, success, xhr) {
            if (xhr && xhr.status >= 200 && xhr.status < 300) {
              $("[data-role=main-loader]").fadeOut();
            }
          });
        });

        this.$.whenAll(defArray).done(function () {
          _this.$("[data-role=main-loader]").fadeOut();
        });
      }
    },
    detectAdblock: {

      // fire track event if user has adblock on once all requests have been resolved/rejected

      value: function detectAdblock() {
        var _this = this;

        var defArray = [];
        Object.keys(this.defs).forEach(function (key) {
          var def = _this.defs[key];
          defArray.push(def);
        });

        this.$.whenAll(defArray).done(function () {
          // Most adblockers will hide the banner_ad element
          // offsetParent returns none if the element's display is set to none
          if (!_get(document.getElementById("banner_ad"), "offsetParent", null)) {
            analytics.track({
              event: "ui block enabled",
              properties: {
                eventType: "state" } });
          }
        });
      }
    },
    isAwsDeactivated: {
      value: function isAwsDeactivated(userType) {
        if (!userType) {
          return false;
        }

        var type = userType.type;
        var reseller_username = userType.reseller_username;

        var awsDeactivatedUser = {
          type: "reseller_customer_free",
          resellerUsername: "reseller@aws.com" };

        // user must be a reseller customer, and the
        // reseller's username must be reseller@aws.com
        return type === awsDeactivatedUser.type && reseller_username === awsDeactivatedUser.resellerUsername;
      }
    },
    isSenderVerificationRequired: {
      value: function isSenderVerificationRequired(scopes) {
        var hasSenderVerificationEligibleScope = scopes.some(function (scope) {
          return scope === senderVerificationEligibleScope;
        });
        var hasSenderVerificationExemptScope = scopes.some(function (scope) {
          return scope === senderVerificationExemptScope;
        });

        var isSenderVerificationEligibleBasedOnScopes = hasSenderVerificationEligibleScope && !hasSenderVerificationExemptScope;

        return isSenderVerificationEligibleBasedOnScopes;
      }
    },
    determineUserHasSentEmail: {
      value: function determineUserHasSentEmail(longtermStats) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = longtermStats[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var stats = _step.value;

            if (_get(stats, "stats[0].metrics.requests", 0) > 0) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"]) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return false;
      }
    },
    renderBanner: {

      // see https://docs.google.com/drawings/d/1D2H84rS57RMF46_ialNgN-LOPTPdoXf3W_oOkiQvz0Q/edit

      value: function renderBanner() {
        var _this = this;

        return this.$.whenAll([this.defs.user_status, this.defs.user_type, this.defs.senderIdStatus, this.defs.longtermStats, this.defs.scopes, this.defs.feature_toggles, this.defs.signup_status, this.defs.userProducts]).done(function (userStatusDef, userTypeDef, senderIdStatusDef, longtermStatsDef, scopesDef, featureTogglesDef, s2sStatusDef, userProductsDef) {
          // Always render banner hidden and toggle CSS display property from tiara or mako
          _this.banner.showConsumerTrustSuspended();
          _this.banner.showComplianceSuspended();

          var userStatus = _this.defaultOnError(userStatusDef, {});
          var userType = _this.defaultOnError(userTypeDef, {});
          var senderIdStatus = _this.defaultOnError(senderIdStatusDef, {
            results: {} });
          var longtermStats = _this.defaultOnError(longtermStatsDef, []);
          var scopes = _this.defaultOnError(scopesDef, { scopes: [] }).scopes;
          var featureToggles = _this.defaultOnError(featureTogglesDef, []);
          // s2sStatusDef will return 404 if user finished all steps or never needed to complete them.
          // 404 in tiara is considered a success so s2sStatus will be null in that case
          var s2sStatus = _this.defaultOnError(s2sStatusDef, {});
          var oesAccount = _this.defaultOnError(userProductsDef, {});

          var showSiteMaintenanceBanner = _this.helpers.hasFeatureEnabled("tiara", "site_maintenance", featureToggles);
          if (showSiteMaintenanceBanner) {
            _this.banner.showSiteMaintenanceBanner();
          }

          if (_this.isAwsDeactivated(userType)) {
            _this.banner.showAwsDeactivated();
            return;
          }

          // Show banners for inactive user status
          switch (userStatus.status) {
            case billingSuspendedStatus:
              if (userStatus.prompt_appeal) {
                _this.helpers.revealConsumerTrustSuspendedBanner();
              } else {
                _this.helpers.revealComplianceSuspendedBanner();
              }
              return;
            case billingTerminatedStatus:
              _this.banner.showComplianceBillingTerminated();
              return;
            case billingWarnedStatus:
              _this.banner.showComplianceBillingWarned();
              return;
            case billingFrozenStatus:
              _this.banner.showComplianceBillingFrozen();
              return;
          }

          var onboardingBanner = _this.getOnboardingBanner(scopes, senderIdStatus, longtermStats, s2sStatus, oesAccount, featureToggles);

          switch (onboardingBanner) {
            case Banner.ONBOARDING_CREATE_SENDER_ID:
              _this.banner.showCreateSenderIdentity();
              return;
            case Banner.ONBOARDING_SEND_FIRST_EMAIL:
              _this.banner.showSendFirstEmail();
              return;
            case Banner.ONBOARDING_FINISH_ACCOUNT_SETUP:
              _this.banner.showOnboardingFinishAccountSetup();
              return;
            case Banner.ONBOARDING_CHOOSE_PLAN:
              _this.banner.showOnboardingChoosePlan();
              return;
            case Banner.ONBOARDING_CONSUMER_TRUST_TEAM_PENDING:
              _this.banner.showConsumerTrustTeamPending();
              return;
          }

          return _this.$.when(_this.defs.pkg).done(function (pkg) {
            var base_price = pkg.base_price;
            var is_signup_to_send = pkg.is_signup_to_send;

            if (!is_signup_to_send) {
              return;
            }

            if (base_price > 0) {
              // on a paid package
              return _this.$.when(_this.defs.signup_status).done(function (signup_status) {
                var progress = _this.signupProgress(signup_status);

                if (progress === "complete") {
                  _this.easeEligibility(userStatus, base_price);
                  return;
                }
              });
            }

            return _this.$.when(_this.defs.credits).done(function (credits) {
              // on free 100 and have sent more than 100 emails
              if (credits.total > 0 && credits.remain <= 0) {
                return _this.$.when(_this.defs.signup_status).done(function (signup_status) {
                  if (_this.signupProgress(signup_status) === "complete") {
                    _this.banner.showOverlimitUpgrade({ credits: credits });
                    return;
                  }

                  _this.banner.showOverlimitVerify({ credits: credits });
                });
              }
            });
          }).done(function () {
            return _this.$.when(_this.defs.userProducts).done(function (oesAccount) {
              if (_this.helpers.isPaymentDeclined(oesAccount)) {
                _this.banner.showPaymentDeclined();
              }
            });
          });
        }).fail(function () {
          console.error("No banner deferreds retrieved.");
        });
      }
    },
    areS2sStepsComplete: {

      /** Returns true if all required s2s steps irrespective of manual_vetting are complete */

      value: function areS2sStepsComplete(s2sStatus) {
        var email_complete = s2sStatus.email_complete;
        var email_required = s2sStatus.email_required;
        var mfa_complete = s2sStatus.mfa_complete;
        var mfa_required = s2sStatus.mfa_required;
        var payment_method_verification_complete = s2sStatus.payment_method_verification_complete;
        var payment_method_verification_required = s2sStatus.payment_method_verification_required;
        var whitelabel_complete = s2sStatus.whitelabel_complete;
        var whitelabel_required = s2sStatus.whitelabel_required;

        if (email_required && !email_complete || whitelabel_required && !whitelabel_complete || mfa_required && !mfa_complete || payment_method_verification_required && !payment_method_verification_complete) {
          return false;
        }
        return true;
      }
    },
    getOnboardingBanner: {
      value: function getOnboardingBanner(scopes, senderIdStatus, stats, s2sStatus, oesAccount, featureToggles) {
        var hasSecureOnboardingFeatureToggle = this.helpers.hasFeatureEnabled("mako", "secure_onboarding", featureToggles);
        if (hasSecureOnboardingFeatureToggle && s2sStatus != null) {
          var manual_vetting_complete = s2sStatus.manual_vetting_complete;
          var manual_vetting_required = s2sStatus.manual_vetting_required;

          if (this.areS2sStepsComplete(s2sStatus) && manual_vetting_required && !manual_vetting_complete) {
            // User has secure onboarding enabled, all onboarding steps are
            // complete, and is only waiting for manual vetting to complete
            return Banner.ONBOARDING_CONSUMER_TRUST_TEAM_PENDING;
          }
        }

        var isSenderVerificationRequired = this.isSenderVerificationRequired(scopes);
        var _senderIdStatus$results = senderIdStatus.results;
        var domain_verified = _senderIdStatus$results.domain_verified;
        var sender_verified = _senderIdStatus$results.sender_verified;

        var hasVerifiedSenderOrDomainAuth = domain_verified || sender_verified;
        var isSenderIdStepComplete = !isSenderVerificationRequired || hasVerifiedSenderOrDomainAuth;

        if (!isSenderIdStepComplete) {
          return Banner.ONBOARDING_CREATE_SENDER_ID;
        }

        // signup to send endpoint returns a 404 when all steps are complete
        // and the fetcher sets the response to null
        if (!s2sStatus) {
          return;
        }

        var hasSentEmail = this.determineUserHasSentEmail(stats);
        if (!hasSentEmail) {
          return Banner.ONBOARDING_SEND_FIRST_EMAIL;
        }

        if (!this.areS2sStepsComplete(s2sStatus)) {
          return Banner.ONBOARDING_FINISH_ACCOUNT_SETUP;
        }

        if (!oesAccount || !oesAccount.entitlements) {
          return;
        }
        var entitlements = oesAccount.entitlements;
        var ei_tier = entitlements.ei_tier;
        var mc_tier = entitlements.mc_tier;

        var isFreeUser = ei_tier === "free" && mc_tier === "free";
        if (isFreeUser) {
          return Banner.ONBOARDING_CHOOSE_PLAN;
        }
      }
    },
    signupProgress: {
      value: function signupProgress(status) {
        if (!status) {
          // 'complete' status can also be represented by 404
          return "complete";
        }

        // From early 2018 onwards, new user signups are no longer held to the
        // MFA/Whitelabel S2S status requirements and only need to verify the account email address
        // As a result, we deprecate the MFA/whitelabel checks and those old users before 2018 still held to
        // the old S2S requirements will need to contact Support/still verify the domain auth or MFA to send more than 100 emails
        if (status.email_required && !status.email_complete) {
          return "not_started";
        } else {
          return "complete";
        }
      }
    },
    revealEmailsRemaining: {
      value: function revealEmailsRemaining() {
        this.$("[data-role=emails-remaining]").removeClass("hidden");
      }
    },
    getCookie: {
      value: function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == " ") {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }
    },
    easeEligibility: {
      value: function easeEligibility(userStatus, base_price) {
        var _this = this;

        if (this.getCookie("easePromoShown") || localStorage.getItem("easePromoShown") || base_price > 8955.95) {
          return false;
        }
        var user_id = 0;
        var easePromoArgs = {
          sendStatsLast30Days: false,
          notTerminated: false,
          correctScope: false,
          notEase: false,
          notReseller: false,
          noSubusers: false };

        this.$.whenAll([this.defs.monthly_stats, this.defs.scopes, this.defs.message_storage, this.defs.username, this.defs.user_type, this.defs.parent_subusers]).done(function (monthlyStats, scopes, message_storage, username, userTypeDef, subusers) {
          user_id = username[0].user_id;
          easePromoArgs.notTerminated = userStatus.status !== billingTerminatedStatus;
          easePromoArgs.correctScope = _this.helpers.hasScope("^billing\\.read$", scopes[0].scopes) && _this.helpers.hasScope("^messages\\.read$", scopes[0].scopes);
          if (monthlyStats[0][0] && monthlyStats[0][0].stats && monthlyStats[0][0].stats[0] && monthlyStats[0][0].stats[0].metrics && monthlyStats[0][0].stats[0].metrics.requests) {
            easePromoArgs.sendStatsLast30Days = monthlyStats[0][0].stats[0].metrics.requests > 0;
          }
          easePromoArgs.notReseller = userTypeDef.type !== "reseller";
          easePromoArgs.notEase = message_storage[0].storage !== "30 days";
          easePromoArgs.noSubusers = subusers[2] === "FORBIDDEN" || subusers[0].length < 2;

          var easePromoEligible = Object.keys(easePromoArgs).every(function (key) {
            return easePromoArgs[key] === true;
          });
          if (easePromoEligible) {
            _this.banner.showEase(user_id);
          }
        });
      }
    },
    restrictedSubuserAccessControl: {

      // users with restricted subuser access are restricted from accessing Mako/MC unless they are impersonating a subuser
      // if they are not impersonating and are not on the subuser access page, we redirect them back to login/impersonate a subuser

      value: function restrictedSubuserAccessControl(isImpersonating, makoHost) {
        var restrictedSubuserAccessRouteAcceptList = ["logout", "subuser/access"];
        var isOnAcceptedRoute = restrictedSubuserAccessRouteAcceptList.some(function (route) {
          return window.location.pathname.includes(route);
        });

        if (!isOnAcceptedRoute && !isImpersonating && this.defs.subuserAccess) {
          this.$.when(this.defs.subuserAccess).done(function (subuserAccess) {
            var hasRestrictedSubuserAccess = subuserAccess.has_restricted_subuser_access;

            if (hasRestrictedSubuserAccess) {
              window.location.href = "" + makoHost + "/subuser/access";
            }
          }).fail(function () {
            return console.log("Failed to determine subuser access redirect");
          });
        }
      }
    },
    defaultOnError: {
      value: function defaultOnError(jqXHR, defaultResponse) {
        return !(jqXHR == null) && jqXHR[1] === successResponse ? jqXHR[0] : defaultResponse;
      }
    }
  });

  return DeferredHandlers;
})();

},{"./templates":8,"@sendgrid/bloodhound":202,"lodash/get":358}],5:[function(require,module,exports){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var _require = require("./browserFingerprint");

var getBrowserFingerprintHeader = _require.getBrowserFingerprintHeader;

module.exports = (function () {
  function Fetcher($, token, options) {
    _classCallCheck(this, Fetcher);

    options = options || {};
    this.$ = $;
    this.token = token;
    this.api_host = options.api_host;
    this.logoutConfigURL = options.logoutConfigURL || "https://links.integrations.sendgrid.net/links.json";

    this.impersonatingUsername = options.impersonating;

    // Optional option.  This will be a no-op unless configured to logout on auth failure
    this.logoutCallback = options.logoutCallback || function () {};
  }

  _createClass(Fetcher, {
    fetchProfile: {

      // Example response: {"first_name": "Pat", "last_name":  "Pattington"}

      value: function fetchProfile() {
        return this.authorizedAjax("user/profile");
      }
    },
    fetchEmail: {

      // Example response: {"email": "me@example.com"}

      value: function fetchEmail() {
        return this.authorizedAjax("user/email");
      }
    },
    fetchAccount: {

      // Example response: {"reputation": 99, "type": "paid"}

      value: function fetchAccount() {
        return this.authorizedAjax("user/account");
      }
    },
    fetchCredits: {

      /* Example response:
      {
        "last_reset": "2015-03-01",
        "next_reset": "2015-04-01",
        "overage": 0,
        "remain": 99997,
        "reset_frequency": "monthly",
        "total": 100000,
        "used": 3
      } */

      value: function fetchCredits() {
        return this.authorizedAjax("user/credits");
      }
    },
    fetchCreditsIncludingSubusers: {

      /* Example response:
      {
        "last_reset": "2015-03-01",
        "next_reset": "2015-04-01",
        "overage": 0,
        "remain": 99997,
        "reset_frequency": "monthly",
        "total": 100000,
        "used": 3
      } */

      value: function fetchCreditsIncludingSubusers() {
        return this.authorizedAjax("user/credits?include_subusers=true");
      }
    },
    fetchMonthlyEmailStats: {

      /* Example response:
         [{
           "date": "2015-03-03",
           "stats": [{
             "metrics": {
               "blocks": 0,
               "bounce_drops": 0,
               "bounces": 0,
               "clicks": 0,
               "deferred": 0,
               "delivered": 0,
               "invalid_emails": 0,
               "opens": 0,
               "processed": 0,
               "requests": 0,
               "spam_report_drops": 0,
               "spam_reports": 0,
               "unique_clicks": 0,
               "unique_opens": 0,
               "unsubscribe_drops": 0,
               "unsubscribes": 0
             }
           }]
         }]
       */

      value: function fetchMonthlyEmailStats() {
        var monthStart = monthStartDateString();
        var today = todayDateString();
        return this.authorizedAjax("stats?aggregated_by=month&start_date=" + monthStart + "&end_date=" + today);
      }
    },
    fetchSubusers: {

      /* Example response:
        [{
         "id": 100,
         "username": "subby1",
         "email": "subby1@example.com"
        }, {
         "id": 101,
         "username": "subby2",
         "email": "subby2@example.com"
        ]
      */

      value: function fetchSubusers(userParams) {
        var params = { limit: 20 };
        if (userParams) {
          this.$.extend(params, userParams);
        }
        return this.authorizedAjax("subusers?" + this.$.param(params));
      }
    },
    fetchFeatureToggles: {

      /* Example response:
      [
        {feature_name:'signup', app_name:'mako'},
        {feature_name:'subuser_mgmt', app_name:'mako'},
        {feature_name:'subusers', app_name:'mako'},
        {feature_name:'api_keys', app_name:'mako'},
        {feature_name:'parse', app_name:'mako'},
        {feature_name:'mail_settings', app_name:'mako'},
        {feature_name:'alerts', app_name:'mako'},
        {feature_name:'package_and_billing', app_name:'mako'},
        {feature_name:'multifactor_auth', app_name:'mako'},
        {feature_name:'edit_profile', app_name:'mako'},
        {feature_name:'whitelabel', app_name:'mako'},
        {feature_name:'ip_access_mgmt', app_name:'mako'},
        {feature_name:'teammates', app_name:'mako'},
        {feature_name:'multifactor_authentication', app_name:'mako'},
        {feature_name:'ips_self_service', app_name:'mako'},
        {feature_name:'reactive_troubleshooting', app_name:'mako'},
      ]
      */

      value: function fetchFeatureToggles() {
        return this.authorizedAjax("feature_toggles");
      }
    },
    fetchLegacyNewsletterAccess: {

      /* Example response:
        {
          "valid": true
        }
      */

      value: function fetchLegacyNewsletterAccess() {
        return this.authorizedAjax("legacy_newsletter");
      }
    },
    fetchScopes: {

      /* Example response:
        {
          "scopes": [
            "alerts.create",
            "alerts.read",
            "alerts.update",
            "alerts.delete"
          ]
        }
      */

      value: function fetchScopes() {
        return this.authorizedAjax("scopes");
      }
    },
    fetchUsername: {

      /* Example response:
        {
          "user_id": 180,
          "username": "my_username"
        }
      */

      value: function fetchUsername() {
        return this.authorizedAjax("user/username");
      }
    },
    fetchPackage: {

      /* Example response:
        {
          name: "Silver Package",
          description: "Silver Package includes 100,000 email credits per month, $0.00085 per email thereafter.",
          base_price: 79.95,
          overage_price: 0.00085,
          newsletter_price: 0,
          campaign_price: 0,
          is_hv: false,
          package_id: "8b8403b0-ce8a-11e4-b4e5-5fcde71ee009",
          package_status: "Active",
          downgrade_package_id: ""
        }
      */

      value: function fetchPackage() {
        return this.authorizedAjax("user/package");
      }
    },
    fetchSignupStatus: {

      /* Example repsonse:
        {
          email_complete:      false,
          email_required:      true,
          mfa_complete:        false,
          mfa_required:        true,
          profile_complete:    true,
          profile_required:    true,
          whitelabel_complete: false,
          whitelabel_required: false,
        }
        HOWEVER, this 404s on users who are not currently
        in the signup-to-send process. Therefore, we must
        wrap it in a Deferred so it'll return null instead
        of a 404 error.
      */

      value: function fetchSignupStatus() {
        var deferred = this.$.Deferred();

        this.authorizedAjax("s2s/signup/status").done(function (data, textStatus, jqXHR) {
          deferred.resolve(data, textStatus, jqXHR);
        }).fail(function (jqXHR, textStatus, errorThrown) {
          if (jqXHR.status === 404) {
            deferred.resolve(null, "success", jqXHR);
          } else {
            deferred.reject(jqXHR, textStatus, errorThrown);
          }
        });

        return deferred;
      }
    },
    fetchTransactionalTemplates: {
      value: function fetchTransactionalTemplates() {
        return this.authorizedAjax("templates");
      }
    },
    fetchUserStatus: {

      /* Example response:
        {
          status: "active"
        }
      */

      value: function fetchUserStatus() {
        return this.authorizedAjax("user/status");
      }
    },
    fetchUserType: {

      /* Example response:
        {
          type: "reseller",
          reseller_username: "reseller@aws.com"
        }
      */

      value: function fetchUserType() {
        return this.authorizedAjax("user/type");
      }
    },
    fetchMessageStorage: {

      /* Example response:
        {
          storage: "3 days",
          pending_downgrade: false
        }
         If the storage == "30 days", then the user has the EASE addon
      */

      value: function fetchMessageStorage() {
        return this.authorizedAjax("billing/message_storage");
      }
    },
    fetchUserProducts: {
      value: function fetchUserProducts() {
        return this.authorizedAjax("accounts/offerings?_show&_pricing&_offerings");
      }
    },
    fetchOngoingExpertServices: {
      value: function fetchOngoingExpertServices() {
        return this.authorizedAjax("expert_services/ongoing");
      }
    },
    fetchCAMAccount: {
      value: function fetchCAMAccount() {
        return this.authorizedAjax("accounts");
      }
    },
    fetchLogoutConfig: {

      // A by-org mapping of logout destinations
      /* Example response:
        {
          "azure": {
            "billing": "https://portal.azure.com/#blade/Microsoft_Azure_GTM/ModernBillingMenuBlade/Overview",
            "sso_logout": "https://portal.azure.com/"
          },
          "google": {
            "billing": "https://console.cloud.google.com/billing",
            "sso_logout": "https://console.cloud.google.com/"
          },
          "heroku": {
            "billing": "https://dashboard.heroku.com/account/billing",
            "sso_logout": "https://id.heroku.com/login"
          },
          "ibm": {
            "billing": "https://cloud.ibm.com/billing",
            "sso_logout": "https://cloud.ibm.com/"
          },
          "kke": {
            "billing": "https://sendgrid.kke.co.jp/app?p=mypage.billing_menu",
            "sso_logout": "https://sendgrid.kke.co.jp/app?p=login.index"
          }
        }
      */

      value: function fetchLogoutConfig() {
        return this.$.ajax({
          url: this.logoutConfigURL });
      }
    },
    fetchApiKeys: {

      /* Example response:
        {
          result: [
            {
              name: "test1",
              api_key_id: "B35dGObITtKkr9_B0UPpjg"
            },
            {
              name: "test2",
              api_key_id: "C35aGObITtKkr9_B0UPpbj"
            }
          ];
        }
      */

      value: function fetchApiKeys() {
        return this.authorizedAjax("api_keys");
      }
    },
    fetchApiKey: {

      /* Example response:
        {
          name: "test1",
          api_key_id: "B35dGObITtKkr9_B0UPpjg"
          scopes: [
            "mail.read",
            "alerts.read",
            "alerts.create",
          ];
        }
      */

      value: function fetchApiKey(id) {
        return this.authorizedAjax("api_keys/" + id);
      }
    },
    fetchLongtermStats: {

      // Used to determine if a user has ever successfully sent an email. Needed for onboarding steps.
      // Ideally this would be a boolean for each user and exposed to us via an API, but our only way
      // at this data currently is to query stats over a really wide timeframe.

      value: function fetchLongtermStats() {
        var threeYearsMilliseconds = 1000 * 60 * 60 * 24 * 1095;
        var threeYearsAgo = new Date(new Date().getTime() - threeYearsMilliseconds);
        var startDate = threeYearsAgo.toISOString().slice(0, 10);
        return this.authorizedAjax("stats?aggregated_by=month&start_date=" + startDate);
      }
    },
    fetchSenderIdentityStatus: {
      value: function fetchSenderIdentityStatus() {
        return this.authorizedAjax("verified_senders/steps_completed");
      }
    },
    fetchSubuserAccess: {
      value: function fetchSubuserAccess(username) {
        return this.authorizedAjax("teammates/" + username + "/subuser_access?limit=10");
      }
    },
    handleFetchSubuserAccess: {
      value: function handleFetchSubuserAccess(username, subuserAccessDef) {
        this.fetchSubuserAccess(username).done(function (data, textStatus, jqXHR) {
          return subuserAccessDef.resolve(data, textStatus, jqXHR);
        }).fail(function (jqXHR, textStatus, errorThrown) {
          return subuserAccessDef.reject(jqXHR, textStatus, errorThrown);
        });
      }
    },
    fetchSubuserCursor: {
      value: function fetchSubuserCursor(adaptSubuserCursorData) {
        return this.authorizedAjax("subusers_cursor?limit=10", adaptSubuserCursorData);
      }
    },
    handleFetchSubuserCursor: {
      value: function handleFetchSubuserCursor(subuserCursorDataAdapter, subuserAccessDef) {
        this.fetchSubuserCursor(subuserCursorDataAdapter).done(function (data, textStatus, jqXHR) {
          return subuserAccessDef.resolve(data, textStatus, jqXHR);
        }).fail(function (jqXHR, textStatus, errorThrown) {
          return subuserAccessDef.reject(jqXHR, textStatus, errorThrown);
        });
      }
    },
    handleGetSubuserAccess: {
      value: function handleGetSubuserAccess(usernameDef, profileDef, subuserCursorDataAdapter) {
        var _this = this;

        var subuserAccessDef = this.$.Deferred();
        this.$.whenAll([usernameDef, profileDef]).done(function (username, profile) {
          var isSSOTeammate = profile[0].type === "sso_teammate";
          if (isSSOTeammate) {
            _this.handleFetchSubuserAccess(username[0].username, subuserAccessDef);
          } else {
            _this.handleFetchSubuserCursor(subuserCursorDataAdapter, subuserAccessDef);
          }
        }).fail(function (jqXHR, textStatus, errorThrown) {
          return subuserAccessDef.reject(jqXHR, textStatus, errorThrown);
        });

        return subuserAccessDef;
      }
    },
    authorizedAjax: {
      value: function authorizedAjax(route) {
        var dataFilter = arguments[1] === undefined ? undefined : arguments[1];

        var headers = { authorization: "token " + this.token };

        var base64BrowserFingerprint = getBrowserFingerprintHeader();
        if (base64BrowserFingerprint) {
          headers["Browser-Fingerprint"] = base64BrowserFingerprint;
        }

        var skipImpersonation = false;

        if (this.impersonatingUsername) {
          headers["On-Behalf-Of"] = this.impersonatingUsername;
        } else {
          // if you use $.ajaxPrefilter in your client code,
          // check options to avoid applying "On-Behalf-Of"
          skipImpersonation = true;
        }
        return this.$.ajax({
          url: "" + this.api_host + "" + route,
          headers: headers,
          skipImpersonation: skipImpersonation,
          statusCode: {
            401: (function () {
              // Added to assist in debugging a CFD will be removed in: https://issues.corp.twilio.com/browse/CLFED-1139
              console.trace("Tiara 401");
              this.logoutCallback();
            }).bind(this) },
          // Option to sanitize/adapt raw data
          dataFilter: dataFilter });
      }
    }
  });

  return Fetcher;
})();

// return today's date formatted, ex: "2015-02-28"
function todayDateString() {
  var today = new Date();
  var date = today.getDate();
  var month = today.getMonth() + 1; // months are 0-indexed
  var year = today.getFullYear();

  if (date < 10) {
    date = "0" + date;
  }

  if (month < 10) {
    month = "0" + month;
  }

  return [year, month, date].join("-");
}

function monthStartDateString() {
  var monthStart = new Date();
  var monthStartDate = "01"; // First of the current month with an appended '0'
  var monthStartMonth = monthStart.getMonth() + 1; // months are 0-indexed
  var monthStartYear = monthStart.getFullYear();

  if (monthStartMonth < 10) {
    monthStartMonth = "0" + monthStartMonth;
  }

  return [monthStartYear, monthStartMonth, monthStartDate].join("-");
}

},{"./browserFingerprint":2}],6:[function(require,module,exports){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var Templates = require("./templates");

module.exports = (function () {
  function Helpers($, _, $container) {
    _classCallCheck(this, Helpers);

    this.$ = $;
    this._ = _;
    this.$container = $container;
  }

  _createClass(Helpers, {
    revealConsumerTrustSuspendedBanner: {
      value: function revealConsumerTrustSuspendedBanner() {
        $("[data-role=consumerTrustSuspendedBanner]").removeClass("hidden");
      }
    },
    revealComplianceSuspendedBanner: {
      value: function revealComplianceSuspendedBanner() {
        $("[data-role=complianceSuspendedBanner]").removeClass("hidden");
      }
    },
    revealLinksViaFeatureToggles: {
      value: function revealLinksViaFeatureToggles(featureToggles) {
        var $ = this.$;
        var self = this;
        // display links that should be shown ONLY if feature toggle is ON
        this.$container.find("[data-ft-app][data-ft-feature]").each(function (i, link) {
          var $link = $(link);
          var appName = $link.data("ft-app");
          var featureName = $link.data("ft-feature");

          if (self.hasFeatureEnabled(appName, featureName, featureToggles)) {
            $link.removeClass(Templates.featureToggleHiddenClass);
          } else {
            $link.addClass(Templates.featureToggleHiddenClass);
          }
        });
        // display links that should be shown ONLY if feature toggle is OFF
        this.$container.find("[data-ft-app][data-ft-feature-off]").each(function (i, link) {
          var $link = $(link);
          var appName = $link.data("ft-app");
          var featureName = $link.data("ft-feature-off");
          if (!self.hasFeatureEnabled(appName, featureName, featureToggles)) {
            $link.removeClass(Templates.featureToggleHiddenClass);
          } else {
            $link.addClass(Templates.featureToggleHiddenClass);
          }
        });
      }
    },
    revealLinksViaTransactionalTemplateType: {
      value: function revealLinksViaTransactionalTemplateType(templates) {
        var $ = this.$;
        var self = this;

        this.$container.find("[data-legacy-templates-on]").each(function (i, link) {
          var $link = $(link);

          if (self.hasTransactionalTemplates({ type: "legacy", templates: templates })) {
            $link.removeClass(Templates.legacyTemplatesHiddenClass);
          } else {
            $link.addClass(Templates.legacyTemplatesHiddenClass);
          }
        });
      }
    },
    revealLinksViaScopes: {
      value: function revealLinksViaScopes(scopes) {
        var $ = this.$;
        var self = this;

        this.$container.find("[data-scope]").each(function (i, link) {
          var $link = $(link);
          var scope = $link.data("scope");
          var teammatesIgnoreScope = !!$link.data("teammates-ignore-scope");

          if (teammatesIgnoreScope || self.hasScope(new RegExp(scope), scopes)) {
            $link.removeClass(Templates.scopeHiddenClass);
          } else {
            $link.addClass(Templates.scopeHiddenClass);
          }
        });

        this.$container.find("[data-scope-off]").each(function (i, link) {
          var $link = $(link);
          var scope = $link.data("scope-off");
          var teammatesIgnoreScope = !!$link.data("teammates-ignore-scope");

          if (teammatesIgnoreScope || !self.hasScope(new RegExp(scope), scopes)) {
            $link.removeClass(Templates.scopeHiddenClass);
          } else {
            $link.addClass(Templates.scopeHiddenClass);
          }
        });
      }
    },
    revealLinksViaEntitlement: {
      value: function revealLinksViaEntitlement(userEntitlements) {
        var $ = this.$;

        this.$container.find("[data-entitlements]").each(function (i, link) {
          var $link = $(link);
          var entitlements = $link.data("entitlements");
          var shouldReveal = false;

          $.each(entitlements, function (key, values) {
            if (userEntitlements[key] && values.includes(userEntitlements[key])) {
              shouldReveal = true;
            }
          });

          if (shouldReveal) {
            $link.removeClass(Templates.entitlementHiddenClass);
          } else {
            $link.addClass(Templates.entitlementHiddenClass);
          }
        });

        this.$container.find("[data-entitlements-off]").each(function (i, link) {
          var $link = $(link);
          var entitlements = $link.data("entitlements-off");
          var shouldHide = true;

          $.each(entitlements, function (key, values) {
            if (userEntitlements[key] && values.includes(userEntitlements[key])) {
              shouldHide = false;
            }
          });

          if (shouldHide) {
            $link.removeClass(Templates.entitlementHiddenClass);
          } else {
            $link.addClass(Templates.entitlementHiddenClass);
          }
        });
      }
    },
    revealMarketingNewLinks: {

      /**
       * IMPORTANT - PLEASE READ
       * This helper is meant to be invoked after `revealLinksViaScopes` and `revealLinksViaFeatureToggles`.
       * It is only to be used for *new* Marketing Campaigns (aka TNE) links
       * It will remove the "hidden" classes (scope-hidden and feature-toggle-hidden) if *any* of the following are true:
       *    1) the user has the 'marketing.read' scope
       * If the link includes 'ft-app' and 'ft-feature' data attrs, it is assumed that the specified feature toggle is required IN ADDITION
       *    to the 'marketing.read' scope
       * If the link includes ft-scope, it is assumed that the specified scope is required IN ADDTION
       *    to the 'marketing.read' scope
       *
       * PLEASE NOTE THIS IS A SPECIAL EXCEPTION TO SOME WELL DEFINED PATTERNS IN TIARA - IT SHOULD NOT BE REPLICATED
       */

      value: function revealMarketingNewLinks(scopes) {
        var $ = this.$;
        var self = this;

        this.$container.find("[data-marketing-new-link=\"true\"]").each(function (i, link) {
          var $link = $(link);
          var featureNameOff = $link.data("ft-feature-off");

          var userHasNewMCScope = self.hasScope(new RegExp("^marketing\\.read"), scopes);

          if (!featureNameOff && userHasNewMCScope) {
            $link.removeClass(Templates.featureToggleHiddenClass);
            $link.removeClass(Templates.scopeHiddenClass);
          }
        });
      }
    },
    revealIpsPageForSubusers: {

      // TODO: Remove this helper after new IPs pages are released and stable for
      // a month. This is used to show the IP Addresses nav item to subusers if
      // they have the ip_management feature toggle

      value: function revealIpsPageForSubusers(featureToggles) {
        var $ = this.$;
        var self = this;

        this.$container.find("[data-nav-title=\"ip addresses\"]").parent().each(function (i, link) {
          var $link = $(link);

          var userHasIpManagementFeatureToggle = self.hasFeatureEnabled("mako", "ip_management", featureToggles);

          if (userHasIpManagementFeatureToggle) {
            $link.removeClass(Templates.subuserHiddenClass);
            $link.removeAttr("data-subuser-restricted");
          }
        });
      }
    },
    revealAllLinks: {
      value: function revealAllLinks() {
        this.$container.find("[data-ft-app][data-ft-feature], [data-scope], [data-subuser-restricted]").each(function (i, link) {
          $(link).show();
        });
      }
    },
    disableLinksViaRegion: {

      // if the usage of a link is region dependent and disabled_region matches the user account_region:
      // applies disabled styling, removes link attrs, hides subpages, and appends region disabled badge

      value: function disableLinksViaRegion(region) {
        var $ = this.$;

        this.$container.find("[data-region-disabled]").each(function (i, li) {
          var $li = $(li);
          var disabledRegion = $li.data("region-disabled");
          if (region && disabledRegion.includes(region)) {
            var isPage = $li.attr("role") === "page";
            $li.addClass(Templates.regionDisabledClass);

            // guarantees that badge is only added if absolutely relevant
            var $regionBadge = $("<span class=\"region-disabled-label badge is-small steel\">\n          Disabled for EU users\n          <span data-tooltip=\"Switch to a non-EU subuser to use this feature.\" data-tooltip-pos=\"right\" data-tooltip-length=\"large\">\n            <i class=\"sg-icon sg-icon-info-circle small\"></i>\n          </span>\n        </span>");

            var $listLink = $li.find("a").first();
            $listLink.attr("aria-disabled", true);
            $listLink.removeAttr("href");
            $listLink.removeAttr("data-analytics-properties");
            $listLink.removeAttr("data-mako-route"); // mako links will still redirect otherwise

            // sub page links dont get the badge
            if (isPage) {
              $listLink.append($regionBadge);
            }

            $li.find("[role=subpages]").addClass("hidden");
            $li.find(".page-expand-icon").addClass("hidden");
          } else {
            // defaults to removing the class if region undefined or not a match
            $li.removeClass(Templates.regionDisabledClass);
          }
        });
      }
    },
    hasFeatureEnabled: {
      value: function hasFeatureEnabled(appName, featureName, featureToggles) {
        var featureTogglesLength = featureToggles.length;
        for (var i = 0; i < featureTogglesLength; i++) {
          var ftAppName = featureToggles[i].app_name;
          var ftFeatureName = featureToggles[i].feature_name;
          if (appName == ftAppName && featureName == ftFeatureName) {
            return true;
          }
        }
        return false;
      }
    },
    hasTransactionalTemplates: {
      value: function hasTransactionalTemplates(_ref) {
        var type = _ref.type;
        var templates = _ref.templates;

        if (!templates) {
          return false;
        }

        var templateType = templates.find(function (t) {
          return t.generation === type;
        });

        return !!templateType;
      }
    },
    hasScope: {
      value: function hasScope(scopeRegex, scopes) {
        if (!scopes || !scopeRegex) {
          return false;
        }
        var scopeLength = scopes.length;
        for (var i = 0; i < scopeLength; i++) {
          var scope = scopes[i];
          if (scope.match(scopeRegex)) {
            return true;
          }
        }
        return false;
      }
    },
    bindNav: {
      value: function bindNav() {
        var $ = this.$;
        var $pageLinks = this.$container.find("[role=page] > a");
        var $allSubpages = this.$container.find("[role=subpages]");
        var speed = "fast";

        $pageLinks.on("click", function (e) {
          var $parent = $(e.currentTarget).parent();
          var $subpages = $parent.find("[role=subpages]");

          if (!$parent.hasClass("region-disabled")) {
            if ($subpages.length > 0) {
              if ($subpages.is(":visible")) {
                // if the subpages are already visible, toggle it off
                $allSubpages.slideUp(speed);
                $parent.removeClass("is-active");
              } else {
                // if the subpages aren't visible, toggle it on
                $allSubpages.slideUp(speed);
                $subpages.slideDown(speed);
                $pageLinks.parent().removeClass("is-active");
                $parent.addClass("is-active");
              }
              e.preventDefault();
            } else {
              $pageLinks.parent().removeClass("is-active");
              $parent.addClass("is-active");
              $allSubpages.slideUp(speed);
            }
          } else {
            $parent.removeClass("is-active");
            $pageLinks.parent().removeClass("is-active");
            $allSubpages.slideUp(speed);
          }
        });
      }
    },
    bindAccount: {
      value: function bindAccount(logoutCallback) {
        var _this = this;

        var $ = this.$;

        $(document).on("click", function (event) {
          var $target = $(event.target);
          var $dropdowns = _this.$container.find("[data-dropdown-toggle]");

          // if a dropdown is already active, close all dropdown-menus
          if ($dropdowns.hasClass("is-active")) {
            // don't close when clicking a menu item like 'search'
            if ($target.closest("[data-dropdown-no-close]").length == 0) {
              $dropdowns.removeClass("is-active");
            }
          } else {
            // if they're clicking an inactive dropdown in tiara, open it
            if ($target.closest(_this.$container).length > 0) {
              $target.closest("[data-dropdown-toggle]").addClass("is-active");
            }
          }
        });

        this.$container.find("[data-account-toggle-submenu]").on("click", function () {
          _this.$container.find("[data-account-submenu=\"account\"]").toggleClass("is-active");
          _this.$container.find("[data-account-submenu=\"subusers\"]").toggleClass("is-active");
        });

        this.$container.find("[data-logout]").on("click", function () {
          logoutCallback(true);
        });
      }
    },
    showReputation: {
      value: function showReputation(reputation) {
        this.$container.find("[role=reputation]").text(reputation + "%");
        this.$container.find("[role=reputation-progress-bar]").addClass(this.barClass(reputation)).css("width", reputation + "%");
        this.$container.show();
      }
    },
    showCredits: {
      value: function showCredits(used, total, isUnverified) {
        var creditsPercentage = undefined,
            creditsTitle = undefined,
            creditsClass = undefined;
        if (total > 0) {
          // normal user
          // only show "per day" when user has 100 total credits
          var perDay = total === 100 ? " per day" : "";

          if (used > total) {
            // overage!
            creditsPercentage = 0;
            creditsTitle = "0 / " + this.prettyNumber(total) + "" + perDay + " (" + this.prettyNumber(used) + " total used)";
            creditsClass = "overage";
          } else {
            var remaining = total - used;
            creditsPercentage = 100 * remaining / total;
            creditsTitle = "" + this.prettyNumber(remaining) + " / " + this.prettyNumber(total) + "" + perDay;
          }
        } else {
          // unlimited user
          creditsPercentage = 100; // default to nice full bar
          creditsTitle = "";
        }

        var creditsFractionElement = this.$container[0].querySelector("[role='credits-fraction']");
        if (creditsFractionElement) {
          creditsFractionElement.textContent = creditsTitle;
          creditsFractionElement.classList.add(creditsClass);
        }
        this.$container.find("[role=credits-progress-bar]").addClass(this.barClass(creditsPercentage)).css("width", creditsPercentage + "%");

        // begin tooltip logic

        var tooltipTitle;
        if (isUnverified) {
          tooltipTitle = "You may only send up to 100 emails per day until you verify your account.";
        }

        if (tooltipTitle) {
          this.$container.find("[role=credits-tooltip-container]").attr("data-balloon", tooltipTitle).attr("data-balloon-pos", "right").attr("data-balloon-length", "large").removeClass("hidden");
        }
        this.$container.show();
      }
    },
    showUsage: {
      value: function showUsage(usage) {
        this.$container.find("[role=usage-metric]").text(this.prettyNumber(usage));
      }
    },
    showUsageLabels: {
      value: function showUsageLabels(frequency, mayHaveSubusers) {
        var usageTooltip = this.buildUsageTooltip(frequency, mayHaveSubusers);
        var usageLabel = this.buildUsageLabel(frequency);

        this.$container.find("[role=usage-details]").show();
        this.$container.find("[role=credits-reset-frequency-label]").text(usageLabel);
        this.$container.find("[role=credits-reset-frequency]").attr("data-tooltip", usageTooltip);
      }
    },
    showAccountUsageLink: {
      value: function showAccountUsageLink() {
        this.$container.find("[role=account-usage]").show();
        this.$container.find("[role=account-usage-link]").on("click", function () {
          if (window && window.SendGridTiara && window.SendGridTiara.trackWithUserInfo) {
            window.SendGridTiara.trackWithUserInfo("click_section_mail_sends");
          }
        });
      }
    },
    showAccount: {
      value: function showAccount(name) {
        if (name.trim()) {
          var container = document.querySelector("[data-account-name]");
          if (container) {
            container.textContent = name;
          }
        }
      }
    },
    hideTwilioSendgridBranding: {
      value: function hideTwilioSendgridBranding() {
        this.$container.find("[data-account-dropdown]").hide();
        this.$container.find(".pages").css("margin-top", "0");
      }
    },
    isPaymentDeclined: {
      value: function isPaymentDeclined(oesAccount) {
        if (!oesAccount || !oesAccount.entitlements) {
          return false;
        }
        var entitlements = oesAccount.entitlements;

        return entitlements.compat_payment_declined || false;
      }
    },
    buildUsageLabel: {

      // private

      value: function buildUsageLabel(frequency) {
        var usageLabel = "Emails this month";

        if (frequency === "daily") {
          usageLabel = "Emails today";
        } else {
          usageLabel = "Emails this month";
        }

        return usageLabel;
      }
    },
    buildUsageTooltip: {
      value: function buildUsageTooltip(frequency, mayHaveSubusers) {
        var usageTooltip = "The total number of requests ";

        if (mayHaveSubusers) {
          usageTooltip += "you and your subusers ";
        } else {
          usageTooltip += "you ";
        }

        if (frequency === "daily") {
          usageTooltip += "have made to send email today.";
        } else {
          usageTooltip += "have made to send email this month.";
        }

        return usageTooltip;
      }
    },
    barClass: {
      value: function barClass(percentage) {
        switch (true) {
          case percentage > 50:
            return "is-above-50";
          case percentage > 25:
            return "is-below-50";
          default:
            return "is-below-25";
        }
      }
    },
    prettyNumber: {
      value: function prettyNumber(num) {
        if (isNaN(num)) {
          return "N/A";
        } else {
          return this.abbrNum(num, 2);
        }
      }
    },
    abbrNum: {

      // from http://stackoverflow.com/a/2686098

      value: function abbrNum(number, decPlaces) {
        decPlaces = Math.pow(10, decPlaces);

        var abbrev = ["k", "m", "b", "t"];

        // Go through the array backwards, so we do the largest first
        for (var i = abbrev.length - 1; i >= 0; i--) {
          // Convert array index to "1000", "1000000", etc
          var size = Math.pow(10, (i + 1) * 3);

          // If the number is bigger or equal do the abbreviation
          if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;

            // Handle special case where we round up to the next abbreviation
            if (number == 1000 && i < abbrev.length - 1) {
              number = 1;
              i++;
            }

            // Add the letter for the abbreviation
            number += abbrev[i];

            // We are done... stop
            break;
          }
        }

        return number;
      }
    },
    activateNav: {
      value: function activateNav(path, $list) {
        var $ = this.$;
        var $matchingA = undefined,
            matchingHref = "";
        $list.find("a").each(function (index, a) {
          var href = a.pathname;
          // path starts with link's href
          if (path.indexOf(href) == 0) {
            // ignore any link that is hidden due to feature toggle being on/off,
            // otherwise check if link is more specific
            if ($(a).closest("li").css("display") !== "none" && href.length > matchingHref.length) {
              $matchingA = $(a);
              matchingHref = href;
            }
          }
        });

        if ($matchingA) {
          var $mainLink = $matchingA.parents(".page");
          var parentAlreadyExpanded = $mainLink.hasClass("is-active");

          // clear all 'active' subpages
          $list.find(".subpages li").removeClass("is-active");

          $matchingA.parent("li").addClass("is-active");

          // simulate a click if page isn't already expanded
          if (!parentAlreadyExpanded) {
            // simulate opening subpages by clicking main link
            $mainLink.find("a:first").trigger("click");
          }
        }
      }
    },
    adaptSubuserCursorData: {
      value: function adaptSubuserCursorData(data, dataType) {
        var parsedData = JSON.parse(data);
        return JSON.stringify({
          has_restricted_subuser_access: false,
          subuser_access: parsedData.subusers,
          _metadata: parsedData._metadata });
      }
    }
  });

  return Helpers;
})();

},{"./templates":8}],7:[function(require,module,exports){
// sidebar svgs
"use strict";

var dashboardSvg = require("../style-guide/app/img/icons/sidebar/dashboard.svg");
// see ../style-guide-debt for marketingLegacy/New icons
// TODO: after bumping style-guide, we'll need to replace these icons and badge styles
var designLibrarySvg = require("../style-guide-debt/app/img/icons/sidebar/design-library.svg");
var marketingLegacySvg = require("../style-guide-debt/app/img/icons/sidebar/marketing-legacy.svg");
var marketingNewSvg = require("../style-guide-debt/app/img/icons/sidebar/marketing-new.svg");
var statsSvg = require("../style-guide/app/img/icons/sidebar/stats.svg");
var activitySvg = require("../style-guide/app/img/icons/sidebar/activity.svg");
// see ../style-guide-debt/README.md validation icon
// TODO: after bumping style-guide, we'll need to replace this icon and badge styles
var validationSvg = require("../style-guide-debt/app/img/icons/sidebar/validation.svg");
var reportsSvg = require("../style-guide/app/img/icons/sidebar/reports.svg");
var settingsSvg = require("../style-guide/app/img/icons/sidebar/settings.svg");
var adsSvg = require("../style-guide/app/img/icons/sidebar/ads.svg");
var emailApiSvg = require("../style-guide-debt/app/img/icons/sidebar/api.svg");

var leftSideNavigation = "left side navigation";
var linkElementType = "link";
var accordionToggleElement = "accordion toggle";
var marketingLegacySection = function (hasBadge) {
  return hasBadge ? "marketing legacy with badge" : "marketing legacy without badge";
};
var marketingNewSection = "marketing new";
var emailApiSection = "email api";
var statsSection = "stats";
var suppressionsSection = "suppressions";
var settingsSection = "settings";

function marketingLegacySubpages(nlvxHost, sgHost, hasBadge) {
  return [{
    title: "Tour",
    href: "" + nlvxHost + "/ui/tour",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "tour nav clicked",
    analytics_elementType: linkElementType }, {
    title: "Overview",
    href: "" + nlvxHost + "/ui/overview",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "overview nav clicked",
    analytics_elementType: linkElementType }, {
    title: "Campaigns",
    href: "" + nlvxHost + "/ui/campaigns",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "campaigns nav clicked",
    analytics_elementType: linkElementType }, {
    title: "Contacts",
    href: "" + nlvxHost + "/ui/contacts",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "contacts nav clicked",
    analytics_elementType: linkElementType }, {
    title: "Custom Fields",
    href: "" + nlvxHost + "/ui/custom_fields",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "custom fields nav clicked",
    analytics_elementType: linkElementType }, {
    title: "Templates",
    href: "" + nlvxHost + "/ui/marketing_templates",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "templates nav clicked",
    analytics_elementType: linkElementType }, {
    title: "Senders",
    href: "" + nlvxHost + "/ui/senders",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "senders nav clicked",
    analytics_elementType: linkElementType }, {
    title: "Notifications",
    href: "" + nlvxHost + "/ui/notifications",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "notifications nav clicked",
    analytics_elementType: linkElementType }, {
    title: "Unsubscribe Groups",
    href: "" + nlvxHost + "/ui/unsubscribe-groups",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "unsubscribe groups nav clicked",
    analytics_elementType: linkElementType }, {
    title: "User Guide",
    href: "" + sgHost + "/docs/User_Guide/Marketing_Campaigns/index.html",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "user guide nav clicked",
    analytics_elementType: linkElementType }];
}

// New legacy nav bar menu for NLVX migrated users
function marketingNlvxMigratedSubpages(mcAutoHost, sgHost, hasBadge) {
  return [{
    title: "Single Sends",
    href: "" + mcAutoHost + "/legacy/single-sends",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "campaigns nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Contacts",
    href: "" + mcAutoHost + "/legacy/contacts",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "contacts nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Custom Fields",
    href: "" + mcAutoHost + "/legacy/custom-fields",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "custom fields nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Templates",
    href: "" + mcAutoHost + "/legacy/templates",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "templates nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Senders",
    href: "" + mcAutoHost + "/legacy/senders",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "senders nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Notifications",
    href: "" + mcAutoHost + "/legacy/notifications",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "notifications nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Unsubscribe Groups",
    href: "" + mcAutoHost + "/legacy/unsubscribe-groups",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "unsubscribe groups nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "User Guide",
    href: "" + sgHost + "/docs/User_Guide/Marketing_Campaigns/index.html",
    analytics_location: leftSideNavigation,
    analytics_section: marketingLegacySection(hasBadge),
    analytics_event: "user guide nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }];
}

function marketingNewSubpages(mcAutoHost, sgHost) {
  return [{
    title: "Automations",
    href: "" + mcAutoHost + "/automations",
    analytics_location: leftSideNavigation,
    analytics_section: marketingNewSection,
    analytics_event: "automations nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Single Sends",
    href: "" + mcAutoHost + "/single-sends",
    analytics_location: leftSideNavigation,
    analytics_section: marketingNewSection,
    analytics_event: "single sends nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Ad Campaigns",
    href: "" + mcAutoHost + "/ads",
    feature_toggle: ["tiara", "ads_tne"],
    analytics_location: leftSideNavigation,
    analytics_section: marketingNewSection,
    analytics_event: "ad campaigns nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Contacts",
    href: "" + mcAutoHost + "/contacts",
    analytics_location: leftSideNavigation,
    analytics_section: marketingNewSection,
    analytics_event: "contacts nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Custom Fields",
    href: "" + mcAutoHost + "/custom-fields",
    feature_toggle: ["mc", "custom_fields"],
    analytics_location: leftSideNavigation,
    analytics_section: marketingNewSection,
    analytics_event: "custom fields nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Signup Forms",
    href: "" + mcAutoHost + "/forms/signup",
    analytics_location: leftSideNavigation,
    analytics_section: marketingNewSection,
    analytics_event: "signup forms nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Senders",
    href: "" + mcAutoHost + "/senders",
    analytics_location: leftSideNavigation,
    analytics_section: marketingNewSection,
    analytics_event: "senders nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Notifications",
    href: "" + mcAutoHost + "/notifications",
    analytics_location: leftSideNavigation,
    analytics_section: marketingNewSection,
    analytics_event: "notifications nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Unsubscribe Groups",
    href: "" + mcAutoHost + "/unsubscribe-groups",
    analytics_location: leftSideNavigation,
    analytics_section: marketingNewSection,
    analytics_event: "unsubscribe groups nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Integrations",
    href: "" + mcAutoHost + "/integrations",
    analytics_location: leftSideNavigation,
    analytics_section: marketingNewSection,
    analytics_event: "integrations nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }, {
    title: "Migration Guide",
    href: "" + sgHost + "/docs/ui/sending-email/migrating-from-legacy-marketing-campaigns/",
    scope: "^marketing_campaigns\\.read",
    analytics_location: leftSideNavigation,
    analytics_section: marketingNewSection,
    analytics_event: "migration guide nav clicked",
    analytics_elementType: linkElementType,
    role: "tne" }];
}

module.exports = {
  leftSideNavigation: leftSideNavigation,
  getPageData: function getPageData(params) {
    var makoHost = params.makoHost;
    var nlvxHost = params.nlvxHost;
    var sgHost = params.sgHost;
    var labsUrl = params.labsUrl;
    var mcAutoHost = params.mcAutoHost;

    return [{
      title: "Dashboard",
      img: dashboardSvg,
      href: makoHost,
      mako_route: "/",
      analytics_location: leftSideNavigation,
      analytics_event: "dashboard nav clicked",
      analytics_elementType: linkElementType }, {
      title: "Email API",
      analytics_location: leftSideNavigation,
      analytics_event: "email api section toggled",
      analytics_elementType: accordionToggleElement,
      img: emailApiSvg,
      subpages: [{
        title: "Dynamic Templates",
        href: "" + mcAutoHost + "/dynamic-templates",
        analytics_location: leftSideNavigation,
        analytics_section: emailApiSection,
        analytics_event: "dynamic templates nav clicked",
        analytics_elementType: linkElementType,
        role: "tne" }, {
        title: "Legacy Templates",
        href: "" + sgHost + "/templates",
        analytics_location: leftSideNavigation,
        analytics_section: emailApiSection,
        analytics_event: "legacy templates nav clicked",
        analytics_elementType: linkElementType,
        feature_toggle: ["nlvx", "tite-beta-1"],
        has_transactional_templates: { legacy: true } }, {
        title: "Integration Guide",
        href: "" + makoHost + "/guide/integrate",
        analytics_location: leftSideNavigation,
        analytics_section: emailApiSection,
        analytics_event: "integration guide nav clicked",
        analytics_elementType: linkElementType }] }, {
      title: "Marketing",
      analytics_location: leftSideNavigation,
      analytics_event: "marketing new section toggled",
      analytics_elementType: accordionToggleElement,
      img: marketingNewSvg,
      href: "" + mcAutoHost,
      scope: "^marketing\\.read",
      new_marketing_link: true,
      region_disabled: ["eu"],
      subpages: marketingNewSubpages(mcAutoHost, sgHost),
      role: "tne" }, {
      title: "Marketing",
      analytics_location: leftSideNavigation,
      analytics_event: "marketing upgrade clicked",
      analytics_elementType: linkElementType,
      img: marketingNewSvg,
      href: "" + makoHost + "/account/products",
      // Once user is put on a "mc_end_of_trial" offering, it will remove user's "marketing.read" scope.
      // It also add "mc_end_of_trial: true" entitlement so that the access to Marketing menu is removed
      // and user is directed to product upgrade page to purchase the Marketing add-on.
      entitlements: { mc_end_of_trial: [true] },
      new_marketing_link: true,
      role: "tne" }, {
      title: "Marketing <span class='mc-legacy-badge badge steel is-small is-subtle'>Legacy</span>",
      img: marketingLegacySvg,
      href: "" + mcAutoHost,
      scope: "^marketing_campaigns\\.read",
      entitlements: { mc_nlvx_data_migration_state: [2, 4] },
      region_disabled: ["eu"],
      subpages: marketingNlvxMigratedSubpages(mcAutoHost, sgHost, true),
      analytics_location: leftSideNavigation,
      analytics_event: "marketing legacy with badge section toggled",
      analytics_elementType: accordionToggleElement,
      role: "tne" }, {
      title: "Marketing <span class='mc-legacy-badge badge steel is-small is-subtle'>Legacy</span>",
      img: marketingLegacySvg,
      scope: "^marketing_campaigns\\.read",
      entitlements_off: { mc_nlvx_data_migration_state: [2, 4] },
      region_disabled: ["eu"],
      subpages: marketingLegacySubpages(nlvxHost, sgHost, true),
      analytics_location: leftSideNavigation,
      analytics_event: "marketing legacy with badge section toggled",
      analytics_elementType: accordionToggleElement }, {
      title: "Design Library",
      img: designLibrarySvg,
      href: "" + mcAutoHost + "/design-library/your-designs",
      analytics_location: leftSideNavigation,
      scope: "^design_library\\.read",
      analytics_event: "design library nav clicked",
      analytics_elementType: linkElementType,
      role: "tne" }, {
      title: "Ads <span class='badge is-beta is-small ads-beta-badge is-subtle'>Beta</span>",
      img: adsSvg,
      href: "" + labsUrl + "/grow",
      feature_toggle: ["tiara", "ads"],
      role: "ads",
      analytics_location: leftSideNavigation,
      analytics_event: "ads nav clicked",
      analytics_elementType: linkElementType }, {
      title: "Stats",
      img: statsSvg,
      analytics_location: leftSideNavigation,
      analytics_event: "stats section toggled",
      analytics_elementType: accordionToggleElement,
      subpages: [{
        title: "Overview",
        href: "" + makoHost + "/statistics",
        mako_route: "statistics",
        scope: "^stats\\.read",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "overview nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Expert Insights",
        href: "" + makoHost + "/expert_insights",
        mako_route: "expert_insights",
        reseller_restricted: true,
        scope: "^messages\\.read",
        teammates_ignore_scope: false,
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "expert insights nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Deliverability Insights",
        href: "" + makoHost + "/email_insights/deliverability/overview",
        mako_route: "email_insights/deliverability/overview",
        scope: "^stats\\.read",
        teammates_ignore_scope: false,
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "deliverability insights nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Global Stats",
        href: "" + makoHost + "/statistics/global",
        mako_route: "statistics/global",
        scope: "^stats\\.global\\.read",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "global stats nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Category Stats",
        href: "" + makoHost + "/statistics/category",
        mako_route: "statistics/category",
        scope: "^categories\\.stats\\.read",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "category stats nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Category Comparison",
        href: "" + makoHost + "/statistics/category/compare",
        mako_route: "statistics/category/compare",
        scope: "^categories\\.stats\\.read",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "category comparison nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Subuser Stats",
        href: "" + makoHost + "/statistics/subuser",
        mako_route: "statistics/subuser",
        scope: "^subusers\\.stats\\.",
        teammates_ignore_scope: true,
        subuser_restricted: true,
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "subuser stats nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Subuser Comparison",
        href: "" + makoHost + "/statistics/subuser/compare",
        mako_route: "statistics/subuser/compare",
        scope: "^subusers\\.stats\\.",
        teammates_ignore_scope: true,
        subuser_restricted: true,
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "subuser comparison nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Geographical",
        href: "" + makoHost + "/statistics/geo",
        mako_route: "statistics/geo",
        scope: "^geo\\.stats\\.read",
        teammates_ignore_scope: true,
        region_disabled: ["eu"],
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "geographical nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Email Clients & Devices",
        href: "" + makoHost + "/statistics/device",
        mako_route: "statistics/device",
        scope: "^clients\\.stats\\.read|^devices\\.stats\\.read",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "email clients & devices nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Mailbox Provider Stats",
        href: "" + makoHost + "/statistics/mailbox_provider",
        mako_route: "statistics/mailbox_provider",
        scope: "^mailbox_providers\\.stats\\.read",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "mailbox provider stats nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Mailbox Provider Comparison",
        href: "" + makoHost + "/statistics/mailbox_provider/compare",
        mako_route: "statistics/mailbox_provider/compare",
        scope: "^mailbox_providers\\.stats\\.read",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "mailbox provider comparison nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Browser Stats",
        href: "" + makoHost + "/statistics/browser",
        mako_route: "statistics/browser",
        scope: "^clients\\.stats\\.read",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "browser stats nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Browser Comparison",
        href: "" + makoHost + "/statistics/browser/compare",
        mako_route: "statistics/browser/compare",
        scope: "^clients\\.stats\\.read",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "browser comparison nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Parse Webhook",
        href: "" + makoHost + "/statistics/parse_webhook",
        mako_route: "statistics/parse_webhook",
        scope: "^user\\.webhooks\\.parse\\.settings\\.read",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: statsSection,
        analytics_event: "parse webhook nav clicked",
        analytics_elementType: linkElementType }] },
    // there are two Activity items here
    // the first is the old behaviour before Email Logs where there are no subitems
    // the second is the new behaviour where Email Logs is a subitem along with Email Activity
    // in this case, the main Activity sidebar link cannot have links
    // hence the missing mako_route and href properties with feature_toggle set
    {
      title: "Activity",
      img: activitySvg,
      href: "" + makoHost + "/email_activity",
      mako_route: "email_activity",
      scope: "^email_activity\\.read$",
      feature_toggle_off: ["mako", "email_logs"],
      teammates_ignore_scope: true,
      region_disabled: ["eu"],
      analytics_location: leftSideNavigation,
      analytics_event: "activity nav clicked",
      analytics_elementType: linkElementType }, {
      title: "Activity",
      img: activitySvg,
      scope: "^email_activity\\.read$",
      feature_toggle: ["mako", "email_logs"],
      teammates_ignore_scope: true,
      analytics_location: leftSideNavigation,
      analytics_event: "activity nav clicked",
      analytics_elementType: linkElementType,
      subpages: [{
        title: "Email Logs",
        href: "" + makoHost + "/email_logs",
        mako_route: "email_logs" }, {
        title: "Activity Feed",
        region_disabled: ["eu"],
        href: "" + makoHost + "/email_activity",
        mako_route: "email_activity" }] }, {
      title: "Validation",
      img: validationSvg,
      href: "" + makoHost + "/email_validation",
      feature_toggle: ["mako", "email_validation"],
      region_disabled: ["eu"],
      mako_route: "email_validation",
      entitlements: { email_validation_available_in_catalog: [true] },
      reseller_restricted: true,
      analytics_location: leftSideNavigation,
      analytics_event: "validation nav clicked",
      analytics_elementType: linkElementType }, {
      title: "Suppressions",
      img: reportsSvg,
      analytics_location: leftSideNavigation,
      analytics_event: "suppressions section toggled",
      analytics_elementType: accordionToggleElement,
      scope: "^suppression\\.read$|^asm\\.groups\\.read$",
      teammates_ignore_scope: true,
      subpages: [{
        title: "Global Unsubscribes",
        href: "" + makoHost + "/suppressions/global_unsubscribes",
        mako_route: "suppressions/global_unsubscribes",
        scope: "^suppression\\.read$",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: suppressionsSection,
        analytics_event: "global unsubscribes nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Group Unsubscribes",
        href: "" + makoHost + "/suppressions/group_unsubscribes",
        mako_route: "suppressions/group_unsubscribes",
        scope: "^suppression\\.read$",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: suppressionsSection,
        analytics_event: "group unsubscribes nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Bounces",
        href: "" + makoHost + "/suppressions/bounces",
        mako_route: "suppressions/bounces",
        scope: "^suppression\\.read$",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: suppressionsSection,
        analytics_event: "bounces nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Spam Reports",
        href: "" + makoHost + "/suppressions/spam_reports",
        mako_route: "suppressions/spam_reports",
        scope: "^suppression\\.read$",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: suppressionsSection,
        analytics_event: "spam reports nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Blocks",
        href: "" + makoHost + "/suppressions/blocks",
        mako_route: "suppressions/blocks",
        scope: "^suppression\\.read$",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: suppressionsSection,
        analytics_event: "blocks nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Invalid",
        href: "" + makoHost + "/suppressions/invalid_emails",
        mako_route: "suppressions/invalid_emails",
        scope: "^suppression\\.read$",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: suppressionsSection,
        analytics_event: "invalid nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Unsubscribe Groups",
        href: "" + makoHost + "/suppressions/advanced_suppression_manager",
        mako_route: "suppressions/advanced_suppression_manager",
        scope: "^asm\\.groups\\.read$",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: suppressionsSection,
        analytics_event: "unsubscribe groups nav clicked",
        analytics_elementType: linkElementType }] }, {
      title: "Settings",
      img: settingsSvg,
      analytics_location: leftSideNavigation,
      analytics_event: "settings section toggled",
      analytics_elementType: accordionToggleElement,
      subpages: [{
        title: "Account Details",
        href: "" + makoHost + "/account/details",
        analytics_location: leftSideNavigation,
        analytics_section: settingsSection,
        analytics_event: "account details nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Alert Settings",
        href: "" + makoHost + "/settings/alerts",
        mako_route: "settings/alerts",
        scope: "^alerts\\.read$",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: settingsSection,
        analytics_event: "alert settings nav clicked",
        analytics_elementType: linkElementType }, {
        title: "API Keys",
        href: "" + makoHost + "/settings/api_keys",
        mako_route: "settings/api_keys",
        scope: "^api_keys\\.read",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: settingsSection,
        analytics_event: "api keys nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Data Residency - EU",
        href: "" + makoHost + "/settings/data_residency/setup/eu",
        mako_route: "settings/data_residency/setup/eu",
        feature_toggle: ["mako", "data_residency_setup"],
        analytics_location: leftSideNavigation,
        analytics_section: settingsSection,
        analytics_event: "eu data residency setup nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Inbound Parse",
        href: "" + makoHost + "/settings/parse",
        mako_route: "settings/parse",
        scope: "^user\\.webhooks\\.parse\\.settings\\.read",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: settingsSection,
        analytics_event: "inbound parse nav clicked",
        analytics_elementType: linkElementType }, {
        title: "IP Access Management",
        href: "" + makoHost + "/settings/access",
        mako_route: "settings/access",
        feature_toggle: ["mako", "ip_access_mgmt"],
        analytics_location: leftSideNavigation,
        analytics_section: settingsSection,
        analytics_event: "ip access management nav clicked",
        analytics_elementType: linkElementType }, {
        title: "IP Addresses",
        href: "" + makoHost + "/settings/ip_addresses",
        mako_route: "settings/ip_addresses",
        scope: "^ips\\.read$",
        teammates_ignore_scope: true,
        // TODO: remove subuser_restricted attribute after new
        // IPs pages are released and stable for a month
        subuser_restricted: true,
        feature_toggle: ["mako", "ips_self_service"],
        analytics_location: leftSideNavigation,
        analytics_section: settingsSection,
        analytics_event: "ip addresses nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Mail Settings",
        href: "" + makoHost + "/settings/mail_settings",
        mako_route: "settings/mail_settings",
        scope: "^mail_settings\\.read$",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: settingsSection,
        analytics_event: "mail settings nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Sender Authentication",
        href: "" + makoHost + "/settings/sender_auth",
        mako_route: "settings/sender_auth",
        scope: "^whitelabel\\.read$",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: settingsSection,
        analytics_event: "sender authentication nav clicked",
        analytics_elementType: linkElementType }, {
        title: "SSO Settings",
        href: "" + makoHost + "/settings/sso",
        mako_route: "settings/sso",
        scope: "^sso\\.settings\\.read",
        subuser_restricted: true,
        analytics_location: leftSideNavigation,
        analytics_section: settingsSection,
        analytics_event: "sso nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Subuser Management",
        href: "" + makoHost + "/settings/subusers",
        mako_route: "settings/subusers",
        scope: "^subusers\\.read$",
        teammates_ignore_scope: true,
        subuser_restricted: true,
        analytics_location: leftSideNavigation,
        analytics_section: settingsSection,
        analytics_event: "subuser management nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Teammates",
        href: "" + makoHost + "/settings/teammates",
        mako_route: "settings/teammates",
        scope: "^teammates\\.",
        role: "teammates",
        analytics_location: leftSideNavigation,
        analytics_section: settingsSection,
        analytics_event: "teammates nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Tracking",
        href: "" + makoHost + "/settings/tracking",
        mako_route: "settings/tracking",
        scope: "^tracking_settings\\.read$",
        teammates_ignore_scope: true,
        analytics_location: leftSideNavigation,
        analytics_section: settingsSection,
        analytics_event: "tracking nav clicked",
        analytics_elementType: linkElementType }, {
        title: "Two-Factor Authentication",
        href: "" + makoHost + "/settings/auth",
        mako_route: "settings/auth",
        scope: "^user\\.multifactor_authentication\\.",
        role: "two_factor_auth",
        analytics_location: leftSideNavigation,
        analytics_section: settingsSection,
        analytics_event: "two-factor authentication nav clicked",
        analytics_elementType: linkElementType }] }];
  } };

},{"../style-guide-debt/app/img/icons/sidebar/api.svg":386,"../style-guide-debt/app/img/icons/sidebar/design-library.svg":387,"../style-guide-debt/app/img/icons/sidebar/marketing-legacy.svg":388,"../style-guide-debt/app/img/icons/sidebar/marketing-new.svg":389,"../style-guide-debt/app/img/icons/sidebar/validation.svg":390,"../style-guide/app/img/icons/sidebar/activity.svg":397,"../style-guide/app/img/icons/sidebar/ads.svg":398,"../style-guide/app/img/icons/sidebar/dashboard.svg":399,"../style-guide/app/img/icons/sidebar/reports.svg":400,"../style-guide/app/img/icons/sidebar/settings.svg":401,"../style-guide/app/img/icons/sidebar/stats.svg":402}],8:[function(require,module,exports){
"use strict";

var Pages = require("./pages.js");
var logoSvg = require("../style-guide/app/img/logo-tiara.svg");
var TwilioPasteArrowBack = require("../style-guide-debt/app/img/icons/twilio-paste/ArrowBack.svg");
var TwilioPasteUser = require("../style-guide-debt/app/img/icons/twilio-paste/User.svg");
var ExternalLink = require("../style-guide-debt/app/img/icons/twilio-paste/LinkExternal.svg");

var nameDropdownText = "name dropdown";
var leftSideNavigation = Pages.leftSideNavigation;

module.exports = {
  sidebarHtml: function sidebarHtml(params) {
    var html = "\n    <nav data-tiara-nav=\"true\" data-tiara-generated=\"true\" class=\"navbar\">\n      <div role=\"show-after-fetched\" style=\"display: none\">\n        " + this.account(params.makoHost, params.unifiedUserInfo, params.impersonating) + "\n        " + this.pages(params) + "\n        " + this.stats(params.makoHost) + "\n        " + this.modals() + "\n      </div>\n    </nav>";
    return html;
  },
  // private

  account: function account(makoHost, unifiedUserInfo, impersonating) {
    // this html is also dynamically modified by deferred_handlers:handleSubuserImpersonation, ensure any changes are
    // still compatible with that code
    return "<div data-account-dropdown class=\"account dropdown\" data-dropdown-toggle=\"true\">\n      <div class=\"account-title\">\n        <div class=\"account-logo\" style=\"top: -8px; left: -5px\">" + logoSvg + "</div>\n        <span class=\"account-name\" data-account-name=\"name\"\n          data-events-to-track='click'\n          data-analytics-properties='{\"page\": \"" + leftSideNavigation + "\", \"elementType\": \"dropdown toggle\", \"eventName\": \"name dropdown clicked\"}'\n        >&nbsp;</span>\n        <div class=\"account-name-fader\"></div>\n        <span data-account-dropdown-icon class=\"account-expand-icon\">\n          <i class=\"sg-icon sg-icon-caret\"></i>\n        </span>\n      </div>\n\n      <div class=\"dropdown-menu dropdown-menu-account\" data-dropdown-menu=\"true\">\n        <ul class=\"account-submenu is-active\" data-account-submenu=\"account\">\n          " + (!unifiedUserInfo || impersonating ? "\n          <li>\n            <a class=\"dropdown-link\"\n              href=\"" + makoHost + "/account/details\"\n              data-account-details='top'\n              data-events-to-track='click'\n              data-analytics-properties='{\"page\": \"" + leftSideNavigation + "\", \"section\": \"" + nameDropdownText + "\", \"elementType\": \"link\", \"eventName\": \"account details nav clicked\"}'\n            >\n              Account Details\n            </a>\n          </li>\n          <li>\n            <a class=\"dropdown-link\"\n              href=\"" + makoHost + "/guide\"\n              data-mako-route=\"guide\"\n              data-events-to-track='click'\n              data-analytics-properties='{\"page\": \"" + leftSideNavigation + "\", \"section\": \"" + nameDropdownText + "\", \"elementType\": \"link\", \"eventName\": \"setup guide nav clicked\"}'\n            >\n              Setup Guide\n            </a>\n          </li>\n          <li>\n            <a class=\"dropdown-link\"\n              target=\"_blank\"\n              href=\"https://support.sendgrid.com/hc/en-us\"\n              data-events-to-track='click'\n              data-analytics-properties='{\"page\": \"" + leftSideNavigation + "\", \"section\": \"" + nameDropdownText + "\", \"elementType\": \"link\", \"eventName\": \"support nav clicked\"}'\n            >\n              Help &amp; Support\n            </a>\n          </li>\n          " : "") + "\n          <li data-account-subuser-access=\"true\" style=\"display: none\">\n            <a class=\"dropdown-link\" style=\"display: inline-flex; align-items: center;\"\n              href=\"" + makoHost + "/subuser/access?redirect_to=" + encodeURIComponent(window.location.href) + "\"\n              data-events-to-track='click'\n              data-analytics-properties='{\"page\": \"" + leftSideNavigation + "\", \"section\": \"" + nameDropdownText + "\", \"elementType\": \"link\", \"eventName\": \"change account nav clicked\"}'\n            >Change Account<span style=\"width: 20px; height: 20px;\">" + ExternalLink + "</span></a>\n            <div style=\"margin-left: 15px;\" data-account-subusers=\"true\">\n            </div>\n          </li>\n          " + (!unifiedUserInfo || impersonating ? "\n          <li data-logout=\"logout\">\n          <a class=\"dropdown-link\"\n            data-events-to-track='click'\n            data-analytics-properties='{\"page\": \"" + leftSideNavigation + "\", \"section\": \"" + nameDropdownText + "\", \"elementType\": \"link\", \"eventName\": \"sign out nav clicked\"}'\n          >\n            Sign Out of Account\n          </a>\n        </li>\n          " : "") + "\n        </ul>\n      </div>\n    </div>";
  },

  pages: (function (_pages) {
    var _pagesWrapper = function pages(_x) {
      return _pages.apply(this, arguments);
    };

    _pagesWrapper.toString = function () {
      return _pages.toString();
    };

    return _pagesWrapper;
  })(function (params) {
    var html = "<ul class=\"pages\">";
    var pages = Pages.getPageData(params);

    var pagesLength = pages.length;
    for (var i = 0; i < pagesLength; i++) {
      html += this.pageHtml(pages[i]);
    }
    return html + "</ul>";
  }),

  pageHtml: function pageHtml(page) {
    var liClass = "";
    var featureToggleAttributes = this.getFeatureToggleAttributes(page);
    var scopeAttributes = this.getScopeAttributes(page);
    var entitlementsAttributes = this.getEntitlementsAttributes(page);
    var regionalAttributes = this.getRegionalAttributes(page);
    var overrideAttributes = this.getOverrideAttributes(page);
    var expandIcon = "";
    if (featureToggleAttributes) {
      liClass += " " + this.featureToggleHiddenClass;
    }
    if (scopeAttributes) {
      liClass += " " + this.scopeHiddenClass;
    }
    if (entitlementsAttributes) {
      liClass += " " + this.entitlementHiddenClass;
    }
    if (regionalAttributes) {
      liClass += " " + this.regionDisabledClass;
    }
    if (page.subpages) {
      expandIcon = "<span class=\"page-expand-icon\">\n        <i class=\"sg-icon sg-icon-caret\"></i>\n      </span>";
    }

    return "<li " + featureToggleAttributes + " " + scopeAttributes + " " + entitlementsAttributes + " " + regionalAttributes + " " + overrideAttributes + " role=\"page\" class=\"page " + liClass + "\">\n      " + this.aTagStartHtml(page) + "\n        <div class=\"page-icon\">\n          " + page.img + "\n        </div>\n        <span class=\"page-title\">\n          " + page.title + "\n        </span>\n        " + expandIcon + "\n      </a>\n      " + this.subpagesHtml(page.subpages) + "\n    </li>";
  },

  subpagesHtml: function subpagesHtml(subpages) {
    if (!subpages) {
      return "";
    }

    var html = "<ul role=\"subpages\" class=\"subpages\">";
    var subpagesLength = subpages.length;
    for (var i = 0; i < subpagesLength; i++) {
      html += this.subpageHtml(subpages[i]);
    }
    return html + "</ul>";
  },

  subpageHtml: function subpageHtml(subpage) {
    var html = undefined;
    var featureToggleAttributes = this.getFeatureToggleAttributes(subpage);
    var scopeAttributes = this.getScopeAttributes(subpage);
    var overrideAttributes = this.getOverrideAttributes(subpage);
    var regionalAttributes = this.getRegionalAttributes(subpage);
    var subuserRestrictedAttributes = this.getSubuserRestrictedAttributes(subpage);
    var transactionalTemplateAttributes = this.getTransactionalTemplateAttributes(subpage);
    var resellerAttributes = this.getResellerAttributes(subpage);

    var classes = "subpage";
    if (featureToggleAttributes) {
      classes += " " + this.featureToggleHiddenClass;
    }
    if (scopeAttributes) {
      classes += " " + this.scopeHiddenClass;
    }
    if (subuserRestrictedAttributes) {
      classes += " " + this.subuserHiddenClass;
    }
    if (transactionalTemplateAttributes) {
      classes += " " + this.legacyTemplatesHiddenClass;
    }
    if (regionalAttributes) {
      classes += " " + this.regionDisabledClass;
    }

    var spanClasses = "subpage-title";
    if (subpage.is_indented) {
      spanClasses += " is-indented";
    }

    html = "<li " + featureToggleAttributes + " " + scopeAttributes + " " + subuserRestrictedAttributes + " " + transactionalTemplateAttributes + " " + overrideAttributes + " " + regionalAttributes + " " + resellerAttributes + " class=\"" + classes + "\">\n      " + this.aTagStartHtml(subpage, true) + "\n        <span class=\"" + spanClasses + "\">\n          " + subpage.title + "\n        </span>\n      </a>";
    return html + "</li>";
  },

  getResellerAttributes: function getResellerAttributes(page) {
    if (page.reseller_restricted) {
      return "data-reseller-restricted=true";
    }

    return "";
  },

  getFeatureToggleAttributes: function getFeatureToggleAttributes(page) {
    if (page.feature_toggle) {
      return "data-ft-app=\"" + page.feature_toggle[0] + "\" data-ft-feature=\"" + page.feature_toggle[1] + "\"";
    }
    if (page.feature_toggle_off) {
      return "data-ft-app=\"" + page.feature_toggle_off[0] + "\" data-ft-feature-off=\"" + page.feature_toggle_off[1] + "\"";
    }
    return "";
  },

  getTransactionalTemplateAttributes: function getTransactionalTemplateAttributes(page) {
    if (page.has_transactional_templates) {
      var _page$has_transactional_templates = page.has_transactional_templates;
      var _page$has_transactional_templates$legacy = _page$has_transactional_templates.legacy;
      var hasLegacy = _page$has_transactional_templates$legacy === undefined ? false : _page$has_transactional_templates$legacy;
      var _page$has_transactional_templates$dynamic = _page$has_transactional_templates.dynamic;
      var hasDynamic = _page$has_transactional_templates$dynamic === undefined ? false : _page$has_transactional_templates$dynamic;

      return "data-legacy-templates-on=\"" + hasLegacy + "\" data-legacy-templates-off=\"" + !hasLegacy + "\" data-dynamic-templates-on=\"" + hasDynamic + "\" data-dynamic-templates-off=\"" + !hasDynamic + "\"";
    }
    return "";
  },

  getScopeAttributes: function getScopeAttributes(page) {
    var result = "";
    if (page.scope) {
      result += "data-scope=\"" + page.scope + "\" ";
    }

    if (page.scope_off) {
      result += "data-scope-off=\"" + page.scope_off + "\"";
    }
    // if teammates_ignore_scope is set to true, teammates can request access
    // if teammates_ignore_scope is set to false or not included, user must have required scopes to see feature
    if (page.teammates_ignore_scope) {
      result += "data-teammates-ignore-scope=\"" + page.teammates_ignore_scope + "\" ";
    }
    return result;
  },

  getEntitlementsAttributes: function getEntitlementsAttributes(page) {
    var result = "";
    if (page.entitlements) {
      var entitlementsString = JSON.stringify(page.entitlements);
      result += "data-entitlements='" + entitlementsString + "' ";
    }

    if (page.entitlements_off) {
      var entitlementsString = JSON.stringify(page.entitlements_off);
      result += "data-entitlements-off='" + entitlementsString + "' ";
    }

    return result;
  },

  getRegionalAttributes: function getRegionalAttributes(page) {
    var result = "";
    if (page.region_disabled) {
      var regionString = JSON.stringify(page.region_disabled);
      result += "data-region-disabled='" + regionString + "' ";
    }

    return result;
  },

  getOverrideAttributes: function getOverrideAttributes(page) {
    if (page.new_marketing_link) {
      return "data-marketing-new-link=\"true\"";
    }

    return "";
  },

  getSubuserRestrictedAttributes: function getSubuserRestrictedAttributes(page) {
    if (page.subuser_restricted) {
      return "data-subuser-restricted=\"" + page.subuser_restricted + "\" ";
    }
    return "";
  },

  legacyTemplatesHiddenClass: "legacy-templates-hidden",
  featureToggleHiddenClass: "feature-toggle-hidden",
  scopeHiddenClass: "scope-hidden",
  entitlementHiddenClass: "entitlement-hidden",
  regionDisabledClass: "region-disabled",
  subuserHiddenClass: "subuser-hidden",
  resellerHiddenClass: "reseller-hidden",

  aTagStartHtml: function aTagStartHtml(page, isSubpage) {
    var klass = isSubpage ? "subpage-link" : "page-link";
    var html = "<a class=\"" + klass + "\"";
    if (page.href !== undefined) {
      html += " href=\"" + page.href + "\"";
    }
    if (page.role) {
      html += " role=\"" + page.role + "\"";
    }
    if (page.hidden) {
      html += " style=\"display: none\"";
    }

    if (page.analytics_event) {
      html += " data-events-to-track='click'";

      var trackArray = [];
      html += " data-analytics-properties='{";

      trackArray.push("\"eventName\": \"" + page.analytics_event + "\"");

      if (page.analytics_location) {
        trackArray.push("\"page\": \"" + page.analytics_location + "\"");
      }

      if (page.analytics_section) {
        trackArray.push("\"section\": \"" + page.analytics_section + "\"");
      }

      if (page.analytics_subsection) {
        trackArray.push("\"subSection\": \"" + page.analytics_subsection + "\"");
      }

      if (page.analytics_elementType) {
        trackArray.push("\"elementType\": \"" + page.analytics_elementType + "\"");
      }

      html += trackArray.join(", ");

      html += "}'";
    }

    if (page.title) {
      html += " data-nav-title=\"" + page.title.toLowerCase() + "\" ";
    }
    if (page.mako_route) {
      html += " data-mako-route=\"" + page.mako_route + "\"";
    }
    return html + ">";
  },

  stats: function stats(makoHost) {
    return "<div class=\"navbar-stats\">\n      <div class=\"meter-container\">\n            <abbr>Reputation</abbr>\n        <span class=\"meter-value\" role=\"reputation\"></span>\n\n        <div class=\"meter-bar\">\n          <div class=\"meter-bar-fill\" role=\"reputation-progress-bar\"></div>\n        </div>\n      </div>\n\n      <div class=\"meter-container\" role=\"account-usage\" style=\"display: none\">\n        <a\n          class=\"meter-title account-usage-link\"\n          role=\"account-usage-link\"\n          href=\"" + makoHost + "/account/products\"\n          data-events-to-track='click'\n          data-analytics-properties='{\"page\": \"" + leftSideNavigation + "\", \"elementType\": \"link\", \"eventName\": \"view account usage link clicked\"}'\n        >\n          View Account Usage\n        </a>\n      </div>\n\n      <div class=\"meter-container\" role=\"usage-details\" style=\"display: none\">\n        <span role=\"credits-reset-frequency\" class=\"meter-title has-underline\" data-tooltip=\"The total number of emails you've requested this month.\" data-tooltip-pos=\"right\" data-tooltip-length=\"large\"><abbr role=\"credits-reset-frequency-label\">Emails this month</abbr></span>\n        <div class=\"emails-sent-today\" role=\"usage-metric\"></div>\n      </div>\n    </div>";
  },

  multisubuserImpersonationBanner: function multisubuserImpersonationBanner(impersonatingUsername, hasRestrictedSubuserAccess) {
    var className = hasRestrictedSubuserAccess ? "visibillity-hidden" : "multisubuser-impersonation-banner-back";

    return "<div class=\"multisubuser-impersonation-banner\" data-role=\"multisubuser-impersonation-banner\">\n        <div role=\"back-to-parent-account\" class=" + className + ">\n          <div>" + TwilioPasteArrowBack + "</div>\n          <div>Return to your parent account</div>\n        </div>\n        <div class=\"multisubuser-impersonation-banner-title\">\n          <span>You are currently logged in as </span>\n          <span class=\"multisubuser-impersonation-banner-username\">\n            " + impersonatingUsername + "\n          </span>\n        </div>\n        <div role=\"change-account\" class=\"multisubuser-impersonation-banner-button\">\n          " + TwilioPasteUser + "\n          <span class=\"multisubuser-impersonation-banner-button-title\">\n            Change account\n          </span>\n        </div>\n      </div>";
  },

  modals: function modals() {
    return "<div class=\"hidden conf-alert conf-alert-old-sg-warning\" data-conf-alert-old-sg-warning=\"true\">\n      <h2 class=\"conf-alert-header\">\n        Please note that you will be taken to the old SendGrid interface where you will be logged in as the parent user. You will need to reselect the subuser on the next page.\n      </h2>\n      <div class=\"conf-alert-actions\">\n        <a class=\"btn btn-small btn-secondary\" data-old-sg-warning-cancel-btn=\"true\">Cancel</a>\n        <a class=\"btn btn-small btn-primary\" data-old-sg-warning-ok-btn=\"true\">OK</a>\n      </div>\n    </div>\n    ";
  },

  barClass: function barClass(percentage) {
    switch (true) {
      case percentage > 50:
        return "is-above-50";
      case percentage > 25:
        return "is-below-50";
      default:
        return "is-below-25";
    }
  },

  prettyNumber: function prettyNumber(num) {
    if (isNaN(num)) {
      return "N/A";
    } else {
      return this.abbrNum(num, 2);
    }
  },

  // from http://stackoverflow.com/a/2686098
  abbrNum: function abbrNum(number, decPlaces) {
    decPlaces = Math.pow(10, decPlaces);

    var abbrev = ["k", "m", "b", "t"];

    // Go through the array backwards, so we do the largest first
    for (var i = abbrev.length - 1; i >= 0; i--) {
      // Convert array index to "1000", "1000000", etc
      var size = Math.pow(10, (i + 1) * 3);

      // If the number is bigger or equal do the abbreviation
      if (size <= number) {
        // Here, we multiply by decPlaces, round, and then divide by decPlaces.
        // This gives us nice rounding to a particular decimal place.
        number = Math.round(number * decPlaces / size) / decPlaces;

        // Handle special case where we round up to the next abbreviation
        if (number == 1000 && i < abbrev.length - 1) {
          number = 1;
          i++;
        }

        // Add the letter for the abbreviation
        number += abbrev[i];

        // We are done... stop
        break;
      }
    }

    return number;
  } };

},{"../style-guide-debt/app/img/icons/twilio-paste/ArrowBack.svg":392,"../style-guide-debt/app/img/icons/twilio-paste/LinkExternal.svg":394,"../style-guide-debt/app/img/icons/twilio-paste/User.svg":396,"../style-guide/app/img/logo-tiara.svg":403,"./pages.js":7}],9:[function(require,module,exports){
"use strict";

var Helpers = require("./helpers");
var Templates = require("./templates");
var Fetcher = require("./fetcher");
var Pages = require("./pages");
var Banner = require("./banner");
var DeferredHandlers = require("./deferred_handlers");
var whenAll = require("./when_all");
var analytics = require("@sendgrid/bloodhound").analytics;

var _require = require("./browserFingerprint");

var browserFingerprintReady = _require.browserFingerprintReady;

var debounce = require("lodash/debounce");
var omit = require("lodash/omit");
var flatten = require("lodash/flatten");
var sortBy = require("lodash/sortBy");
var Cookies = require("js-cookie");

var _ = undefined,
    $ = undefined;
var RESELLER_BANNER_COOKIE = "mako-reseller-header";
var READ_TOOLTIPS_COOKIE = "read-tooltips";
var IMPERSONATING_USERNAME_COOKIE = "sendgrid-impersonating-username";
var MAKO_AUTH_TOKEN_COOKIE = "mako_auth_token";
var SITE_COOKIE = "sendgrid_frontend";
var EMAIL_CONFIRMED_COOKIE = "mako_email_confirmed";
var ACCOUNT_REGION_COOKIE = "account_region";

// See https://segment.com/docs/libraries/analytics.js/#selecting-integrations
var VISUAL_SEGMENT_INTEGRATIONS = {
  All: true };

var NON_VISUAL_SEGMENT_INTEGRATIONS = {
  All: true,
  Intercom: false };

var getCookieOptions = function () {
  var localDomains = ["localhost", "127.0.0.1"];
  var domain = localDomains.includes(window.location.hostname) ? undefined : ".sendgrid.com";

  return {
    domain: domain,
    path: "/" };
};

module.exports = {
  run: function run(config) {
    window.SendGridTiara = {
      init: function init(params) {
        var _this = this;

        $ = params.jQuery;
        _ = params.underscore;
        this.auth_token = params.auth_token || Cookies.get(MAKO_AUTH_TOKEN_COOKIE);
        this.target = params.target || "[role=tiara-target]";
        this.render = params.render || function () {};
        this.api_host = params.api_host || "https://api.sendgrid.com/v3/";
        this.showBannersInContentContainer = params.showBannersInContentContainer ? params.showBannersInContentContainer : false;
        this.sg_host = params.sg_host === undefined ? "https://sendgrid.com" : params.sg_host;
        this.logoutCallback = params.logoutCallback || this.defaultLogout.bind(this);
        this.readTooltips = params.read_tooltips || this._getReadTooltips();
        this.resellerHeader = params.reseller_header || this._getResellerHeader($);
        this.nlvxHost = params.nlvxHost === undefined ? "https://sendgrid.com/marketing_campaigns" : params.nlvxHost;
        this.makoHost = params.makoHost ? params.makoHost : "https://app.sendgrid.com";
        this.revealAllLinks = params.revealAllLinks;
        this.shouldLogoutOnAuthFail = params.shouldLogoutOnAuthFail;
        this.shouldHideSidebar = params.shouldHideSidebar;
        this.segmentIntegrations = params.shouldHideSegmentIntegrations ? NON_VISUAL_SEGMENT_INTEGRATIONS : VISUAL_SEGMENT_INTEGRATIONS;
        this.shouldMakeRequests = params.shouldMakeRequests === undefined ? true : params.shouldMakeRequests;
        this.labsUrl = params.labsUrl || config.labs_url || "https://labs.sendgrid.com";
        this.segmentKey = params.segmentKey || config.api_key;
        this.linkCallback = params.linkCallback || function () {};
        this.mcAutoHost = params.mcAutoHost && params.mcAutoHost.replace(/\/$/, "") || "https://mc.sendgrid.com";
        this.datadogRum = params.datadogRum;
        this.unifiedUserInfo = params.unifiedUserInfo;
        this.shouldShowGlobalNavBarUpdates = params.shouldShowGlobalNavBarUpdates === undefined ? false : params.shouldShowGlobalNavBarUpdates;
        var trackingWithUserInfo = this.analyticsTrackingWithUserInfo;
        var _params$includeThirdPartyScripts = params.includeThirdPartyScripts;
        var includeThirdPartyScripts = _params$includeThirdPartyScripts === undefined ? true : _params$includeThirdPartyScripts;

        this.includeThirdPartyScripts = includeThirdPartyScripts;
        // expose default segment integration options just in case the client
        // needs them to do more advanced tracking
        this.VISUAL_SEGMENT_INTEGRATIONS = VISUAL_SEGMENT_INTEGRATIONS;
        this.NON_VISUAL_SEGMENT_INTEGRATIONS = NON_VISUAL_SEGMENT_INTEGRATIONS;

        whenAll.load($); // attach $.whenAll function
        var banner = new Banner(".tiara-headers", this.makoHost, this.mcAutoHost);

        // subuser impersonation params
        this.disableImpersonation = params.disable_impersonation;
        this.impersonating = false;
        if (!this.disableImpersonation) {
          this.impersonating = params.impersonating || Cookies.get(IMPERSONATING_USERNAME_COOKIE);
          this.impersonateCallback = params.impersonate_callback || this._defaultImpersonateCallback;
          this.backToParentCallback = params.back_to_parent_callback || this._defaultBackToParentCallback;
        }

        // Log out if auth token is missing
        if (!this.auth_token && this.shouldLogoutOnAuthFail) {
          this.logoutCallback();
        }

        if (this.shouldHideSidebar) {
          // skip all dom manipulation, just set up deferreds and analytics
          this.helpers = new Helpers($, _, $(""));
          this.render();
          this.hasInitialized = true;

          var _defs = this._createDeferreds();
          var _deferredHandlers = new DeferredHandlers(_defs, this.helpers, banner, undefined, this.unifiedUserInfo, $);

          _deferredHandlers.restrictedSubuserAccessControl(this.impersonating, this.makoHost);

          if (this.segmentKey && this.includeThirdPartyScripts) {
            this._initAnalytics(this.segmentKey, this.auth_token);
          } else {
            console.error("Could not find a Segment API key for this environment.");
          }
          _deferredHandlers.hideLoadingScreen();
          return _defs;
        }

        // find target
        var $target = $(this.target);
        if ($target.length == 0) {
          console.error("Could not find element matching " + this.target + " selector");
          $("[data-role=main-loader]").fadeOut();
          return;
        }

        this._wrapTarget($target, this.showBannersInContentContainer);

        this.helpers = new Helpers($, _, $("[data-tiara-generated]"));
        this.helpers.bindNav();
        this.helpers.bindAccount(this.logoutCallback);
        this.render();
        this.hasInitialized = true;

        var defs = this._createDeferreds();
        // now that we've set up our fetchers and deferred user data, bind to them
        var deferredHandlers = new DeferredHandlers(defs, this.helpers, banner, this.revealAllLinks, this.unifiedUserInfo, $);
        deferredHandlers.restrictedSubuserAccessControl(this.impersonating, this.makoHost);
        deferredHandlers.revealPagesViaFeatureTogglesAndScopes();
        deferredHandlers.revealPagesViaAccount();
        deferredHandlers.revealPagesViaEntitlement();
        deferredHandlers.revealPagesViaTransactionalTemplateType();
        deferredHandlers.renderPages().always(function () {
          return _this.updateNav();
        });
        deferredHandlers.showReputationBar();
        deferredHandlers.showCreditsBar();
        deferredHandlers.showUsage();
        deferredHandlers.showAccountName(this.impersonating, this.shouldShowGlobalNavBarUpdates);
        deferredHandlers.hideLoadingScreen();
        deferredHandlers.showAdsTiara();
        deferredHandlers.detectAdblock();

        deferredHandlers.disablePagesViaRegion(Cookies.get(ACCOUNT_REGION_COOKIE));

        if (this.segmentKey && this.includeThirdPartyScripts) {
          this._initAnalytics(this.segmentKey, this.auth_token);
        } else {
          console.error("Could not find a Segment API key for this environment.");
        }
        this.renderBannerDef = deferredHandlers.renderBanner();
        deferredHandlers.revealEmailsRemaining();

        if (!this.disableImpersonation) {
          deferredHandlers.handleSubuserImpersonation(this.impersonating, this.makoHost, this.backToParentCallback, this.shouldShowGlobalNavBarUpdates);
        }

        deferredHandlers.preventImpersonationIfNecessary();

        $("nav[data-tiara-nav=true]").on("click", "a.page-link, a.subpage-link", function (event) {
          var callback = params.linkCallback || function () {};
          return callback(event, this);
        });

        $("[data-account-details=top]").on("click", function (e) {
          trackingWithUserInfo("click_tiara_accountdetails_top");
        });

        $("[data-nav-title=\"account details\"]").on("click", function (e) {
          trackingWithUserInfo("click_tiara_accountdetails_bottom");
        });

        $("[data-events-to-track*=\"mouseover\"]").on("mouseover", debounce(function (evt) {
          sendTrackingEvents(evt);
        }, 400));

        $("[data-events-to-track*=\"click\"]").on("click", function (evt) {
          sendTrackingEvents(evt);
        });

        var sendTrackingEvents = function sendTrackingEvents(evt) {
          var el = evt.currentTarget;
          if (!el) {
            return;
          }

          var actionsToTrack = el.getAttribute("data-events-to-track");
          if (!actionsToTrack || !actionsToTrack.includes(evt.type)) {
            return;
          }

          var rawProperties = el.getAttribute("data-analytics-properties");
          var properties = rawProperties ? JSON.parse(rawProperties) : {};

          var eventName = properties.eventName || null;

          if (!eventName) {
            return;
          }
          properties = omit(properties, "eventName");
          properties = Object.assign({}, properties, {
            eventType: evt.type });

          trackingWithUserInfo(eventName, properties);
        };

        window.onpopstate = function () {
          _this.updateNav();
        };

        this.getUserType();
        this.getCatalogOrg();
        this.getLogoutConfig();

        this._sendBrowserFingerprint();

        // return deferred userdata
        return defs;
      },

      analyticsTrackingWithUserInfo: function analyticsTrackingWithUserInfo(event, properties) {
        analytics.track({
          event: event,
          properties: properties });
      },

      updateNav: function updateNav() {
        var routeInfo = arguments[0] === undefined ? {} : arguments[0];

        if (this.hasInitialized) {
          this.helpers.activateNav(document.location.pathname.toLowerCase(), $("[data-tiara-nav] .pages"));
        }
      },

      getUserType: function getUserType() {
        var _this = this;

        // Don't runtime error when we don't have a valid auth cookie
        if (this.fetcher) {
          this.fetcher.fetchProfile().done(function (data) {
            _this.userType = data.type;
          });
        }
      },

      getCatalogOrg: function getCatalogOrg() {
        var _this = this;

        // Don't runtime error when we don't have a valid auth cookie
        if (this.fetcher) {
          this.fetcher.fetchCAMAccount().done(function (data) {
            _this.catalogOrg = data.catalog_org;
          });
        }
      },

      getLogoutConfig: function getLogoutConfig() {
        var _this = this;

        // Don't runtime error when we don't have a valid auth cookie
        if (this.fetcher) {
          this.fetcher.fetchLogoutConfig().done(function (data) {
            _this.logoutConfig = data;
          });
        }
      },

      updateName: function updateName(name) {
        if (this.hasInitialized) {
          this.helpers.showAccount(name);
        }
      },

      refreshHiddenLinks: function refreshHiddenLinks() {
        var _this = this;

        if (this.hasInitialized) {
          this.fetcher.fetchFeatureToggles().done(function (data) {
            _this.helpers.revealLinksViaFeatureToggles(data);
          });
          this.fetcher.fetchScopes().done(function (data) {
            _this.helpers.revealLinksViaScopes(data.scopes);
          });
          this.fetcher.fetchTransactionalTemplates().done(function (data) {
            _this.helpers.revealLinksViaTransactionalTemplateType(data.templates);
          });
        }
      },

      navigateTo: function navigateTo(url) {
        window.location.href = url;
      },

      defaultLogout: function defaultLogout(clickedLogOut) {
        var _this = this;

        var self = this;
        return this._logout().always(function () {
          analytics.resetIdentity();
          // Since site needs to read in the cookie, a cross-domain ajax call won't work.
          // This frame won't render due to CSP, but that's fine, since site will still
          // process the iframe request and delete the cookie server-side.
          $("<iframe src=\"" + self.sg_host + "/user/logout?session=true\"></iframe>").appendTo($("body"));
          // Redirect to login or logged-out page (or SSO login page for SSO teammates)
          var isSSOTeammate = self.userType === "sso_teammate";

          if (clickedLogOut && isSSOTeammate) {
            var host = new URL(self.sg_host).host;
            var logoutConfig = self.logoutConfig || {};
            var orgConfig = logoutConfig[_this.catalogOrg] || {
              sso_logout: "https://app." + host + "/ssologin" };

            _this.navigateTo(orgConfig.sso_logout);
          } else if (clickedLogOut) {
            _this.navigateTo("" + self.sg_host + "/logged-out");
          } else {
            var redirect_to = encodeURIComponent(window.location.pathname + window.location.search);

            //Remove /'s in the path so /login/ and /login are the same
            if (window.location.pathname.replace(/\//g, "") === "login") {
              redirect_to = "";
            } else {
              redirect_to = "?redirect_to=" + redirect_to;
            }
            _this.navigateTo("" + self.makoHost + "/login" + redirect_to);
          }
        });
      },

      logout: function logout() {
        var _this = this;

        return new Promise(function (resolve, reject) {
          _this._logout().done(function () {
            return resolve();
          }).fail(function () {
            return reject();
          });
        });
      },

      getImpersonatingUsername: function getImpersonatingUsername() {
        return Cookies.get(IMPERSONATING_USERNAME_COOKIE);
      },

      analytics: function analytics() {
        return window.analytics;
      },

      analyticsTrack: function analyticsTrack(event, properties, options, callback) {
        analytics.track({
          event: event,
          properties: properties });
      },

      pollPaymentStatus: function pollPaymentStatus() {
        var _this = this;

        var POLLING_INTERVAL = 5 * 1000;
        var POLLING_TIMEOUT = 3 * 60 * 1000;
        var banner = new Banner(".tiara-headers", this.makoHost, this.mcAutoHost);
        var intervalHandle = window.setInterval(function () {
          _this.fetcher.fetchUserProducts().done(function (data) {
            var isPaymentDeclined = _this.helpers.isPaymentDeclined(data);
            var paymentDeclinedBanner = $("[data-role=paymentDeclinedBanner]");

            if (!paymentDeclinedBanner.length && !isPaymentDeclined) {
              // watch for async payment decline - poll until timeout
              return;
            }

            if (!paymentDeclinedBanner.length && isPaymentDeclined) {
              banner.showPaymentDeclined();
            }

            if (paymentDeclinedBanner.length && !isPaymentDeclined) {
              paymentDeclinedBanner.remove();
            }

            window.clearInterval(intervalHandle);
          }).fail(function () {
            return console.warn("Error polling OES for payment status");
          });
        }, POLLING_INTERVAL);
        window.setTimeout(function () {
          return window.clearInterval(intervalHandle);
        }, POLLING_TIMEOUT);
      },

      bannerReady: function bannerReady() {
        var _this = this;

        return new Promise(function (resolve) {
          if (!_this.renderBannerDef) {
            // if an app is not init-ing tiara but is still wondering if the banners are ready
            resolve();
          }
          _this.renderBannerDef.always(function () {
            return resolve();
          });
        })["catch"](function (error) {
          resolve();
        });
      },

      browserFingerprintReady: browserFingerprintReady,

      // private

      _logout: function _logout() {
        // Added to assist in debugging a CFD will be removed in: https://issues.corp.twilio.com/browse/CLFED-1139
        console.trace("Tiara logout");
        // Delete session server-side
        var self = this;
        return $.ajax({
          url: "" + self.api_host + "tokens",
          method: "DELETE",
          contentType: "application/json",
          data: JSON.stringify({
            token: Cookies.get(MAKO_AUTH_TOKEN_COOKIE) }),
          complete: function complete() {
            var cookieOptions = getCookieOptions();
            // Delete cookies
            Cookies.remove(MAKO_AUTH_TOKEN_COOKIE, cookieOptions);
            Cookies.remove(RESELLER_BANNER_COOKIE, cookieOptions);
            Cookies.remove(IMPERSONATING_USERNAME_COOKIE, cookieOptions);
            Cookies.remove(ACCOUNT_REGION_COOKIE, cookieOptions);
            Cookies.remove(SITE_COOKIE, cookieOptions);
            Cookies.remove(EMAIL_CONFIRMED_COOKIE, cookieOptions);
          } });
      },

      _defaultImpersonateCallback: function _defaultImpersonateCallback(subuserId, subuserUsername) {
        var cookieOptions = getCookieOptions();
        Cookies.set(IMPERSONATING_USERNAME_COOKIE, subuserUsername, cookieOptions);
        Cookies.remove(ACCOUNT_REGION_COOKIE, cookieOptions);
        window.location.reload();
      },

      _defaultBackToParentCallback: function _defaultBackToParentCallback() {
        var cookieOptions = getCookieOptions();
        Cookies.remove(IMPERSONATING_USERNAME_COOKIE, cookieOptions);
        Cookies.remove(ACCOUNT_REGION_COOKIE, cookieOptions);

        if (Cookies.get(IMPERSONATING_USERNAME_COOKIE)) {
          console.error("Failed to remove subuser cookie when navigating back to parent account for non-unified account");
        }

        window.location.reload();
      },

      _wrapTarget: function _wrapTarget($target, showBannersInContentContainer) {
        var _this = this;

        var $tiaraContentContainer = $("<div class=\"tiara-content-container\"></div>");
        $target.wrap($tiaraContentContainer);
        $(".tiara-content-container").wrap("<div class=\"tiara-container\"></div>");
        $(".tiara-container").prepend(Templates.sidebarHtml({
          nlvxHost: this.nlvxHost,
          makoHost: this.makoHost,
          sgHost: this.sg_host,
          labsUrl: this.labsUrl,
          newMCAM: this.newMCAM,
          mcAutoHost: this.mcAutoHost,
          unifiedUserInfo: this.unifiedUserInfo,
          impersonating: this.impersonating }));

        var bannersContainer = showBannersInContentContainer ? ".tiara-content-container" : ".tiara-container";
        $(bannersContainer).prepend("<header class=\"tiara-headers\" data-tiara-generated=\"true\"></header>");

        if (this.resellerHeader) {
          if (this.resellerHeader.reseller_boomerang_header) {
            (function () {
              var self = _this;
              $.getScript(_this.resellerHeader.reseller_boomerang_header, function () {
                Boomerang.init({
                  app: self.resellerHeader.reseller_heroku_app,
                  addon: "SendGrid" });
              });
            })();
          }
        }

        // Adding bait to detect adblockers
        // Most adblockers will hide this element
        $(".tiara-container").prepend("<div id=\"banner_ad\"></div>");
      },

      _getReadTooltips: function _getReadTooltips() {
        try {
          return JSON.parse(Cookies.get(READ_TOOLTIPS_COOKIE));
        } catch (err) {
          return null;
        }
      },

      _hasReadTooltip: function _hasReadTooltip(tooltip) {
        if (this.readTooltips) {
          return this.readTooltips[tooltip] || false;
        } else {
          return false;
        }
      },

      _setReadTooltip: function _setReadTooltip(tooltip) {
        if (!this.readTooltips) {
          this.readTooltips = {};
        }
        this.readTooltips[tooltip] = true;
        var cookieOptions = getCookieOptions();
        Cookies.set(READ_TOOLTIPS_COOKIE, JSON.stringify(this.readTooltips), {
          domain: cookieOptions.domain,
          path: cookieOptions.path,
          expires: 365500 });
      },

      _createDeferreds: function _createDeferreds() {
        var defs = {};

        // Use a no-op if we don't want to log them out when auth token is expired
        var logoutCallback = this.shouldLogoutOnAuthFail ? this.logoutCallback : function () {};

        if (this.auth_token && this.shouldMakeRequests) {
          if (this.impersonating) {
            this.fetcher = new Fetcher($, this.auth_token, {
              api_host: this.api_host,
              impersonating: this.impersonating,
              logoutConfigURL: this.logoutConfigURL,
              logoutCallback: logoutCallback });
            this.parentFetcher = new Fetcher($, this.auth_token, {
              api_host: this.api_host });

            defs.scopes = this.fetcher.fetchScopes();
            defs.feature_toggles = this.fetcher.fetchFeatureToggles();
            defs.account = this.fetcher.fetchAccount();
            defs.credits = this.fetcher.fetchCredits();
            defs.usage_stats = this.fetcher.fetchCreditsIncludingSubusers();
            defs.profile = this.fetcher.fetchProfile();
            defs.nonImpersonatedProfile = this.parentFetcher.fetchProfile();
            defs.username = this.fetcher.fetchUsername();
            defs.nonImpersonatedUsername = this.parentFetcher.fetchUsername();
            defs.email = this.fetcher.fetchEmail();
            defs.pkg = this.fetcher.fetchPackage();
            defs.signup_status = $.Deferred().resolve([]); // subusers never have s2s status
            defs.user_status = this.fetcher.fetchUserStatus();
            defs.user_type = this.fetcher.fetchUserType();
            defs.subusers = $.Deferred().resolve([]); // subusers never have subusers
            defs.parent_subusers = this.parentFetcher.fetchSubusers();
            defs.nlv3 = this.fetcher.fetchLegacyNewsletterAccess();
            defs.transactional_templates = this.fetcher.fetchTransactionalTemplates();
            defs.message_storage = this.fetcher.fetchMessageStorage();
            defs.monthly_stats = this.fetcher.fetchMonthlyEmailStats();
            defs.userProducts = this.fetcher.fetchUserProducts();
            defs.ongoingExpertServices = this.fetcher.fetchOngoingExpertServices();
            defs.camAccount = this.fetcher.fetchCAMAccount();
            defs.longtermStats = this.fetcher.fetchLongtermStats();
            defs.senderIdStatus = this.fetcher.fetchSenderIdentityStatus();
            defs.apiKeys = this.fetcher.fetchApiKeys();
            defs.subuserAccess = this.parentFetcher.handleGetSubuserAccess(defs.nonImpersonatedUsername, defs.nonImpersonatedProfile, this.helpers.adaptSubuserCursorData);
          } else {
            this.fetcher = new Fetcher($, this.auth_token, {
              api_host: this.api_host,
              logoutConfigURL: this.logoutConfigURL,
              logoutCallback: logoutCallback });

            defs.scopes = this.fetcher.fetchScopes();
            defs.feature_toggles = this.fetcher.fetchFeatureToggles();
            defs.account = this.fetcher.fetchAccount();
            defs.credits = this.fetcher.fetchCredits();
            defs.usage_stats = this.fetcher.fetchCreditsIncludingSubusers();
            defs.profile = this.fetcher.fetchProfile();
            // Since when not impersonating -> nonImpersonatedProfile will be the same as profile,
            // we can re-use defs.profile to avoid having a duplicate api call
            defs.nonImpersonatedProfile = defs.profile;
            defs.username = this.fetcher.fetchUsername();
            defs.nonImpersonatedUsername = defs.username;
            defs.email = this.fetcher.fetchEmail();
            defs.pkg = this.fetcher.fetchPackage();
            defs.signup_status = this.fetcher.fetchSignupStatus();
            defs.user_status = this.fetcher.fetchUserStatus();
            defs.user_type = this.fetcher.fetchUserType();
            defs.subusers = this.fetcher.fetchSubusers();
            defs.parent_subusers = this.fetcher.fetchSubusers();
            defs.nlv3 = this.fetcher.fetchLegacyNewsletterAccess();
            defs.transactional_templates = this.fetcher.fetchTransactionalTemplates();
            defs.message_storage = this.fetcher.fetchMessageStorage();
            defs.monthly_stats = this.fetcher.fetchMonthlyEmailStats();
            defs.userProducts = this.fetcher.fetchUserProducts();
            defs.ongoingExpertServices = this.fetcher.fetchOngoingExpertServices();
            defs.camAccount = this.fetcher.fetchCAMAccount();
            defs.longtermStats = this.fetcher.fetchLongtermStats();
            defs.senderIdStatus = this.fetcher.fetchSenderIdentityStatus();
            defs.apiKeys = this.fetcher.fetchApiKeys();
            defs.subuserAccess = this.fetcher.handleGetSubuserAccess(defs.username, defs.profile, this.helpers.adaptSubuserCursorData);
          }
        } else {
          defs.account = $.Deferred().reject();
          defs.credits = $.Deferred().reject();
          defs.usage_stats = $.Deferred().reject();
          defs.profile = $.Deferred().reject();
          defs.nonImpersonatedProfile = $.Deferred().reject();
          defs.feature_toggles = $.Deferred().reject();
          defs.scopes = $.Deferred().reject();
          defs.username = $.Deferred().reject();
          defs.nonImpersonatedUsername = $.Deferred().reject();
          defs.email = $.Deferred().reject();
          defs.pkg = $.Deferred().reject();
          defs.subusers = $.Deferred().reject();
          defs.signup_status = $.Deferred().reject();
          defs.user_status = $.Deferred().reject();
          defs.user_type = $.Deferred().reject();
          defs.parent_subusers = $.Deferred().reject();
          defs.nlv3 = $.Deferred().reject();
          defs.transactional_templates = $.Deferred().reject();
          defs.message_storage = $.Deferred().reject();
          defs.monthly_stats = $.Deferred().reject();
          defs.userProducts = $.Deferred().reject();
          defs.ongoingExpertServices = $.Deferred().reject();
          defs.camAccount = $.Deferred().reject();
          defs.apiKeys = $.Deferred().reject();
          defs.longtermStats = $.Deferred().reject();
          defs.senderIdStatus = $.Deferred().reject();
          defs.subuserAccess = $.Deferred().reject();
        }

        return defs;
      },

      _getAllRoutes: function _getAllRoutes(makoHost, nlvxHost) {
        var routes = [];
        var pageData = Pages.getPageData({
          makoHost: this.makoHost,
          nlvxHost: this.nlvxHost,
          sgHost: this.sg_host });
        for (var i in pageData) {
          routes.push(this._getSubpages(pageData[i]));
        }
        routes = flatten(routes);
        routes = sortBy(routes, "length");
        return routes;
      },

      _getSubpages: function _getSubpages(page) {
        var hrefs = page.href ? [page.href] : [];
        if (page.subpages) {
          for (var i in page.subpages) {
            hrefs.push(this._getSubpages(page.subpages[i]));
          }
        }
        return hrefs;
      },

      _getResellerHeader: function _getResellerHeader() {
        try {
          return JSON.parse(atob(Cookies.get(RESELLER_BANNER_COOKIE)));
        } catch (err) {
          return null;
        }
      },

      _initAnalytics: function _initAnalytics() {
        analytics.init({
          apiBaseUrl: this.api_host,
          segmentApiKey: this.segmentKey,
          datadogRum: this.datadogRum });

        analytics.identify({
          authToken: this.auth_token });
      },

      _sendBrowserFingerprint: function _sendBrowserFingerprint() {
        var _this = this;

        return browserFingerprintReady.then(function () {
          return _this.fetcher.fetchScopes();
        })["catch"](function (err) {});
      } };
  } };

},{"./banner":1,"./browserFingerprint":2,"./deferred_handlers":4,"./fetcher":5,"./helpers":6,"./pages":7,"./templates":8,"./when_all":10,"@sendgrid/bloodhound":202,"js-cookie":204,"lodash/debounce":355,"lodash/flatten":357,"lodash/omit":379,"lodash/sortBy":381}],10:[function(require,module,exports){
"use strict";

module.exports = {
  load: function load($) {
    // from http://stackoverflow.com/a/30381148
    $.whenAll = function (deferreds) {
      var lastResolved = 0;
      var wrappedDeferreds = [];

      for (var i = 0; i < deferreds.length; i++) {
        wrappedDeferreds.push($.Deferred());
        if (deferreds[i] && deferreds[i].always) {
          deferreds[i].always(wrappedDeferreds[lastResolved++].resolve);
        } else {
          wrappedDeferreds[lastResolved++].resolve(deferreds[i]);
        }
      }

      return $.when.apply($, wrappedDeferreds).promise();
    };
  } };

},{}],11:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineGlobal = exports.makePublicApi = void 0;
var catchUserErrors_1 = require("../tools/catchUserErrors");
var monitor_1 = require("../tools/monitor");
var polyfills_1 = require("../tools/utils/polyfills");
function makePublicApi(stub) {
    var publicApi = (0, polyfills_1.assign)({
        version: "4.50.1",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        },
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function () {
            return monitor_1.setDebugMode;
        },
        enumerable: false,
    });
    return publicApi;
}
exports.makePublicApi = makePublicApi;
function defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return (0, catchUserErrors_1.catchUserErrors)(fn, 'onReady callback threw an error:')(); });
    }
}
exports.defineGlobal = defineGlobal;
//# sourceMappingURL=init.js.map
},{"../tools/catchUserErrors":59,"../tools/monitor":67,"../tools/utils/polyfills":80}],12:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addEventListeners = exports.addEventListener = void 0;
var monitor_1 = require("../tools/monitor");
var getZoneJsOriginalValue_1 = require("../tools/getZoneJsOriginalValue");
/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(configuration, eventTarget, eventName, listener, options) {
    return addEventListeners(configuration, eventTarget, [eventName], listener, options);
}
exports.addEventListener = addEventListener;
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(_, eventTarget, eventNames, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var listenerWithMonitor = (0, monitor_1.monitor)(once
        ? function (event) {
            stop();
            listener(event);
        }
        : listener);
    var options = passive ? { capture: capture, passive: passive } : capture;
    var add = (0, getZoneJsOriginalValue_1.getZoneJsOriginalValue)(eventTarget, 'addEventListener');
    eventNames.forEach(function (eventName) { return add.call(eventTarget, eventName, listenerWithMonitor, options); });
    function stop() {
        var remove = (0, getZoneJsOriginalValue_1.getZoneJsOriginalValue)(eventTarget, 'removeEventListener');
        eventNames.forEach(function (eventName) { return remove.call(eventTarget, eventName, listenerWithMonitor, options); });
    }
    return {
        stop: stop,
    };
}
exports.addEventListeners = addEventListeners;
//# sourceMappingURL=addEventListener.js.map
},{"../tools/getZoneJsOriginalValue":63,"../tools/monitor":67}],13:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentSite = exports.areCookiesAuthorized = exports.deleteCookie = exports.getCookie = exports.setCookie = void 0;
var display_1 = require("../tools/display");
var timeUtils_1 = require("../tools/utils/timeUtils");
var stringUtils_1 = require("../tools/utils/stringUtils");
function setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure);
}
exports.setCookie = setCookie;
function getCookie(name) {
    return (0, stringUtils_1.findCommaSeparatedValue)(document.cookie, name);
}
exports.getCookie = getCookie;
function deleteCookie(name, options) {
    setCookie(name, '', 0, options);
}
exports.deleteCookie = deleteCookie;
function areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat((0, stringUtils_1.generateUUID)());
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, timeUtils_1.ONE_MINUTE, options);
        var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
        deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        display_1.display.error(error);
        return false;
    }
}
exports.areCookiesAuthorized = areCookiesAuthorized;
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
    if (getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat((0, stringUtils_1.generateUUID)());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !getCookie(testCookieName)) {
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            setCookie(testCookieName, testCookieValue, timeUtils_1.ONE_SECOND, { domain: candidateDomain });
        }
        deleteCookie(testCookieName, { domain: candidateDomain });
        getCurrentSiteCache = candidateDomain;
    }
    return getCurrentSiteCache;
}
exports.getCurrentSite = getCurrentSite;
//# sourceMappingURL=cookie.js.map
},{"../tools/display":60,"../tools/utils/stringUtils":82,"../tools/utils/timeUtils":83}],14:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFetchObservable = void 0;
var instrumentMethod_1 = require("../tools/instrumentMethod");
var monitor_1 = require("../tools/monitor");
var observable_1 = require("../tools/observable");
var timeUtils_1 = require("../tools/utils/timeUtils");
var urlPolyfill_1 = require("../tools/utils/urlPolyfill");
var fetchObservable;
function initFetchObservable() {
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
exports.initFetchObservable = initFetchObservable;
function createFetchObservable() {
    var observable = new observable_1.Observable(function () {
        if (!window.fetch) {
            return;
        }
        var stop = (0, instrumentMethod_1.instrumentMethod)(window, 'fetch', function (originalFetch) {
            return function (input, init) {
                var responsePromise;
                var context = (0, monitor_1.callMonitored)(beforeSend, null, [observable, input, init]);
                if (context) {
                    responsePromise = originalFetch.call(this, context.input, context.init);
                    (0, monitor_1.callMonitored)(afterSend, null, [observable, responsePromise, context]);
                }
                else {
                    responsePromise = originalFetch.call(this, input, init);
                }
                return responsePromise;
            };
        }).stop;
        return stop;
    });
    return observable;
}
function beforeSend(observable, input, init) {
    var method = (init && init.method) || (input instanceof Request && input.method) || 'GET';
    var url = input instanceof Request ? input.url : (0, urlPolyfill_1.normalizeUrl)(String(input));
    var startClocks = (0, timeUtils_1.clocksNow)();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
    };
    observable.notify(context);
    return context;
}
function afterSend(observable, responsePromise, startContext) {
    var reportFetch = function (response) {
        var context = startContext;
        context.state = 'resolve';
        if ('stack' in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
        }
        else if ('status' in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
        }
        observable.notify(context);
    };
    responsePromise.then((0, monitor_1.monitor)(reportFetch), (0, monitor_1.monitor)(reportFetch));
}
//# sourceMappingURL=fetchObservable.js.map
},{"../tools/instrumentMethod":64,"../tools/monitor":67,"../tools/observable":68,"../tools/utils/timeUtils":83,"../tools/utils/urlPolyfill":85}],15:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPageExitReason = exports.createPageExitObservable = exports.PageExitReason = void 0;
var experimentalFeatures_1 = require("../tools/experimentalFeatures");
var observable_1 = require("../tools/observable");
var polyfills_1 = require("../tools/utils/polyfills");
var functionUtils_1 = require("../tools/utils/functionUtils");
var addEventListener_1 = require("./addEventListener");
exports.PageExitReason = {
    HIDDEN: 'visibility_hidden',
    UNLOADING: 'before_unload',
    PAGEHIDE: 'page_hide',
    FROZEN: 'page_frozen',
};
function createPageExitObservable(configuration) {
    var observable = new observable_1.Observable(function () {
        var pagehideEnabled = (0, experimentalFeatures_1.isExperimentalFeatureEnabled)(experimentalFeatures_1.ExperimentalFeature.PAGEHIDE);
        var stopListeners = (0, addEventListener_1.addEventListeners)(configuration, window, ["visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */, "freeze" /* DOM_EVENT.FREEZE */, "pagehide" /* DOM_EVENT.PAGE_HIDE */], function (event) {
            if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */ && pagehideEnabled) {
                /**
                 * Only event that detect page unload events while being compatible with the back/forward cache (bfcache)
                 */
                observable.notify({ reason: exports.PageExitReason.PAGEHIDE });
            }
            else if (event.type === "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ && document.visibilityState === 'hidden') {
                /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */
                observable.notify({ reason: exports.PageExitReason.HIDDEN });
            }
            else if (event.type === "freeze" /* DOM_EVENT.FREEZE */) {
                /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */
                observable.notify({ reason: exports.PageExitReason.FROZEN });
            }
        }, { capture: true }).stop;
        var stopBeforeUnloadListener = functionUtils_1.noop;
        if (!pagehideEnabled) {
            stopBeforeUnloadListener = (0, addEventListener_1.addEventListener)(configuration, window, "beforeunload" /* DOM_EVENT.BEFORE_UNLOAD */, function () {
                observable.notify({ reason: exports.PageExitReason.UNLOADING });
            }).stop;
        }
        return function () {
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
    return observable;
}
exports.createPageExitObservable = createPageExitObservable;
function isPageExitReason(reason) {
    return (0, polyfills_1.includes)((0, polyfills_1.objectValues)(exports.PageExitReason), reason);
}
exports.isPageExitReason = isPageExitReason;
//# sourceMappingURL=pageExitObservable.js.map
},{"../tools/experimentalFeatures":61,"../tools/observable":68,"../tools/utils/functionUtils":77,"../tools/utils/polyfills":80,"./addEventListener":12}],16:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runOnReadyState = void 0;
var addEventListener_1 = require("./addEventListener");
function runOnReadyState(configuration, expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
    }
    else {
        var eventName = expectedReadyState === 'complete' ? "load" /* DOM_EVENT.LOAD */ : "DOMContentLoaded" /* DOM_EVENT.DOM_CONTENT_LOADED */;
        (0, addEventListener_1.addEventListener)(configuration, window, eventName, callback, { once: true });
    }
}
exports.runOnReadyState = runOnReadyState;
//# sourceMappingURL=runOnReadyState.js.map
},{"./addEventListener":12}],17:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initXhrObservable = void 0;
var instrumentMethod_1 = require("../tools/instrumentMethod");
var observable_1 = require("../tools/observable");
var timeUtils_1 = require("../tools/utils/timeUtils");
var urlPolyfill_1 = require("../tools/utils/urlPolyfill");
var objectUtils_1 = require("../tools/utils/objectUtils");
var addEventListener_1 = require("./addEventListener");
var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable(configuration) {
    if (!xhrObservable) {
        xhrObservable = createXhrObservable(configuration);
    }
    return xhrObservable;
}
exports.initXhrObservable = initXhrObservable;
function createXhrObservable(configuration) {
    var observable = new observable_1.Observable(function () {
        var stopInstrumentingStart = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(XMLHttpRequest.prototype, 'open', {
            before: openXhr,
        }).stop;
        var stopInstrumentingSend = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(XMLHttpRequest.prototype, 'send', {
            before: function () {
                sendXhr.call(this, configuration, observable);
            },
        }).stop;
        var stopInstrumentingAbort = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(XMLHttpRequest.prototype, 'abort', {
            before: abortXhr,
        }).stop;
        return function () {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
    return observable;
}
function openXhr(method, url) {
    xhrContexts.set(this, {
        state: 'open',
        method: method,
        url: (0, urlPolyfill_1.normalizeUrl)(String(url)),
    });
}
function sendXhr(configuration, observable) {
    var _this = this;
    var context = xhrContexts.get(this);
    if (!context) {
        return;
    }
    var startContext = context;
    startContext.state = 'start';
    startContext.startTime = (0, timeUtils_1.relativeNow)();
    startContext.startClocks = (0, timeUtils_1.clocksNow)();
    startContext.isAborted = false;
    startContext.xhr = this;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(this, 'onreadystatechange', {
        before: function () {
            if (this.readyState === XMLHttpRequest.DONE) {
                // Try to report the XHR as soon as possible, because the XHR may be mutated by the
                // application during a future event. For example, Angular is calling .abort() on
                // completed requests during a onreadystatechange event, so the status becomes '0'
                // before the request is collected.
                onEnd();
            }
        },
    }).stop;
    var onEnd = function () {
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = (0, timeUtils_1.elapsed)(startContext.startClocks.timeStamp, (0, timeUtils_1.timeStampNow)());
        completeContext.status = _this.status;
        observable.notify((0, objectUtils_1.shallowClone)(completeContext));
    };
    var unsubscribeLoadEndListener = (0, addEventListener_1.addEventListener)(configuration, this, 'loadend', onEnd).stop;
    observable.notify(startContext);
}
function abortXhr() {
    var context = xhrContexts.get(this);
    if (context) {
        context.isAborted = true;
    }
}
//# sourceMappingURL=xhrObservable.js.map
},{"../tools/instrumentMethod":64,"../tools/observable":68,"../tools/utils/objectUtils":79,"../tools/utils/timeUtils":83,"../tools/utils/urlPolyfill":85,"./addEventListener":12}],18:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeConfiguration = exports.validateAndBuildConfiguration = exports.DefaultPrivacyLevel = void 0;
var catchUserErrors_1 = require("../../tools/catchUserErrors");
var display_1 = require("../../tools/display");
var experimentalFeatures_1 = require("../../tools/experimentalFeatures");
var timeUtils_1 = require("../../tools/utils/timeUtils");
var numberUtils_1 = require("../../tools/utils/numberUtils");
var byteUtils_1 = require("../../tools/utils/byteUtils");
var objectUtils_1 = require("../../tools/utils/objectUtils");
var polyfills_1 = require("../../tools/utils/polyfills");
var sessionStore_1 = require("../session/sessionStore");
var transportConfiguration_1 = require("./transportConfiguration");
exports.DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
};
function validateAndBuildConfiguration(initConfiguration) {
    var _a, _b, _c;
    if (!initConfiguration || !initConfiguration.clientToken) {
        display_1.display.error('Client Token is not configured, we will not send any data.');
        return;
    }
    var sessionSampleRate = (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : initConfiguration.sampleRate;
    if (sessionSampleRate !== undefined && !(0, numberUtils_1.isPercentage)(sessionSampleRate)) {
        display_1.display.error('Session Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetrySampleRate !== undefined && !(0, numberUtils_1.isPercentage)(initConfiguration.telemetrySampleRate)) {
        display_1.display.error('Telemetry Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetryConfigurationSampleRate !== undefined &&
        !(0, numberUtils_1.isPercentage)(initConfiguration.telemetryConfigurationSampleRate)) {
        display_1.display.error('Telemetry Configuration Sample Rate should be a number between 0 and 100');
        return;
    }
    // Set the experimental feature flags as early as possible, so we can use them in most places
    if (Array.isArray(initConfiguration.enableExperimentalFeatures)) {
        (0, experimentalFeatures_1.addExperimentalFeatures)(initConfiguration.enableExperimentalFeatures.filter(function (flag) {
            return (0, objectUtils_1.objectHasValue)(experimentalFeatures_1.ExperimentalFeature, flag);
        }));
    }
    return (0, polyfills_1.assign)({
        beforeSend: initConfiguration.beforeSend && (0, catchUserErrors_1.catchUserErrors)(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        sessionStoreStrategyType: (0, sessionStore_1.selectSessionStoreStrategyType)(initConfiguration),
        sessionSampleRate: sessionSampleRate !== null && sessionSampleRate !== void 0 ? sessionSampleRate : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        service: initConfiguration.service,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */
        batchBytesLimit: 16 * byteUtils_1.ONE_KIBI_BYTE,
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */
        flushTimeout: (30 * timeUtils_1.ONE_SECOND),
        /**
         * Logs intake limit
         */
        batchMessagesLimit: 50,
        messageBytesLimit: 256 * byteUtils_1.ONE_KIBI_BYTE,
    }, (0, transportConfiguration_1.computeTransportConfiguration)(initConfiguration));
}
exports.validateAndBuildConfiguration = validateAndBuildConfiguration;
function serializeConfiguration(initConfiguration) {
    var _a, _b;
    var proxy = (_a = initConfiguration.proxy) !== null && _a !== void 0 ? _a : initConfiguration.proxyUrl;
    return {
        session_sample_rate: (_b = initConfiguration.sessionSampleRate) !== null && _b !== void 0 ? _b : initConfiguration.sampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_cross_site_session_cookie: initConfiguration.useCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: proxy !== undefined ? !!proxy : undefined,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        track_resources: initConfiguration.trackResources,
        track_long_task: initConfiguration.trackLongTasks,
        allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
        store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
    };
}
exports.serializeConfiguration = serializeConfiguration;
//# sourceMappingURL=configuration.js.map
},{"../../tools/catchUserErrors":59,"../../tools/display":60,"../../tools/experimentalFeatures":61,"../../tools/utils/byteUtils":76,"../../tools/utils/numberUtils":78,"../../tools/utils/objectUtils":79,"../../tools/utils/polyfills":80,"../../tools/utils/timeUtils":83,"../session/sessionStore":40,"./transportConfiguration":23}],19:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEndpointBuilder = exports.ENDPOINTS = void 0;
var timeUtils_1 = require("../../tools/utils/timeUtils");
var urlPolyfill_1 = require("../../tools/utils/urlPolyfill");
var experimentalFeatures_1 = require("../../tools/experimentalFeatures");
var stringUtils_1 = require("../../tools/utils/stringUtils");
var intakeSites_1 = require("./intakeSites");
exports.ENDPOINTS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'session-replay',
};
var INTAKE_TRACKS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'replay',
};
function createEndpointBuilder(initConfiguration, endpointType, configurationTags) {
    var buildUrlWithParameters = createEndpointUrlWithParametersBuilder(initConfiguration, endpointType);
    return {
        build: function (api, payload) {
            var parameters = buildEndpointParameters(initConfiguration, endpointType, configurationTags, api, payload);
            return buildUrlWithParameters(parameters);
        },
        urlPrefix: buildUrlWithParameters(''),
        endpointType: endpointType,
    };
}
exports.createEndpointBuilder = createEndpointBuilder;
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function createEndpointUrlWithParametersBuilder(initConfiguration, endpointType) {
    var path = "/api/v2/".concat(INTAKE_TRACKS[endpointType]);
    var proxy = initConfiguration.proxy, proxyUrl = initConfiguration.proxyUrl;
    if (proxy) {
        var normalizedProxyUrl_1 = (0, urlPolyfill_1.normalizeUrl)(proxy);
        return function (parameters) { return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters))); };
    }
    var host = buildEndpointHost(initConfiguration, endpointType);
    if (proxy === undefined && proxyUrl) {
        // TODO: remove this in a future major.
        var normalizedProxyUrl_2 = (0, urlPolyfill_1.normalizeUrl)(proxyUrl);
        return function (parameters) {
            return "".concat(normalizedProxyUrl_2, "?ddforward=").concat(encodeURIComponent("https://".concat(host).concat(path, "?").concat(parameters)));
        };
    }
    return function (parameters) { return "https://".concat(host).concat(path, "?").concat(parameters); };
}
function buildEndpointHost(initConfiguration, endpointType) {
    var _a = initConfiguration.site, site = _a === void 0 ? intakeSites_1.INTAKE_SITE_US1 : _a, internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
    if (internalAnalyticsSubdomain && site === intakeSites_1.INTAKE_SITE_US1) {
        return "".concat(internalAnalyticsSubdomain, ".").concat(intakeSites_1.INTAKE_SITE_US1);
    }
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    var subdomain = site !== intakeSites_1.INTAKE_SITE_AP1 ? "".concat(exports.ENDPOINTS[endpointType], ".") : '';
    return "".concat(subdomain, "browser-intake-").concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function buildEndpointParameters(_a, endpointType, configurationTags, api, _b) {
    var clientToken = _a.clientToken, internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
    var retry = _b.retry, flushReason = _b.flushReason, encoding = _b.encoding;
    var tags = ["sdk_version:".concat("4.50.1"), "api:".concat(api)].concat(configurationTags);
    if (flushReason && (0, experimentalFeatures_1.isExperimentalFeatureEnabled)(experimentalFeatures_1.ExperimentalFeature.COLLECT_FLUSH_REASON)) {
        tags.push("flush_reason:".concat(flushReason));
    }
    if (retry) {
        tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
    }
    var parameters = [
        'ddsource=browser',
        "ddtags=".concat(encodeURIComponent(tags.join(','))),
        "dd-api-key=".concat(clientToken),
        "dd-evp-origin-version=".concat(encodeURIComponent("4.50.1")),
        'dd-evp-origin=browser',
        "dd-request-id=".concat((0, stringUtils_1.generateUUID)()),
    ];
    if (encoding) {
        parameters.push("dd-evp-encoding=".concat(encoding));
    }
    if (endpointType === 'rum') {
        parameters.push("batch_time=".concat((0, timeUtils_1.timeStampNow)()));
    }
    if (internalAnalyticsSubdomain) {
        parameters.reverse();
    }
    return parameters.join('&');
}
//# sourceMappingURL=endpointBuilder.js.map
},{"../../tools/experimentalFeatures":61,"../../tools/utils/stringUtils":82,"../../tools/utils/timeUtils":83,"../../tools/utils/urlPolyfill":85,"./intakeSites":21}],20:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEndpointBuilder = exports.serializeConfiguration = exports.validateAndBuildConfiguration = exports.DefaultPrivacyLevel = void 0;
var configuration_1 = require("./configuration");
Object.defineProperty(exports, "DefaultPrivacyLevel", { enumerable: true, get: function () { return configuration_1.DefaultPrivacyLevel; } });
Object.defineProperty(exports, "validateAndBuildConfiguration", { enumerable: true, get: function () { return configuration_1.validateAndBuildConfiguration; } });
Object.defineProperty(exports, "serializeConfiguration", { enumerable: true, get: function () { return configuration_1.serializeConfiguration; } });
var endpointBuilder_1 = require("./endpointBuilder");
Object.defineProperty(exports, "createEndpointBuilder", { enumerable: true, get: function () { return endpointBuilder_1.createEndpointBuilder; } });
__exportStar(require("./intakeSites"), exports);
//# sourceMappingURL=index.js.map
},{"./configuration":18,"./endpointBuilder":19,"./intakeSites":21}],21:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTAKE_SITE_US1_FED = exports.INTAKE_SITE_AP1 = exports.INTAKE_SITE_EU1 = exports.INTAKE_SITE_US1 = exports.INTAKE_SITE_STAGING = void 0;
exports.INTAKE_SITE_STAGING = 'datad0g.com';
exports.INTAKE_SITE_US1 = 'datadoghq.com';
exports.INTAKE_SITE_EU1 = 'datadoghq.eu';
exports.INTAKE_SITE_AP1 = 'ap1.datadoghq.com';
exports.INTAKE_SITE_US1_FED = 'ddog-gov.com';
//# sourceMappingURL=intakeSites.js.map
},{}],22:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTag = exports.buildTags = exports.TAG_SIZE_LIMIT = void 0;
var display_1 = require("../../tools/display");
exports.TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    if (datacenter) {
        tags.push(buildTag('datacenter', datacenter));
    }
    return tags;
}
exports.buildTags = buildTags;
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = exports.TAG_SIZE_LIMIT - key.length - 1;
    if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
        display_1.display.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}
exports.buildTag = buildTag;
//# sourceMappingURL=tags.js.map
},{"../../tools/display":60}],23:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeTransportConfiguration = void 0;
var polyfills_1 = require("../../tools/utils/polyfills");
var endpointBuilder_1 = require("./endpointBuilder");
var tags_1 = require("./tags");
var intakeSites_1 = require("./intakeSites");
function computeTransportConfiguration(initConfiguration) {
    var tags = (0, tags_1.buildTags)(initConfiguration);
    var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
    var intakeUrlPrefixes = (0, polyfills_1.objectValues)(endpointBuilders).map(function (builder) { return builder.urlPrefix; });
    var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
    return (0, polyfills_1.assign)({
        isIntakeUrl: function (url) { return intakeUrlPrefixes.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); },
        replica: replicaConfiguration,
        site: initConfiguration.site || intakeSites_1.INTAKE_SITE_US1,
    }, endpointBuilders);
}
exports.computeTransportConfiguration = computeTransportConfiguration;
function computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(initConfiguration, 'logs', tags),
        rumEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(initConfiguration, 'sessionReplay', tags),
    };
}
function computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = (0, polyfills_1.assign)({}, initConfiguration, {
        site: intakeSites_1.INTAKE_SITE_US1,
        clientToken: initConfiguration.replica.clientToken,
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(replicaConfiguration, 'rum', tags),
    };
    intakeUrlPrefixes.push.apply(intakeUrlPrefixes, (0, polyfills_1.objectValues)(replicaEndpointBuilders).map(function (builder) { return builder.urlPrefix; }));
    return (0, polyfills_1.assign)({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}
//# sourceMappingURL=transportConfiguration.js.map
},{"../../tools/utils/polyfills":80,"./endpointBuilder":19,"./intakeSites":21,"./tags":22}],24:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetConsoleObservable = exports.initConsoleObservable = void 0;
var tracekit_1 = require("../tracekit");
var error_1 = require("../error/error");
var observable_1 = require("../../tools/observable");
var display_1 = require("../../tools/display");
var monitor_1 = require("../../tools/monitor");
var sanitize_1 = require("../../tools/serialisation/sanitize");
var polyfills_1 = require("../../tools/utils/polyfills");
var jsonStringify_1 = require("../../tools/serialisation/jsonStringify");
var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
    var consoleObservables = apis.map(function (api) {
        if (!consoleObservablesByApi[api]) {
            consoleObservablesByApi[api] = createConsoleObservable(api);
        }
        return consoleObservablesByApi[api];
    });
    return observable_1.mergeObservables.apply(void 0, consoleObservables);
}
exports.initConsoleObservable = initConsoleObservable;
function resetConsoleObservable() {
    consoleObservablesByApi = {};
}
exports.resetConsoleObservable = resetConsoleObservable;
function createConsoleObservable(api) {
    var observable = new observable_1.Observable(function () {
        var originalConsoleApi = display_1.globalConsole[api];
        display_1.globalConsole[api] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            originalConsoleApi.apply(console, params);
            var handlingStack = (0, error_1.createHandlingStack)();
            (0, monitor_1.callMonitored)(function () {
                observable.notify(buildConsoleLog(params, api, handlingStack));
            });
        };
        return function () {
            display_1.globalConsole[api] = originalConsoleApi;
        };
    });
    return observable;
}
function buildConsoleLog(params, api, handlingStack) {
    // Todo: remove console error prefix in the next major version
    var message = params.map(function (param) { return formatConsoleParameters(param); }).join(' ');
    var stack;
    var fingerprint;
    if (api === display_1.ConsoleApiName.error) {
        var firstErrorParam = (0, polyfills_1.find)(params, function (param) { return param instanceof Error; });
        stack = firstErrorParam ? (0, error_1.toStackTraceString)((0, tracekit_1.computeStackTrace)(firstErrorParam)) : undefined;
        fingerprint = (0, error_1.tryToGetFingerprint)(firstErrorParam);
        message = "console error: ".concat(message);
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
        fingerprint: fingerprint,
    };
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return (0, sanitize_1.sanitize)(param);
    }
    if (param instanceof Error) {
        return (0, error_1.formatErrorMessage)((0, tracekit_1.computeStackTrace)(param));
    }
    return (0, jsonStringify_1.jsonStringify)((0, sanitize_1.sanitize)(param), undefined, 2);
}
//# sourceMappingURL=consoleObservable.js.map
},{"../../tools/display":60,"../../tools/monitor":67,"../../tools/observable":68,"../../tools/serialisation/jsonStringify":71,"../../tools/serialisation/sanitize":72,"../../tools/utils/polyfills":80,"../error/error":30,"../tracekit":51}],25:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContextManager = exports.BYTES_COMPUTATION_THROTTLING_DELAY = void 0;
var byteUtils_1 = require("../../tools/utils/byteUtils");
var functionUtils_1 = require("../../tools/utils/functionUtils");
var mergeInto_1 = require("../../tools/mergeInto");
var typeUtils_1 = require("../../tools/utils/typeUtils");
var jsonStringify_1 = require("../../tools/serialisation/jsonStringify");
var sanitize_1 = require("../../tools/serialisation/sanitize");
var observable_1 = require("../../tools/observable");
var heavyCustomerDataWarning_1 = require("./heavyCustomerDataWarning");
exports.BYTES_COMPUTATION_THROTTLING_DELAY = 200;
function createContextManager(customerDataType, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = byteUtils_1.computeBytesCount; }
    var context = {};
    var bytesCountCache;
    var alreadyWarned = false;
    var changeObservable = new observable_1.Observable();
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call context APIs synchronously multiple times in a row
    var computeBytesCountThrottled = (0, functionUtils_1.throttle)(function (context) {
        bytesCountCache = computeBytesCountImpl((0, jsonStringify_1.jsonStringify)(context));
        if (!alreadyWarned) {
            alreadyWarned = (0, heavyCustomerDataWarning_1.warnIfCustomerDataLimitReached)(bytesCountCache, customerDataType);
        }
    }, exports.BYTES_COMPUTATION_THROTTLING_DELAY).throttled;
    var contextManager = {
        getBytesCount: function () { return bytesCountCache; },
        /** @deprecated use getContext instead */
        get: function () { return context; },
        /** @deprecated use setContextProperty instead */
        add: function (key, value) {
            context[key] = value;
            computeBytesCountThrottled(context);
            changeObservable.notify();
        },
        /** @deprecated renamed to removeContextProperty */
        remove: function (key) {
            delete context[key];
            computeBytesCountThrottled(context);
            changeObservable.notify();
        },
        /** @deprecated use setContext instead */
        set: function (newContext) {
            context = newContext;
            computeBytesCountThrottled(context);
            changeObservable.notify();
        },
        getContext: function () { return (0, mergeInto_1.deepClone)(context); },
        setContext: function (newContext) {
            if ((0, typeUtils_1.getType)(newContext) === 'object') {
                context = (0, sanitize_1.sanitize)(newContext);
                computeBytesCountThrottled(context);
            }
            else {
                contextManager.clearContext();
            }
            changeObservable.notify();
        },
        setContextProperty: function (key, property) {
            context[key] = (0, sanitize_1.sanitize)(property);
            computeBytesCountThrottled(context);
            changeObservable.notify();
        },
        removeContextProperty: function (key) {
            delete context[key];
            computeBytesCountThrottled(context);
            changeObservable.notify();
        },
        clearContext: function () {
            context = {};
            bytesCountCache = 0;
            changeObservable.notify();
        },
        changeObservable: changeObservable,
    };
    return contextManager;
}
exports.createContextManager = createContextManager;
//# sourceMappingURL=contextManager.js.map
},{"../../tools/mergeInto":66,"../../tools/observable":68,"../../tools/serialisation/jsonStringify":71,"../../tools/serialisation/sanitize":72,"../../tools/utils/byteUtils":76,"../../tools/utils/functionUtils":77,"../../tools/utils/typeUtils":84,"./heavyCustomerDataWarning":26}],26:[function(require,module,exports){
"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.warnIfCustomerDataLimitReached = exports.CUSTOMER_DATA_BYTES_LIMIT = void 0;
var byteUtils_1 = require("../../tools/utils/byteUtils");
var display_1 = require("../../tools/display");
// RUM and logs batch bytes limit is 16KB
// ensure that we leave room for other event attributes and maintain a decent amount of event per batch
// (3KB (customer data) + 1KB (other attributes)) * 4 (events per batch) = 16KB
exports.CUSTOMER_DATA_BYTES_LIMIT = 3 * byteUtils_1.ONE_KIBI_BYTE;
var CustomerDataLabel = (_a = {},
    _a[0 /* CustomerDataType.FeatureFlag */] = 'feature flag evaluation',
    _a[1 /* CustomerDataType.User */] = 'user',
    _a[2 /* CustomerDataType.GlobalContext */] = 'global context',
    _a[3 /* CustomerDataType.LoggerContext */] = 'logger context',
    _a);
function warnIfCustomerDataLimitReached(bytesCount, customerDataType) {
    if (bytesCount > exports.CUSTOMER_DATA_BYTES_LIMIT) {
        display_1.display.warn("The ".concat(CustomerDataLabel[customerDataType], " data exceeds the recommended ").concat(exports.CUSTOMER_DATA_BYTES_LIMIT / byteUtils_1.ONE_KIBI_BYTE, "KiB threshold. More details: https://docs.datadoghq.com/real_user_monitoring/browser/troubleshooting/#customer-data-exceeds-the-recommended-3kib-warning"));
        return true;
    }
    return false;
}
exports.warnIfCustomerDataLimitReached = warnIfCustomerDataLimitReached;
//# sourceMappingURL=heavyCustomerDataWarning.js.map
},{"../../tools/display":60,"../../tools/utils/byteUtils":76}],27:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeStorageListeners = exports.buildStorageKey = exports.createStoredContextManager = void 0;
var byteUtils_1 = require("../../tools/utils/byteUtils");
var addEventListener_1 = require("../../browser/addEventListener");
var contextManager_1 = require("./contextManager");
var CONTEXT_STORE_KEY_PREFIX = '_dd_c';
var storageListeners = [];
function createStoredContextManager(configuration, productKey, customerDataType, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = byteUtils_1.computeBytesCount; }
    var storageKey = buildStorageKey(productKey, customerDataType);
    var contextManager = (0, contextManager_1.createContextManager)(customerDataType, computeBytesCountImpl);
    synchronizeWithStorage();
    storageListeners.push((0, addEventListener_1.addEventListener)(configuration, window, "storage" /* DOM_EVENT.STORAGE */, function (_a) {
        var key = _a.key;
        if (storageKey === key) {
            synchronizeWithStorage();
        }
    }));
    contextManager.changeObservable.subscribe(dumpToStorage);
    return contextManager;
    function synchronizeWithStorage() {
        var rawContext = localStorage.getItem(storageKey);
        var context = rawContext !== null ? JSON.parse(rawContext) : {};
        contextManager.setContext(context);
    }
    function dumpToStorage() {
        localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
    }
}
exports.createStoredContextManager = createStoredContextManager;
function buildStorageKey(productKey, customerDataType) {
    return "".concat(CONTEXT_STORE_KEY_PREFIX, "_").concat(productKey, "_").concat(customerDataType);
}
exports.buildStorageKey = buildStorageKey;
function removeStorageListeners() {
    storageListeners.map(function (listener) { return listener.stop(); });
}
exports.removeStorageListeners = removeStorageListeners;
//# sourceMappingURL=storedContextManager.js.map
},{"../../browser/addEventListener":12,"../../tools/utils/byteUtils":76,"./contextManager":25}],28:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map
},{"./types":29}],29:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=types.js.map
},{}],30:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenErrorCauses = exports.createHandlingStack = exports.formatErrorMessage = exports.getFileFromStackTraceString = exports.toStackTraceString = exports.tryToGetFingerprint = exports.computeRawError = exports.NO_ERROR_STACK_PRESENT_MESSAGE = void 0;
var tracekit_1 = require("../tracekit");
var monitor_1 = require("../../tools/monitor");
var sanitize_1 = require("../../tools/serialisation/sanitize");
var functionUtils_1 = require("../../tools/utils/functionUtils");
var jsonStringify_1 = require("../../tools/serialisation/jsonStringify");
exports.NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
function computeRawError(_a) {
    var stackTrace = _a.stackTrace, originalError = _a.originalError, handlingStack = _a.handlingStack, startClocks = _a.startClocks, nonErrorPrefix = _a.nonErrorPrefix, source = _a.source, handling = _a.handling;
    var isErrorInstance = originalError instanceof Error;
    var message = computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError);
    var stack = hasUsableStack(isErrorInstance, stackTrace)
        ? toStackTraceString(stackTrace)
        : exports.NO_ERROR_STACK_PRESENT_MESSAGE;
    var causes = isErrorInstance ? flattenErrorCauses(originalError, source) : undefined;
    var type = stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name;
    var fingerprint = tryToGetFingerprint(originalError);
    return {
        startClocks: startClocks,
        source: source,
        handling: handling,
        handlingStack: handlingStack,
        originalError: originalError,
        type: type,
        message: message,
        stack: stack,
        causes: causes,
        fingerprint: fingerprint,
    };
}
exports.computeRawError = computeRawError;
function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name)
        ? stackTrace.message
        : !isErrorInstance
            ? "".concat(nonErrorPrefix, " ").concat((0, jsonStringify_1.jsonStringify)((0, sanitize_1.sanitize)(originalError)))
            : 'Empty message';
}
function hasUsableStack(isErrorInstance, stackTrace) {
    if (stackTrace === undefined) {
        return false;
    }
    if (isErrorInstance) {
        return true;
    }
    // handle cases where tracekit return stack = [] or stack = [{url: undefined, line: undefined, column: undefined}]
    // TODO rework tracekit integration to avoid generating those unusable stack
    return stackTrace.stack.length > 0 && (stackTrace.stack.length > 1 || stackTrace.stack[0].url !== undefined);
}
function tryToGetFingerprint(originalError) {
    return originalError instanceof Error && 'dd_fingerprint' in originalError
        ? String(originalError.dd_fingerprint)
        : undefined;
}
exports.tryToGetFingerprint = tryToGetFingerprint;
function toStackTraceString(stack) {
    var result = formatErrorMessage(stack);
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
exports.toStackTraceString = toStackTraceString;
function getFileFromStackTraceString(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
exports.getFileFromStackTraceString = getFileFromStackTraceString;
function formatErrorMessage(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}
exports.formatErrorMessage = formatErrorMessage;
/**
 Creates a stacktrace without SDK internal frames.
 
 Constraints:
 - Has to be called at the utmost position of the call stack.
 - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) {
        try {
            throw error;
        }
        catch (e) {
            (0, functionUtils_1.noop)();
        }
    }
    (0, monitor_1.callMonitored)(function () {
        var stackTrace = (0, tracekit_1.computeStackTrace)(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = toStackTraceString(stackTrace);
    });
    return formattedStack;
}
exports.createHandlingStack = createHandlingStack;
function flattenErrorCauses(error, parentSource) {
    var currentError = error;
    var causes = [];
    while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
        var stackTrace = (0, tracekit_1.computeStackTrace)(currentError.cause);
        causes.push({
            message: currentError.cause.message,
            source: parentSource,
            type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
            stack: stackTrace && toStackTraceString(stackTrace),
        });
        currentError = currentError.cause;
    }
    return causes.length ? causes : undefined;
}
exports.flattenErrorCauses = flattenErrorCauses;
//# sourceMappingURL=error.js.map
},{"../../tools/monitor":67,"../../tools/serialisation/jsonStringify":71,"../../tools/serialisation/sanitize":72,"../../tools/utils/functionUtils":77,"../tracekit":51}],31:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorSource = void 0;
exports.ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
//# sourceMappingURL=error.types.js.map
},{}],32:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackRuntimeError = void 0;
var timeUtils_1 = require("../../tools/utils/timeUtils");
var tracekit_1 = require("../tracekit");
var error_1 = require("./error");
var error_types_1 = require("./error.types");
function trackRuntimeError(errorObservable) {
    return (0, tracekit_1.startUnhandledErrorCollection)(function (stackTrace, originalError) {
        errorObservable.notify((0, error_1.computeRawError)({
            stackTrace: stackTrace,
            originalError: originalError,
            startClocks: (0, timeUtils_1.clocksNow)(),
            nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */,
            source: error_types_1.ErrorSource.SOURCE,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
        }));
    });
}
exports.trackRuntimeError = trackRuntimeError;
//# sourceMappingURL=trackRuntimeError.js.map
},{"../../tools/utils/timeUtils":83,"../tracekit":51,"./error":30,"./error.types":31}],33:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventRateLimiter = void 0;
var timer_1 = require("../../tools/timer");
var timeUtils_1 = require("../../tools/utils/timeUtils");
var error_types_1 = require("../error/error.types");
function createEventRateLimiter(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function () {
            if (eventCount === 0) {
                (0, timer_1.setTimeout)(function () {
                    eventCount = 0;
                }, timeUtils_1.ONE_MINUTE);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: error_types_1.ErrorSource.AGENT,
                        startClocks: (0, timeUtils_1.clocksNow)(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
exports.createEventRateLimiter = createEventRateLimiter;
//# sourceMappingURL=createEventRateLimiter.js.map
},{"../../tools/timer":73,"../../tools/utils/timeUtils":83,"../error/error.types":31}],34:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initReportObservable = exports.RawReportType = void 0;
var error_1 = require("../error/error");
var monitor_1 = require("../../tools/monitor");
var observable_1 = require("../../tools/observable");
var addEventListener_1 = require("../../browser/addEventListener");
var polyfills_1 = require("../../tools/utils/polyfills");
var stringUtils_1 = require("../../tools/utils/stringUtils");
exports.RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(configuration, apis) {
    var observables = [];
    if ((0, polyfills_1.includes)(apis, exports.RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable(configuration));
    }
    var reportTypes = apis.filter(function (api) { return api !== exports.RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return observable_1.mergeObservables.apply(void 0, observables);
}
exports.initReportObservable = initReportObservable;
function createReportObservable(reportTypes) {
    var observable = new observable_1.Observable(function () {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = (0, monitor_1.monitor)(function (reports, _) {
            return reports.forEach(function (report) {
                observable.notify(buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
    return observable;
}
function createCspViolationReportObservable(configuration) {
    var observable = new observable_1.Observable(function () {
        var stop = (0, addEventListener_1.addEventListener)(configuration, document, "securitypolicyviolation" /* DOM_EVENT.SECURITY_POLICY_VIOLATION */, function (event) {
            observable.notify(buildRawReportFromCspViolation(event));
        }).stop;
        return stop;
    });
    return observable;
}
function buildRawReportFromReport(_a) {
    var type = _a.type, body = _a.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function buildRawReportFromCspViolation(event) {
    var type = exports.RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: exports.RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: buildStack(event.effectiveDirective, event.originalPolicy
            ? "".concat(message, " of the policy \"").concat((0, stringUtils_1.safeTruncate)(event.originalPolicy, 100, '...'), "\"")
            : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return sourceFile
        ? (0, error_1.toStackTraceString)({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
                    column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined,
                },
            ],
        })
        : undefined;
}
//# sourceMappingURL=reportObservable.js.map
},{"../../browser/addEventListener":12,"../../tools/monitor":67,"../../tools/observable":68,"../../tools/utils/polyfills":80,"../../tools/utils/stringUtils":82,"../error/error":30}],35:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=resourceUtils.js.map
},{}],36:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryOldCookiesMigration = exports.LOGS_SESSION_KEY = exports.RUM_SESSION_KEY = exports.OLD_LOGS_COOKIE_NAME = exports.OLD_RUM_COOKIE_NAME = exports.OLD_SESSION_COOKIE_NAME = void 0;
var cookie_1 = require("../../browser/cookie");
var sessionStoreStrategy_1 = require("./storeStrategies/sessionStoreStrategy");
var sessionState_1 = require("./sessionState");
exports.OLD_SESSION_COOKIE_NAME = '_dd';
exports.OLD_RUM_COOKIE_NAME = '_dd_r';
exports.OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
exports.RUM_SESSION_KEY = 'rum';
exports.LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(cookieStoreStrategy) {
    var sessionString = (0, cookie_1.getCookie)(sessionStoreStrategy_1.SESSION_STORE_KEY);
    if (!sessionString) {
        var oldSessionId = (0, cookie_1.getCookie)(exports.OLD_SESSION_COOKIE_NAME);
        var oldRumType = (0, cookie_1.getCookie)(exports.OLD_RUM_COOKIE_NAME);
        var oldLogsType = (0, cookie_1.getCookie)(exports.OLD_LOGS_COOKIE_NAME);
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[exports.LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[exports.RUM_SESSION_KEY] = oldRumType;
        }
        if (!(0, sessionState_1.isSessionInExpiredState)(session)) {
            (0, sessionState_1.expandSessionState)(session);
            cookieStoreStrategy.persistSession(session);
        }
    }
}
exports.tryOldCookiesMigration = tryOldCookiesMigration;
//# sourceMappingURL=oldCookiesMigration.js.map
},{"../../browser/cookie":13,"./sessionState":39,"./storeStrategies/sessionStoreStrategy":44}],37:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_EXPIRATION_DELAY = exports.SESSION_TIME_OUT_DELAY = void 0;
var timeUtils_1 = require("../../tools/utils/timeUtils");
exports.SESSION_TIME_OUT_DELAY = 4 * timeUtils_1.ONE_HOUR;
exports.SESSION_EXPIRATION_DELAY = 15 * timeUtils_1.ONE_MINUTE;
//# sourceMappingURL=sessionConstants.js.map
},{"../../tools/utils/timeUtils":83}],38:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stopSessionManager = exports.startSessionManager = exports.VISIBILITY_CHECK_DELAY = void 0;
var valueHistory_1 = require("../../tools/valueHistory");
var timeUtils_1 = require("../../tools/utils/timeUtils");
var addEventListener_1 = require("../../browser/addEventListener");
var timer_1 = require("../../tools/timer");
var sessionConstants_1 = require("./sessionConstants");
var sessionStore_1 = require("./sessionStore");
exports.VISIBILITY_CHECK_DELAY = timeUtils_1.ONE_MINUTE;
var SESSION_CONTEXT_TIMEOUT_DELAY = sessionConstants_1.SESSION_TIME_OUT_DELAY;
var stopCallbacks = [];
function startSessionManager(configuration, productKey, computeSessionState) {
    // TODO - Improve configuration type and remove assertion
    var sessionStore = (0, sessionStore_1.startSessionStore)(configuration.sessionStoreStrategyType, productKey, computeSessionState);
    stopCallbacks.push(function () { return sessionStore.stop(); });
    var sessionContextHistory = new valueHistory_1.ValueHistory(SESSION_CONTEXT_TIMEOUT_DELAY);
    stopCallbacks.push(function () { return sessionContextHistory.stop(); });
    sessionStore.renewObservable.subscribe(function () {
        sessionContextHistory.add(buildSessionContext(), (0, timeUtils_1.relativeNow)());
    });
    sessionStore.expireObservable.subscribe(function () {
        sessionContextHistory.closeActive((0, timeUtils_1.relativeNow)());
    });
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), (0, timeUtils_1.clocksOrigin)().relative);
    trackActivity(configuration, function () { return sessionStore.expandOrRenewSession(); });
    trackVisibility(configuration, function () { return sessionStore.expandSession(); });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
        };
    }
    return {
        findActiveSession: function (startTime) { return sessionContextHistory.find(startTime); },
        renewObservable: sessionStore.renewObservable,
        expireObservable: sessionStore.expireObservable,
        expire: sessionStore.expire,
    };
}
exports.startSessionManager = startSessionManager;
function stopSessionManager() {
    stopCallbacks.forEach(function (e) { return e(); });
    stopCallbacks = [];
}
exports.stopSessionManager = stopSessionManager;
function trackActivity(configuration, expandOrRenewSession) {
    var stop = (0, addEventListener_1.addEventListeners)(configuration, window, ["click" /* DOM_EVENT.CLICK */, "touchstart" /* DOM_EVENT.TOUCH_START */, "keydown" /* DOM_EVENT.KEY_DOWN */, "scroll" /* DOM_EVENT.SCROLL */], expandOrRenewSession, { capture: true, passive: true }).stop;
    stopCallbacks.push(stop);
}
function trackVisibility(configuration, expandSession) {
    var expandSessionWhenVisible = function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    };
    var stop = (0, addEventListener_1.addEventListener)(configuration, document, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */, expandSessionWhenVisible).stop;
    stopCallbacks.push(stop);
    var visibilityCheckInterval = (0, timer_1.setInterval)(expandSessionWhenVisible, exports.VISIBILITY_CHECK_DELAY);
    stopCallbacks.push(function () {
        (0, timer_1.clearInterval)(visibilityCheckInterval);
    });
}
//# sourceMappingURL=sessionManager.js.map
},{"../../browser/addEventListener":12,"../../tools/timer":73,"../../tools/utils/timeUtils":83,"../../tools/valueHistory":86,"./sessionConstants":37,"./sessionStore":40}],39:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSessionState = exports.toSessionString = exports.expandSessionState = exports.isSessionInExpiredState = void 0;
var objectUtils_1 = require("../../tools/utils/objectUtils");
var polyfills_1 = require("../../tools/utils/polyfills");
var timeUtils_1 = require("../../tools/utils/timeUtils");
var sessionConstants_1 = require("./sessionConstants");
var SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
function isSessionInExpiredState(session) {
    return (0, objectUtils_1.isEmptyObject)(session);
}
exports.isSessionInExpiredState = isSessionInExpiredState;
function expandSessionState(session) {
    session.expire = String((0, timeUtils_1.dateNow)() + sessionConstants_1.SESSION_EXPIRATION_DELAY);
}
exports.expandSessionState = expandSessionState;
function toSessionString(session) {
    return (0, polyfills_1.objectEntries)(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join(SESSION_ENTRY_SEPARATOR);
}
exports.toSessionString = toSessionString;
function toSessionState(sessionString) {
    var session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
exports.toSessionState = toSessionState;
function isValidSessionString(sessionString) {
    return (!!sessionString &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
//# sourceMappingURL=sessionState.js.map
},{"../../tools/utils/objectUtils":79,"../../tools/utils/polyfills":80,"../../tools/utils/timeUtils":83,"./sessionConstants":37}],40:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startSessionStore = exports.selectSessionStoreStrategyType = exports.STORAGE_POLL_DELAY = void 0;
var timer_1 = require("../../tools/timer");
var observable_1 = require("../../tools/observable");
var timeUtils_1 = require("../../tools/utils/timeUtils");
var functionUtils_1 = require("../../tools/utils/functionUtils");
var stringUtils_1 = require("../../tools/utils/stringUtils");
var sessionConstants_1 = require("./sessionConstants");
var sessionInCookie_1 = require("./storeStrategies/sessionInCookie");
var sessionInLocalStorage_1 = require("./storeStrategies/sessionInLocalStorage");
var sessionStoreOperations_1 = require("./sessionStoreOperations");
/**
 * Every second, the storage will be polled to check for any change that can occur
 * to the session state in another browser tab, or another window.
 * This value has been determined from our previous cookie-only implementation.
 */
exports.STORAGE_POLL_DELAY = timeUtils_1.ONE_SECOND;
/**
 * Checks if cookies are available as the preferred storage
 * Else, checks if LocalStorage is allowed and available
 */
function selectSessionStoreStrategyType(initConfiguration) {
    var sessionStoreStrategyType = (0, sessionInCookie_1.selectCookieStrategy)(initConfiguration);
    if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) {
        sessionStoreStrategyType = (0, sessionInLocalStorage_1.selectLocalStorageStrategy)();
    }
    return sessionStoreStrategyType;
}
exports.selectSessionStoreStrategyType = selectSessionStoreStrategyType;
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(sessionStoreStrategyType, productKey, computeSessionState) {
    var renewObservable = new observable_1.Observable();
    var expireObservable = new observable_1.Observable();
    var sessionStoreStrategy = sessionStoreStrategyType.type === 'Cookie'
        ? (0, sessionInCookie_1.initCookieStrategy)(sessionStoreStrategyType.cookieOptions)
        : (0, sessionInLocalStorage_1.initLocalStorageStrategy)();
    var clearSession = sessionStoreStrategy.clearSession, retrieveSession = sessionStoreStrategy.retrieveSession;
    var watchSessionTimeoutId = (0, timer_1.setInterval)(watchSession, exports.STORAGE_POLL_DELAY);
    var sessionCache = retrieveActiveSession();
    function expandOrRenewSession() {
        var isTracked;
        (0, sessionStoreOperations_1.processSessionStoreOperations)({
            process: function (sessionState) {
                var synchronizedSession = synchronizeSession(sessionState);
                isTracked = expandOrRenewSessionState(synchronizedSession);
                return synchronizedSession;
            },
            after: function (sessionState) {
                if (isTracked && !hasSessionInCache()) {
                    renewSessionInCache(sessionState);
                }
                sessionCache = sessionState;
            },
        }, sessionStoreStrategy);
    }
    function expandSession() {
        (0, sessionStoreOperations_1.processSessionStoreOperations)({
            process: function (sessionState) { return (hasSessionInCache() ? synchronizeSession(sessionState) : undefined); },
        }, sessionStoreStrategy);
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session store
     * - if the session is not active, clear the session store and expire the session cache
     */
    function watchSession() {
        (0, sessionStoreOperations_1.processSessionStoreOperations)({
            process: function (sessionState) { return (!isActiveSession(sessionState) ? {} : undefined); },
            after: synchronizeSession,
        }, sessionStoreStrategy);
    }
    function synchronizeSession(sessionState) {
        if (!isActiveSession(sessionState)) {
            sessionState = {};
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(sessionState)) {
                expireSessionInCache();
            }
            else {
                sessionCache = sessionState;
            }
        }
        return sessionState;
    }
    function expandOrRenewSessionState(sessionState) {
        var _a = computeSessionState(sessionState[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        sessionState[productKey] = trackingType;
        if (isTracked && !sessionState.id) {
            sessionState.id = (0, stringUtils_1.generateUUID)();
            sessionState.created = String((0, timeUtils_1.dateNow)());
        }
        return isTracked;
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(sessionState) {
        return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
    }
    function expireSessionInCache() {
        sessionCache = {};
        expireObservable.notify();
    }
    function renewSessionInCache(sessionState) {
        sessionCache = sessionState;
        renewObservable.notify();
    }
    function retrieveActiveSession() {
        var session = retrieveSession();
        if (isActiveSession(session)) {
            return session;
        }
        return {};
    }
    function isActiveSession(sessionState) {
        // created and expire can be undefined for versions which was not storing them
        // these checks could be removed when older versions will not be available/live anymore
        return ((sessionState.created === undefined || (0, timeUtils_1.dateNow)() - Number(sessionState.created) < sessionConstants_1.SESSION_TIME_OUT_DELAY) &&
            (sessionState.expire === undefined || (0, timeUtils_1.dateNow)() < Number(sessionState.expire)));
    }
    return {
        expandOrRenewSession: (0, functionUtils_1.throttle)(expandOrRenewSession, exports.STORAGE_POLL_DELAY).throttled,
        expandSession: expandSession,
        getSession: function () { return sessionCache; },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        expire: function () {
            clearSession();
            synchronizeSession({});
        },
        stop: function () {
            (0, timer_1.clearInterval)(watchSessionTimeoutId);
        },
    };
}
exports.startSessionStore = startSessionStore;
//# sourceMappingURL=sessionStore.js.map
},{"../../tools/observable":68,"../../tools/timer":73,"../../tools/utils/functionUtils":77,"../../tools/utils/stringUtils":82,"../../tools/utils/timeUtils":83,"./sessionConstants":37,"./sessionStoreOperations":41,"./storeStrategies/sessionInCookie":42,"./storeStrategies/sessionInLocalStorage":43}],41:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processSessionStoreOperations = exports.LOCK_MAX_TRIES = exports.LOCK_RETRY_DELAY = void 0;
var timer_1 = require("../../tools/timer");
var stringUtils_1 = require("../../tools/utils/stringUtils");
var sessionState_1 = require("./sessionState");
exports.LOCK_RETRY_DELAY = 10;
exports.LOCK_MAX_TRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function processSessionStoreOperations(operations, sessionStoreStrategy, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) { numberOfRetries = 0; }
    var isLockEnabled = sessionStoreStrategy.isLockEnabled, retrieveSession = sessionStoreStrategy.retrieveSession, persistSession = sessionStoreStrategy.persistSession, clearSession = sessionStoreStrategy.clearSession;
    if (!ongoingOperations) {
        ongoingOperations = operations;
    }
    if (operations !== ongoingOperations) {
        bufferedOperations.push(operations);
        return;
    }
    if (isLockEnabled && numberOfRetries >= exports.LOCK_MAX_TRIES) {
        next(sessionStoreStrategy);
        return;
    }
    var currentLock;
    var currentSession = retrieveSession();
    if (isLockEnabled) {
        // if someone has lock, retry later
        if (currentSession.lock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = (0, stringUtils_1.generateUUID)();
        currentSession.lock = currentLock;
        persistSession(currentSession);
        // if lock is not acquired, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentSession);
    if (isLockEnabled) {
        // if lock corrupted after process, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        if ((0, sessionState_1.isSessionInExpiredState)(processedSession)) {
            clearSession();
        }
        else {
            (0, sessionState_1.expandSessionState)(processedSession);
            persistSession(processedSession);
        }
    }
    if (isLockEnabled) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && (0, sessionState_1.isSessionInExpiredState)(processedSession))) {
            // if lock corrupted after persist, retry later
            currentSession = retrieveSession();
            if (currentSession.lock !== currentLock) {
                retryLater(operations, sessionStoreStrategy, numberOfRetries);
                return;
            }
            delete currentSession.lock;
            persistSession(currentSession);
            processedSession = currentSession;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date session state value => the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentSession);
    next(sessionStoreStrategy);
}
exports.processSessionStoreOperations = processSessionStoreOperations;
function retryLater(operations, sessionStore, currentNumberOfRetries) {
    (0, timer_1.setTimeout)(function () {
        processSessionStoreOperations(operations, sessionStore, currentNumberOfRetries + 1);
    }, exports.LOCK_RETRY_DELAY);
}
function next(sessionStore) {
    ongoingOperations = undefined;
    var nextOperations = bufferedOperations.shift();
    if (nextOperations) {
        processSessionStoreOperations(nextOperations, sessionStore);
    }
}
//# sourceMappingURL=sessionStoreOperations.js.map
},{"../../tools/timer":73,"../../tools/utils/stringUtils":82,"./sessionState":39}],42:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCookieOptions = exports.initCookieStrategy = exports.selectCookieStrategy = void 0;
var browserDetection_1 = require("../../../tools/utils/browserDetection");
var cookie_1 = require("../../../browser/cookie");
var oldCookiesMigration_1 = require("../oldCookiesMigration");
var sessionConstants_1 = require("../sessionConstants");
var sessionState_1 = require("../sessionState");
var sessionStoreStrategy_1 = require("./sessionStoreStrategy");
function selectCookieStrategy(initConfiguration) {
    var cookieOptions = buildCookieOptions(initConfiguration);
    return (0, cookie_1.areCookiesAuthorized)(cookieOptions) ? { type: 'Cookie', cookieOptions: cookieOptions } : undefined;
}
exports.selectCookieStrategy = selectCookieStrategy;
function initCookieStrategy(cookieOptions) {
    var cookieStore = {
        /**
         * Lock strategy allows mitigating issues due to concurrent access to cookie.
         * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
         */
        isLockEnabled: (0, browserDetection_1.isChromium)(),
        persistSession: persistSessionCookie(cookieOptions),
        retrieveSession: retrieveSessionCookie,
        clearSession: deleteSessionCookie(cookieOptions),
    };
    (0, oldCookiesMigration_1.tryOldCookiesMigration)(cookieStore);
    return cookieStore;
}
exports.initCookieStrategy = initCookieStrategy;
function persistSessionCookie(options) {
    return function (session) {
        (0, cookie_1.setCookie)(sessionStoreStrategy_1.SESSION_STORE_KEY, (0, sessionState_1.toSessionString)(session), sessionConstants_1.SESSION_EXPIRATION_DELAY, options);
    };
}
function retrieveSessionCookie() {
    var sessionString = (0, cookie_1.getCookie)(sessionStoreStrategy_1.SESSION_STORE_KEY);
    return (0, sessionState_1.toSessionState)(sessionString);
}
function deleteSessionCookie(options) {
    return function () {
        (0, cookie_1.deleteCookie)(sessionStoreStrategy_1.SESSION_STORE_KEY, options);
    };
}
function buildCookieOptions(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = !!initConfiguration.useSecureSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.crossSite = !!initConfiguration.useCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = (0, cookie_1.getCurrentSite)();
    }
    return cookieOptions;
}
exports.buildCookieOptions = buildCookieOptions;
//# sourceMappingURL=sessionInCookie.js.map
},{"../../../browser/cookie":13,"../../../tools/utils/browserDetection":75,"../oldCookiesMigration":36,"../sessionConstants":37,"../sessionState":39,"./sessionStoreStrategy":44}],43:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initLocalStorageStrategy = exports.selectLocalStorageStrategy = void 0;
var stringUtils_1 = require("../../../tools/utils/stringUtils");
var sessionState_1 = require("../sessionState");
var sessionStoreStrategy_1 = require("./sessionStoreStrategy");
var LOCAL_STORAGE_TEST_KEY = '_dd_test_';
function selectLocalStorageStrategy() {
    try {
        var id = (0, stringUtils_1.generateUUID)();
        var testKey = "".concat(LOCAL_STORAGE_TEST_KEY).concat(id);
        localStorage.setItem(testKey, id);
        var retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? { type: 'LocalStorage' } : undefined;
    }
    catch (e) {
        return undefined;
    }
}
exports.selectLocalStorageStrategy = selectLocalStorageStrategy;
function initLocalStorageStrategy() {
    return {
        isLockEnabled: false,
        persistSession: persistInLocalStorage,
        retrieveSession: retrieveSessionFromLocalStorage,
        clearSession: clearSessionFromLocalStorage,
    };
}
exports.initLocalStorageStrategy = initLocalStorageStrategy;
function persistInLocalStorage(sessionState) {
    localStorage.setItem(sessionStoreStrategy_1.SESSION_STORE_KEY, (0, sessionState_1.toSessionString)(sessionState));
}
function retrieveSessionFromLocalStorage() {
    var sessionString = localStorage.getItem(sessionStoreStrategy_1.SESSION_STORE_KEY);
    return (0, sessionState_1.toSessionState)(sessionString);
}
function clearSessionFromLocalStorage() {
    localStorage.removeItem(sessionStoreStrategy_1.SESSION_STORE_KEY);
}
//# sourceMappingURL=sessionInLocalStorage.js.map
},{"../../../tools/utils/stringUtils":82,"../sessionState":39,"./sessionStoreStrategy":44}],44:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_STORE_KEY = void 0;
exports.SESSION_STORE_KEY = '_dd_s';
//# sourceMappingURL=sessionStoreStrategy.js.map
},{}],45:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSyntheticsResultId = exports.getSyntheticsTestId = exports.willSyntheticsInjectRum = exports.SYNTHETICS_INJECTS_RUM_COOKIE_NAME = exports.SYNTHETICS_RESULT_ID_COOKIE_NAME = exports.SYNTHETICS_TEST_ID_COOKIE_NAME = void 0;
var cookie_1 = require("../../browser/cookie");
exports.SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
exports.SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
exports.SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function willSyntheticsInjectRum() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || (0, cookie_1.getCookie)(exports.SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
exports.willSyntheticsInjectRum = willSyntheticsInjectRum;
function getSyntheticsTestId() {
    var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || (0, cookie_1.getCookie)(exports.SYNTHETICS_TEST_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
exports.getSyntheticsTestId = getSyntheticsTestId;
function getSyntheticsResultId() {
    var value = window._DATADOG_SYNTHETICS_RESULT_ID || (0, cookie_1.getCookie)(exports.SYNTHETICS_RESULT_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
exports.getSyntheticsResultId = getSyntheticsResultId;
//# sourceMappingURL=syntheticsWorkerValues.js.map
},{"../../browser/cookie":13}],46:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addTelemetryConfiguration = exports.isTelemetryReplicationAllowed = exports.startTelemetry = exports.resetTelemetry = exports.startFakeTelemetry = exports.addTelemetryError = exports.addTelemetryDebug = void 0;
var telemetry_1 = require("./telemetry");
Object.defineProperty(exports, "addTelemetryDebug", { enumerable: true, get: function () { return telemetry_1.addTelemetryDebug; } });
Object.defineProperty(exports, "addTelemetryError", { enumerable: true, get: function () { return telemetry_1.addTelemetryError; } });
Object.defineProperty(exports, "startFakeTelemetry", { enumerable: true, get: function () { return telemetry_1.startFakeTelemetry; } });
Object.defineProperty(exports, "resetTelemetry", { enumerable: true, get: function () { return telemetry_1.resetTelemetry; } });
Object.defineProperty(exports, "startTelemetry", { enumerable: true, get: function () { return telemetry_1.startTelemetry; } });
Object.defineProperty(exports, "isTelemetryReplicationAllowed", { enumerable: true, get: function () { return telemetry_1.isTelemetryReplicationAllowed; } });
Object.defineProperty(exports, "addTelemetryConfiguration", { enumerable: true, get: function () { return telemetry_1.addTelemetryConfiguration; } });
__exportStar(require("./rawTelemetryEvent.types"), exports);
__exportStar(require("./telemetryEvent.types"), exports);
//# sourceMappingURL=index.js.map
},{"./rawTelemetryEvent.types":47,"./telemetry":48,"./telemetryEvent.types":49}],47:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryType = void 0;
exports.TelemetryType = {
    log: 'log',
    configuration: 'configuration',
};
//# sourceMappingURL=rawTelemetryEvent.types.js.map
},{}],48:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrubCustomerFrames = exports.formatError = exports.addTelemetryConfiguration = exports.addTelemetryError = exports.addTelemetryDebug = exports.isTelemetryReplicationAllowed = exports.resetTelemetry = exports.startFakeTelemetry = exports.startTelemetry = void 0;
var display_1 = require("../../tools/display");
var error_1 = require("../error/error");
var experimentalFeatures_1 = require("../../tools/experimentalFeatures");
var configuration_1 = require("../configuration");
var tracekit_1 = require("../tracekit");
var observable_1 = require("../../tools/observable");
var timeUtils_1 = require("../../tools/utils/timeUtils");
var monitor_1 = require("../../tools/monitor");
var sendToExtension_1 = require("../../tools/sendToExtension");
var polyfills_1 = require("../../tools/utils/polyfills");
var numberUtils_1 = require("../../tools/utils/numberUtils");
var jsonStringify_1 = require("../../tools/serialisation/jsonStringify");
var mergeInto_1 = require("../../tools/mergeInto");
var rawTelemetryEvent_types_1 = require("./rawTelemetryEvent.types");
var ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'https://d3uc069fcn7uxw.cloudfront.net',
    'https://d20xtzwzcl0ceb.cloudfront.net',
    'http://localhost',
    '<anonymous>',
];
var TELEMETRY_EXCLUDED_SITES = [configuration_1.INTAKE_SITE_US1_FED];
var telemetryConfiguration = { maxEventsPerPage: 0, sentEventCount: 0, telemetryEnabled: false, telemetryConfigurationEnabled: false };
var onRawTelemetryEventCollected;
function startTelemetry(telemetryService, configuration) {
    var contextProvider;
    var observable = new observable_1.Observable();
    telemetryConfiguration.telemetryEnabled =
        !(0, polyfills_1.includes)(TELEMETRY_EXCLUDED_SITES, configuration.site) && (0, numberUtils_1.performDraw)(configuration.telemetrySampleRate);
    telemetryConfiguration.telemetryConfigurationEnabled =
        telemetryConfiguration.telemetryEnabled && (0, numberUtils_1.performDraw)(configuration.telemetryConfigurationSampleRate);
    var runtimeEnvInfo = getRuntimeEnvInfo();
    onRawTelemetryEventCollected = function (rawEvent) {
        if (telemetryConfiguration.telemetryEnabled) {
            var event_1 = toTelemetryEvent(telemetryService, rawEvent, runtimeEnvInfo);
            observable.notify(event_1);
            (0, sendToExtension_1.sendToExtension)('telemetry', event_1);
        }
    };
    (0, monitor_1.startMonitorErrorCollection)(addTelemetryError);
    (0, polyfills_1.assign)(telemetryConfiguration, {
        maxEventsPerPage: configuration.maxTelemetryEventsPerPage,
        sentEventCount: 0,
    });
    function toTelemetryEvent(telemetryService, event, runtimeEnvInfo) {
        return (0, mergeInto_1.combine)({
            type: 'telemetry',
            date: (0, timeUtils_1.timeStampNow)(),
            service: telemetryService,
            version: "4.50.1",
            source: 'browser',
            _dd: {
                format_version: 2,
            },
            telemetry: (0, mergeInto_1.combine)(event, {
                runtime_env: runtimeEnvInfo,
            }),
            experimental_features: (0, polyfills_1.arrayFrom)((0, experimentalFeatures_1.getExperimentalFeatures)()),
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function (provider) {
            contextProvider = provider;
        },
        observable: observable,
        enabled: telemetryConfiguration.telemetryEnabled,
    };
}
exports.startTelemetry = startTelemetry;
function getRuntimeEnvInfo() {
    return {
        is_local_file: window.location.protocol === 'file:',
        is_worker: 'WorkerGlobalScope' in self,
    };
}
function startFakeTelemetry() {
    var events = [];
    (0, polyfills_1.assign)(telemetryConfiguration, {
        maxEventsPerPage: Infinity,
        sentEventCount: 0,
    });
    onRawTelemetryEventCollected = function (event) {
        events.push(event);
    };
    return events;
}
exports.startFakeTelemetry = startFakeTelemetry;
function resetTelemetry() {
    onRawTelemetryEventCollected = undefined;
}
exports.resetTelemetry = resetTelemetry;
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
    return configuration.site === configuration_1.INTAKE_SITE_STAGING;
}
exports.isTelemetryReplicationAllowed = isTelemetryReplicationAllowed;
function addTelemetryDebug(message, context) {
    (0, monitor_1.displayIfDebugEnabled)(display_1.ConsoleApiName.debug, message, context);
    addTelemetry((0, polyfills_1.assign)({
        type: rawTelemetryEvent_types_1.TelemetryType.log,
        message: message,
        status: "debug" /* StatusType.debug */,
    }, context));
}
exports.addTelemetryDebug = addTelemetryDebug;
function addTelemetryError(e, context) {
    addTelemetry((0, polyfills_1.assign)({
        type: rawTelemetryEvent_types_1.TelemetryType.log,
        status: "error" /* StatusType.error */,
    }, formatError(e), context));
}
exports.addTelemetryError = addTelemetryError;
function addTelemetryConfiguration(configuration) {
    if (telemetryConfiguration.telemetryConfigurationEnabled) {
        addTelemetry({
            type: rawTelemetryEvent_types_1.TelemetryType.configuration,
            configuration: configuration,
        });
    }
}
exports.addTelemetryConfiguration = addTelemetryConfiguration;
function addTelemetry(event) {
    if (onRawTelemetryEventCollected && telemetryConfiguration.sentEventCount < telemetryConfiguration.maxEventsPerPage) {
        telemetryConfiguration.sentEventCount += 1;
        onRawTelemetryEventCollected(event);
    }
}
function formatError(e) {
    if (e instanceof Error) {
        var stackTrace = (0, tracekit_1.computeStackTrace)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0, error_1.toStackTraceString)(scrubCustomerFrames(stackTrace)),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: error_1.NO_ERROR_STACK_PRESENT_MESSAGE,
        },
        message: "".concat("Uncaught" /* NonErrorPrefix.UNCAUGHT */, " ").concat((0, jsonStringify_1.jsonStringify)(e)),
    };
}
exports.formatError = formatError;
function scrubCustomerFrames(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function (frame) { return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) { return (0, polyfills_1.startsWith)(frame.url, allowedFrameUrl); }); });
    return stackTrace;
}
exports.scrubCustomerFrames = scrubCustomerFrames;
//# sourceMappingURL=telemetry.js.map
},{"../../tools/display":60,"../../tools/experimentalFeatures":61,"../../tools/mergeInto":66,"../../tools/monitor":67,"../../tools/observable":68,"../../tools/sendToExtension":70,"../../tools/serialisation/jsonStringify":71,"../../tools/utils/numberUtils":78,"../../tools/utils/polyfills":80,"../../tools/utils/timeUtils":83,"../configuration":20,"../error/error":30,"../tracekit":51,"./rawTelemetryEvent.types":47}],49:[function(require,module,exports){
"use strict";
/* eslint-disable */
/**
 * DO NOT MODIFY IT BY HAND. Run `yarn rum-events-format:sync` instead.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=telemetryEvent.types.js.map
},{}],50:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeStackTrace = void 0;
var polyfills_1 = require("../../tools/utils/polyfills");
var UNKNOWN_FUNCTION = '?';
/**
 * Computes a stack trace for an exception.
 */
function computeStackTrace(ex) {
    var stack = [];
    var stackProperty = tryToGetString(ex, 'stack');
    var exString = String(ex);
    if (stackProperty && (0, polyfills_1.startsWith)(stackProperty, exString)) {
        stackProperty = stackProperty.slice(exString.length);
    }
    if (stackProperty) {
        stackProperty.split('\n').forEach(function (line) {
            var stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    return {
        message: tryToGetString(ex, 'message'),
        name: tryToGetString(ex, 'name'),
        stack: stack,
    };
}
exports.computeStackTrace = computeStackTrace;
var fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)';
var filePosition = '(?::(\\d+))';
var CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "?\\)?\\s*$"), 'i');
var CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(filePosition).concat(filePosition, "\\)"));
function parseChromeLine(line) {
    var parts = CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
var CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "??\\s*$"), 'i');
function parseChromeAnonymousLine(line) {
    var parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1],
    };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
    var parts = WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
var GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
    var parts = GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=computeStackTrace.js.map
},{"../../tools/utils/polyfills":80}],51:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startUnhandledErrorCollection = exports.computeStackTrace = void 0;
var computeStackTrace_1 = require("./computeStackTrace");
Object.defineProperty(exports, "computeStackTrace", { enumerable: true, get: function () { return computeStackTrace_1.computeStackTrace; } });
var tracekit_1 = require("./tracekit");
Object.defineProperty(exports, "startUnhandledErrorCollection", { enumerable: true, get: function () { return tracekit_1.startUnhandledErrorCollection; } });
//# sourceMappingURL=index.js.map
},{"./computeStackTrace":50,"./tracekit":52}],52:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startUnhandledErrorCollection = void 0;
var instrumentMethod_1 = require("../../tools/instrumentMethod");
var computeStackTrace_1 = require("./computeStackTrace");
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
/**
 * Cross-browser collection of unhandled errors
 *
 * Supports:
 * - Firefox: full stack trace with line numbers, plus column number
 * on top frame; column number is not guaranteed
 * - Opera: full stack trace with line and column numbers
 * - Chrome: full stack trace with line and column numbers
 * - Safari: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 * - IE: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 * - IE5.5+ (only 8.0 tested)
 * - Firefox 0.9+ (only 3.5+ tested)
 * - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 * Exceptions Have Stacktrace to be enabled in opera:config)
 * - Safari 3+ (only 4+ tested)
 * - Chrome 1+ (only 5+ tested)
 * - Konqueror 3.5+ (untested)
 *
 * Tries to catch all unhandled errors and report them to the
 * callback.
 *
 * Callbacks receive a StackTrace object as described in the
 * computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */
function startUnhandledErrorCollection(callback) {
    var stopInstrumentingOnError = instrumentOnError(callback).stop;
    var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(callback).stop;
    return {
        stop: function () {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        },
    };
}
exports.startUnhandledErrorCollection = startUnhandledErrorCollection;
/**
 * Install a global onerror handler
 */
function instrumentOnError(callback) {
    return (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(window, 'onerror', {
        before: function (messageObj, url, line, column, errorObj) {
            var stackTrace;
            if (errorObj instanceof Error) {
                stackTrace = (0, computeStackTrace_1.computeStackTrace)(errorObj);
            }
            else {
                var stack = [{ url: url, column: column, line: line }];
                var _a = tryToParseMessage(messageObj), name_1 = _a.name, message = _a.message;
                stackTrace = {
                    name: name_1,
                    message: message,
                    stack: stack,
                };
            }
            callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
        },
    });
}
function tryToParseMessage(messageObj) {
    var _a;
    var name;
    var message;
    if ({}.toString.call(messageObj) === '[object String]') {
        ;
        _a = ERROR_TYPES_RE.exec(messageObj), name = _a[1], message = _a[2];
    }
    return { name: name, message: message };
}
/**
 * Install a global onunhandledrejection handler
 */
function instrumentUnhandledRejection(callback) {
    return (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(window, 'onunhandledrejection', {
        before: function (e) {
            var reason = e.reason || 'Empty reason';
            var stack = (0, computeStackTrace_1.computeStackTrace)(reason);
            callback(stack, reason);
        },
    });
}
//# sourceMappingURL=tracekit.js.map
},{"../../tools/instrumentMethod":64,"./computeStackTrace":50}],53:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./user.types"), exports);
__exportStar(require("./user"), exports);
//# sourceMappingURL=index.js.map
},{"./user":54,"./user.types":55}],54:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkUser = exports.sanitizeUser = void 0;
var display_1 = require("../../tools/display");
var typeUtils_1 = require("../../tools/utils/typeUtils");
var polyfills_1 = require("../../tools/utils/polyfills");
/**
 * Clone input data and ensure known user properties (id, name, email)
 * are strings, as defined here:
 * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
 */
function sanitizeUser(newUser) {
    // We shallow clone only to prevent mutation of user data.
    var user = (0, polyfills_1.assign)({}, newUser);
    var keys = ['id', 'name', 'email'];
    keys.forEach(function (key) {
        if (key in user) {
            user[key] = String(user[key]);
        }
    });
    return user;
}
exports.sanitizeUser = sanitizeUser;
/**
 * Simple check to ensure user is valid
 */
function checkUser(newUser) {
    var isValid = (0, typeUtils_1.getType)(newUser) === 'object';
    if (!isValid) {
        display_1.display.error('Unsupported user:', newUser);
    }
    return isValid;
}
exports.checkUser = checkUser;
//# sourceMappingURL=user.js.map
},{"../../tools/display":60,"../../tools/utils/polyfills":80,"../../tools/utils/typeUtils":84}],55:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=user.types.js.map
},{}],56:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileFromStackTraceString = exports.toStackTraceString = exports.createHandlingStack = exports.computeRawError = exports.instrumentSetter = exports.instrumentMethodAndCallOriginal = exports.instrumentMethod = exports.getZoneJsOriginalValue = exports.runOnReadyState = exports.sendToExtension = exports.AbstractLifeCycle = exports.createFlushController = exports.startBatchWithReplica = exports.getEventBridge = exports.canUseEventBridge = exports.createHttpRequest = exports.SESSION_TIME_OUT_DELAY = exports.stopSessionManager = exports.startSessionManager = exports.Observable = exports.setDebugMode = exports.callMonitored = exports.monitor = exports.monitored = exports.addTelemetryConfiguration = exports.isTelemetryReplicationAllowed = exports.resetTelemetry = exports.startFakeTelemetry = exports.addTelemetryError = exports.addTelemetryDebug = exports.startTelemetry = exports.RawReportType = exports.initReportObservable = exports.makePublicApi = exports.defineGlobal = exports.computeStackTrace = exports.trackRuntimeError = exports.ExperimentalFeature = exports.getExperimentalFeatures = exports.resetExperimentalFeatures = exports.addExperimentalFeatures = exports.isExperimentalFeatureEnabled = exports.INTAKE_SITE_EU1 = exports.INTAKE_SITE_US1_FED = exports.INTAKE_SITE_US1 = exports.INTAKE_SITE_STAGING = exports.INTAKE_SITE_AP1 = exports.serializeConfiguration = exports.DefaultPrivacyLevel = exports.validateAndBuildConfiguration = void 0;
exports.ErrorSource = exports.sanitizeUser = exports.checkUser = exports.getSyntheticsResultId = exports.getSyntheticsTestId = exports.willSyntheticsInjectRum = exports.SESSION_STORE_KEY = exports.STORAGE_POLL_DELAY = exports.readBytesFromStream = exports.CLEAR_OLD_VALUES_INTERVAL = exports.ValueHistory = exports.CUSTOMER_DATA_BYTES_LIMIT = exports.warnIfCustomerDataLimitReached = exports.removeStorageListeners = exports.createStoredContextManager = exports.createContextManager = exports.catchUserErrors = exports.BoundedBuffer = exports.resetConsoleObservable = exports.initConsoleObservable = exports.isPageExitReason = exports.PageExitReason = exports.createPageExitObservable = exports.initFetchObservable = exports.initXhrObservable = exports.deleteCookie = exports.setCookie = exports.getCookie = exports.areCookiesAuthorized = exports.NO_ERROR_STACK_PRESENT_MESSAGE = void 0;
var configuration_1 = require("./domain/configuration");
Object.defineProperty(exports, "validateAndBuildConfiguration", { enumerable: true, get: function () { return configuration_1.validateAndBuildConfiguration; } });
Object.defineProperty(exports, "DefaultPrivacyLevel", { enumerable: true, get: function () { return configuration_1.DefaultPrivacyLevel; } });
Object.defineProperty(exports, "serializeConfiguration", { enumerable: true, get: function () { return configuration_1.serializeConfiguration; } });
Object.defineProperty(exports, "INTAKE_SITE_AP1", { enumerable: true, get: function () { return configuration_1.INTAKE_SITE_AP1; } });
Object.defineProperty(exports, "INTAKE_SITE_STAGING", { enumerable: true, get: function () { return configuration_1.INTAKE_SITE_STAGING; } });
Object.defineProperty(exports, "INTAKE_SITE_US1", { enumerable: true, get: function () { return configuration_1.INTAKE_SITE_US1; } });
Object.defineProperty(exports, "INTAKE_SITE_US1_FED", { enumerable: true, get: function () { return configuration_1.INTAKE_SITE_US1_FED; } });
Object.defineProperty(exports, "INTAKE_SITE_EU1", { enumerable: true, get: function () { return configuration_1.INTAKE_SITE_EU1; } });
var experimentalFeatures_1 = require("./tools/experimentalFeatures");
Object.defineProperty(exports, "isExperimentalFeatureEnabled", { enumerable: true, get: function () { return experimentalFeatures_1.isExperimentalFeatureEnabled; } });
Object.defineProperty(exports, "addExperimentalFeatures", { enumerable: true, get: function () { return experimentalFeatures_1.addExperimentalFeatures; } });
Object.defineProperty(exports, "resetExperimentalFeatures", { enumerable: true, get: function () { return experimentalFeatures_1.resetExperimentalFeatures; } });
Object.defineProperty(exports, "getExperimentalFeatures", { enumerable: true, get: function () { return experimentalFeatures_1.getExperimentalFeatures; } });
Object.defineProperty(exports, "ExperimentalFeature", { enumerable: true, get: function () { return experimentalFeatures_1.ExperimentalFeature; } });
var trackRuntimeError_1 = require("./domain/error/trackRuntimeError");
Object.defineProperty(exports, "trackRuntimeError", { enumerable: true, get: function () { return trackRuntimeError_1.trackRuntimeError; } });
var tracekit_1 = require("./domain/tracekit");
Object.defineProperty(exports, "computeStackTrace", { enumerable: true, get: function () { return tracekit_1.computeStackTrace; } });
var init_1 = require("./boot/init");
Object.defineProperty(exports, "defineGlobal", { enumerable: true, get: function () { return init_1.defineGlobal; } });
Object.defineProperty(exports, "makePublicApi", { enumerable: true, get: function () { return init_1.makePublicApi; } });
var reportObservable_1 = require("./domain/report/reportObservable");
Object.defineProperty(exports, "initReportObservable", { enumerable: true, get: function () { return reportObservable_1.initReportObservable; } });
Object.defineProperty(exports, "RawReportType", { enumerable: true, get: function () { return reportObservable_1.RawReportType; } });
var telemetry_1 = require("./domain/telemetry");
Object.defineProperty(exports, "startTelemetry", { enumerable: true, get: function () { return telemetry_1.startTelemetry; } });
Object.defineProperty(exports, "addTelemetryDebug", { enumerable: true, get: function () { return telemetry_1.addTelemetryDebug; } });
Object.defineProperty(exports, "addTelemetryError", { enumerable: true, get: function () { return telemetry_1.addTelemetryError; } });
Object.defineProperty(exports, "startFakeTelemetry", { enumerable: true, get: function () { return telemetry_1.startFakeTelemetry; } });
Object.defineProperty(exports, "resetTelemetry", { enumerable: true, get: function () { return telemetry_1.resetTelemetry; } });
Object.defineProperty(exports, "isTelemetryReplicationAllowed", { enumerable: true, get: function () { return telemetry_1.isTelemetryReplicationAllowed; } });
Object.defineProperty(exports, "addTelemetryConfiguration", { enumerable: true, get: function () { return telemetry_1.addTelemetryConfiguration; } });
var monitor_1 = require("./tools/monitor");
Object.defineProperty(exports, "monitored", { enumerable: true, get: function () { return monitor_1.monitored; } });
Object.defineProperty(exports, "monitor", { enumerable: true, get: function () { return monitor_1.monitor; } });
Object.defineProperty(exports, "callMonitored", { enumerable: true, get: function () { return monitor_1.callMonitored; } });
Object.defineProperty(exports, "setDebugMode", { enumerable: true, get: function () { return monitor_1.setDebugMode; } });
var observable_1 = require("./tools/observable");
Object.defineProperty(exports, "Observable", { enumerable: true, get: function () { return observable_1.Observable; } });
var sessionManager_1 = require("./domain/session/sessionManager");
Object.defineProperty(exports, "startSessionManager", { enumerable: true, get: function () { return sessionManager_1.startSessionManager; } });
// Exposed for tests
Object.defineProperty(exports, "stopSessionManager", { enumerable: true, get: function () { return sessionManager_1.stopSessionManager; } });
var sessionConstants_1 = require("./domain/session/sessionConstants");
Object.defineProperty(exports, "SESSION_TIME_OUT_DELAY", { enumerable: true, get: function () { return sessionConstants_1.SESSION_TIME_OUT_DELAY; } });
var transport_1 = require("./transport");
Object.defineProperty(exports, "createHttpRequest", { enumerable: true, get: function () { return transport_1.createHttpRequest; } });
Object.defineProperty(exports, "canUseEventBridge", { enumerable: true, get: function () { return transport_1.canUseEventBridge; } });
Object.defineProperty(exports, "getEventBridge", { enumerable: true, get: function () { return transport_1.getEventBridge; } });
Object.defineProperty(exports, "startBatchWithReplica", { enumerable: true, get: function () { return transport_1.startBatchWithReplica; } });
Object.defineProperty(exports, "createFlushController", { enumerable: true, get: function () { return transport_1.createFlushController; } });
__exportStar(require("./tools/display"), exports);
__exportStar(require("./tools/utils/urlPolyfill"), exports);
__exportStar(require("./tools/utils/timeUtils"), exports);
__exportStar(require("./tools/utils/arrayUtils"), exports);
__exportStar(require("./tools/serialisation/sanitize"), exports);
__exportStar(require("./tools/getGlobalObject"), exports);
var abstractLifeCycle_1 = require("./tools/abstractLifeCycle");
Object.defineProperty(exports, "AbstractLifeCycle", { enumerable: true, get: function () { return abstractLifeCycle_1.AbstractLifeCycle; } });
__exportStar(require("./domain/eventRateLimiter/createEventRateLimiter"), exports);
__exportStar(require("./tools/utils/browserDetection"), exports);
var sendToExtension_1 = require("./tools/sendToExtension");
Object.defineProperty(exports, "sendToExtension", { enumerable: true, get: function () { return sendToExtension_1.sendToExtension; } });
var runOnReadyState_1 = require("./browser/runOnReadyState");
Object.defineProperty(exports, "runOnReadyState", { enumerable: true, get: function () { return runOnReadyState_1.runOnReadyState; } });
var getZoneJsOriginalValue_1 = require("./tools/getZoneJsOriginalValue");
Object.defineProperty(exports, "getZoneJsOriginalValue", { enumerable: true, get: function () { return getZoneJsOriginalValue_1.getZoneJsOriginalValue; } });
var instrumentMethod_1 = require("./tools/instrumentMethod");
Object.defineProperty(exports, "instrumentMethod", { enumerable: true, get: function () { return instrumentMethod_1.instrumentMethod; } });
Object.defineProperty(exports, "instrumentMethodAndCallOriginal", { enumerable: true, get: function () { return instrumentMethod_1.instrumentMethodAndCallOriginal; } });
Object.defineProperty(exports, "instrumentSetter", { enumerable: true, get: function () { return instrumentMethod_1.instrumentSetter; } });
var error_1 = require("./domain/error/error");
Object.defineProperty(exports, "computeRawError", { enumerable: true, get: function () { return error_1.computeRawError; } });
Object.defineProperty(exports, "createHandlingStack", { enumerable: true, get: function () { return error_1.createHandlingStack; } });
Object.defineProperty(exports, "toStackTraceString", { enumerable: true, get: function () { return error_1.toStackTraceString; } });
Object.defineProperty(exports, "getFileFromStackTraceString", { enumerable: true, get: function () { return error_1.getFileFromStackTraceString; } });
Object.defineProperty(exports, "NO_ERROR_STACK_PRESENT_MESSAGE", { enumerable: true, get: function () { return error_1.NO_ERROR_STACK_PRESENT_MESSAGE; } });
var cookie_1 = require("./browser/cookie");
Object.defineProperty(exports, "areCookiesAuthorized", { enumerable: true, get: function () { return cookie_1.areCookiesAuthorized; } });
Object.defineProperty(exports, "getCookie", { enumerable: true, get: function () { return cookie_1.getCookie; } });
Object.defineProperty(exports, "setCookie", { enumerable: true, get: function () { return cookie_1.setCookie; } });
Object.defineProperty(exports, "deleteCookie", { enumerable: true, get: function () { return cookie_1.deleteCookie; } });
var xhrObservable_1 = require("./browser/xhrObservable");
Object.defineProperty(exports, "initXhrObservable", { enumerable: true, get: function () { return xhrObservable_1.initXhrObservable; } });
var fetchObservable_1 = require("./browser/fetchObservable");
Object.defineProperty(exports, "initFetchObservable", { enumerable: true, get: function () { return fetchObservable_1.initFetchObservable; } });
var pageExitObservable_1 = require("./browser/pageExitObservable");
Object.defineProperty(exports, "createPageExitObservable", { enumerable: true, get: function () { return pageExitObservable_1.createPageExitObservable; } });
Object.defineProperty(exports, "PageExitReason", { enumerable: true, get: function () { return pageExitObservable_1.PageExitReason; } });
Object.defineProperty(exports, "isPageExitReason", { enumerable: true, get: function () { return pageExitObservable_1.isPageExitReason; } });
__exportStar(require("./browser/addEventListener"), exports);
__exportStar(require("./tools/timer"), exports);
var consoleObservable_1 = require("./domain/console/consoleObservable");
Object.defineProperty(exports, "initConsoleObservable", { enumerable: true, get: function () { return consoleObservable_1.initConsoleObservable; } });
Object.defineProperty(exports, "resetConsoleObservable", { enumerable: true, get: function () { return consoleObservable_1.resetConsoleObservable; } });
var boundedBuffer_1 = require("./tools/boundedBuffer");
Object.defineProperty(exports, "BoundedBuffer", { enumerable: true, get: function () { return boundedBuffer_1.BoundedBuffer; } });
var catchUserErrors_1 = require("./tools/catchUserErrors");
Object.defineProperty(exports, "catchUserErrors", { enumerable: true, get: function () { return catchUserErrors_1.catchUserErrors; } });
var contextManager_1 = require("./domain/context/contextManager");
Object.defineProperty(exports, "createContextManager", { enumerable: true, get: function () { return contextManager_1.createContextManager; } });
var storedContextManager_1 = require("./domain/context/storedContextManager");
Object.defineProperty(exports, "createStoredContextManager", { enumerable: true, get: function () { return storedContextManager_1.createStoredContextManager; } });
Object.defineProperty(exports, "removeStorageListeners", { enumerable: true, get: function () { return storedContextManager_1.removeStorageListeners; } });
var heavyCustomerDataWarning_1 = require("./domain/context/heavyCustomerDataWarning");
Object.defineProperty(exports, "warnIfCustomerDataLimitReached", { enumerable: true, get: function () { return heavyCustomerDataWarning_1.warnIfCustomerDataLimitReached; } });
Object.defineProperty(exports, "CUSTOMER_DATA_BYTES_LIMIT", { enumerable: true, get: function () { return heavyCustomerDataWarning_1.CUSTOMER_DATA_BYTES_LIMIT; } });
var valueHistory_1 = require("./tools/valueHistory");
Object.defineProperty(exports, "ValueHistory", { enumerable: true, get: function () { return valueHistory_1.ValueHistory; } });
Object.defineProperty(exports, "CLEAR_OLD_VALUES_INTERVAL", { enumerable: true, get: function () { return valueHistory_1.CLEAR_OLD_VALUES_INTERVAL; } });
var readBytesFromStream_1 = require("./tools/readBytesFromStream");
Object.defineProperty(exports, "readBytesFromStream", { enumerable: true, get: function () { return readBytesFromStream_1.readBytesFromStream; } });
var sessionStore_1 = require("./domain/session/sessionStore");
Object.defineProperty(exports, "STORAGE_POLL_DELAY", { enumerable: true, get: function () { return sessionStore_1.STORAGE_POLL_DELAY; } });
var sessionStoreStrategy_1 = require("./domain/session/storeStrategies/sessionStoreStrategy");
Object.defineProperty(exports, "SESSION_STORE_KEY", { enumerable: true, get: function () { return sessionStoreStrategy_1.SESSION_STORE_KEY; } });
var syntheticsWorkerValues_1 = require("./domain/synthetics/syntheticsWorkerValues");
Object.defineProperty(exports, "willSyntheticsInjectRum", { enumerable: true, get: function () { return syntheticsWorkerValues_1.willSyntheticsInjectRum; } });
Object.defineProperty(exports, "getSyntheticsTestId", { enumerable: true, get: function () { return syntheticsWorkerValues_1.getSyntheticsTestId; } });
Object.defineProperty(exports, "getSyntheticsResultId", { enumerable: true, get: function () { return syntheticsWorkerValues_1.getSyntheticsResultId; } });
var user_1 = require("./domain/user");
Object.defineProperty(exports, "checkUser", { enumerable: true, get: function () { return user_1.checkUser; } });
Object.defineProperty(exports, "sanitizeUser", { enumerable: true, get: function () { return user_1.sanitizeUser; } });
__exportStar(require("./domain/resourceUtils"), exports);
__exportStar(require("./tools/utils/polyfills"), exports);
__exportStar(require("./tools/utils/numberUtils"), exports);
__exportStar(require("./tools/utils/byteUtils"), exports);
__exportStar(require("./tools/utils/objectUtils"), exports);
__exportStar(require("./tools/utils/functionUtils"), exports);
__exportStar(require("./tools/serialisation/jsonStringify"), exports);
__exportStar(require("./tools/mergeInto"), exports);
__exportStar(require("./tools/utils/stringUtils"), exports);
__exportStar(require("./tools/matchOption"), exports);
__exportStar(require("./tools/utils/responseUtils"), exports);
__exportStar(require("./tools/utils/typeUtils"), exports);
var error_types_1 = require("./domain/error/error.types");
Object.defineProperty(exports, "ErrorSource", { enumerable: true, get: function () { return error_types_1.ErrorSource; } });
__exportStar(require("./domain/deflate"), exports);
//# sourceMappingURL=index.js.map
},{"./boot/init":11,"./browser/addEventListener":12,"./browser/cookie":13,"./browser/fetchObservable":14,"./browser/pageExitObservable":15,"./browser/runOnReadyState":16,"./browser/xhrObservable":17,"./domain/configuration":20,"./domain/console/consoleObservable":24,"./domain/context/contextManager":25,"./domain/context/heavyCustomerDataWarning":26,"./domain/context/storedContextManager":27,"./domain/deflate":28,"./domain/error/error":30,"./domain/error/error.types":31,"./domain/error/trackRuntimeError":32,"./domain/eventRateLimiter/createEventRateLimiter":33,"./domain/report/reportObservable":34,"./domain/resourceUtils":35,"./domain/session/sessionConstants":37,"./domain/session/sessionManager":38,"./domain/session/sessionStore":40,"./domain/session/storeStrategies/sessionStoreStrategy":44,"./domain/synthetics/syntheticsWorkerValues":45,"./domain/telemetry":46,"./domain/tracekit":51,"./domain/user":53,"./tools/abstractLifeCycle":57,"./tools/boundedBuffer":58,"./tools/catchUserErrors":59,"./tools/display":60,"./tools/experimentalFeatures":61,"./tools/getGlobalObject":62,"./tools/getZoneJsOriginalValue":63,"./tools/instrumentMethod":64,"./tools/matchOption":65,"./tools/mergeInto":66,"./tools/monitor":67,"./tools/observable":68,"./tools/readBytesFromStream":69,"./tools/sendToExtension":70,"./tools/serialisation/jsonStringify":71,"./tools/serialisation/sanitize":72,"./tools/timer":73,"./tools/utils/arrayUtils":74,"./tools/utils/browserDetection":75,"./tools/utils/byteUtils":76,"./tools/utils/functionUtils":77,"./tools/utils/numberUtils":78,"./tools/utils/objectUtils":79,"./tools/utils/polyfills":80,"./tools/utils/responseUtils":81,"./tools/utils/stringUtils":82,"./tools/utils/timeUtils":83,"./tools/utils/typeUtils":84,"./tools/utils/urlPolyfill":85,"./tools/valueHistory":86,"./transport":91}],57:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractLifeCycle = void 0;
var AbstractLifeCycle = /** @class */ (function () {
    function AbstractLifeCycle() {
        this.callbacks = {};
    }
    AbstractLifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    AbstractLifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return AbstractLifeCycle;
}());
exports.AbstractLifeCycle = AbstractLifeCycle;
//# sourceMappingURL=abstractLifeCycle.js.map
},{}],58:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundedBuffer = void 0;
var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */ (function () {
    function BoundedBuffer() {
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function (callback) {
        var length = this.buffer.push(callback);
        if (length > BUFFER_LIMIT) {
            this.buffer.splice(0, 1);
        }
    };
    BoundedBuffer.prototype.drain = function () {
        this.buffer.forEach(function (callback) { return callback(); });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}());
exports.BoundedBuffer = BoundedBuffer;
//# sourceMappingURL=boundedBuffer.js.map
},{}],59:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catchUserErrors = void 0;
var display_1 = require("./display");
function catchUserErrors(fn, errorMsg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (err) {
            display_1.display.error(errorMsg, err);
        }
    };
}
exports.catchUserErrors = catchUserErrors;
//# sourceMappingURL=catchUserErrors.js.map
},{"./display":60}],60:[function(require,module,exports){
"use strict";
/* eslint-disable local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.display = exports.originalConsoleMethods = exports.globalConsole = exports.ConsoleApiName = void 0;
exports.ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
/**
 * When building JS bundles, some users might use a plugin[1] or configuration[2] to remove
 * "console.*" references. This causes some issue as we expect `console.*` to be defined.
 * As a workaround, let's use a variable alias, so those expressions won't be taken into account by
 * simple static analysis.
 *
 * [1]: https://babeljs.io/docs/babel-plugin-transform-remove-console/
 * [2]: https://github.com/terser/terser#compress-options (look for drop_console)
 */
exports.globalConsole = console;
exports.originalConsoleMethods = {};
Object.keys(exports.ConsoleApiName).forEach(function (name) {
    exports.originalConsoleMethods[name] = exports.globalConsole[name];
});
var PREFIX = 'Datadog Browser SDK:';
exports.display = {
    debug: exports.originalConsoleMethods.debug.bind(exports.globalConsole, PREFIX),
    log: exports.originalConsoleMethods.log.bind(exports.globalConsole, PREFIX),
    info: exports.originalConsoleMethods.info.bind(exports.globalConsole, PREFIX),
    warn: exports.originalConsoleMethods.warn.bind(exports.globalConsole, PREFIX),
    error: exports.originalConsoleMethods.error.bind(exports.globalConsole, PREFIX),
};
//# sourceMappingURL=display.js.map
},{}],61:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExperimentalFeatures = exports.resetExperimentalFeatures = exports.isExperimentalFeatureEnabled = exports.addExperimentalFeatures = exports.ExperimentalFeature = void 0;
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */
// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag
// eslint-disable-next-line no-restricted-syntax
var ExperimentalFeature;
(function (ExperimentalFeature) {
    ExperimentalFeature["PAGEHIDE"] = "pagehide";
    ExperimentalFeature["FEATURE_FLAGS"] = "feature_flags";
    ExperimentalFeature["RESOURCE_PAGE_STATES"] = "resource_page_states";
    ExperimentalFeature["PAGE_STATES"] = "page_states";
    ExperimentalFeature["COLLECT_FLUSH_REASON"] = "collect_flush_reason";
    ExperimentalFeature["NO_RESOURCE_DURATION_FROZEN_STATE"] = "no_resource_duration_frozen_state";
    ExperimentalFeature["SCROLLMAP"] = "scrollmap";
    ExperimentalFeature["INTERACTION_TO_NEXT_PAINT"] = "interaction_to_next_paint";
    ExperimentalFeature["WEB_VITALS_ATTRIBUTION"] = "web_vitals_attribution";
    ExperimentalFeature["DISABLE_REPLAY_INLINE_CSS"] = "disable_replay_inline_css";
})(ExperimentalFeature || (exports.ExperimentalFeature = ExperimentalFeature = {}));
var enabledExperimentalFeatures = new Set();
function addExperimentalFeatures(enabledFeatures) {
    enabledFeatures.forEach(function (flag) {
        enabledExperimentalFeatures.add(flag);
    });
}
exports.addExperimentalFeatures = addExperimentalFeatures;
function isExperimentalFeatureEnabled(featureName) {
    return enabledExperimentalFeatures.has(featureName);
}
exports.isExperimentalFeatureEnabled = isExperimentalFeatureEnabled;
function resetExperimentalFeatures() {
    enabledExperimentalFeatures.clear();
}
exports.resetExperimentalFeatures = resetExperimentalFeatures;
function getExperimentalFeatures() {
    return enabledExperimentalFeatures;
}
exports.getExperimentalFeatures = getExperimentalFeatures;
//# sourceMappingURL=experimentalFeatures.js.map
},{}],62:[function(require,module,exports){
"use strict";
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalObject = void 0;
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
exports.getGlobalObject = getGlobalObject;
//# sourceMappingURL=getGlobalObject.js.map
},{}],63:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZoneJsOriginalValue = void 0;
var getGlobalObject_1 = require("./getGlobalObject");
/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 *
 * Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
 * value of the patched functions/constructors/methods in a hidden property prefixed by
 * __zone_symbol__.
 *
 * In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
 * browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
 * use the original DOM API instead of the one patched by Zone.js.
 *
 * [1]: https://github.com/angular/angular/tree/main/packages/zone.js
 */
function getZoneJsOriginalValue(target, name) {
    var browserWindow = (0, getGlobalObject_1.getGlobalObject)();
    var original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') {
        original = target[browserWindow.Zone.__symbol__(name)];
    }
    if (!original) {
        original = target[name];
    }
    return original;
}
exports.getZoneJsOriginalValue = getZoneJsOriginalValue;
//# sourceMappingURL=getZoneJsOriginalValue.js.map
},{"./getGlobalObject":62}],64:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instrumentSetter = exports.instrumentMethodAndCallOriginal = exports.instrumentMethod = void 0;
var timer_1 = require("./timer");
var monitor_1 = require("./monitor");
var functionUtils_1 = require("./utils/functionUtils");
function instrumentMethod(object, method, instrumentationFactory) {
    var original = object[method];
    var instrumentation = instrumentationFactory(original);
    var instrumentationWrapper = function () {
        if (typeof instrumentation !== 'function') {
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return instrumentation.apply(this, arguments);
    };
    object[method] = instrumentationWrapper;
    return {
        stop: function () {
            if (object[method] === instrumentationWrapper) {
                object[method] = original;
            }
            else {
                instrumentation = original;
            }
        },
    };
}
exports.instrumentMethod = instrumentMethod;
function instrumentMethodAndCallOriginal(object, method, _a) {
    var before = _a.before, after = _a.after;
    return instrumentMethod(object, method, function (original) {
        return function () {
            var args = arguments;
            var result;
            if (before) {
                (0, monitor_1.callMonitored)(before, this, args);
            }
            if (typeof original === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                result = original.apply(this, args);
            }
            if (after) {
                (0, monitor_1.callMonitored)(after, this, args);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return result;
        };
    });
}
exports.instrumentMethodAndCallOriginal = instrumentMethodAndCallOriginal;
function instrumentSetter(object, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(object, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
        return { stop: functionUtils_1.noop };
    }
    var instrumentation = function (thisObject, value) {
        // put hooked setter into event loop to avoid of set latency
        (0, timer_1.setTimeout)(function () {
            after(thisObject, value);
        }, 0);
    };
    var instrumentationWrapper = function (value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(object, property, {
        set: instrumentationWrapper,
    });
    return {
        stop: function () {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(object, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
                Object.defineProperty(object, property, originalDescriptor);
            }
            else {
                instrumentation = functionUtils_1.noop;
            }
        },
    };
}
exports.instrumentSetter = instrumentSetter;
//# sourceMappingURL=instrumentMethod.js.map
},{"./monitor":67,"./timer":73,"./utils/functionUtils":77}],65:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchList = exports.isMatchOption = void 0;
var polyfills_1 = require("./utils/polyfills");
var display_1 = require("./display");
var typeUtils_1 = require("./utils/typeUtils");
function isMatchOption(item) {
    var itemType = (0, typeUtils_1.getType)(item);
    return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
exports.isMatchOption = isMatchOption;
/**
 * Returns true if value can be matched by at least one of the provided MatchOptions.
 * When comparing strings, setting useStartsWith to true will compare the value with the start of
 * the option, instead of requiring an exact match.
 */
function matchList(list, value, useStartsWith) {
    if (useStartsWith === void 0) { useStartsWith = false; }
    return list.some(function (item) {
        try {
            if (typeof item === 'function') {
                return item(value);
            }
            else if (item instanceof RegExp) {
                return item.test(value);
            }
            else if (typeof item === 'string') {
                return useStartsWith ? (0, polyfills_1.startsWith)(value, item) : item === value;
            }
        }
        catch (e) {
            display_1.display.error(e);
        }
        return false;
    });
}
exports.matchList = matchList;
//# sourceMappingURL=matchOption.js.map
},{"./display":60,"./utils/polyfills":80,"./utils/typeUtils":84}],66:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combine = exports.deepClone = exports.mergeInto = void 0;
var typeUtils_1 = require("./utils/typeUtils");
/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) { circularReferenceChecker = createCircularReferenceChecker(); }
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        var flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for (var i = 0; i < source.length; ++i) {
            merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
        }
        return merged_1;
    }
    var merged = (0, typeUtils_1.getType)(destination) === 'object' ? destination : {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
exports.mergeInto = mergeInto;
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
    return mergeInto(undefined, value);
}
exports.deepClone = deepClone;
function combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source);
    }
    return destination;
}
exports.combine = combine;
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
//# sourceMappingURL=mergeInto.js.map
},{"./utils/typeUtils":84}],67:[function(require,module,exports){
"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayIfDebugEnabled = exports.callMonitored = exports.monitor = exports.monitored = exports.resetMonitor = exports.setDebugMode = exports.startMonitorErrorCollection = void 0;
var display_1 = require("./display");
var onMonitorErrorCollected;
var debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
    onMonitorErrorCollected = newOnMonitorErrorCollected;
}
exports.startMonitorErrorCollection = startMonitorErrorCollection;
function setDebugMode(newDebugMode) {
    debugMode = newDebugMode;
}
exports.setDebugMode = setDebugMode;
function resetMonitor() {
    onMonitorErrorCollected = undefined;
    debugMode = false;
}
exports.resetMonitor = resetMonitor;
function monitored(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var decorated = onMonitorErrorCollected ? monitor(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
exports.monitored = monitored;
function monitor(fn) {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return callMonitored(fn, this, arguments);
    }; // consider output type has input type
}
exports.monitor = monitor;
function callMonitored(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    }
    catch (e) {
        displayIfDebugEnabled(e);
        if (onMonitorErrorCollected) {
            try {
                onMonitorErrorCollected(e);
            }
            catch (e) {
                displayIfDebugEnabled(e);
            }
        }
    }
}
exports.callMonitored = callMonitored;
function displayIfDebugEnabled() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (debugMode) {
        display_1.display.error.apply(display_1.display, __spreadArray(['[MONITOR]'], args, false));
    }
}
exports.displayIfDebugEnabled = displayIfDebugEnabled;
//# sourceMappingURL=monitor.js.map
},{"./display":60}],68:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeObservables = exports.Observable = void 0;
var Observable = /** @class */ (function () {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        var _this = this;
        if (!this.observers.length && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe() || undefined;
        }
        this.observers.push(f);
        return {
            unsubscribe: function () {
                _this.observers = _this.observers.filter(function (other) { return f !== other; });
                if (!_this.observers.length && _this.onLastUnsubscribe) {
                    _this.onLastUnsubscribe();
                }
            },
        };
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());
exports.Observable = Observable;
function mergeObservables() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var globalObservable = new Observable(function () {
        var subscriptions = observables.map(function (observable) {
            return observable.subscribe(function (data) { return globalObservable.notify(data); });
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
    return globalObservable;
}
exports.mergeObservables = mergeObservables;
//# sourceMappingURL=observable.js.map
},{}],69:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readBytesFromStream = void 0;
var monitor_1 = require("./monitor");
var functionUtils_1 = require("./utils/functionUtils");
/**
 * Read bytes from a ReadableStream until at least `limit` bytes have been read (or until the end of
 * the stream). The callback is invoked with the at most `limit` bytes, and indicates that the limit
 * has been exceeded if more bytes were available.
 */
function readBytesFromStream(stream, callback, options) {
    var reader = stream.getReader();
    var chunks = [];
    var readBytesCount = 0;
    readMore();
    function readMore() {
        reader.read().then((0, monitor_1.monitor)(function (result) {
            if (result.done) {
                onDone();
                return;
            }
            if (options.collectStreamBody) {
                chunks.push(result.value);
            }
            readBytesCount += result.value.length;
            if (readBytesCount > options.bytesLimit) {
                onDone();
            }
            else {
                readMore();
            }
        }), (0, monitor_1.monitor)(function (error) { return callback(error); }));
    }
    function onDone() {
        reader.cancel().catch(
        // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
        // as an unhandled rejection
        functionUtils_1.noop);
        var bytes;
        var limitExceeded;
        if (options.collectStreamBody) {
            var completeBuffer_1;
            if (chunks.length === 1) {
                // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
                // use it directly.
                completeBuffer_1 = chunks[0];
            }
            else {
                // else, we need to copy buffers into a larger buffer to concatenate them.
                completeBuffer_1 = new Uint8Array(readBytesCount);
                var offset_1 = 0;
                chunks.forEach(function (chunk) {
                    completeBuffer_1.set(chunk, offset_1);
                    offset_1 += chunk.length;
                });
            }
            bytes = completeBuffer_1.slice(0, options.bytesLimit);
            limitExceeded = completeBuffer_1.length > options.bytesLimit;
        }
        callback(undefined, bytes, limitExceeded);
    }
}
exports.readBytesFromStream = readBytesFromStream;
//# sourceMappingURL=readBytesFromStream.js.map
},{"./monitor":67,"./utils/functionUtils":77}],70:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendToExtension = void 0;
function sendToExtension(type, payload) {
    var callback = window.__ddBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type: type, payload: payload });
    }
}
exports.sendToExtension = sendToExtension;
//# sourceMappingURL=sendToExtension.js.map
},{}],71:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detachToJsonMethod = exports.jsonStringify = void 0;
var functionUtils_1 = require("../utils/functionUtils");
/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify(value, replacer, space) {
    if (typeof value !== 'object' || value === null) {
        return JSON.stringify(value);
    }
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
    var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
    var restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
    var restoreValueToJson = detachToJsonMethod(value);
    try {
        return JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        return '<error: unable to serialize object>';
    }
    finally {
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
exports.jsonStringify = jsonStringify;
function detachToJsonMethod(value) {
    var object = value;
    var objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return function () {
            object.toJSON = objectToJson;
        };
    }
    return functionUtils_1.noop;
}
exports.detachToJsonMethod = detachToJsonMethod;
//# sourceMappingURL=jsonStringify.js.map
},{"../utils/functionUtils":77}],72:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitize = void 0;
var display_1 = require("../display");
var byteUtils_1 = require("../utils/byteUtils");
var jsonStringify_1 = require("./jsonStringify");
// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
var SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * byteUtils_1.ONE_KIBI_BYTE;
// Symbol for the root element of the JSONPath used for visited objects
var JSON_PATH_ROOT_ELEMENT = '$';
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
var KEY_DECORATION_LENGTH = 3;
function sanitize(source, maxCharacterCount) {
    var _a;
    if (maxCharacterCount === void 0) { maxCharacterCount = SANITIZE_DEFAULT_MAX_CHARACTER_COUNT; }
    // Unbind any toJSON function we may have on [] or {} prototypes
    var restoreObjectPrototypeToJson = (0, jsonStringify_1.detachToJsonMethod)(Object.prototype);
    var restoreArrayPrototypeToJson = (0, jsonStringify_1.detachToJsonMethod)(Array.prototype);
    // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
    var containerQueue = [];
    var visitedObjectsWithPath = new WeakMap();
    var sanitizedData = sanitizeProcessor(source, JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
    var accumulatedCharacterCount = ((_a = JSON.stringify(sanitizedData)) === null || _a === void 0 ? void 0 : _a.length) || 0;
    if (accumulatedCharacterCount > maxCharacterCount) {
        warnOverCharacterLimit(maxCharacterCount, 'discarded', source);
        return undefined;
    }
    while (containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount) {
        var containerToProcess = containerQueue.shift();
        var separatorLength = 0; // 0 for the first element, 1 for subsequent elements
        // Arrays and Objects have to be handled distinctly to ensure
        // we do not pick up non-numerical properties from Arrays
        if (Array.isArray(containerToProcess.source)) {
            for (var key = 0; key < containerToProcess.source.length; key++) {
                var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                if (targetData !== undefined) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length;
                }
                else {
                    // When an element of an Array (targetData) is undefined, it is serialized as null:
                    // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
                    accumulatedCharacterCount += 4;
                }
                accumulatedCharacterCount += separatorLength;
                separatorLength = 1;
                if (accumulatedCharacterCount > maxCharacterCount) {
                    warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                    break;
                }
                ;
                containerToProcess.target[key] = targetData;
            }
        }
        else {
            for (var key in containerToProcess.source) {
                if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                    var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                    // When a property of an object has an undefined value, it will be dropped during serialization:
                    // JSON.stringify({a:undefined}) => '{}'
                    if (targetData !== undefined) {
                        accumulatedCharacterCount +=
                            JSON.stringify(targetData).length + separatorLength + key.length + KEY_DECORATION_LENGTH;
                        separatorLength = 1;
                    }
                    if (accumulatedCharacterCount > maxCharacterCount) {
                        warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                        break;
                    }
                    ;
                    containerToProcess.target[key] = targetData;
                }
            }
        }
    }
    // Rebind detached toJSON functions
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    return sanitizedData;
}
exports.sanitize = sanitize;
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */
function sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    // Start by handling toJSON, as we want to sanitize its output
    var sourceToSanitize = tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== 'object') {
        return sanitizePrimitivesAndFunctions(sourceToSanitize);
    }
    var sanitizedSource = sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== '[Object]' && sanitizedSource !== '[Array]' && sanitizedSource !== '[Error]') {
        return sanitizedSource;
    }
    // Handle potential cyclic references
    // We need to use source as sourceToSanitize could be a reference to a new object
    // At this stage, we know the source is an object type
    var sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) {
        return "[Reference seen at ".concat(visitedObjectsWithPath.get(sourceAsObject), "]");
    }
    // Add processed source to queue
    var currentPath = key !== undefined ? "".concat(parentPath, ".").concat(key) : parentPath;
    var target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({ source: sourceToSanitize, target: target, path: currentPath });
    return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */
function sanitizePrimitivesAndFunctions(value) {
    // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
    if (typeof value === 'bigint') {
        return "[BigInt] ".concat(value.toString());
    }
    // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
    // so it won't prevent stringify from serializing later
    if (typeof value === 'function') {
        return "[Function] ".concat(value.name || 'unknown');
    }
    // JSON.stringify() does not serialize symbols.
    if (typeof value === 'symbol') {
        return "[Symbol] ".concat(value.description || value.toString());
    }
    return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 * - IE11 does not return a distinct type for objects such as Map, WeakMap, ... These objects will pass through and their
 * properties enumerated if any.
 *
 */
function sanitizeObjects(value) {
    try {
        // Handle events - Keep a simple implementation to avoid breaking changes
        if (value instanceof Event) {
            return {
                isTrusted: value.isTrusted,
            };
        }
        // Handle all remaining object types in a generic way
        var result = Object.prototype.toString.call(value);
        var match = result.match(/\[object (.*)\]/);
        if (match && match[1]) {
            return "[".concat(match[1], "]");
        }
    }
    catch (_a) {
        // If the previous serialization attempts failed, and we cannot convert using
        // Object.prototype.toString, declare the value unserializable
    }
    return '[Unserializable]';
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */
function tryToApplyToJSON(value) {
    var object = value;
    if (object && typeof object.toJSON === 'function') {
        try {
            return object.toJSON();
        }
        catch (_a) {
            // If toJSON fails, we continue by trying to serialize the value manually
        }
    }
    return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */
function warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    display_1.display.warn("The data provided has been ".concat(changeType, " as it is over the limit of ").concat(maxCharacterCount, " characters:"), source);
}
//# sourceMappingURL=sanitize.js.map
},{"../display":60,"../utils/byteUtils":76,"./jsonStringify":71}],73:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearInterval = exports.setInterval = exports.clearTimeout = exports.setTimeout = void 0;
var getZoneJsOriginalValue_1 = require("./getZoneJsOriginalValue");
var monitor_1 = require("./monitor");
var getGlobalObject_1 = require("./getGlobalObject");
function setTimeout(callback, delay) {
    return (0, getZoneJsOriginalValue_1.getZoneJsOriginalValue)((0, getGlobalObject_1.getGlobalObject)(), 'setTimeout')((0, monitor_1.monitor)(callback), delay);
}
exports.setTimeout = setTimeout;
function clearTimeout(timeoutId) {
    (0, getZoneJsOriginalValue_1.getZoneJsOriginalValue)((0, getGlobalObject_1.getGlobalObject)(), 'clearTimeout')(timeoutId);
}
exports.clearTimeout = clearTimeout;
function setInterval(callback, delay) {
    return (0, getZoneJsOriginalValue_1.getZoneJsOriginalValue)((0, getGlobalObject_1.getGlobalObject)(), 'setInterval')((0, monitor_1.monitor)(callback), delay);
}
exports.setInterval = setInterval;
function clearInterval(timeoutId) {
    (0, getZoneJsOriginalValue_1.getZoneJsOriginalValue)((0, getGlobalObject_1.getGlobalObject)(), 'clearInterval')(timeoutId);
}
exports.clearInterval = clearInterval;
//# sourceMappingURL=timer.js.map
},{"./getGlobalObject":62,"./getZoneJsOriginalValue":63,"./monitor":67}],74:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDuplicates = void 0;
var polyfills_1 = require("./polyfills");
function removeDuplicates(array) {
    var set = new Set();
    array.forEach(function (item) { return set.add(item); });
    return (0, polyfills_1.arrayFrom)(set);
}
exports.removeDuplicates = removeDuplicates;
//# sourceMappingURL=arrayUtils.js.map
},{"./polyfills":80}],75:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSafari = exports.isChromium = exports.isIE = void 0;
var browserIsIE;
function isIE() {
    return browserIsIE !== null && browserIsIE !== void 0 ? browserIsIE : (browserIsIE = Boolean(document.documentMode));
}
exports.isIE = isIE;
var browserIsChromium;
function isChromium() {
    return (browserIsChromium !== null && browserIsChromium !== void 0 ? browserIsChromium : (browserIsChromium = !!window.chrome || /HeadlessChrome/.test(window.navigator.userAgent)));
}
exports.isChromium = isChromium;
var browserIsSafari;
function isSafari() {
    return browserIsSafari !== null && browserIsSafari !== void 0 ? browserIsSafari : (browserIsSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent));
}
exports.isSafari = isSafari;
//# sourceMappingURL=browserDetection.js.map
},{}],76:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatBuffers = exports.computeBytesCount = exports.ONE_MEBI_BYTE = exports.ONE_KIBI_BYTE = void 0;
exports.ONE_KIBI_BYTE = 1024;
exports.ONE_MEBI_BYTE = 1024 * exports.ONE_KIBI_BYTE;
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function computeBytesCount(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
        return candidate.length;
    }
    if (window.TextEncoder !== undefined) {
        return new TextEncoder().encode(candidate).length;
    }
    return new Blob([candidate]).size;
}
exports.computeBytesCount = computeBytesCount;
function concatBuffers(buffers) {
    var length = buffers.reduce(function (total, buffer) { return total + buffer.length; }, 0);
    var result = new Uint8Array(length);
    var offset = 0;
    for (var _i = 0, buffers_1 = buffers; _i < buffers_1.length; _i++) {
        var buffer = buffers_1[_i];
        result.set(buffer, offset);
        offset += buffer.length;
    }
    return result;
}
exports.concatBuffers = concatBuffers;
//# sourceMappingURL=byteUtils.js.map
},{}],77:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = exports.throttle = void 0;
var timer_1 = require("../timer");
// use lodash API
function throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var parameters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                parameters[_i] = arguments[_i];
            }
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(void 0, parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = (0, timer_1.setTimeout)(function () {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn.apply(void 0, pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function () {
            (0, timer_1.clearTimeout)(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
exports.throttle = throttle;
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
exports.noop = noop;
//# sourceMappingURL=functionUtils.js.map
},{"../timer":73}],78:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumber = exports.isPercentage = exports.round = exports.performDraw = void 0;
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
exports.performDraw = performDraw;
function round(num, decimals) {
    return +num.toFixed(decimals);
}
exports.round = round;
function isPercentage(value) {
    return isNumber(value) && value >= 0 && value <= 100;
}
exports.isPercentage = isPercentage;
function isNumber(value) {
    return typeof value === 'number';
}
exports.isNumber = isNumber;
//# sourceMappingURL=numberUtils.js.map
},{}],79:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapValues = exports.isEmptyObject = exports.objectHasValue = exports.shallowClone = void 0;
var polyfills_1 = require("./polyfills");
function shallowClone(object) {
    return (0, polyfills_1.assign)({}, object);
}
exports.shallowClone = shallowClone;
function objectHasValue(object, value) {
    return Object.keys(object).some(function (key) { return object[key] === value; });
}
exports.objectHasValue = objectHasValue;
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
exports.isEmptyObject = isEmptyObject;
function mapValues(object, fn) {
    var newObject = {};
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
exports.mapValues = mapValues;
//# sourceMappingURL=objectUtils.js.map
},{"./polyfills":80}],80:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assign = exports.cssEscape = exports.elementMatches = exports.endsWith = exports.startsWith = exports.objectEntries = exports.objectValues = exports.forEach = exports.findLast = exports.find = exports.arrayFrom = exports.includes = void 0;
function includes(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
exports.includes = includes;
function arrayFrom(arrayLike) {
    if (Array.from) {
        return Array.from(arrayLike);
    }
    var array = [];
    if (arrayLike instanceof Set) {
        arrayLike.forEach(function (item) { return array.push(item); });
    }
    else {
        for (var i = 0; i < arrayLike.length; i++) {
            array.push(arrayLike[i]);
        }
    }
    return array;
}
exports.arrayFrom = arrayFrom;
function find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i)) {
            return item;
        }
    }
    return undefined;
}
exports.find = find;
function findLast(array, predicate) {
    for (var i = array.length - 1; i >= 0; i -= 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
exports.findLast = findLast;
function forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
exports.forEach = forEach;
function objectValues(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
exports.objectValues = objectValues;
function objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
exports.objectEntries = objectEntries;
function startsWith(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
exports.startsWith = startsWith;
function endsWith(candidate, search) {
    return candidate.slice(-search.length) === search;
}
exports.endsWith = endsWith;
function elementMatches(element, selector) {
    if (element.matches) {
        return element.matches(selector);
    }
    // IE11 support
    if (element.msMatchesSelector) {
        return element.msMatchesSelector(selector);
    }
    return false;
}
exports.elementMatches = elementMatches;
// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function cssEscape(str) {
    if (window.CSS && window.CSS.escape) {
        return window.CSS.escape(str);
    }
    // eslint-disable-next-line no-control-regex
    return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === '\0') {
                return '\uFFFD';
            }
            // Control characters and (dependent upon position) numbers get escaped as code points
            return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\".concat(ch);
    });
}
exports.cssEscape = cssEscape;
function assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
    return target;
}
exports.assign = assign;
//# sourceMappingURL=polyfills.js.map
},{}],81:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryToClone = exports.isServerError = void 0;
function isServerError(status) {
    return status >= 500;
}
exports.isServerError = isServerError;
function tryToClone(response) {
    try {
        return response.clone();
    }
    catch (e) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}
exports.tryToClone = tryToClone;
//# sourceMappingURL=responseUtils.js.map
},{}],82:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeTruncate = exports.findCommaSeparatedValue = exports.generateUUID = void 0;
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
exports.generateUUID = generateUUID;
function findCommaSeparatedValue(rawString, name) {
    var regex = new RegExp("(?:^|;)\\s*".concat(name, "\\s*=\\s*([^;]+)"));
    var matches = regex.exec(rawString);
    return matches ? matches[1] : undefined;
}
exports.findCommaSeparatedValue = findCommaSeparatedValue;
function safeTruncate(candidate, length, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) {
        return candidate;
    }
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}
exports.safeTruncate = safeTruncate;
//# sourceMappingURL=stringUtils.js.map
},{}],83:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetNavigationStart = exports.looksLikeRelativeTime = exports.getTimeStamp = exports.getRelativeTime = exports.addDuration = exports.elapsed = exports.clocksOrigin = exports.clocksNow = exports.relativeNow = exports.timeStampNow = exports.dateNow = exports.toServerDuration = exports.currentDrift = exports.relativeToClocks = exports.ONE_YEAR = exports.ONE_DAY = exports.ONE_HOUR = exports.ONE_MINUTE = exports.ONE_SECOND = void 0;
var numberUtils_1 = require("./numberUtils");
exports.ONE_SECOND = 1000;
exports.ONE_MINUTE = 60 * exports.ONE_SECOND;
exports.ONE_HOUR = 60 * exports.ONE_MINUTE;
exports.ONE_DAY = 24 * exports.ONE_HOUR;
exports.ONE_YEAR = 365 * exports.ONE_DAY;
function relativeToClocks(relative) {
    return { relative: relative, timeStamp: getCorrectedTimeStamp(relative) };
}
exports.relativeToClocks = relativeToClocks;
function getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = (dateNow() - performance.now());
    // apply correction only for positive drift
    if (correctedOrigin > getNavigationStart()) {
        return Math.round(addDuration(correctedOrigin, relativeTime));
    }
    return getTimeStamp(relativeTime);
}
function currentDrift() {
    return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}
exports.currentDrift = currentDrift;
function toServerDuration(duration) {
    if (!(0, numberUtils_1.isNumber)(duration)) {
        return duration;
    }
    return (0, numberUtils_1.round)(duration * 1e6, 0);
}
exports.toServerDuration = toServerDuration;
function dateNow() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
exports.dateNow = dateNow;
function timeStampNow() {
    return dateNow();
}
exports.timeStampNow = timeStampNow;
function relativeNow() {
    return performance.now();
}
exports.relativeNow = relativeNow;
function clocksNow() {
    return { relative: relativeNow(), timeStamp: timeStampNow() };
}
exports.clocksNow = clocksNow;
function clocksOrigin() {
    return { relative: 0, timeStamp: getNavigationStart() };
}
exports.clocksOrigin = clocksOrigin;
function elapsed(start, end) {
    return (end - start);
}
exports.elapsed = elapsed;
function addDuration(a, b) {
    return a + b;
}
exports.addDuration = addDuration;
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
    return (timestamp - getNavigationStart());
}
exports.getRelativeTime = getRelativeTime;
function getTimeStamp(relativeTime) {
    return Math.round(addDuration(getNavigationStart(), relativeTime));
}
exports.getTimeStamp = getTimeStamp;
function looksLikeRelativeTime(time) {
    return time < exports.ONE_YEAR;
}
exports.looksLikeRelativeTime = looksLikeRelativeTime;
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
    if (navigationStart === undefined) {
        navigationStart = performance.timing.navigationStart;
    }
    return navigationStart;
}
function resetNavigationStart() {
    navigationStart = undefined;
}
exports.resetNavigationStart = resetNavigationStart;
//# sourceMappingURL=timeUtils.js.map
},{"./numberUtils":78}],84:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getType = void 0;
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
exports.getType = getType;
//# sourceMappingURL=typeUtils.js.map
},{}],85:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLinkElementOrigin = exports.getLocationOrigin = exports.buildUrl = exports.getHash = exports.getSearch = exports.getPathName = exports.getOrigin = exports.isValidUrl = exports.normalizeUrl = void 0;
var jsonStringify_1 = require("../serialisation/jsonStringify");
function normalizeUrl(url) {
    return buildUrl(url, getLocationOrigin()).href;
}
exports.normalizeUrl = normalizeUrl;
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
exports.isValidUrl = isValidUrl;
function getOrigin(url) {
    return getLinkElementOrigin(buildUrl(url));
}
exports.getOrigin = getOrigin;
function getPathName(url) {
    var pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
exports.getPathName = getPathName;
function getSearch(url) {
    return buildUrl(url).search;
}
exports.getSearch = getSearch;
function getHash(url) {
    return buildUrl(url).hash;
}
exports.getHash = getHash;
function buildUrl(url, base) {
    var supportedURL = getSupportedUrl();
    if (supportedURL) {
        try {
            return base !== undefined ? new supportedURL(url, base) : new supportedURL(url);
        }
        catch (error) {
            throw new Error("Failed to construct URL: ".concat(String(error), " ").concat((0, jsonStringify_1.jsonStringify)({ url: url, base: base })));
        }
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '".concat(url, "'"));
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
exports.buildUrl = buildUrl;
var originalURL = URL;
var isURLSupported;
function getSupportedUrl() {
    if (isURLSupported === undefined) {
        try {
            var url = new originalURL('http://test/path');
            isURLSupported = url.href === 'http://test/path';
        }
        catch (_a) {
            isURLSupported = false;
        }
    }
    return isURLSupported ? originalURL : undefined;
}
function getLocationOrigin() {
    return getLinkElementOrigin(window.location);
}
exports.getLocationOrigin = getLocationOrigin;
/**
 * Fallback
 * On IE HTMLAnchorElement origin is not supported: https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/origin
 * On Firefox window.location.origin is "null" for file: URIs: https://bugzilla.mozilla.org/show_bug.cgi?id=878297
 */
function getLinkElementOrigin(element) {
    if (element.origin && element.origin !== 'null') {
        return element.origin;
    }
    var sanitizedHost = element.host.replace(/(:80|:443)$/, '');
    return "".concat(element.protocol, "//").concat(sanitizedHost);
}
exports.getLinkElementOrigin = getLinkElementOrigin;
//# sourceMappingURL=urlPolyfill.js.map
},{"../serialisation/jsonStringify":71}],86:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueHistory = exports.CLEAR_OLD_VALUES_INTERVAL = void 0;
var timer_1 = require("./timer");
var timeUtils_1 = require("./utils/timeUtils");
var END_OF_TIMES = Infinity;
exports.CLEAR_OLD_VALUES_INTERVAL = timeUtils_1.ONE_MINUTE;
/**
 * Store and keep track of values spans. This whole class assumes that values are added in
 * chronological order (i.e. all entries have an increasing start time).
 */
var ValueHistory = /** @class */ (function () {
    function ValueHistory(expireDelay, maxEntries) {
        var _this = this;
        this.expireDelay = expireDelay;
        this.maxEntries = maxEntries;
        this.entries = [];
        this.clearOldValuesInterval = (0, timer_1.setInterval)(function () { return _this.clearOldValues(); }, exports.CLEAR_OLD_VALUES_INTERVAL);
    }
    /**
     * Add a value to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */
    ValueHistory.prototype.add = function (value, startTime) {
        var _this = this;
        var entry = {
            value: value,
            startTime: startTime,
            endTime: END_OF_TIMES,
            remove: function () {
                var index = _this.entries.indexOf(entry);
                if (index >= 0) {
                    _this.entries.splice(index, 1);
                }
            },
            close: function (endTime) {
                entry.endTime = endTime;
            },
        };
        if (this.maxEntries && this.entries.length >= this.maxEntries) {
            this.entries.pop();
        }
        this.entries.unshift(entry);
        return entry;
    };
    /**
     * Return the latest value that was active during `startTime`, or the currently active value
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     */
    ValueHistory.prototype.find = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
            var entry = _a[_i];
            if (entry.startTime <= startTime) {
                if (startTime <= entry.endTime) {
                    return entry.value;
                }
                break;
            }
        }
    };
    /**
     * Helper function to close the currently active value, if any. This method assumes that entries
     * are not overlapping.
     */
    ValueHistory.prototype.closeActive = function (endTime) {
        var latestEntry = this.entries[0];
        if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
            latestEntry.close(endTime);
        }
    };
    /**
     * Return all values with an active period overlapping with the duration,
     * or all values that were active during `startTime` if no duration is provided,
     * or all currently active values if no `startTime` is provided.
     */
    ValueHistory.prototype.findAll = function (startTime, duration) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        if (duration === void 0) { duration = 0; }
        var endTime = (0, timeUtils_1.addDuration)(startTime, duration);
        return this.entries
            .filter(function (entry) { return entry.startTime <= endTime && startTime <= entry.endTime; })
            .map(function (entry) { return entry.value; });
    };
    /**
     * Remove all entries from this collection.
     */
    ValueHistory.prototype.reset = function () {
        this.entries = [];
    };
    /**
     * Stop internal garbage collection of past entries.
     */
    ValueHistory.prototype.stop = function () {
        (0, timer_1.clearInterval)(this.clearOldValuesInterval);
    };
    ValueHistory.prototype.clearOldValues = function () {
        var oldTimeThreshold = (0, timeUtils_1.relativeNow)() - this.expireDelay;
        while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
            this.entries.pop();
        }
    };
    return ValueHistory;
}());
exports.ValueHistory = ValueHistory;
//# sourceMappingURL=valueHistory.js.map
},{"./timer":73,"./utils/timeUtils":83}],87:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Batch = void 0;
var display_1 = require("../tools/display");
var polyfills_1 = require("../tools/utils/polyfills");
var pageExitObservable_1 = require("../browser/pageExitObservable");
var byteUtils_1 = require("../tools/utils/byteUtils");
var jsonStringify_1 = require("../tools/serialisation/jsonStringify");
var Batch = /** @class */ (function () {
    function Batch(request, flushController, messageBytesLimit) {
        var _this = this;
        this.request = request;
        this.flushController = flushController;
        this.messageBytesLimit = messageBytesLimit;
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        this.flushSubscription = this.flushController.flushObservable.subscribe(function (event) { return _this.flush(event); });
    }
    Batch.prototype.add = function (message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function (message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.stop = function () {
        this.flushSubscription.unsubscribe();
    };
    Batch.prototype.flush = function (event) {
        var messages = this.pushOnlyBuffer.concat((0, polyfills_1.objectValues)(this.upsertBuffer));
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        var payload = { data: messages.join('\n'), bytesCount: event.bytesCount, flushReason: event.reason };
        if ((0, pageExitObservable_1.isPageExitReason)(event.reason)) {
            this.request.sendOnExit(payload);
        }
        else {
            this.request.send(payload);
        }
    };
    Batch.prototype.addOrUpdate = function (message, key) {
        var _a = this.process(message), processedMessage = _a.processedMessage, messageBytesCount = _a.messageBytesCount;
        if (messageBytesCount >= this.messageBytesLimit) {
            display_1.display.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
            return;
        }
        if (this.hasMessageFor(key)) {
            this.remove(key);
        }
        this.push(processedMessage, messageBytesCount, key);
    };
    Batch.prototype.process = function (message) {
        var processedMessage = (0, jsonStringify_1.jsonStringify)(message);
        var messageBytesCount = (0, byteUtils_1.computeBytesCount)(processedMessage);
        return { processedMessage: processedMessage, messageBytesCount: messageBytesCount };
    };
    Batch.prototype.push = function (processedMessage, messageBytesCount, key) {
        // If there are other messages, a '\n' will be added at serialization
        var separatorBytesCount = this.flushController.messagesCount > 0 ? 1 : 0;
        this.flushController.notifyBeforeAddMessage(messageBytesCount + separatorBytesCount);
        if (key !== undefined) {
            this.upsertBuffer[key] = processedMessage;
        }
        else {
            this.pushOnlyBuffer.push(processedMessage);
        }
        this.flushController.notifyAfterAddMessage();
    };
    Batch.prototype.remove = function (key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesCount = (0, byteUtils_1.computeBytesCount)(removedMessage);
        // If there are other messages, a '\n' will be added at serialization
        var separatorBytesCount = this.flushController.messagesCount > 1 ? 1 : 0;
        this.flushController.notifyAfterRemoveMessage(messageBytesCount + separatorBytesCount);
    };
    Batch.prototype.hasMessageFor = function (key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    return Batch;
}());
exports.Batch = Batch;
//# sourceMappingURL=batch.js.map
},{"../browser/pageExitObservable":15,"../tools/display":60,"../tools/serialisation/jsonStringify":71,"../tools/utils/byteUtils":76,"../tools/utils/polyfills":80}],88:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canUseEventBridge = exports.getEventBridge = void 0;
var polyfills_1 = require("../tools/utils/polyfills");
var getGlobalObject_1 = require("../tools/getGlobalObject");
function getEventBridge() {
    var eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event) {
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event }));
        },
    };
}
exports.getEventBridge = getEventBridge;
function canUseEventBridge(currentHost) {
    var _a;
    if (currentHost === void 0) { currentHost = (_a = (0, getGlobalObject_1.getGlobalObject)().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    var bridge = getEventBridge();
    return (!!bridge &&
        bridge
            .getAllowedWebViewHosts()
            .some(function (allowedHost) { return currentHost === allowedHost || (0, polyfills_1.endsWith)(currentHost, ".".concat(allowedHost)); }));
}
exports.canUseEventBridge = canUseEventBridge;
function getEventBridgeGlobal() {
    return (0, getGlobalObject_1.getGlobalObject)().DatadogEventBridge;
}
//# sourceMappingURL=eventBridge.js.map
},{"../tools/getGlobalObject":62,"../tools/utils/polyfills":80}],89:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFlushController = void 0;
var observable_1 = require("../tools/observable");
var timer_1 = require("../tools/timer");
/**
 * Returns a "flush controller", responsible of notifying when flushing a pool of pending data needs
 * to happen. The implementation is designed to support both synchronous and asynchronous usages,
 * but relies on invariants described in each method documentation to keep a coherent state.
 */
function createFlushController(_a) {
    var messagesLimit = _a.messagesLimit, bytesLimit = _a.bytesLimit, durationLimit = _a.durationLimit, pageExitObservable = _a.pageExitObservable, sessionExpireObservable = _a.sessionExpireObservable;
    var pageExitSubscription = pageExitObservable.subscribe(function (event) { return flush(event.reason); });
    var sessionExpireSubscription = sessionExpireObservable.subscribe(function () { return flush('session_expire'); });
    var flushObservable = new observable_1.Observable(function () { return function () {
        pageExitSubscription.unsubscribe();
        sessionExpireSubscription.unsubscribe();
    }; });
    var currentBytesCount = 0;
    var currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) {
            return;
        }
        var messagesCount = currentMessagesCount;
        var bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount: messagesCount,
            bytesCount: bytesCount,
        });
    }
    var durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === undefined) {
            durationLimitTimeoutId = (0, timer_1.setTimeout)(function () {
                flush('duration_limit');
            }, durationLimit);
        }
    }
    function cancelDurationLimitTimeout() {
        (0, timer_1.clearTimeout)(durationLimitTimeoutId);
        durationLimitTimeoutId = undefined;
    }
    return {
        flushObservable: flushObservable,
        get messagesCount() {
            return currentMessagesCount;
        },
        /**
         * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right before adding the message, so no flush
         * event can happen after `notifyBeforeAddMessage` and before adding the message.
         */
        notifyBeforeAddMessage: function (messageBytesCount) {
            if (currentBytesCount + messageBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
            // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
            // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
            // to notify when a flush is needed (for example on page exit).
            currentMessagesCount += 1;
            currentBytesCount += messageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
         * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
         *
         * This function can be called asynchronously after the message was added, but in this case it
         * should not be called if a flush event occurred in between.
         */
        notifyAfterAddMessage: function () {
            if (currentMessagesCount >= messagesLimit) {
                flush('messages_limit');
            }
            else if (currentBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
        },
        /**
         * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right after removing the message, so no flush
         * event can happen after removing the message and before `notifyAfterRemoveMessage`.
         */
        notifyAfterRemoveMessage: function (messageBytesCount) {
            currentBytesCount -= messageBytesCount;
            currentMessagesCount -= 1;
            if (currentMessagesCount === 0) {
                cancelDurationLimitTimeout();
            }
        },
    };
}
exports.createFlushController = createFlushController;
//# sourceMappingURL=flushController.js.map
},{"../tools/observable":68,"../tools/timer":73}],90:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendXHR = exports.fetchKeepAliveStrategy = exports.createHttpRequest = void 0;
var telemetry_1 = require("../domain/telemetry");
var monitor_1 = require("../tools/monitor");
var addEventListener_1 = require("../browser/addEventListener");
var sendWithRetryStrategy_1 = require("./sendWithRetryStrategy");
function createHttpRequest(configuration, endpointBuilder, bytesLimit, reportError) {
    var retryState = (0, sendWithRetryStrategy_1.newRetryState)();
    var sendStrategyForRetry = function (payload, onResponse) {
        return fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function (payload) {
            (0, sendWithRetryStrategy_1.sendWithRetryStrategy)(payload, retryState, sendStrategyForRetry, endpointBuilder.endpointType, reportError);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */
        sendOnExit: function (payload) {
            sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload);
        },
    };
}
exports.createHttpRequest = createHttpRequest;
function sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload) {
    var canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
    if (canUseBeacon) {
        try {
            var beaconUrl = endpointBuilder.build('beacon', payload);
            var isQueued = navigator.sendBeacon(beaconUrl, payload.data);
            if (isQueued) {
                return;
            }
        }
        catch (e) {
            reportBeaconError(e);
        }
    }
    var xhrUrl = endpointBuilder.build('xhr', payload);
    sendXHR(configuration, xhrUrl, payload.data);
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        (0, telemetry_1.addTelemetryError)(e);
    }
}
function fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse) {
    var canUseKeepAlive = isKeepAliveSupported() && payload.bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        var fetchUrl = endpointBuilder.build('fetch', payload);
        fetch(fetchUrl, { method: 'POST', body: payload.data, keepalive: true, mode: 'cors' }).then((0, monitor_1.monitor)(function (response) { return onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: response.status, type: response.type }); }), (0, monitor_1.monitor)(function () {
            var xhrUrl = endpointBuilder.build('xhr', payload);
            // failed to queue the request
            sendXHR(configuration, xhrUrl, payload.data, onResponse);
        }));
    }
    else {
        var xhrUrl = endpointBuilder.build('xhr', payload);
        sendXHR(configuration, xhrUrl, payload.data, onResponse);
    }
}
exports.fetchKeepAliveStrategy = fetchKeepAliveStrategy;
function isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && 'keepalive' in new Request('http://a');
    }
    catch (_a) {
        return false;
    }
}
function sendXHR(configuration, url, data, onResponse) {
    var request = new XMLHttpRequest();
    request.open('POST', url, true);
    (0, addEventListener_1.addEventListener)(configuration, request, 'loadend', function () {
        onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: request.status });
    }, {
        // prevent multiple onResponse callbacks
        // if the xhr instance is reused by a third party
        once: true,
    });
    request.send(data);
}
exports.sendXHR = sendXHR;
//# sourceMappingURL=httpRequest.js.map
},{"../browser/addEventListener":12,"../domain/telemetry":46,"../tools/monitor":67,"./sendWithRetryStrategy":92}],91:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFlushController = exports.startBatchWithReplica = exports.getEventBridge = exports.canUseEventBridge = exports.createHttpRequest = void 0;
var httpRequest_1 = require("./httpRequest");
Object.defineProperty(exports, "createHttpRequest", { enumerable: true, get: function () { return httpRequest_1.createHttpRequest; } });
var eventBridge_1 = require("./eventBridge");
Object.defineProperty(exports, "canUseEventBridge", { enumerable: true, get: function () { return eventBridge_1.canUseEventBridge; } });
Object.defineProperty(exports, "getEventBridge", { enumerable: true, get: function () { return eventBridge_1.getEventBridge; } });
var startBatchWithReplica_1 = require("./startBatchWithReplica");
Object.defineProperty(exports, "startBatchWithReplica", { enumerable: true, get: function () { return startBatchWithReplica_1.startBatchWithReplica; } });
var flushController_1 = require("./flushController");
Object.defineProperty(exports, "createFlushController", { enumerable: true, get: function () { return flushController_1.createFlushController; } });
//# sourceMappingURL=index.js.map
},{"./eventBridge":88,"./flushController":89,"./httpRequest":90,"./startBatchWithReplica":93}],92:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newRetryState = exports.sendWithRetryStrategy = exports.INITIAL_BACKOFF_TIME = exports.MAX_BACKOFF_TIME = exports.MAX_QUEUE_BYTES_COUNT = exports.MAX_ONGOING_REQUESTS = exports.MAX_ONGOING_BYTES_COUNT = void 0;
var timer_1 = require("../tools/timer");
var timeUtils_1 = require("../tools/utils/timeUtils");
var byteUtils_1 = require("../tools/utils/byteUtils");
var responseUtils_1 = require("../tools/utils/responseUtils");
var error_types_1 = require("../domain/error/error.types");
exports.MAX_ONGOING_BYTES_COUNT = 80 * byteUtils_1.ONE_KIBI_BYTE;
exports.MAX_ONGOING_REQUESTS = 32;
exports.MAX_QUEUE_BYTES_COUNT = 3 * byteUtils_1.ONE_MEBI_BYTE;
exports.MAX_BACKOFF_TIME = timeUtils_1.ONE_MINUTE;
exports.INITIAL_BACKOFF_TIME = timeUtils_1.ONE_SECOND;
function sendWithRetryStrategy(payload, state, sendStrategy, endpointType, reportError) {
    if (state.transportStatus === 0 /* TransportStatus.UP */ &&
        state.queuedPayloads.size() === 0 &&
        state.bandwidthMonitor.canHandle(payload)) {
        send(payload, state, sendStrategy, {
            onSuccess: function () { return retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */, state, sendStrategy, endpointType, reportError); },
            onFailure: function () {
                state.queuedPayloads.enqueue(payload);
                scheduleRetry(state, sendStrategy, endpointType, reportError);
            },
        });
    }
    else {
        state.queuedPayloads.enqueue(payload);
    }
}
exports.sendWithRetryStrategy = sendWithRetryStrategy;
function scheduleRetry(state, sendStrategy, endpointType, reportError) {
    if (state.transportStatus !== 2 /* TransportStatus.DOWN */) {
        return;
    }
    (0, timer_1.setTimeout)(function () {
        var payload = state.queuedPayloads.first();
        send(payload, state, sendStrategy, {
            onSuccess: function () {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = exports.INITIAL_BACKOFF_TIME;
                retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */, state, sendStrategy, endpointType, reportError);
            },
            onFailure: function () {
                state.currentBackoffTime = Math.min(exports.MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
                scheduleRetry(state, sendStrategy, endpointType, reportError);
            },
        });
    }, state.currentBackoffTime);
}
function send(payload, state, sendStrategy, _a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, function (response) {
        state.bandwidthMonitor.remove(payload);
        if (!shouldRetryRequest(response)) {
            state.transportStatus = 0 /* TransportStatus.UP */;
            onSuccess();
        }
        else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus =
                state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */ : 2 /* TransportStatus.DOWN */;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status,
            };
            onFailure();
        }
    });
}
function retryQueuedPayloads(reason, state, sendStrategy, endpointType, reportError) {
    if (reason === 0 /* RetryReason.AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: "Reached max ".concat(endpointType, " events size queued for upload: ").concat(exports.MAX_QUEUE_BYTES_COUNT / byteUtils_1.ONE_MEBI_BYTE, "MiB"),
            source: error_types_1.ErrorSource.AGENT,
            startClocks: (0, timeUtils_1.clocksNow)(),
        });
        state.queueFullReported = true;
    }
    var previousQueue = state.queuedPayloads;
    state.queuedPayloads = newPayloadQueue();
    while (previousQueue.size() > 0) {
        sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, endpointType, reportError);
    }
}
function shouldRetryRequest(response) {
    return (response.type !== 'opaque' &&
        ((response.status === 0 && !navigator.onLine) ||
            response.status === 408 ||
            response.status === 429 ||
            (0, responseUtils_1.isServerError)(response.status)));
}
function newRetryState() {
    return {
        transportStatus: 0 /* TransportStatus.UP */,
        currentBackoffTime: exports.INITIAL_BACKOFF_TIME,
        bandwidthMonitor: newBandwidthMonitor(),
        queuedPayloads: newPayloadQueue(),
        queueFullReported: false,
    };
}
exports.newRetryState = newRetryState;
function newPayloadQueue() {
    var queue = [];
    return {
        bytesCount: 0,
        enqueue: function (payload) {
            if (this.isFull()) {
                return;
            }
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
        },
        first: function () {
            return queue[0];
        },
        dequeue: function () {
            var payload = queue.shift();
            if (payload) {
                this.bytesCount -= payload.bytesCount;
            }
            return payload;
        },
        size: function () {
            return queue.length;
        },
        isFull: function () {
            return this.bytesCount >= exports.MAX_QUEUE_BYTES_COUNT;
        },
    };
}
function newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle: function (payload) {
            return (this.ongoingRequestCount === 0 ||
                (this.ongoingByteCount + payload.bytesCount <= exports.MAX_ONGOING_BYTES_COUNT &&
                    this.ongoingRequestCount < exports.MAX_ONGOING_REQUESTS));
        },
        add: function (payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove: function (payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
    };
}
//# sourceMappingURL=sendWithRetryStrategy.js.map
},{"../domain/error/error.types":31,"../tools/timer":73,"../tools/utils/byteUtils":76,"../tools/utils/responseUtils":81,"../tools/utils/timeUtils":83}],93:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startBatchWithReplica = void 0;
var batch_1 = require("./batch");
var httpRequest_1 = require("./httpRequest");
var flushController_1 = require("./flushController");
function startBatchWithReplica(configuration, primary, replica, reportError, pageExitObservable, sessionExpireObservable) {
    var primaryBatch = createBatch(configuration, primary.endpoint);
    var replicaBatch = replica && createBatch(configuration, replica.endpoint);
    function createBatch(configuration, endpointBuilder) {
        return new batch_1.Batch((0, httpRequest_1.createHttpRequest)(configuration, endpointBuilder, configuration.batchBytesLimit, reportError), (0, flushController_1.createFlushController)({
            messagesLimit: configuration.batchMessagesLimit,
            bytesLimit: configuration.batchBytesLimit,
            durationLimit: configuration.flushTimeout,
            pageExitObservable: pageExitObservable,
            sessionExpireObservable: sessionExpireObservable,
        }), configuration.messageBytesLimit);
    }
    return {
        flushObservable: primaryBatch.flushController.flushObservable,
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(replica.transformMessage ? replica.transformMessage(message) : message);
            }
        },
        upsert: function (message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) {
                replicaBatch.upsert(replica.transformMessage ? replica.transformMessage(message) : message, key);
            }
        },
        stop: function () {
            primaryBatch.stop();
            replicaBatch === null || replicaBatch === void 0 ? void 0 : replicaBatch.stop();
        },
    };
}
exports.startBatchWithReplica = startBatchWithReplica;
//# sourceMappingURL=startBatchWithReplica.js.map
},{"./batch":87,"./flushController":89,"./httpRequest":90}],94:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRumPublicApi = void 0;
var browser_core_1 = require("@datadog/browser-core");
var configuration_1 = require("../domain/configuration");
var commonContext_1 = require("../domain/contexts/commonContext");
var RUM_STORAGE_KEY = 'rum';
function makeRumPublicApi(startRumImpl, recorderApi, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.ignoreInitIfSyntheticsWillInjectRum, ignoreInitIfSyntheticsWillInjectRum = _c === void 0 ? true : _c;
    var isAlreadyInitialized = false;
    var globalContextManager = (0, browser_core_1.createContextManager)(2 /* CustomerDataType.GlobalContext */);
    var userContextManager = (0, browser_core_1.createContextManager)(1 /* CustomerDataType.User */);
    var getInternalContextStrategy = function () { return undefined; };
    var getInitConfigurationStrategy = function () { return undefined; };
    var stopSessionStrategy = browser_core_1.noop;
    var getSessionReplayLinkStrategy = function () { return undefined; };
    var bufferApiCalls = new browser_core_1.BoundedBuffer();
    var addTimingStrategy = function (name, time) {
        if (time === void 0) { time = (0, browser_core_1.timeStampNow)(); }
        bufferApiCalls.add(function () { return addTimingStrategy(name, time); });
    };
    var startViewStrategy = function (options, startClocks) {
        if (startClocks === void 0) { startClocks = (0, browser_core_1.clocksNow)(); }
        bufferApiCalls.add(function () { return startViewStrategy(options, startClocks); });
    };
    var addActionStrategy = function (action, commonContext) {
        if (commonContext === void 0) { commonContext = (0, commonContext_1.buildCommonContext)(globalContextManager, userContextManager, recorderApi); }
        bufferApiCalls.add(function () { return addActionStrategy(action, commonContext); });
    };
    var addErrorStrategy = function (providedError, commonContext) {
        if (commonContext === void 0) { commonContext = (0, commonContext_1.buildCommonContext)(globalContextManager, userContextManager, recorderApi); }
        bufferApiCalls.add(function () { return addErrorStrategy(providedError, commonContext); });
    };
    var addFeatureFlagEvaluationStrategy = function (key, value) {
        bufferApiCalls.add(function () { return addFeatureFlagEvaluationStrategy(key, value); });
    };
    function initRum(initConfiguration) {
        if (!initConfiguration) {
            browser_core_1.display.error('Missing configuration');
            return;
        }
        // This function should be available, regardless of initialization success.
        getInitConfigurationStrategy = function () { return (0, browser_core_1.deepClone)(initConfiguration); };
        // If we are in a Synthetics test configured to automatically inject a RUM instance, we want to
        // completely discard the customer application RUM instance by ignoring their init() call.  But,
        // we should not ignore the init() call from the Synthetics-injected RUM instance, so the
        // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
        if (ignoreInitIfSyntheticsWillInjectRum && (0, browser_core_1.willSyntheticsInjectRum)()) {
            return;
        }
        var eventBridgeAvailable = (0, browser_core_1.canUseEventBridge)();
        if (eventBridgeAvailable) {
            initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
        }
        if (!canInitRum(initConfiguration)) {
            return;
        }
        var configuration = (0, configuration_1.validateAndBuildRumConfiguration)(initConfiguration);
        if (!configuration) {
            return;
        }
        if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
            browser_core_1.display.warn('No storage available for session. We will not send any data.');
            return;
        }
        if (!configuration.trackViewsManually) {
            doStartRum(initConfiguration, configuration);
        }
        else {
            // drain beforeInitCalls by buffering them until we start RUM
            // if we get a startView, drain re-buffered calls before continuing to drain beforeInitCalls
            // in order to ensure that calls are processed in order
            var beforeInitCalls = bufferApiCalls;
            bufferApiCalls = new browser_core_1.BoundedBuffer();
            startViewStrategy = function (options) {
                doStartRum(initConfiguration, configuration, options);
            };
            beforeInitCalls.drain();
        }
        isAlreadyInitialized = true;
    }
    function doStartRum(initConfiguration, configuration, initialViewOptions) {
        if (initConfiguration.storeContextsAcrossPages) {
            var beforeInitGlobalContext = globalContextManager.getContext();
            globalContextManager = (0, browser_core_1.createStoredContextManager)(configuration, RUM_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */);
            globalContextManager.setContext((0, browser_core_1.combine)(globalContextManager.getContext(), beforeInitGlobalContext));
            var beforeInitUserContext = userContextManager.getContext();
            userContextManager = (0, browser_core_1.createStoredContextManager)(configuration, RUM_STORAGE_KEY, 1 /* CustomerDataType.User */);
            userContextManager.setContext((0, browser_core_1.combine)(userContextManager.getContext(), beforeInitUserContext));
        }
        var startRumResults = startRumImpl(initConfiguration, configuration, recorderApi, globalContextManager, userContextManager, initialViewOptions);
        getSessionReplayLinkStrategy = function () {
            return recorderApi.getSessionReplayLink(configuration, startRumResults.session, startRumResults.viewContexts);
        };
        (startViewStrategy = startRumResults.startView, addActionStrategy = startRumResults.addAction, addErrorStrategy = startRumResults.addError, addTimingStrategy = startRumResults.addTiming, addFeatureFlagEvaluationStrategy = startRumResults.addFeatureFlagEvaluation, getInternalContextStrategy = startRumResults.getInternalContext, stopSessionStrategy = startRumResults.stopSession);
        bufferApiCalls.drain();
        recorderApi.onRumStart(startRumResults.lifeCycle, configuration, startRumResults.session, startRumResults.viewContexts);
    }
    var startView = (0, browser_core_1.monitor)(function (options) {
        var sanitizedOptions = typeof options === 'object' ? options : { name: options };
        startViewStrategy(sanitizedOptions);
    });
    var rumPublicApi = (0, browser_core_1.makePublicApi)({
        init: (0, browser_core_1.monitor)(initRum),
        /** @deprecated: use setGlobalContextProperty instead */
        addRumGlobalContext: (0, browser_core_1.monitor)(function (key, value) { return globalContextManager.add(key, value); }),
        setGlobalContextProperty: (0, browser_core_1.monitor)(function (key, value) { return globalContextManager.setContextProperty(key, value); }),
        /** @deprecated: use removeGlobalContextProperty instead */
        removeRumGlobalContext: (0, browser_core_1.monitor)(function (key) { return globalContextManager.remove(key); }),
        removeGlobalContextProperty: (0, browser_core_1.monitor)(function (key) { return globalContextManager.removeContextProperty(key); }),
        /** @deprecated: use getGlobalContext instead */
        getRumGlobalContext: (0, browser_core_1.monitor)(function () { return globalContextManager.get(); }),
        getGlobalContext: (0, browser_core_1.monitor)(function () { return globalContextManager.getContext(); }),
        /** @deprecated: use setGlobalContext instead */
        setRumGlobalContext: (0, browser_core_1.monitor)(function (context) { return globalContextManager.set(context); }),
        setGlobalContext: (0, browser_core_1.monitor)(function (context) { return globalContextManager.setContext(context); }),
        clearGlobalContext: (0, browser_core_1.monitor)(function () { return globalContextManager.clearContext(); }),
        getInternalContext: (0, browser_core_1.monitor)(function (startTime) { return getInternalContextStrategy(startTime); }),
        getInitConfiguration: (0, browser_core_1.monitor)(function () { return getInitConfigurationStrategy(); }),
        addAction: (0, browser_core_1.monitor)(function (name, context) {
            addActionStrategy({
                name: (0, browser_core_1.sanitize)(name),
                context: (0, browser_core_1.sanitize)(context),
                startClocks: (0, browser_core_1.clocksNow)(),
                type: "custom" /* ActionType.CUSTOM */,
            });
        }),
        addError: function (error, context) {
            var handlingStack = (0, browser_core_1.createHandlingStack)();
            (0, browser_core_1.callMonitored)(function () {
                addErrorStrategy({
                    error: error,
                    handlingStack: handlingStack,
                    context: (0, browser_core_1.sanitize)(context),
                    startClocks: (0, browser_core_1.clocksNow)(),
                });
            });
        },
        addTiming: (0, browser_core_1.monitor)(function (name, time) {
            addTimingStrategy((0, browser_core_1.sanitize)(name), time);
        }),
        setUser: (0, browser_core_1.monitor)(function (newUser) {
            if ((0, browser_core_1.checkUser)(newUser)) {
                userContextManager.setContext((0, browser_core_1.sanitizeUser)(newUser));
            }
        }),
        getUser: (0, browser_core_1.monitor)(function () { return userContextManager.getContext(); }),
        setUserProperty: (0, browser_core_1.monitor)(function (key, property) {
            var _a;
            var sanitizedProperty = (0, browser_core_1.sanitizeUser)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0, browser_core_1.monitor)(function (key) { return userContextManager.removeContextProperty(key); }),
        /** @deprecated: renamed to clearUser */
        removeUser: (0, browser_core_1.monitor)(function () { return userContextManager.clearContext(); }),
        clearUser: (0, browser_core_1.monitor)(function () { return userContextManager.clearContext(); }),
        startView: startView,
        stopSession: (0, browser_core_1.monitor)(function () {
            stopSessionStrategy();
        }),
        startSessionReplayRecording: (0, browser_core_1.monitor)(recorderApi.start),
        stopSessionReplayRecording: (0, browser_core_1.monitor)(recorderApi.stop),
        /**
         * This feature is currently in beta. For more information see the full [feature flag tracking guide](https://docs.datadoghq.com/real_user_monitoring/feature_flag_tracking/).
         */
        addFeatureFlagEvaluation: (0, browser_core_1.monitor)(function (key, value) {
            addFeatureFlagEvaluationStrategy((0, browser_core_1.sanitize)(key), (0, browser_core_1.sanitize)(value));
        }),
        getSessionReplayLink: (0, browser_core_1.monitor)(function () { return getSessionReplayLinkStrategy(); }),
    });
    return rumPublicApi;
    function canInitRum(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                browser_core_1.display.error('DD_RUM is already initialized.');
            }
            return false;
        }
        return true;
    }
    function overrideInitConfigurationForBridge(initConfiguration) {
        return (0, browser_core_1.assign)({}, initConfiguration, {
            applicationId: '00000000-aaaa-0000-aaaa-000000000000',
            clientToken: 'empty',
            sessionSampleRate: 100,
        });
    }
}
exports.makeRumPublicApi = makeRumPublicApi;
//# sourceMappingURL=rumPublicApi.js.map
},{"../domain/configuration":109,"../domain/contexts/commonContext":111,"@datadog/browser-core":56}],95:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRumEventCollection = exports.startRum = void 0;
var browser_core_1 = require("@datadog/browser-core");
var domMutationObservable_1 = require("../browser/domMutationObservable");
var performanceCollection_1 = require("../browser/performanceCollection");
var assembly_1 = require("../domain/assembly");
var internalContext_1 = require("../domain/contexts/internalContext");
var lifeCycle_1 = require("../domain/lifeCycle");
var viewContexts_1 = require("../domain/contexts/viewContexts");
var requestCollection_1 = require("../domain/requestCollection");
var actionCollection_1 = require("../domain/action/actionCollection");
var errorCollection_1 = require("../domain/error/errorCollection");
var longTaskCollection_1 = require("../domain/longTask/longTaskCollection");
var resourceCollection_1 = require("../domain/resource/resourceCollection");
var viewCollection_1 = require("../domain/view/viewCollection");
var rumSessionManager_1 = require("../domain/rumSessionManager");
var startRumBatch_1 = require("../transport/startRumBatch");
var startRumEventBridge_1 = require("../transport/startRumEventBridge");
var urlContexts_1 = require("../domain/contexts/urlContexts");
var locationChangeObservable_1 = require("../browser/locationChangeObservable");
var configuration_1 = require("../domain/configuration");
var featureFlagContext_1 = require("../domain/contexts/featureFlagContext");
var startCustomerDataTelemetry_1 = require("../domain/startCustomerDataTelemetry");
var pageStateHistory_1 = require("../domain/contexts/pageStateHistory");
var commonContext_1 = require("../domain/contexts/commonContext");
var displayContext_1 = require("../domain/contexts/displayContext");
function startRum(initConfiguration, configuration, recorderApi, globalContextManager, userContextManager, initialViewOptions) {
    var cleanupTasks = [];
    var lifeCycle = new lifeCycle_1.LifeCycle();
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) { return (0, browser_core_1.sendToExtension)('rum', event); });
    var telemetry = startRumTelemetry(configuration);
    telemetry.setContextProvider(function () {
        var _a, _b;
        return ({
            application: {
                id: configuration.applicationId,
            },
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id,
            },
            view: {
                id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.id,
            },
            action: {
                id: actionContexts.findActionId(),
            },
        });
    });
    var reportError = function (error) {
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error });
        (0, browser_core_1.addTelemetryDebug)('Error reported to customer', { 'error.message': error.message });
    };
    var featureFlagContexts = (0, featureFlagContext_1.startFeatureFlagContexts)(lifeCycle);
    var pageExitObservable = (0, browser_core_1.createPageExitObservable)(configuration);
    var pageExitSubscription = pageExitObservable.subscribe(function (event) {
        lifeCycle.notify(9 /* LifeCycleEventType.PAGE_EXITED */, event);
    });
    cleanupTasks.push(function () { return pageExitSubscription.unsubscribe(); });
    var session = !(0, browser_core_1.canUseEventBridge)() ? (0, rumSessionManager_1.startRumSessionManager)(configuration, lifeCycle) : (0, rumSessionManager_1.startRumSessionManagerStub)();
    if (!(0, browser_core_1.canUseEventBridge)()) {
        var batch_1 = (0, startRumBatch_1.startRumBatch)(configuration, lifeCycle, telemetry.observable, reportError, pageExitObservable, session.expireObservable);
        cleanupTasks.push(function () { return batch_1.stop(); });
        (0, startCustomerDataTelemetry_1.startCustomerDataTelemetry)(configuration, telemetry, lifeCycle, globalContextManager, userContextManager, featureFlagContexts, batch_1.flushObservable);
    }
    else {
        (0, startRumEventBridge_1.startRumEventBridge)(lifeCycle);
    }
    var domMutationObservable = (0, domMutationObservable_1.createDOMMutationObservable)();
    var locationChangeObservable = (0, locationChangeObservable_1.createLocationChangeObservable)(configuration, location);
    var _a = startRumEventCollection(lifeCycle, configuration, location, session, locationChangeObservable, domMutationObservable, function () { return (0, commonContext_1.buildCommonContext)(globalContextManager, userContextManager, recorderApi); }, reportError), viewContexts = _a.viewContexts, pageStateHistory = _a.pageStateHistory, urlContexts = _a.urlContexts, actionContexts = _a.actionContexts, addAction = _a.addAction, stopRumEventCollection = _a.stop;
    cleanupTasks.push(stopRumEventCollection);
    (0, browser_core_1.addTelemetryConfiguration)((0, configuration_1.serializeRumConfiguration)(initConfiguration));
    (0, longTaskCollection_1.startLongTaskCollection)(lifeCycle, session);
    (0, resourceCollection_1.startResourceCollection)(lifeCycle, configuration, session, pageStateHistory);
    var _b = (0, viewCollection_1.startViewCollection)(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions), addTiming = _b.addTiming, startView = _b.startView, stopViewCollection = _b.stop;
    cleanupTasks.push(stopViewCollection);
    var addError = (0, errorCollection_1.startErrorCollection)(lifeCycle, configuration, pageStateHistory, featureFlagContexts).addError;
    (0, requestCollection_1.startRequestCollection)(lifeCycle, configuration, session);
    (0, performanceCollection_1.startPerformanceCollection)(lifeCycle, configuration);
    var internalContext = (0, internalContext_1.startInternalContext)(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
    return {
        addAction: addAction,
        addError: addError,
        addTiming: addTiming,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView: startView,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts,
        session: session,
        stopSession: function () { return session.expire(); },
        getInternalContext: internalContext.get,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
exports.startRum = startRum;
function startRumTelemetry(configuration) {
    var telemetry = (0, browser_core_1.startTelemetry)("browser-rum-sdk" /* TelemetryService.RUM */, configuration);
    if ((0, browser_core_1.canUseEventBridge)()) {
        var bridge_1 = (0, browser_core_1.getEventBridge)();
        telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
    }
    return telemetry;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, locationChangeObservable, domMutationObservable, buildCommonContext, reportError) {
    var viewContexts = (0, viewContexts_1.startViewContexts)(lifeCycle);
    var urlContexts = (0, urlContexts_1.startUrlContexts)(lifeCycle, locationChangeObservable, location);
    var pageStateHistory = (0, pageStateHistory_1.startPageStateHistory)(configuration);
    var _a = (0, actionCollection_1.startActionCollection)(lifeCycle, domMutationObservable, configuration, pageStateHistory), addAction = _a.addAction, actionContexts = _a.actionContexts;
    var displayContext = (0, displayContext_1.startDisplayContext)(configuration);
    (0, assembly_1.startRumAssembly)(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, buildCommonContext, reportError);
    return {
        viewContexts: viewContexts,
        pageStateHistory: pageStateHistory,
        urlContexts: urlContexts,
        addAction: addAction,
        actionContexts: actionContexts,
        stop: function () {
            displayContext.stop();
            pageStateHistory.stop();
            urlContexts.stop();
            viewContexts.stop();
            pageStateHistory.stop();
        },
    };
}
exports.startRumEventCollection = startRumEventCollection;
//# sourceMappingURL=startRum.js.map
},{"../browser/domMutationObservable":96,"../browser/locationChangeObservable":98,"../browser/performanceCollection":99,"../domain/action/actionCollection":102,"../domain/assembly":108,"../domain/configuration":109,"../domain/contexts/commonContext":111,"../domain/contexts/displayContext":112,"../domain/contexts/featureFlagContext":113,"../domain/contexts/internalContext":115,"../domain/contexts/pageStateHistory":116,"../domain/contexts/urlContexts":118,"../domain/contexts/viewContexts":119,"../domain/error/errorCollection":120,"../domain/lifeCycle":125,"../domain/longTask/longTaskCollection":127,"../domain/requestCollection":128,"../domain/resource/resourceCollection":130,"../domain/rumSessionManager":132,"../domain/startCustomerDataTelemetry":133,"../domain/view/viewCollection":139,"../transport/startRumBatch":154,"../transport/startRumEventBridge":155,"@datadog/browser-core":56}],96:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMutationObserverConstructor = exports.createDOMMutationObservable = void 0;
var browser_core_1 = require("@datadog/browser-core");
function createDOMMutationObservable() {
    var MutationObserver = getMutationObserverConstructor();
    var observable = new browser_core_1.Observable(function () {
        if (!MutationObserver) {
            return;
        }
        var observer = new MutationObserver((0, browser_core_1.monitor)(function () { return observable.notify(); }));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });
        return function () { return observer.disconnect(); };
    });
    return observable;
}
exports.createDOMMutationObservable = createDOMMutationObservable;
function getMutationObserverConstructor() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = (0, browser_core_1.getZoneJsOriginalValue)(browserWindow, 'MutationObserver');
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            var patchedInstance = new browserWindow.MutationObserver(browser_core_1.noop);
            var originalInstance = (0, browser_core_1.getZoneJsOriginalValue)(patchedInstance, 'originalInstance');
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) {
        constructor = browserWindow.MutationObserver;
    }
    return constructor;
}
exports.getMutationObserverConstructor = getMutationObserverConstructor;
//# sourceMappingURL=domMutationObservable.js.map
},{"@datadog/browser-core":56}],97:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParentNode = exports.forEachChildNodes = exports.hasChildNodes = exports.isNodeShadowRoot = exports.isNodeShadowHost = exports.isElementNode = exports.isCommentNode = exports.isTextNode = void 0;
function isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
exports.isTextNode = isTextNode;
function isCommentNode(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
exports.isCommentNode = isCommentNode;
function isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
exports.isElementNode = isElementNode;
function isNodeShadowHost(node) {
    return isElementNode(node) && Boolean(node.shadowRoot);
}
exports.isNodeShadowHost = isNodeShadowHost;
function isNodeShadowRoot(node) {
    var shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
exports.isNodeShadowRoot = isNodeShadowRoot;
function hasChildNodes(node) {
    return node.childNodes.length > 0 || isNodeShadowHost(node);
}
exports.hasChildNodes = hasChildNodes;
function forEachChildNodes(node, callback) {
    node.childNodes.forEach(callback);
    if (isNodeShadowHost(node)) {
        callback(node.shadowRoot);
    }
}
exports.forEachChildNodes = forEachChildNodes;
/**
 * Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
 */
function getParentNode(node) {
    return isNodeShadowRoot(node) ? node.host : node.parentNode;
}
exports.getParentNode = getParentNode;
//# sourceMappingURL=htmlDomUtils.js.map
},{}],98:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLocationChangeObservable = void 0;
var browser_core_1 = require("@datadog/browser-core");
function createLocationChangeObservable(configuration, location) {
    var currentLocation = (0, browser_core_1.shallowClone)(location);
    var observable = new browser_core_1.Observable(function () {
        var stopHistoryTracking = trackHistory(configuration, onLocationChange).stop;
        var stopHashTracking = trackHash(configuration, onLocationChange).stop;
        return function () {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
    function onLocationChange() {
        if (currentLocation.href === location.href) {
            return;
        }
        var newLocation = (0, browser_core_1.shallowClone)(location);
        observable.notify({
            newLocation: newLocation,
            oldLocation: currentLocation,
        });
        currentLocation = newLocation;
    }
    return observable;
}
exports.createLocationChangeObservable = createLocationChangeObservable;
function trackHistory(configuration, onHistoryChange) {
    var stopInstrumentingPushState = (0, browser_core_1.instrumentMethodAndCallOriginal)(history, 'pushState', {
        after: onHistoryChange,
    }).stop;
    var stopInstrumentingReplaceState = (0, browser_core_1.instrumentMethodAndCallOriginal)(history, 'replaceState', {
        after: onHistoryChange,
    }).stop;
    var removeListener = (0, browser_core_1.addEventListener)(configuration, window, "popstate" /* DOM_EVENT.POP_STATE */, onHistoryChange).stop;
    return {
        stop: function () {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        },
    };
}
function trackHash(configuration, onHashChange) {
    return (0, browser_core_1.addEventListener)(configuration, window, "hashchange" /* DOM_EVENT.HASH_CHANGE */, onHashChange);
}
//# sourceMappingURL=locationChangeObservable.js.map
},{"@datadog/browser-core":56}],99:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retrieveInitialDocumentResourceTiming = exports.startPerformanceCollection = exports.supportPerformanceTimingEvent = exports.RumPerformanceEntryType = void 0;
var browser_core_1 = require("@datadog/browser-core");
var resourceUtils_1 = require("../domain/resource/resourceUtils");
var getDocumentTraceId_1 = require("../domain/tracing/getDocumentTraceId");
// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected performance entry
// eslint-disable-next-line no-restricted-syntax
var RumPerformanceEntryType;
(function (RumPerformanceEntryType) {
    RumPerformanceEntryType["EVENT"] = "event";
    RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
    RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
    RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
    RumPerformanceEntryType["LONG_TASK"] = "longtask";
    RumPerformanceEntryType["NAVIGATION"] = "navigation";
    RumPerformanceEntryType["PAINT"] = "paint";
    RumPerformanceEntryType["RESOURCE"] = "resource";
})(RumPerformanceEntryType || (exports.RumPerformanceEntryType = RumPerformanceEntryType = {}));
function supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
    return (window.PerformanceObserver &&
        PerformanceObserver.supportedEntryTypes !== undefined &&
        PerformanceObserver.supportedEntryTypes.includes(entryType));
}
exports.supportPerformanceTimingEvent = supportPerformanceTimingEvent;
function startPerformanceCollection(lifeCycle, configuration) {
    retrieveInitialDocumentResourceTiming(configuration, function (timing) {
        handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
    });
    if (supportPerformanceObject()) {
        var performanceEntries_1 = performance.getEntries();
        // Because the performance entry list can be quite large
        // delay the computation to prevent the SDK from blocking the main thread on init
        (0, browser_core_1.setTimeout)(function () { return handleRumPerformanceEntries(lifeCycle, configuration, performanceEntries_1); });
    }
    if (window.PerformanceObserver) {
        var handlePerformanceEntryList_1 = (0, browser_core_1.monitor)(function (entries) {
            return handleRumPerformanceEntries(lifeCycle, configuration, entries.getEntries());
        });
        var mainEntries = [
            RumPerformanceEntryType.RESOURCE,
            RumPerformanceEntryType.NAVIGATION,
            RumPerformanceEntryType.LONG_TASK,
            RumPerformanceEntryType.PAINT,
        ];
        var experimentalEntries = [
            RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT,
            RumPerformanceEntryType.FIRST_INPUT,
            RumPerformanceEntryType.LAYOUT_SHIFT,
            RumPerformanceEntryType.EVENT,
        ];
        try {
            // Experimental entries are not retrieved by performance.getEntries()
            // use a single PerformanceObserver with buffered flag by type
            // to get values that could happen before SDK init
            experimentalEntries.forEach(function (type) {
                var observer = new window.PerformanceObserver(handlePerformanceEntryList_1);
                observer.observe({
                    type: type,
                    buffered: true,
                    // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
                    // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L209
                    durationThreshold: 40,
                });
            });
        }
        catch (e) {
            // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to PerformanceObserver with entryTypes
            mainEntries.push.apply(mainEntries, experimentalEntries);
        }
        var mainObserver = new PerformanceObserver(handlePerformanceEntryList_1);
        mainObserver.observe({ entryTypes: mainEntries });
        if (supportPerformanceObject() && 'addEventListener' in performance) {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
            (0, browser_core_1.addEventListener)(configuration, performance, 'resourcetimingbufferfull', function () {
                performance.clearResourceTimings();
            });
        }
    }
    if (!supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION)) {
        retrieveNavigationTiming(configuration, function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
    if (!supportPerformanceTimingEvent(RumPerformanceEntryType.FIRST_INPUT)) {
        retrieveFirstInputTiming(configuration, function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
}
exports.startPerformanceCollection = startPerformanceCollection;
function retrieveInitialDocumentResourceTiming(configuration, callback) {
    (0, browser_core_1.runOnReadyState)(configuration, 'interactive', function () {
        var timing;
        var forcedAttributes = {
            entryType: RumPerformanceEntryType.RESOURCE,
            initiatorType: resourceUtils_1.FAKE_INITIAL_DOCUMENT,
            traceId: (0, getDocumentTraceId_1.getDocumentTraceId)(document),
            toJSON: function () { return (0, browser_core_1.assign)({}, timing, { toJSON: undefined }); },
        };
        if (supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION) &&
            performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION).length > 0) {
            var navigationEntry = performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION)[0];
            timing = (0, browser_core_1.assign)(navigationEntry.toJSON(), forcedAttributes);
        }
        else {
            var relativePerformanceTiming = computeRelativePerformanceTiming();
            timing = (0, browser_core_1.assign)(relativePerformanceTiming, {
                decodedBodySize: 0,
                duration: relativePerformanceTiming.responseEnd,
                name: window.location.href,
                startTime: 0,
            }, forcedAttributes);
        }
        callback(timing);
    });
}
exports.retrieveInitialDocumentResourceTiming = retrieveInitialDocumentResourceTiming;
function retrieveNavigationTiming(configuration, callback) {
    function sendFakeTiming() {
        callback((0, browser_core_1.assign)(computeRelativePerformanceTiming(), {
            entryType: RumPerformanceEntryType.NAVIGATION,
        }));
    }
    (0, browser_core_1.runOnReadyState)(configuration, 'complete', function () {
        // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
        (0, browser_core_1.setTimeout)(sendFakeTiming);
    });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(configuration, callback) {
    var startTimeStamp = (0, browser_core_1.dateNow)();
    var timingSent = false;
    var removeEventListeners = (0, browser_core_1.addEventListeners)(configuration, window, ["click" /* DOM_EVENT.CLICK */, "mousedown" /* DOM_EVENT.MOUSE_DOWN */, "keydown" /* DOM_EVENT.KEY_DOWN */, "touchstart" /* DOM_EVENT.TOUCH_START */, "pointerdown" /* DOM_EVENT.POINTER_DOWN */], function (evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) {
            return;
        }
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: RumPerformanceEntryType.FIRST_INPUT,
            processingStart: (0, browser_core_1.relativeNow)(),
            processingEnd: (0, browser_core_1.relativeNow)(),
            startTime: evt.timeStamp,
            duration: 0,
            name: '',
        };
        if (evt.type === "pointerdown" /* DOM_EVENT.POINTER_DOWN */) {
            sendTimingIfPointerIsNotCancelled(configuration, timing);
        }
        else {
            sendTiming(timing);
        }
    }, { passive: true, capture: true }).stop;
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */
    function sendTimingIfPointerIsNotCancelled(configuration, timing) {
        (0, browser_core_1.addEventListeners)(configuration, window, ["pointerup" /* DOM_EVENT.POINTER_UP */, "pointercancel" /* DOM_EVENT.POINTER_CANCEL */], function (event) {
            if (event.type === "pointerup" /* DOM_EVENT.POINTER_UP */) {
                sendTiming(timing);
            }
        }, { once: true });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < (0, browser_core_1.dateNow)() - startTimeStamp) {
                callback(timing);
            }
        }
    }
}
function computeRelativePerformanceTiming() {
    var result = {};
    var timing = performance.timing;
    for (var key in timing) {
        if ((0, browser_core_1.isNumber)(timing[key])) {
            var numberKey = key;
            var timingElement = timing[numberKey];
            result[numberKey] = timingElement === 0 ? 0 : (0, browser_core_1.getRelativeTime)(timingElement);
        }
    }
    return result;
}
function handleRumPerformanceEntries(lifeCycle, configuration, entries) {
    var rumPerformanceEntries = entries.filter(function (entry) {
        return (0, browser_core_1.objectHasValue)(RumPerformanceEntryType, entry.entryType);
    });
    var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) { return !isIncompleteNavigation(entry) && !isForbiddenResource(configuration, entry); });
    if (rumAllowedPerformanceEntries.length) {
        lifeCycle.notify(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, rumAllowedPerformanceEntries);
    }
}
function isIncompleteNavigation(entry) {
    return entry.entryType === RumPerformanceEntryType.NAVIGATION && entry.loadEventEnd <= 0;
}
function isForbiddenResource(configuration, entry) {
    return entry.entryType === RumPerformanceEntryType.RESOURCE && !(0, resourceUtils_1.isAllowedRequestUrl)(configuration, entry.name);
}
//# sourceMappingURL=performanceCollection.js.map
},{"../domain/resource/resourceUtils":131,"../domain/tracing/getDocumentTraceId":134,"@datadog/browser-core":56}],100:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScrollY = exports.getScrollX = void 0;
function getScrollX() {
    var scrollX;
    var visual = window.visualViewport;
    if (visual) {
        scrollX = visual.pageLeft - visual.offsetLeft;
    }
    else if (window.scrollX !== undefined) {
        scrollX = window.scrollX;
    }
    else {
        scrollX = window.pageXOffset || 0;
    }
    return Math.round(scrollX);
}
exports.getScrollX = getScrollX;
function getScrollY() {
    var scrollY;
    var visual = window.visualViewport;
    if (visual) {
        scrollY = visual.pageTop - visual.offsetTop;
    }
    else if (window.scrollY !== undefined) {
        scrollY = window.scrollY;
    }
    else {
        scrollY = window.pageYOffset || 0;
    }
    return Math.round(scrollY);
}
exports.getScrollY = getScrollY;
//# sourceMappingURL=scroll.js.map
},{}],101:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViewportDimension = exports.createViewportObservable = exports.initViewportObservable = void 0;
var browser_core_1 = require("@datadog/browser-core");
var viewportObservable;
function initViewportObservable(configuration) {
    if (!viewportObservable) {
        viewportObservable = createViewportObservable(configuration);
    }
    return viewportObservable;
}
exports.initViewportObservable = initViewportObservable;
function createViewportObservable(configuration) {
    var observable = new browser_core_1.Observable(function () {
        var updateDimension = (0, browser_core_1.throttle)(function () {
            observable.notify(getViewportDimension());
        }, 200).throttled;
        return (0, browser_core_1.addEventListener)(configuration, window, "resize" /* DOM_EVENT.RESIZE */, updateDimension, { capture: true, passive: true })
            .stop;
    });
    return observable;
}
exports.createViewportObservable = createViewportObservable;
// excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport
function getViewportDimension() {
    var visual = window.visualViewport;
    if (visual) {
        return {
            width: Number(visual.width * visual.scale),
            height: Number(visual.height * visual.scale),
        };
    }
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0),
    };
}
exports.getViewportDimension = getViewportDimension;
//# sourceMappingURL=viewportObservable.js.map
},{"@datadog/browser-core":56}],102:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startActionCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var trackClickActions_1 = require("./trackClickActions");
function startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory) {
    lifeCycle.subscribe(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, function (action) {
        return lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processAction(action, pageStateHistory));
    });
    var actionContexts = { findActionId: browser_core_1.noop };
    if (configuration.trackUserInteractions) {
        actionContexts = (0, trackClickActions_1.trackClickActions)(lifeCycle, domMutationObservable, configuration).actionContexts;
    }
    return {
        addAction: function (action, savedCommonContext) {
            lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, (0, browser_core_1.assign)({
                savedCommonContext: savedCommonContext,
            }, processAction(action, pageStateHistory)));
        },
        actionContexts: actionContexts,
    };
}
exports.startActionCollection = startActionCollection;
function processAction(action, pageStateHistory) {
    var autoActionProperties = isAutoAction(action)
        ? {
            action: {
                id: action.id,
                loading_time: (0, browser_core_1.toServerDuration)(action.duration),
                frustration: {
                    type: action.frustrationTypes,
                },
                error: {
                    count: action.counts.errorCount,
                },
                long_task: {
                    count: action.counts.longTaskCount,
                },
                resource: {
                    count: action.counts.resourceCount,
                },
            },
            _dd: {
                action: {
                    target: action.target,
                    position: action.position,
                },
            },
        }
        : undefined;
    var customerContext = !isAutoAction(action) ? action.context : undefined;
    var actionEvent = (0, browser_core_1.combine)({
        action: {
            id: (0, browser_core_1.generateUUID)(),
            target: {
                name: action.name,
            },
            type: action.type,
        },
        date: action.startClocks.timeStamp,
        type: "action" /* RumEventType.ACTION */,
        view: { in_foreground: pageStateHistory.isInActivePageStateAt(action.startClocks.relative) },
    }, autoActionProperties);
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startClocks.relative,
        domainContext: isAutoAction(action) ? { event: action.event, events: action.events } : {},
    };
}
function isAutoAction(action) {
    return action.type !== "custom" /* ActionType.CUSTOM */;
}
//# sourceMappingURL=actionCollection.js.map
},{"./trackClickActions":107,"@datadog/browser-core":56}],103:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClickChain = exports.MAX_DISTANCE_BETWEEN_CLICKS = exports.MAX_DURATION_BETWEEN_CLICKS = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.MAX_DURATION_BETWEEN_CLICKS = browser_core_1.ONE_SECOND;
exports.MAX_DISTANCE_BETWEEN_CLICKS = 100;
function createClickChain(firstClick, onFinalize) {
    var bufferedClicks = [];
    var status = 0 /* ClickChainStatus.WaitingForMoreClicks */;
    var maxDurationBetweenClicksTimeoutId;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        (0, browser_core_1.clearTimeout)(maxDurationBetweenClicksTimeoutId);
        maxDurationBetweenClicksTimeoutId = (0, browser_core_1.setTimeout)(dontAcceptMoreClick, exports.MAX_DURATION_BETWEEN_CLICKS);
    }
    function tryFinalize() {
        if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */ && bufferedClicks.every(function (click) { return click.isStopped(); })) {
            status = 2 /* ClickChainStatus.Finalized */;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        (0, browser_core_1.clearTimeout)(maxDurationBetweenClicksTimeoutId);
        if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */) {
            status = 1 /* ClickChainStatus.WaitingForClicksToStop */;
            tryFinalize();
        }
    }
    return {
        tryAppend: function (click) {
            if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */) {
                return false;
            }
            if (bufferedClicks.length > 0 &&
                !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: function () {
            dontAcceptMoreClick();
        },
    };
}
exports.createClickChain = createClickChain;
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */
function areEventsSimilar(first, second) {
    return (first.target === second.target &&
        mouseEventDistance(first, second) <= exports.MAX_DISTANCE_BETWEEN_CLICKS &&
        first.timeStamp - second.timeStamp <= exports.MAX_DURATION_BETWEEN_CLICKS);
}
function mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}
//# sourceMappingURL=clickChain.js.map
},{"@datadog/browser-core":56}],104:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDead = exports.isRage = exports.computeFrustration = void 0;
var browser_core_1 = require("@datadog/browser-core");
var MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function computeFrustration(clicks, rageClick) {
    if (isRage(clicks)) {
        rageClick.addFrustration("rage_click" /* FrustrationType.RAGE_CLICK */);
        if (clicks.some(isDead)) {
            rageClick.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
        }
        if (rageClick.hasError) {
            rageClick.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
        }
        return { isRage: true };
    }
    var hasSelectionChanged = clicks.some(function (click) { return click.getUserActivity().selection; });
    clicks.forEach(function (click) {
        if (click.hasError) {
            click.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
        }
        if (isDead(click) &&
            // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
            !hasSelectionChanged) {
            click.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
        }
    });
    return { isRage: false };
}
exports.computeFrustration = computeFrustration;
function isRage(clicks) {
    if (clicks.some(function (click) { return click.getUserActivity().selection; })) {
        return false;
    }
    for (var i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
        if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <=
            browser_core_1.ONE_SECOND) {
            return true;
        }
    }
    return false;
}
exports.isRage = isRage;
var DEAD_CLICK_EXCLUDE_SELECTOR = 
// inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),' +
    'textarea,' +
    'select,' +
    // contenteditable and their descendants don't always trigger meaningful changes when manipulated
    '[contenteditable],' +
    '[contenteditable] *,' +
    // canvas, as there is no good way to detect activity occurring on them
    'canvas,' +
    // links that are interactive (have an href attribute) or any of their descendants, as they can
    // open a new tab or navigate to a hash without triggering a meaningful event
    'a[href],' +
    'a[href] *';
function isDead(click) {
    if (click.hasPageActivity || click.getUserActivity().input) {
        return false;
    }
    return !(0, browser_core_1.elementMatches)(click.event.target, DEAD_CLICK_EXCLUDE_SELECTOR);
}
exports.isDead = isDead;
//# sourceMappingURL=computeFrustration.js.map
},{"@datadog/browser-core":56}],105:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActionNameFromElement = exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = void 0;
var browser_core_1 = require("@datadog/browser-core");
/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';
function getActionNameFromElement(element, userProgrammaticAttribute) {
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, use strategies that are known to return good results. Those strategies will be used on
    //   the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    return (getActionNameFromElementProgrammatically(element, exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) ||
        (userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute)) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies) ||
        '');
}
exports.getActionNameFromElement = getActionNameFromElement;
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if (supportsElementClosest()) {
        elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
    }
    else {
        var element = targetElement;
        while (element) {
            if (element.hasAttribute(programmaticAttribute)) {
                elementWithAttribute = element;
                break;
            }
            element = element.parentElement;
        }
    }
    if (!elementWithAttribute) {
        return;
    }
    var name = elementWithAttribute.getAttribute(programmaticAttribute);
    return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
    // associated LABEL text
    function (element, userProgrammaticAttribute) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if (supportsLabelProperty()) {
            if ('labels' in element && element.labels && element.labels.length > 0) {
                return getTextualContent(element.labels[0], userProgrammaticAttribute);
            }
        }
        else if (element.id) {
            var label = element.ownerDocument &&
                (0, browser_core_1.find)(element.ownerDocument.querySelectorAll('label'), function (label) { return label.htmlFor === element.id; });
            return label && getTextualContent(label, userProgrammaticAttribute);
        }
    },
    // INPUT button (and associated) value
    function (element) {
        if (element.nodeName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') {
                return input.value;
            }
        }
    },
    // BUTTON, LABEL or button-like element text
    function (element, userProgrammaticAttribute) {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
            return getTextualContent(element, userProgrammaticAttribute);
        }
    },
    function (element) { return element.getAttribute('aria-label'); },
    // associated element text designated by the aria-labelledby attribute
    function (element, userProgrammaticAttribute) {
        var labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) {
            return labelledByAttribute
                .split(/\s+/)
                .map(function (id) { return getElementById(element, id); })
                .filter(function (label) { return Boolean(label); })
                .map(function (element) { return getTextualContent(element, userProgrammaticAttribute); })
                .join(' ');
        }
    },
    function (element) { return element.getAttribute('alt'); },
    function (element) { return element.getAttribute('name'); },
    function (element) { return element.getAttribute('title'); },
    function (element) { return element.getAttribute('placeholder'); },
    // SELECT first OPTION text
    function (element, userProgrammaticAttribute) {
        if ('options' in element && element.options.length > 0) {
            return getTextualContent(element.options[0], userProgrammaticAttribute);
        }
    },
];
var fallbackStrategies = [
    function (element, userProgrammaticAttribute) { return getTextualContent(element, userProgrammaticAttribute); },
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies) {
    var element = targetElement;
    var recursionCounter = 0;
    while (recursionCounter <= MAX_PARENTS_TO_CONSIDER &&
        element &&
        element.nodeName !== 'BODY' &&
        element.nodeName !== 'HTML' &&
        element.nodeName !== 'HEAD') {
        for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
            var strategy = strategies_1[_i];
            var name_1 = strategy(element, userProgrammaticAttribute);
            if (typeof name_1 === 'string') {
                var trimmedName = name_1.trim();
                if (trimmedName) {
                    return truncate(normalizeWhitespace(trimmedName));
                }
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') {
            break;
        }
        element = element.parentElement;
        recursionCounter += 1;
    }
}
function normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function truncate(s) {
    return s.length > 100 ? "".concat((0, browser_core_1.safeTruncate)(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute) {
    if (element.isContentEditable) {
        return;
    }
    if ('innerText' in element) {
        var text_1 = element.innerText;
        var removeTextFromElements = function (query) {
            var list = element.querySelectorAll(query);
            for (var index = 0; index < list.length; index += 1) {
                var element_1 = list[index];
                if ('innerText' in element_1) {
                    var textToReplace = element_1.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) {
                        text_1 = text_1.replace(textToReplace, '');
                    }
                }
            }
        };
        if (!supportsInnerTextScriptAndStyleRemoval()) {
            // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
            // be relatively fast and work in most cases.
            removeTextFromElements('script, style');
        }
        // remove the text of elements with programmatic attribute value
        removeTextFromElements("[".concat(exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, "]"));
        if (userProgrammaticAttribute) {
            removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
        }
        return text_1;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
    return !(0, browser_core_1.isIE)();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
    if (supportsLabelPropertyResult === undefined) {
        supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
    }
    return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
    if (supportsElementClosestResult === undefined) {
        supportsElementClosestResult = 'closest' in HTMLElement.prototype;
    }
    return supportsElementClosestResult;
}
//# sourceMappingURL=getActionNameFromElement.js.map
},{"@datadog/browser-core":56}],106:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenActionEvents = void 0;
var browser_core_1 = require("@datadog/browser-core");
function listenActionEvents(configuration, _a) {
    var onPointerDown = _a.onPointerDown, onPointerUp = _a.onPointerUp;
    var selectionEmptyAtPointerDown;
    var userActivity = {
        selection: false,
        input: false,
    };
    var clickContext;
    var listeners = [
        (0, browser_core_1.addEventListener)(configuration, window, "pointerdown" /* DOM_EVENT.POINTER_DOWN */, function (event) {
            if (isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                };
                clickContext = onPointerDown(event);
            }
        }, { capture: true }),
        (0, browser_core_1.addEventListener)(configuration, window, "selectionchange" /* DOM_EVENT.SELECTION_CHANGE */, function () {
            if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
                userActivity.selection = true;
            }
        }, { capture: true }),
        (0, browser_core_1.addEventListener)(configuration, window, "pointerup" /* DOM_EVENT.POINTER_UP */, function (event) {
            if (isValidPointerEvent(event) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                var localUserActivity_1 = userActivity;
                onPointerUp(clickContext, event, function () { return localUserActivity_1; });
                clickContext = undefined;
            }
        }, { capture: true }),
        (0, browser_core_1.addEventListener)(configuration, window, "input" /* DOM_EVENT.INPUT */, function () {
            userActivity.input = true;
        }, { capture: true }),
    ];
    return {
        stop: function () {
            listeners.forEach(function (listener) { return listener.stop(); });
        },
    };
}
exports.listenActionEvents = listenActionEvents;
function isSelectionEmpty() {
    var selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function isValidPointerEvent(event) {
    return (event.target instanceof Element &&
        // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
        // the future.
        event.isPrimary !== false);
}
//# sourceMappingURL=listenActionEvents.js.map
},{"@datadog/browser-core":56}],107:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.finalizeClicks = exports.trackClickActions = exports.ACTION_CONTEXT_TIME_OUT_DELAY = exports.CLICK_ACTION_MAX_DURATION = void 0;
var browser_core_1 = require("@datadog/browser-core");
var trackEventCounts_1 = require("../trackEventCounts");
var waitPageActivityEnd_1 = require("../waitPageActivityEnd");
var getSelectorFromElement_1 = require("../getSelectorFromElement");
var clickChain_1 = require("./clickChain");
var getActionNameFromElement_1 = require("./getActionNameFromElement");
var listenActionEvents_1 = require("./listenActionEvents");
var computeFrustration_1 = require("./computeFrustration");
// Maximum duration for click actions
exports.CLICK_ACTION_MAX_DURATION = 10 * browser_core_1.ONE_SECOND;
exports.ACTION_CONTEXT_TIME_OUT_DELAY = 5 * browser_core_1.ONE_MINUTE; // arbitrary
function trackClickActions(lifeCycle, domMutationObservable, configuration) {
    var history = new browser_core_1.ValueHistory(exports.ACTION_CONTEXT_TIME_OUT_DELAY);
    var stopObservable = new browser_core_1.Observable();
    var currentClickChain;
    lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        history.reset();
    });
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, stopClickChain);
    var stopActionEventsListener = (0, listenActionEvents_1.listenActionEvents)(configuration, {
        onPointerDown: function (pointerDownEvent) {
            return processPointerDown(configuration, lifeCycle, domMutationObservable, history, pointerDownEvent);
        },
        onPointerUp: function (_a, startEvent, getUserActivity) {
            var clickActionBase = _a.clickActionBase, hadActivityOnPointerDown = _a.hadActivityOnPointerDown;
            return startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
        },
    }).stop;
    var actionContexts = {
        findActionId: function (startTime) {
            return configuration.trackFrustrations ? history.findAll(startTime) : history.find(startTime);
        },
    };
    return {
        stop: function () {
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
        },
        actionContexts: actionContexts,
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain || !currentClickChain.tryAppend(click)) {
            var rageClick_1 = click.clone();
            currentClickChain = (0, clickChain_1.createClickChain)(click, function (clicks) {
                finalizeClicks(clicks, rageClick_1);
            });
        }
    }
    function stopClickChain() {
        if (currentClickChain) {
            currentClickChain.stop();
        }
    }
}
exports.trackClickActions = trackClickActions;
function processPointerDown(configuration, lifeCycle, domMutationObservable, history, pointerDownEvent) {
    if (!configuration.trackFrustrations && history.find()) {
        // TODO: remove this in a future major version. To keep retrocompatibility, ignore any new
        // action if another one is already occurring.
        return;
    }
    var clickActionBase = computeClickActionBase(pointerDownEvent, configuration.actionNameAttribute);
    if (!configuration.trackFrustrations && !clickActionBase.name) {
        // TODO: remove this in a future major version. To keep retrocompatibility, ignore any action
        // with a blank name
        return;
    }
    var hadActivityOnPointerDown = false;
    (0, waitPageActivityEnd_1.waitPageActivityEnd)(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, 
    // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    waitPageActivityEnd_1.PAGE_ACTIVITY_VALIDATION_DELAY);
    return { clickActionBase: clickActionBase, hadActivityOnPointerDown: function () { return hadActivityOnPointerDown; } };
}
function startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
    var click = newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    if (configuration.trackFrustrations) {
        appendClickToClickChain(click);
    }
    var stopWaitPageActivityEnd = (0, waitPageActivityEnd_1.waitPageActivityEnd)(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
            // If the clock is looking weird, just discard the click
            click.discard();
        }
        else {
            if (pageActivityEndEvent.hadActivity) {
                click.stop(pageActivityEndEvent.end);
            }
            else if (hadActivityOnPointerDown()) {
                click.stop(
                // using the click start as activity end, so the click will have some activity but its
                // duration will be 0 (as the activity started before the click start)
                click.startClocks.timeStamp);
            }
            else {
                click.stop();
            }
            // Validate or discard the click only if we don't track frustrations. It'll be done when
            // the click chain is finalized.
            if (!configuration.trackFrustrations) {
                if (!pageActivityEndEvent.hadActivity) {
                    // If we are not tracking frustrations, we should discard the click to keep backward
                    // compatibility.
                    click.discard();
                }
                else {
                    click.validate();
                }
            }
        }
    }, exports.CLICK_ACTION_MAX_DURATION).stop;
    var viewEndedSubscription = lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        click.stop(endClocks.timeStamp);
    });
    var stopSubscription = stopObservable.subscribe(function () {
        click.stop();
    });
    click.stopObservable.subscribe(function () {
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function computeClickActionBase(event, actionNameAttribute) {
    var rect = event.target.getBoundingClientRect();
    return {
        type: "click" /* ActionType.CLICK */,
        target: {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector: (0, getSelectorFromElement_1.getSelectorFromElement)(event.target, actionNameAttribute),
        },
        position: {
            // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top),
        },
        name: (0, getActionNameFromElement_1.getActionNameFromElement)(event.target, actionNameAttribute),
    };
}
function newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
    var id = (0, browser_core_1.generateUUID)();
    var startClocks = (0, browser_core_1.clocksNow)();
    var historyEntry = history.add(id, startClocks.relative);
    var eventCountsSubscription = (0, trackEventCounts_1.trackEventCounts)({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) {
            return event.action !== undefined &&
                (Array.isArray(event.action.id) ? (0, browser_core_1.includes)(event.action.id, id) : event.action.id === id);
        },
    });
    var status = 0 /* ClickStatus.ONGOING */;
    var activityEndTime;
    var frustrationTypes = [];
    var stopObservable = new browser_core_1.Observable();
    function stop(newActivityEndTime) {
        if (status !== 0 /* ClickStatus.ONGOING */) {
            return;
        }
        activityEndTime = newActivityEndTime;
        status = 1 /* ClickStatus.STOPPED */;
        if (activityEndTime) {
            historyEntry.close((0, browser_core_1.getRelativeTime)(activityEndTime));
        }
        else {
            historyEntry.remove();
        }
        eventCountsSubscription.stop();
        stopObservable.notify();
    }
    return {
        event: startEvent,
        stop: stop,
        stopObservable: stopObservable,
        get hasError() {
            return eventCountsSubscription.eventCounts.errorCount > 0;
        },
        get hasPageActivity() {
            return activityEndTime !== undefined;
        },
        getUserActivity: getUserActivity,
        addFrustration: function (frustrationType) {
            frustrationTypes.push(frustrationType);
        },
        startClocks: startClocks,
        isStopped: function () { return status === 1 /* ClickStatus.STOPPED */ || status === 2 /* ClickStatus.FINALIZED */; },
        clone: function () { return newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent); },
        validate: function (domEvents) {
            stop();
            if (status !== 1 /* ClickStatus.STOPPED */) {
                return;
            }
            var _a = eventCountsSubscription.eventCounts, resourceCount = _a.resourceCount, errorCount = _a.errorCount, longTaskCount = _a.longTaskCount;
            var clickAction = (0, browser_core_1.assign)({
                type: "click" /* ActionType.CLICK */,
                duration: activityEndTime && (0, browser_core_1.elapsed)(startClocks.timeStamp, activityEndTime),
                startClocks: startClocks,
                id: id,
                frustrationTypes: frustrationTypes,
                counts: {
                    resourceCount: resourceCount,
                    errorCount: errorCount,
                    longTaskCount: longTaskCount,
                },
                events: domEvents !== null && domEvents !== void 0 ? domEvents : [startEvent],
                event: startEvent,
            }, clickActionBase);
            lifeCycle.notify(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, clickAction);
            status = 2 /* ClickStatus.FINALIZED */;
        },
        discard: function () {
            stop();
            status = 2 /* ClickStatus.FINALIZED */;
        },
    };
}
function finalizeClicks(clicks, rageClick) {
    var isRage = (0, computeFrustration_1.computeFrustration)(clicks, rageClick).isRage;
    if (isRage) {
        clicks.forEach(function (click) { return click.discard(); });
        rageClick.stop((0, browser_core_1.timeStampNow)());
        rageClick.validate(clicks.map(function (click) { return click.event; }));
    }
    else {
        rageClick.discard();
        clicks.forEach(function (click) { return click.validate(); });
    }
}
exports.finalizeClicks = finalizeClicks;
//# sourceMappingURL=trackClickActions.js.map
},{"../getSelectorFromElement":123,"../trackEventCounts":136,"../waitPageActivityEnd":152,"./clickChain":103,"./computeFrustration":104,"./getActionNameFromElement":105,"./listenActionEvents":106,"@datadog/browser-core":56}],108:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRumAssembly = void 0;
var browser_core_1 = require("@datadog/browser-core");
var syntheticsContext_1 = require("./contexts/syntheticsContext");
var ciTestContext_1 = require("./contexts/ciTestContext");
var limitModification_1 = require("./limitModification");
var VIEW_MODIFIABLE_FIELD_PATHS = {
    'view.name': 'string',
    'view.url': 'string',
    'view.referrer': 'string',
};
var USER_CUSTOMIZABLE_FIELD_PATHS = {
    context: 'object',
};
var modifiableFieldPathsByEvent;
function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, buildCommonContext, reportError) {
    var _a, _b;
    modifiableFieldPathsByEvent = (_a = {},
        _a["view" /* RumEventType.VIEW */] = VIEW_MODIFIABLE_FIELD_PATHS,
        _a["error" /* RumEventType.ERROR */] = (0, browser_core_1.assign)({
            'error.message': 'string',
            'error.stack': 'string',
            'error.resource.url': 'string',
            'error.fingerprint': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["resource" /* RumEventType.RESOURCE */] = (0, browser_core_1.assign)({
            'resource.url': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["action" /* RumEventType.ACTION */] = (0, browser_core_1.assign)({
            'action.target.name': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["long_task" /* RumEventType.LONG_TASK */] = (0, browser_core_1.assign)({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a);
    var eventRateLimiters = (_b = {},
        _b["error" /* RumEventType.ERROR */] = (0, browser_core_1.createEventRateLimiter)("error" /* RumEventType.ERROR */, configuration.eventRateLimiterThreshold, reportError),
        _b["action" /* RumEventType.ACTION */] = (0, browser_core_1.createEventRateLimiter)("action" /* RumEventType.ACTION */, configuration.eventRateLimiterThreshold, reportError),
        _b);
    var syntheticsContext = (0, syntheticsContext_1.getSyntheticsContext)();
    var ciTestContext = (0, ciTestContext_1.getCiTestContext)();
    lifeCycle.subscribe(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, domainContext = _a.domainContext, savedCommonContext = _a.savedCommonContext, customerContext = _a.customerContext;
        var viewContext = viewContexts.findView(startTime);
        var urlContext = urlContexts.findUrl(startTime);
        var session = sessionManager.findTrackedSession(startTime);
        if (session && viewContext && urlContext) {
            var commonContext = savedCommonContext || buildCommonContext();
            var actionId = actionContexts.findActionId(startTime);
            var rumContext = {
                _dd: {
                    format_version: 2,
                    drift: (0, browser_core_1.currentDrift)(),
                    session: {
                        plan: session.plan,
                    },
                    configuration: {
                        session_sample_rate: (0, browser_core_1.round)(configuration.sessionSampleRate, 3),
                        session_replay_sample_rate: (0, browser_core_1.round)(configuration.sessionReplaySampleRate, 3),
                    },
                    browser_sdk_version: (0, browser_core_1.canUseEventBridge)() ? "4.50.1" : undefined,
                },
                application: {
                    id: configuration.applicationId,
                },
                date: (0, browser_core_1.timeStampNow)(),
                service: viewContext.service || configuration.service,
                version: viewContext.version || configuration.version,
                source: 'browser',
                session: {
                    id: session.id,
                    type: syntheticsContext ? "synthetics" /* SessionType.SYNTHETICS */ : ciTestContext ? "ci_test" /* SessionType.CI_TEST */ : "user" /* SessionType.USER */,
                },
                view: {
                    id: viewContext.id,
                    name: viewContext.name,
                    url: urlContext.url,
                    referrer: urlContext.referrer,
                },
                action: needToAssembleWithAction(rawRumEvent) && actionId ? { id: actionId } : undefined,
                synthetics: syntheticsContext,
                ci_test: ciTestContext,
                display: displayContext.get(),
            };
            var serverRumEvent = (0, browser_core_1.combine)(rumContext, rawRumEvent);
            serverRumEvent.context = (0, browser_core_1.combine)(commonContext.context, customerContext);
            if (!('has_replay' in serverRumEvent.session)) {
                ;
                serverRumEvent.session.has_replay = commonContext.hasReplay;
            }
            if (!(0, browser_core_1.isEmptyObject)(commonContext.user)) {
                ;
                serverRumEvent.usr = commonContext.user;
            }
            if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
                if ((0, browser_core_1.isEmptyObject)(serverRumEvent.context)) {
                    delete serverRumEvent.context;
                }
                lifeCycle.notify(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, serverRumEvent);
            }
        }
    });
}
exports.startRumAssembly = startRumAssembly;
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        var result = (0, limitModification_1.limitModification)(event, modifiableFieldPathsByEvent[event.type], function (event) {
            return beforeSend(event, domainContext);
        });
        if (result === false && event.type !== "view" /* RumEventType.VIEW */) {
            return false;
        }
        if (result === false) {
            browser_core_1.display.warn("Can't dismiss view events using beforeSend!");
        }
    }
    var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
function needToAssembleWithAction(event) {
    return ["error" /* RumEventType.ERROR */, "resource" /* RumEventType.RESOURCE */, "long_task" /* RumEventType.LONG_TASK */].indexOf(event.type) !== -1;
}
//# sourceMappingURL=assembly.js.map
},{"./contexts/ciTestContext":110,"./contexts/syntheticsContext":117,"./limitModification":126,"@datadog/browser-core":56}],109:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeRumConfiguration = exports.validateAndBuildRumConfiguration = void 0;
var browser_core_1 = require("@datadog/browser-core");
var tracer_1 = require("./tracing/tracer");
function validateAndBuildRumConfiguration(initConfiguration) {
    var _a, _b, _c, _d, _e, _f;
    if (!initConfiguration.applicationId) {
        browser_core_1.display.error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    if (initConfiguration.sessionReplaySampleRate !== undefined &&
        !(0, browser_core_1.isPercentage)(initConfiguration.sessionReplaySampleRate)) {
        browser_core_1.display.error('Session Replay Sample Rate should be a number between 0 and 100');
        return;
    }
    // TODO remove fallback in next major
    var premiumSampleRate = (_a = initConfiguration.premiumSampleRate) !== null && _a !== void 0 ? _a : initConfiguration.replaySampleRate;
    if (premiumSampleRate !== undefined && initConfiguration.sessionReplaySampleRate !== undefined) {
        browser_core_1.display.warn('Ignoring Premium Sample Rate because Session Replay Sample Rate is set');
        premiumSampleRate = undefined;
    }
    if (premiumSampleRate !== undefined && !(0, browser_core_1.isPercentage)(premiumSampleRate)) {
        browser_core_1.display.error('Premium Sample Rate should be a number between 0 and 100');
        return;
    }
    var traceSampleRate = (_b = initConfiguration.traceSampleRate) !== null && _b !== void 0 ? _b : initConfiguration.tracingSampleRate;
    if (traceSampleRate !== undefined && !(0, browser_core_1.isPercentage)(traceSampleRate)) {
        browser_core_1.display.error('Trace Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        browser_core_1.display.error('Excluded Activity Urls should be an array');
        return;
    }
    var allowedTracingUrls = validateAndBuildTracingOptions(initConfiguration);
    if (!allowedTracingUrls) {
        return;
    }
    var baseConfiguration = (0, browser_core_1.validateAndBuildConfiguration)(initConfiguration);
    if (!baseConfiguration) {
        return;
    }
    var trackUserInteractions = !!((_c = initConfiguration.trackUserInteractions) !== null && _c !== void 0 ? _c : initConfiguration.trackInteractions);
    var trackFrustrations = !!initConfiguration.trackFrustrations;
    return (0, browser_core_1.assign)({
        applicationId: initConfiguration.applicationId,
        version: initConfiguration.version,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        sessionReplaySampleRate: (_e = (_d = initConfiguration.sessionReplaySampleRate) !== null && _d !== void 0 ? _d : premiumSampleRate) !== null && _e !== void 0 ? _e : 100,
        oldPlansBehavior: initConfiguration.sessionReplaySampleRate === undefined,
        traceSampleRate: traceSampleRate,
        allowedTracingUrls: allowedTracingUrls,
        excludedActivityUrls: (_f = initConfiguration.excludedActivityUrls) !== null && _f !== void 0 ? _f : [],
        workerUrl: initConfiguration.workerUrl,
        trackUserInteractions: trackUserInteractions || trackFrustrations,
        trackFrustrations: trackFrustrations,
        trackViewsManually: !!initConfiguration.trackViewsManually,
        trackResources: initConfiguration.trackResources,
        trackLongTasks: initConfiguration.trackLongTasks,
        subdomain: initConfiguration.subdomain,
        defaultPrivacyLevel: (0, browser_core_1.objectHasValue)(browser_core_1.DefaultPrivacyLevel, initConfiguration.defaultPrivacyLevel)
            ? initConfiguration.defaultPrivacyLevel
            : browser_core_1.DefaultPrivacyLevel.MASK_USER_INPUT,
        customerDataTelemetrySampleRate: 1,
    }, baseConfiguration);
}
exports.validateAndBuildRumConfiguration = validateAndBuildRumConfiguration;
/**
 * Handles allowedTracingUrls and processes legacy allowedTracingOrigins
 */
function validateAndBuildTracingOptions(initConfiguration) {
    // Advise about parameters precedence.
    if (initConfiguration.allowedTracingUrls !== undefined && initConfiguration.allowedTracingOrigins !== undefined) {
        browser_core_1.display.warn('Both allowedTracingUrls and allowedTracingOrigins (deprecated) have been defined. The parameter allowedTracingUrls will override allowedTracingOrigins.');
    }
    // Handle allowedTracingUrls first
    if (initConfiguration.allowedTracingUrls !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
            browser_core_1.display.error('Allowed Tracing URLs should be an array');
            return;
        }
        if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
            browser_core_1.display.error('Service needs to be configured when tracing is enabled');
            return;
        }
        // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
        var tracingOptions_1 = [];
        initConfiguration.allowedTracingUrls.forEach(function (option) {
            if ((0, browser_core_1.isMatchOption)(option)) {
                tracingOptions_1.push({ match: option, propagatorTypes: ['datadog'] });
            }
            else if ((0, tracer_1.isTracingOption)(option)) {
                tracingOptions_1.push(option);
            }
            else {
                browser_core_1.display.warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
            }
        });
        return tracingOptions_1;
    }
    // Handle conversion of allowedTracingOrigins to allowedTracingUrls
    if (initConfiguration.allowedTracingOrigins !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingOrigins)) {
            browser_core_1.display.error('Allowed Tracing Origins should be an array');
            return;
        }
        if (initConfiguration.allowedTracingOrigins.length !== 0 && initConfiguration.service === undefined) {
            browser_core_1.display.error('Service needs to be configured when tracing is enabled');
            return;
        }
        var tracingOptions_2 = [];
        initConfiguration.allowedTracingOrigins.forEach(function (legacyMatchOption) {
            var tracingOption = convertLegacyMatchOptionToTracingOption(legacyMatchOption);
            if (tracingOption) {
                tracingOptions_2.push(tracingOption);
            }
        });
        return tracingOptions_2;
    }
    return [];
}
/**
 * Converts parameters from the deprecated allowedTracingOrigins
 * to allowedTracingUrls. Handles the change from origin to full URLs.
 */
function convertLegacyMatchOptionToTracingOption(item) {
    var match;
    if (typeof item === 'string') {
        match = item;
    }
    else if (item instanceof RegExp) {
        match = function (url) { return item.test((0, browser_core_1.getOrigin)(url)); };
    }
    else if (typeof item === 'function') {
        match = function (url) { return item((0, browser_core_1.getOrigin)(url)); };
    }
    if (match === undefined) {
        browser_core_1.display.warn('Allowed Tracing Origins parameters should be a string, RegExp or function. Ignoring parameter', item);
        return undefined;
    }
    return { match: match, propagatorTypes: ['datadog'] };
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls,
 * and assumes 'datadog' has been selected when using allowedTracingOrigins
 */
function getSelectedTracingPropagators(configuration) {
    var usedTracingPropagators = new Set();
    if (Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0) {
        configuration.allowedTracingUrls.forEach(function (option) {
            if ((0, browser_core_1.isMatchOption)(option)) {
                usedTracingPropagators.add('datadog');
            }
            else if ((0, browser_core_1.getType)(option) === 'object' && Array.isArray(option.propagatorTypes)) {
                // Ensure we have an array, as we cannot rely on types yet (configuration is provided by users)
                option.propagatorTypes.forEach(function (propagatorType) { return usedTracingPropagators.add(propagatorType); });
            }
        });
    }
    if (Array.isArray(configuration.allowedTracingOrigins) && configuration.allowedTracingOrigins.length > 0) {
        usedTracingPropagators.add('datadog');
    }
    return (0, browser_core_1.arrayFrom)(usedTracingPropagators);
}
function serializeRumConfiguration(configuration) {
    var _a, _b;
    var baseSerializedConfiguration = (0, browser_core_1.serializeConfiguration)(configuration);
    return (0, browser_core_1.assign)({
        premium_sample_rate: configuration.premiumSampleRate,
        replay_sample_rate: configuration.replaySampleRate,
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        trace_sample_rate: (_a = configuration.traceSampleRate) !== null && _a !== void 0 ? _a : configuration.tracingSampleRate,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_origins: Array.isArray(configuration.allowedTracingOrigins) && configuration.allowedTracingOrigins.length > 0,
        use_allowed_tracing_urls: Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0,
        selected_tracing_propagators: getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        use_excluded_activity_urls: Array.isArray(configuration.excludedActivityUrls) && configuration.excludedActivityUrls.length > 0,
        use_worker_url: !!configuration.workerUrl,
        track_frustrations: configuration.trackFrustrations,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: (_b = configuration.trackUserInteractions) !== null && _b !== void 0 ? _b : configuration.trackInteractions,
    }, baseSerializedConfiguration);
}
exports.serializeRumConfiguration = serializeRumConfiguration;
//# sourceMappingURL=configuration.js.map
},{"./tracing/tracer":135,"@datadog/browser-core":56}],110:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCiTestContext = void 0;
function getCiTestContext() {
    var _a;
    var testExecutionId = (_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId');
    if (typeof testExecutionId === 'string') {
        return {
            test_execution_id: testExecutionId,
        };
    }
}
exports.getCiTestContext = getCiTestContext;
//# sourceMappingURL=ciTestContext.js.map
},{}],111:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCommonContext = void 0;
function buildCommonContext(globalContextManager, userContextManager, recorderApi) {
    return {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
        hasReplay: recorderApi.isRecording() ? true : undefined,
    };
}
exports.buildCommonContext = buildCommonContext;
//# sourceMappingURL=commonContext.js.map
},{}],112:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startDisplayContext = void 0;
var viewportObservable_1 = require("../../browser/viewportObservable");
function startDisplayContext(configuration) {
    var viewport = (0, viewportObservable_1.getViewportDimension)();
    var unsubscribeViewport = (0, viewportObservable_1.initViewportObservable)(configuration).subscribe(function (viewportDimension) {
        viewport = viewportDimension;
    }).unsubscribe;
    return {
        get: function () { return ({ viewport: viewport }); },
        stop: unsubscribeViewport,
    };
}
exports.startDisplayContext = startDisplayContext;
//# sourceMappingURL=displayContext.js.map
},{"../../browser/viewportObservable":101}],113:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startFeatureFlagContexts = exports.BYTES_COMPUTATION_THROTTLING_DELAY = exports.FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = browser_core_1.SESSION_TIME_OUT_DELAY;
exports.BYTES_COMPUTATION_THROTTLING_DELAY = 200;
/**
 * Start feature flag contexts
 *
 * Feature flag contexts follow the life of views.
 * A new context is added when a view is created and ended when the view is ended
 *
 * Note: we choose not to add a new context at each evaluation to save memory
 */
function startFeatureFlagContexts(lifeCycle, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = browser_core_1.computeBytesCount; }
    if (!(0, browser_core_1.isExperimentalFeatureEnabled)(browser_core_1.ExperimentalFeature.FEATURE_FLAGS)) {
        return {
            findFeatureFlagEvaluations: function () { return undefined; },
            getFeatureFlagBytesCount: function () { return 0; },
            addFeatureFlagEvaluation: browser_core_1.noop,
            stop: browser_core_1.noop,
        };
    }
    var featureFlagContexts = new browser_core_1.ValueHistory(exports.FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY);
    var bytesCountCache = 0;
    var alreadyWarned = false;
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        featureFlagContexts.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        featureFlagContexts.add({}, startClocks.relative);
        bytesCountCache = 0;
    });
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call addFeatureFlagEvaluation API synchronously multiple times in a row
    var _a = (0, browser_core_1.throttle)(function (context) {
        bytesCountCache = computeBytesCountImpl((0, browser_core_1.jsonStringify)(context));
        if (!alreadyWarned) {
            alreadyWarned = (0, browser_core_1.warnIfCustomerDataLimitReached)(bytesCountCache, 0 /* CustomerDataType.FeatureFlag */);
        }
    }, exports.BYTES_COMPUTATION_THROTTLING_DELAY), computeBytesCountThrottled = _a.throttled, cancelPendingComputation = _a.cancel;
    return {
        findFeatureFlagEvaluations: function (startTime) { return featureFlagContexts.find(startTime); },
        getFeatureFlagBytesCount: function () {
            var currentContext = featureFlagContexts.find();
            if (!currentContext) {
                return 0;
            }
            return bytesCountCache;
        },
        addFeatureFlagEvaluation: function (key, value) {
            var currentContext = featureFlagContexts.find();
            if (currentContext) {
                currentContext[key] = value;
                computeBytesCountThrottled(currentContext);
            }
        },
        stop: cancelPendingComputation,
    };
}
exports.startFeatureFlagContexts = startFeatureFlagContexts;
//# sourceMappingURL=featureFlagContext.js.map
},{"@datadog/browser-core":56}],114:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToForegroundPeriods = void 0;
var browser_core_1 = require("@datadog/browser-core");
// Todo: Remove in the next major release
function mapToForegroundPeriods(pageStateServerEntries, duration) {
    var foregroundPeriods = [];
    for (var i = 0; i < pageStateServerEntries.length; i++) {
        var current = pageStateServerEntries[i];
        var next = pageStateServerEntries[i + 1];
        if (current.state === "active" /* PageState.ACTIVE */) {
            var start = current.start >= 0 ? current.start : 0;
            var end = next ? next.start : (0, browser_core_1.toServerDuration)(duration);
            foregroundPeriods.push({
                start: start,
                duration: (end - start),
            });
        }
    }
    return foregroundPeriods;
}
exports.mapToForegroundPeriods = mapToForegroundPeriods;
//# sourceMappingURL=foregroundContexts.js.map
},{"@datadog/browser-core":56}],115:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startInternalContext = void 0;
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
    return {
        get: function (startTime) {
            var viewContext = viewContexts.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            var session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                var actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? { id: actionId } : undefined,
                    view: { id: viewContext.id, name: viewContext.name, referrer: urlContext.referrer, url: urlContext.url },
                };
            }
        },
    };
}
exports.startInternalContext = startInternalContext;
//# sourceMappingURL=internalContext.js.map
},{}],116:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startPageStateHistory = exports.PAGE_STATE_CONTEXT_TIME_OUT_DELAY = exports.MAX_PAGE_STATE_ENTRIES_SELECTABLE = exports.MAX_PAGE_STATE_ENTRIES = void 0;
var browser_core_1 = require("@datadog/browser-core");
// Arbitrary value to cap number of element for memory consumption in the browser
exports.MAX_PAGE_STATE_ENTRIES = 4000;
// Arbitrary value to cap number of element for backend & to save bandwidth
exports.MAX_PAGE_STATE_ENTRIES_SELECTABLE = 500;
exports.PAGE_STATE_CONTEXT_TIME_OUT_DELAY = browser_core_1.SESSION_TIME_OUT_DELAY;
function startPageStateHistory(configuration, maxPageStateEntriesSelectable) {
    if (maxPageStateEntriesSelectable === void 0) { maxPageStateEntriesSelectable = exports.MAX_PAGE_STATE_ENTRIES_SELECTABLE; }
    var pageStateHistory = new browser_core_1.ValueHistory(exports.PAGE_STATE_CONTEXT_TIME_OUT_DELAY, exports.MAX_PAGE_STATE_ENTRIES);
    var currentPageState;
    addPageState(getPageState(), (0, browser_core_1.relativeNow)());
    var stopEventListeners = (0, browser_core_1.addEventListeners)(configuration, window, [
        "pageshow" /* DOM_EVENT.PAGE_SHOW */,
        "focus" /* DOM_EVENT.FOCUS */,
        "blur" /* DOM_EVENT.BLUR */,
        "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */,
        "resume" /* DOM_EVENT.RESUME */,
        "freeze" /* DOM_EVENT.FREEZE */,
        "pagehide" /* DOM_EVENT.PAGE_HIDE */,
    ], function (event) {
        // Only get events fired by the browser to avoid false currentPageState changes done with custom events
        // cf: developer extension auto flush: https://github.com/DataDog/browser-sdk/blob/2f72bf05a672794c9e33965351964382a94c72ba/developer-extension/src/panel/flushEvents.ts#L11-L12
        if (event.isTrusted) {
            addPageState(computePageState(event), event.timeStamp);
        }
    }, { capture: true }).stop;
    function addPageState(nextPageState, startTime) {
        if (startTime === void 0) { startTime = (0, browser_core_1.relativeNow)(); }
        if (nextPageState === currentPageState) {
            return;
        }
        currentPageState = nextPageState;
        pageStateHistory.closeActive(startTime);
        pageStateHistory.add({ state: currentPageState, startTime: startTime }, startTime);
    }
    return {
        findAll: function (eventStartTime, duration) {
            var pageStateEntries = pageStateHistory.findAll(eventStartTime, duration);
            if (pageStateEntries.length === 0) {
                return;
            }
            var pageStateServerEntries = [];
            // limit the number of entries to return
            var limit = Math.max(0, pageStateEntries.length - maxPageStateEntriesSelectable);
            // loop page state entries backward to return the selected ones in desc order
            for (var index = pageStateEntries.length - 1; index >= limit; index--) {
                var pageState = pageStateEntries[index];
                // compute the start time relative to the event start time (ex: to be relative to the view start time)
                var relativeStartTime = (0, browser_core_1.elapsed)(eventStartTime, pageState.startTime);
                pageStateServerEntries.push({
                    state: pageState.state,
                    start: (0, browser_core_1.toServerDuration)(relativeStartTime),
                });
            }
            return pageStateServerEntries;
        },
        isInActivePageStateAt: function (startTime) {
            var pageStateEntry = pageStateHistory.find(startTime);
            return pageStateEntry !== undefined && pageStateEntry.state === "active" /* PageState.ACTIVE */;
        },
        addPageState: addPageState,
        stop: function () {
            stopEventListeners();
            pageStateHistory.stop();
        },
    };
}
exports.startPageStateHistory = startPageStateHistory;
function computePageState(event) {
    if (event.type === "freeze" /* DOM_EVENT.FREEZE */) {
        return "frozen" /* PageState.FROZEN */;
    }
    else if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */) {
        return event.persisted ? "frozen" /* PageState.FROZEN */ : "terminated" /* PageState.TERMINATED */;
    }
    return getPageState();
}
function getPageState() {
    if (document.visibilityState === 'hidden') {
        return "hidden" /* PageState.HIDDEN */;
    }
    if (document.hasFocus()) {
        return "active" /* PageState.ACTIVE */;
    }
    return "passive" /* PageState.PASSIVE */;
}
//# sourceMappingURL=pageStateHistory.js.map
},{"@datadog/browser-core":56}],117:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSyntheticsContext = void 0;
var browser_core_1 = require("@datadog/browser-core");
function getSyntheticsContext() {
    var testId = (0, browser_core_1.getSyntheticsTestId)();
    var resultId = (0, browser_core_1.getSyntheticsResultId)();
    if (testId && resultId) {
        return {
            test_id: testId,
            result_id: resultId,
            injected: (0, browser_core_1.willSyntheticsInjectRum)(),
        };
    }
}
exports.getSyntheticsContext = getSyntheticsContext;
//# sourceMappingURL=syntheticsContext.js.map
},{"@datadog/browser-core":56}],118:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startUrlContexts = exports.URL_CONTEXT_TIME_OUT_DELAY = void 0;
var browser_core_1 = require("@datadog/browser-core");
/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
exports.URL_CONTEXT_TIME_OUT_DELAY = browser_core_1.SESSION_TIME_OUT_DELAY;
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
    var urlContextHistory = new browser_core_1.ValueHistory(exports.URL_CONTEXT_TIME_OUT_DELAY);
    var previousViewUrl;
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        urlContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        var viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl,
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
        var newLocation = _a.newLocation;
        var current = urlContextHistory.find();
        if (current) {
            var changeTime = (0, browser_core_1.relativeNow)();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer,
            }), changeTime);
        }
    });
    function buildUrlContext(_a) {
        var url = _a.url, referrer = _a.referrer;
        return {
            url: url,
            referrer: referrer,
        };
    }
    return {
        findUrl: function (startTime) { return urlContextHistory.find(startTime); },
        stop: function () {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        },
    };
}
exports.startUrlContexts = startUrlContexts;
//# sourceMappingURL=urlContexts.js.map
},{"@datadog/browser-core":56}],119:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startViewContexts = exports.VIEW_CONTEXT_TIME_OUT_DELAY = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.VIEW_CONTEXT_TIME_OUT_DELAY = browser_core_1.SESSION_TIME_OUT_DELAY;
function startViewContexts(lifeCycle) {
    var viewContextHistory = new browser_core_1.ValueHistory(exports.VIEW_CONTEXT_TIME_OUT_DELAY);
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
        viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        viewContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        viewContextHistory.reset();
    });
    function buildViewContext(view) {
        return {
            service: view.service,
            version: view.version,
            id: view.id,
            name: view.name,
            startClocks: view.startClocks,
        };
    }
    return {
        findView: function (startTime) { return viewContextHistory.find(startTime); },
        stop: function () {
            viewContextHistory.stop();
        },
    };
}
exports.startViewContexts = startViewContexts;
//# sourceMappingURL=viewContexts.js.map
},{"@datadog/browser-core":56}],120:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doStartErrorCollection = exports.startErrorCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var trackConsoleError_1 = require("./trackConsoleError");
var trackReportError_1 = require("./trackReportError");
function startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts) {
    var errorObservable = new browser_core_1.Observable();
    (0, trackConsoleError_1.trackConsoleError)(errorObservable);
    (0, browser_core_1.trackRuntimeError)(errorObservable);
    (0, trackReportError_1.trackReportError)(configuration, errorObservable);
    errorObservable.subscribe(function (error) { return lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error }); });
    return doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts);
}
exports.startErrorCollection = startErrorCollection;
function doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts) {
    lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, function (_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, (0, browser_core_1.assign)({
            customerContext: customerContext,
            savedCommonContext: savedCommonContext,
        }, processError(error, pageStateHistory, featureFlagContexts)));
    });
    return {
        addError: function (_a, savedCommonContext) {
            var error = _a.error, handlingStack = _a.handlingStack, startClocks = _a.startClocks, customerContext = _a.context;
            var stackTrace = error instanceof Error ? (0, browser_core_1.computeStackTrace)(error) : undefined;
            var rawError = (0, browser_core_1.computeRawError)({
                stackTrace: stackTrace,
                originalError: error,
                handlingStack: handlingStack,
                startClocks: startClocks,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
                source: browser_core_1.ErrorSource.CUSTOM,
                handling: "handled" /* ErrorHandling.HANDLED */,
            });
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError,
            });
        },
    };
}
exports.doStartErrorCollection = doStartErrorCollection;
function processError(error, pageStateHistory, featureFlagContexts) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: (0, browser_core_1.generateUUID)(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: 'browser',
            fingerprint: error.fingerprint,
        },
        type: "error" /* RumEventType.ERROR */,
        view: { in_foreground: pageStateHistory.isInActivePageStateAt(error.startClocks.relative) },
    };
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(error.startClocks.relative);
    if (featureFlagContext && !(0, browser_core_1.isEmptyObject)(featureFlagContext)) {
        rawRumEvent.feature_flags = featureFlagContext;
    }
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: {
            error: error.originalError,
        },
    };
}
//# sourceMappingURL=errorCollection.js.map
},{"./trackConsoleError":121,"./trackReportError":122,"@datadog/browser-core":56}],121:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackConsoleError = void 0;
var browser_core_1 = require("@datadog/browser-core");
function trackConsoleError(errorObservable) {
    var subscription = (0, browser_core_1.initConsoleObservable)([browser_core_1.ConsoleApiName.error]).subscribe(function (consoleError) {
        return errorObservable.notify({
            startClocks: (0, browser_core_1.clocksNow)(),
            message: consoleError.message,
            stack: consoleError.stack,
            fingerprint: consoleError.fingerprint,
            source: browser_core_1.ErrorSource.CONSOLE,
            handling: "handled" /* ErrorHandling.HANDLED */,
            handlingStack: consoleError.handlingStack,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
exports.trackConsoleError = trackConsoleError;
//# sourceMappingURL=trackConsoleError.js.map
},{"@datadog/browser-core":56}],122:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackReportError = void 0;
var browser_core_1 = require("@datadog/browser-core");
function trackReportError(configuration, errorObservable) {
    var subscription = (0, browser_core_1.initReportObservable)(configuration, [
        browser_core_1.RawReportType.cspViolation,
        browser_core_1.RawReportType.intervention,
    ]).subscribe(function (reportError) {
        return errorObservable.notify({
            startClocks: (0, browser_core_1.clocksNow)(),
            message: reportError.message,
            stack: reportError.stack,
            type: reportError.subtype,
            source: browser_core_1.ErrorSource.REPORT,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
exports.trackReportError = trackReportError;
//# sourceMappingURL=trackReportError.js.map
},{"@datadog/browser-core":56}],123:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportScopeSelector = exports.getSelectorFromElement = exports.STABLE_ATTRIBUTES = void 0;
var browser_core_1 = require("@datadog/browser-core");
var getActionNameFromElement_1 = require("./action/getActionNameFromElement");
/**
 * Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
 * component). Those attribute values should not be generated randomly (hardcoded most of the time)
 * and stay the same across deploys. They are not necessarily unique across the document.
 */
exports.STABLE_ATTRIBUTES = [
    getActionNameFromElement_1.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE,
    // Common test attributes (list provided by google recorder)
    'data-testid',
    'data-test',
    'data-qa',
    'data-cy',
    'data-test-id',
    'data-qa-id',
    'data-testing',
    // FullStory decorator attributes:
    'data-component',
    'data-element',
    'data-source-file',
];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
var GLOBALLY_UNIQUE_SELECTOR_GETTERS = [getStableAttributeSelector, getIDSelector];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
var UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    getStableAttributeSelector,
    getClassSelector,
    getTagNameSelector,
];
function getSelectorFromElement(targetElement, actionNameAttribute) {
    var targetElementSelector = '';
    var element = targetElement;
    while (element && element.nodeName !== 'HTML') {
        var globallyUniqueSelector = findSelector(element, GLOBALLY_UNIQUE_SELECTOR_GETTERS, isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
        if (globallyUniqueSelector) {
            return globallyUniqueSelector;
        }
        var uniqueSelectorAmongChildren = findSelector(element, UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, isSelectorUniqueAmongSiblings, actionNameAttribute, targetElementSelector);
        targetElementSelector =
            uniqueSelectorAmongChildren || combineSelector(getPositionSelector(element), targetElementSelector);
        element = element.parentElement;
    }
    return targetElementSelector;
}
exports.getSelectorFromElement = getSelectorFromElement;
function isGeneratedValue(value) {
    // To compute the "URL path group", the backend replaces every URL path parts as a question mark
    // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
    // present.
    //
    // Here, we use the same strategy: if a the value contains a digit, we consider it generated. This
    // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
    // CSS selectors so it should be fine most of the time. We might want to allow customers to
    // provide their own `isGeneratedValue` at some point.
    return /[0-9]/.test(value);
}
function getIDSelector(element) {
    if (element.id && !isGeneratedValue(element.id)) {
        return "#".concat((0, browser_core_1.cssEscape)(element.id));
    }
}
function getClassSelector(element) {
    if (element.tagName === 'BODY') {
        return;
    }
    if (element.classList.length > 0) {
        for (var i = 0; i < element.classList.length; i += 1) {
            var className = element.classList[i];
            if (isGeneratedValue(className)) {
                continue;
            }
            return "".concat((0, browser_core_1.cssEscape)(element.tagName), ".").concat((0, browser_core_1.cssEscape)(className));
        }
    }
}
function getTagNameSelector(element) {
    return (0, browser_core_1.cssEscape)(element.tagName);
}
function getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        var selector = getAttributeSelector(actionNameAttribute);
        if (selector) {
            return selector;
        }
    }
    for (var _i = 0, STABLE_ATTRIBUTES_1 = exports.STABLE_ATTRIBUTES; _i < STABLE_ATTRIBUTES_1.length; _i++) {
        var attributeName = STABLE_ATTRIBUTES_1[_i];
        var selector = getAttributeSelector(attributeName);
        if (selector) {
            return selector;
        }
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) {
            return "".concat((0, browser_core_1.cssEscape)(element.tagName), "[").concat(attributeName, "=\"").concat((0, browser_core_1.cssEscape)(element.getAttribute(attributeName)), "\"]");
        }
    }
}
function getPositionSelector(element) {
    var sibling = element.parentElement.firstElementChild;
    var elementIndex = 1;
    while (sibling && sibling !== element) {
        if (sibling.tagName === element.tagName) {
            elementIndex += 1;
        }
        sibling = sibling.nextElementSibling;
    }
    return "".concat((0, browser_core_1.cssEscape)(element.tagName), ":nth-of-type(").concat(elementIndex, ")");
}
function findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for (var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++) {
        var selectorGetter = selectorGetters_1[_i];
        var elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) {
            continue;
        }
        var fullSelector = combineSelector(elementSelector, childSelector);
        if (predicate(element, fullSelector)) {
            return fullSelector;
        }
    }
}
/**
 * Check whether the selector is unique among the whole document.
 */
function isSelectorUniqueGlobally(element, selector) {
    return element.ownerDocument.querySelectorAll(selector).length === 1;
}
/**
 * Check whether the selector is unique among the element siblings. In other words, it returns true
 * if "ELEMENT_PARENT > SELECTOR" returns a single element.
 *
 * The result will be less accurate on browsers that don't support :scope (i. e. IE): it will check
 * for any element matching the selector contained in the parent (in other words,
 * "ELEMENT_PARENT SELECTOR" returns a single element), regardless of whether the selector is a
 * direct descendent of the element parent. This should not impact results too much: if it
 * inaccurately returns false, we'll just fall back to another strategy.
 */
function isSelectorUniqueAmongSiblings(element, selector) {
    return (element.parentElement.querySelectorAll(supportScopeSelector() ? combineSelector(':scope', selector) : selector)
        .length === 1);
}
function combineSelector(parent, child) {
    return child ? "".concat(parent, ">").concat(child) : parent;
}
var supportScopeSelectorCache;
function supportScopeSelector() {
    if (supportScopeSelectorCache === undefined) {
        try {
            document.querySelector(':scope');
            supportScopeSelectorCache = true;
        }
        catch (_a) {
            supportScopeSelectorCache = false;
        }
    }
    return supportScopeSelectorCache;
}
exports.supportScopeSelector = supportScopeSelector;
//# sourceMappingURL=getSelectorFromElement.js.map
},{"./action/getActionNameFromElement":105,"@datadog/browser-core":56}],124:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatadogSiteUrl = exports.getSessionReplayUrl = void 0;
var browser_core_1 = require("@datadog/browser-core");
function getSessionReplayUrl(configuration, _a) {
    var session = _a.session, viewContext = _a.viewContext, errorType = _a.errorType;
    var sessionId = session ? session.id : 'no-session-id';
    var parameters = [];
    if (errorType !== undefined) {
        parameters.push("error-type=".concat(errorType));
    }
    if (viewContext) {
        parameters.push("seed=".concat(viewContext.id));
        parameters.push("from=".concat(viewContext.startClocks.timeStamp));
    }
    var origin = getDatadogSiteUrl(configuration);
    var path = "/rum/replay/sessions/".concat(sessionId);
    return "".concat(origin).concat(path, "?").concat(parameters.join('&'));
}
exports.getSessionReplayUrl = getSessionReplayUrl;
function getDatadogSiteUrl(rumConfiguration) {
    var site = rumConfiguration.site;
    var subdomain = rumConfiguration.subdomain || getSiteDefaultSubdomain(rumConfiguration);
    return "https://".concat(subdomain ? "".concat(subdomain, ".") : '').concat(site);
}
exports.getDatadogSiteUrl = getDatadogSiteUrl;
function getSiteDefaultSubdomain(configuration) {
    switch (configuration.site) {
        case browser_core_1.INTAKE_SITE_US1:
        case browser_core_1.INTAKE_SITE_EU1:
            return 'app';
        case browser_core_1.INTAKE_SITE_STAGING:
            return 'dd';
        default:
            return undefined;
    }
}
//# sourceMappingURL=getSessionReplayUrl.js.map
},{"@datadog/browser-core":56}],125:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifeCycle = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.LifeCycle = (browser_core_1.AbstractLifeCycle);
//# sourceMappingURL=lifeCycle.js.map
},{"@datadog/browser-core":56}],126:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.limitModification = void 0;
var browser_core_1 = require("@datadog/browser-core");
/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
    var clone = (0, browser_core_1.deepClone)(object);
    var result = modifier(clone);
    (0, browser_core_1.objectEntries)(modifiableFieldPaths).forEach(function (_a) {
        var fieldPath = _a[0], fieldType = _a[1];
        var newValue = get(clone, fieldPath);
        var newType = (0, browser_core_1.getType)(newValue);
        if (newType === fieldType) {
            set(object, fieldPath, (0, browser_core_1.sanitize)(newValue));
        }
        else if (fieldType === 'object' && (newType === 'undefined' || newType === 'null')) {
            set(object, fieldPath, {});
        }
    });
    return result;
}
exports.limitModification = limitModification;
function get(object, path) {
    var current = object;
    for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
        var field = _a[_i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        current = current[field];
    }
    return current;
}
function set(object, path, value) {
    var current = object;
    var fields = path.split('.');
    for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        if (!isValidObject(current)) {
            return;
        }
        if (i !== fields.length - 1) {
            current = current[field];
        }
        else {
            current[field] = value;
        }
    }
}
function isValidObject(object) {
    return (0, browser_core_1.getType)(object) === 'object';
}
function isValidObjectContaining(object, field) {
    return isValidObject(object) && Object.prototype.hasOwnProperty.call(object, field);
}
//# sourceMappingURL=limitModification.js.map
},{"@datadog/browser-core":56}],127:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startLongTaskCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var performanceCollection_1 = require("../../browser/performanceCollection");
function startLongTaskCollection(lifeCycle, sessionManager) {
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType !== performanceCollection_1.RumPerformanceEntryType.LONG_TASK) {
                break;
            }
            var session = sessionManager.findTrackedSession(entry.startTime);
            if (!session || !session.longTaskAllowed) {
                break;
            }
            var startClocks = (0, browser_core_1.relativeToClocks)(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: (0, browser_core_1.generateUUID)(),
                    duration: (0, browser_core_1.toServerDuration)(entry.duration),
                },
                type: "long_task" /* RumEventType.LONG_TASK */,
                _dd: {
                    discarded: false,
                },
            };
            lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: { performanceEntry: entry.toJSON() },
            });
        }
    });
}
exports.startLongTaskCollection = startLongTaskCollection;
//# sourceMappingURL=longTaskCollection.js.map
},{"../../browser/performanceCollection":99,"@datadog/browser-core":56}],128:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFetch = exports.trackXhr = exports.startRequestCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var resourceUtils_1 = require("./resource/resourceUtils");
var tracer_1 = require("./tracing/tracer");
var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
    var tracer = (0, tracer_1.startTracer)(configuration, sessionManager);
    trackXhr(lifeCycle, configuration, tracer);
    trackFetch(lifeCycle, configuration, tracer);
}
exports.startRequestCollection = startRequestCollection;
function trackXhr(lifeCycle, configuration, tracer) {
    var subscription = (0, browser_core_1.initXhrObservable)(configuration).subscribe(function (rawContext) {
        var context = rawContext;
        if (!(0, resourceUtils_1.isAllowedRequestUrl)(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(6 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: "xhr" /* RequestType.XHR */,
                    url: context.url,
                    xhr: context.xhr,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
exports.trackXhr = trackXhr;
function trackFetch(lifeCycle, configuration, tracer) {
    var subscription = (0, browser_core_1.initFetchObservable)().subscribe(function (rawContext) {
        var context = rawContext;
        if (!(0, resourceUtils_1.isAllowedRequestUrl)(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'resolve':
                waitForResponseToComplete(context, function (duration) {
                    tracer.clearTracingIfNeeded(context);
                    lifeCycle.notify(6 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                        duration: duration,
                        method: context.method,
                        requestIndex: context.requestIndex,
                        responseType: context.responseType,
                        spanId: context.spanId,
                        startClocks: context.startClocks,
                        status: context.status,
                        traceId: context.traceId,
                        traceSampled: context.traceSampled,
                        type: "fetch" /* RequestType.FETCH */,
                        url: context.url,
                        response: context.response,
                        init: context.init,
                        input: context.input,
                    });
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
exports.trackFetch = trackFetch;
function getNextRequestIndex() {
    var result = nextRequestIndex;
    nextRequestIndex += 1;
    return result;
}
function waitForResponseToComplete(context, callback) {
    var clonedResponse = context.response && (0, browser_core_1.tryToClone)(context.response);
    if (!clonedResponse || !clonedResponse.body) {
        // do not try to wait for the response if the clone failed, fetch error or null body
        callback((0, browser_core_1.elapsed)(context.startClocks.timeStamp, (0, browser_core_1.timeStampNow)()));
    }
    else {
        (0, browser_core_1.readBytesFromStream)(clonedResponse.body, function () {
            callback((0, browser_core_1.elapsed)(context.startClocks.timeStamp, (0, browser_core_1.timeStampNow)()));
        }, {
            bytesLimit: Number.POSITIVE_INFINITY,
            collectStreamBody: false,
        });
    }
}
//# sourceMappingURL=requestCollection.js.map
},{"./resource/resourceUtils":131,"./tracing/tracer":135,"@datadog/browser-core":56}],129:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchRequestTiming = void 0;
var browser_core_1 = require("@datadog/browser-core");
var resourceUtils_1 = require("./resourceUtils");
/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - if a single timing match, return the timing
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
    if (!performance || !('getEntriesByName' in performance)) {
        return;
    }
    var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
        return;
    }
    var candidates = sameNameEntries
        .map(function (entry) { return entry.toJSON(); })
        .filter(resourceUtils_1.toValidEntry)
        .filter(function (entry) {
        return isBetween(entry, request.startClocks.relative, endTime({ startTime: request.startClocks.relative, duration: request.duration }));
    });
    if (candidates.length === 1) {
        return candidates[0];
    }
    return;
}
exports.matchRequestTiming = matchRequestTiming;
function endTime(timing) {
    return (0, browser_core_1.addDuration)(timing.startTime, timing.duration);
}
function isBetween(timing, start, end) {
    var errorMargin = 1;
    return timing.startTime >= start - errorMargin && endTime(timing) <= (0, browser_core_1.addDuration)(end, errorMargin);
}
//# sourceMappingURL=matchRequestTiming.js.map
},{"./resourceUtils":131,"@datadog/browser-core":56}],130:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startResourceCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var performanceCollection_1 = require("../../browser/performanceCollection");
var matchRequestTiming_1 = require("./matchRequestTiming");
var resourceUtils_1 = require("./resourceUtils");
function startResourceCollection(lifeCycle, configuration, sessionManager, pageStateHistory) {
    lifeCycle.subscribe(6 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
        lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processRequest(request, configuration, sessionManager, pageStateHistory));
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === performanceCollection_1.RumPerformanceEntryType.RESOURCE && !(0, resourceUtils_1.isRequestKind)(entry)) {
                lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processResourceEntry(entry, configuration, sessionManager, pageStateHistory));
            }
        }
    });
}
exports.startResourceCollection = startResourceCollection;
function processRequest(request, configuration, sessionManager, pageStateHistory) {
    var _a;
    var type = request.type === "xhr" /* RequestType.XHR */ ? "xhr" /* ResourceType.XHR */ : "fetch" /* ResourceType.FETCH */;
    var matchingTiming = (0, matchRequestTiming_1.matchRequestTiming)(request);
    var startClocks = matchingTiming ? (0, browser_core_1.relativeToClocks)(matchingTiming.startTime) : request.startClocks;
    var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
    var tracingInfo = computeRequestTracingInfo(request, configuration);
    var indexingInfo = computeIndexingInfo(sessionManager, startClocks);
    var duration = computeRequestDuration(pageStateHistory, startClocks, request.duration);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, (_a = matchingTiming === null || matchingTiming === void 0 ? void 0 : matchingTiming.duration) !== null && _a !== void 0 ? _a : request.duration);
    var resourceEvent = (0, browser_core_1.combine)({
        date: startClocks.timeStamp,
        resource: {
            id: (0, browser_core_1.generateUUID)(),
            type: type,
            duration: duration,
            method: request.method,
            status_code: request.status,
            url: request.url,
        },
        type: "resource" /* RumEventType.RESOURCE */,
    }, tracingInfo, correspondingTimingOverrides, indexingInfo, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: matchingTiming && toPerformanceEntryRepresentation(matchingTiming),
            xhr: request.xhr,
            response: request.response,
            requestInput: request.input,
            requestInit: request.init,
            error: request.error,
        },
    };
}
function processResourceEntry(entry, configuration, sessionManager, pageStateHistory) {
    var type = (0, resourceUtils_1.computeResourceKind)(entry);
    var entryMetrics = computePerformanceEntryMetrics(entry);
    var startClocks = (0, browser_core_1.relativeToClocks)(entry.startTime);
    var tracingInfo = computeEntryTracingInfo(entry, configuration);
    var indexingInfo = computeIndexingInfo(sessionManager, startClocks);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, entry.duration);
    var resourceEvent = (0, browser_core_1.combine)({
        date: startClocks.timeStamp,
        resource: {
            id: (0, browser_core_1.generateUUID)(),
            type: type,
            url: entry.name,
        },
        type: "resource" /* RumEventType.RESOURCE */,
    }, tracingInfo, entryMetrics, indexingInfo, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: toPerformanceEntryRepresentation(entry),
        },
    };
}
function computePerformanceEntryMetrics(timing) {
    return {
        resource: (0, browser_core_1.assign)({
            duration: (0, resourceUtils_1.computePerformanceResourceDuration)(timing),
            size: (0, resourceUtils_1.computeSize)(timing),
        }, (0, resourceUtils_1.computePerformanceResourceDetails)(timing)),
    };
}
function computeRequestTracingInfo(request, configuration) {
    var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            span_id: request.spanId.toDecimalString(),
            trace_id: request.traceId.toDecimalString(),
            rule_psr: getRulePsr(configuration),
        },
    };
}
function computeEntryTracingInfo(entry, configuration) {
    var hasBeenTraced = entry.traceId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            trace_id: entry.traceId,
            rule_psr: getRulePsr(configuration),
        },
    };
}
// TODO next major: use directly PerformanceEntry type in domain context
function toPerformanceEntryRepresentation(entry) {
    return entry;
}
/**
 * @returns number between 0 and 1 which represents trace sample rate
 */
function getRulePsr(configuration) {
    return (0, browser_core_1.isNumber)(configuration.traceSampleRate) ? configuration.traceSampleRate / 100 : undefined;
}
function computeIndexingInfo(sessionManager, resourceStart) {
    var session = sessionManager.findTrackedSession(resourceStart.relative);
    return {
        _dd: {
            discarded: !session || !session.resourceAllowed,
        },
    };
}
function computePageStateInfo(pageStateHistory, startClocks, duration) {
    if (!(0, browser_core_1.isExperimentalFeatureEnabled)(browser_core_1.ExperimentalFeature.RESOURCE_PAGE_STATES)) {
        return;
    }
    return {
        _dd: {
            page_states: pageStateHistory.findAll(startClocks.relative, duration),
            page_was_discarded: String(document.wasDiscarded),
        },
    };
}
function computeRequestDuration(pageStateHistory, startClocks, duration) {
    var _a;
    // TODO remove FF in next major
    if (!(0, browser_core_1.isExperimentalFeatureEnabled)(browser_core_1.ExperimentalFeature.NO_RESOURCE_DURATION_FROZEN_STATE)) {
        return (0, browser_core_1.toServerDuration)(duration);
    }
    var requestCrossedFrozenState = (_a = pageStateHistory
        .findAll(startClocks.relative, duration)) === null || _a === void 0 ? void 0 : _a.some(function (pageState) { return pageState.state === "frozen" /* PageState.FROZEN */; });
    return !requestCrossedFrozenState ? (0, browser_core_1.toServerDuration)(duration) : undefined;
}
//# sourceMappingURL=resourceCollection.js.map
},{"../../browser/performanceCollection":99,"./matchRequestTiming":129,"./resourceUtils":131,"@datadog/browser-core":56}],131:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllowedRequestUrl = exports.computeSize = exports.toValidEntry = exports.computePerformanceResourceDetails = exports.computePerformanceResourceDuration = exports.isRequestKind = exports.computeResourceKind = exports.FAKE_INITIAL_DOCUMENT = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [
    ["document" /* ResourceType.DOCUMENT */, function (initiatorType) { return exports.FAKE_INITIAL_DOCUMENT === initiatorType; }],
    ["xhr" /* ResourceType.XHR */, function (initiatorType) { return 'xmlhttprequest' === initiatorType; }],
    ["fetch" /* ResourceType.FETCH */, function (initiatorType) { return 'fetch' === initiatorType; }],
    ["beacon" /* ResourceType.BEACON */, function (initiatorType) { return 'beacon' === initiatorType; }],
    ["css" /* ResourceType.CSS */, function (_, path) { return /\.css$/i.test(path); }],
    ["js" /* ResourceType.JS */, function (_, path) { return /\.js$/i.test(path); }],
    [
        "image" /* ResourceType.IMAGE */,
        function (initiatorType, path) {
            return (0, browser_core_1.includes)(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
        },
    ],
    ["font" /* ResourceType.FONT */, function (_, path) { return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null; }],
    [
        "media" /* ResourceType.MEDIA */,
        function (initiatorType, path) {
            return (0, browser_core_1.includes)(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
        },
    ],
];
function computeResourceKind(timing) {
    var url = timing.name;
    if (!(0, browser_core_1.isValidUrl)(url)) {
        (0, browser_core_1.addTelemetryDebug)("Failed to construct URL for \"".concat(timing.name, "\""));
        return "other" /* ResourceType.OTHER */;
    }
    var path = (0, browser_core_1.getPathName)(url);
    for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(timing.initiatorType, path)) {
            return type;
        }
    }
    return "other" /* ResourceType.OTHER */;
}
exports.computeResourceKind = computeResourceKind;
function areInOrder() {
    var numbers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        numbers[_i] = arguments[_i];
    }
    for (var i = 1; i < numbers.length; i += 1) {
        if (numbers[i - 1] > numbers[i]) {
            return false;
        }
    }
    return true;
}
function isRequestKind(timing) {
    return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
exports.isRequestKind = isRequestKind;
function computePerformanceResourceDuration(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) {
        return (0, browser_core_1.toServerDuration)((0, browser_core_1.elapsed)(startTime, responseEnd));
    }
    return (0, browser_core_1.toServerDuration)(duration);
}
exports.computePerformanceResourceDuration = computePerformanceResourceDuration;
function computePerformanceResourceDetails(entry) {
    var validEntry = toValidEntry(entry);
    if (!validEntry) {
        return undefined;
    }
    var startTime = validEntry.startTime, fetchStart = validEntry.fetchStart, redirectStart = validEntry.redirectStart, redirectEnd = validEntry.redirectEnd, domainLookupStart = validEntry.domainLookupStart, domainLookupEnd = validEntry.domainLookupEnd, connectStart = validEntry.connectStart, secureConnectionStart = validEntry.secureConnectionStart, connectEnd = validEntry.connectEnd, requestStart = validEntry.requestStart, responseStart = validEntry.responseStart, responseEnd = validEntry.responseEnd;
    var details = {
        download: formatTiming(startTime, responseStart, responseEnd),
        first_byte: formatTiming(startTime, requestStart, responseStart),
    };
    // Make sure a connection occurred
    if (connectEnd !== fetchStart) {
        details.connect = formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (areInOrder(connectStart, secureConnectionStart, connectEnd)) {
            details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
        }
    }
    // Make sure a domain lookup occurred
    if (domainLookupEnd !== fetchStart) {
        details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
    }
    if (hasRedirection(entry)) {
        details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
    }
    return details;
}
exports.computePerformanceResourceDetails = computePerformanceResourceDetails;
function toValidEntry(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    if (!areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd)) {
        return undefined;
    }
    if (!hasRedirection(entry)) {
        return entry;
    }
    var redirectStart = entry.redirectStart, redirectEnd = entry.redirectEnd;
    // Firefox doesn't provide redirect timings on cross origin requests.
    // Provide a default for those.
    if (redirectStart < entry.startTime) {
        redirectStart = entry.startTime;
    }
    if (redirectEnd < entry.startTime) {
        redirectEnd = entry.fetchStart;
    }
    // Make sure redirect timings are in order
    if (!areInOrder(entry.startTime, redirectStart, redirectEnd, entry.fetchStart)) {
        return undefined;
    }
    return (0, browser_core_1.assign)({}, entry, {
        redirectEnd: redirectEnd,
        redirectStart: redirectStart,
    });
}
exports.toValidEntry = toValidEntry;
function hasRedirection(entry) {
    // The only time fetchStart is different than startTime is if a redirection occurred.
    return entry.fetchStart !== entry.startTime;
}
function formatTiming(origin, start, end) {
    return {
        duration: (0, browser_core_1.toServerDuration)((0, browser_core_1.elapsed)(start, end)),
        start: (0, browser_core_1.toServerDuration)((0, browser_core_1.elapsed)(origin, start)),
    };
}
function computeSize(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        return entry.decodedBodySize;
    }
    return undefined;
}
exports.computeSize = computeSize;
function isAllowedRequestUrl(configuration, url) {
    return url && !configuration.isIntakeUrl(url);
}
exports.isAllowedRequestUrl = isAllowedRequestUrl;
//# sourceMappingURL=resourceUtils.js.map
},{"@datadog/browser-core":56}],132:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRumSessionManagerStub = exports.startRumSessionManager = exports.RUM_SESSION_KEY = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle) {
    var sessionManager = (0, browser_core_1.startSessionManager)(configuration, exports.RUM_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    sessionManager.expireObservable.subscribe(function () {
        lifeCycle.notify(7 /* LifeCycleEventType.SESSION_EXPIRED */);
    });
    sessionManager.renewObservable.subscribe(function () {
        lifeCycle.notify(8 /* LifeCycleEventType.SESSION_RENEWED */);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            if (!session || !isTypeTracked(session.trackingType)) {
                return;
            }
            var plan = session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */
                ? 2 /* RumSessionPlan.WITH_SESSION_REPLAY */
                : 1 /* RumSessionPlan.WITHOUT_SESSION_REPLAY */;
            return {
                id: session.id,
                plan: plan,
                sessionReplayAllowed: plan === 2 /* RumSessionPlan.WITH_SESSION_REPLAY */,
                longTaskAllowed: configuration.trackLongTasks !== undefined
                    ? configuration.trackLongTasks
                    : configuration.oldPlansBehavior && plan === 2 /* RumSessionPlan.WITH_SESSION_REPLAY */,
                resourceAllowed: configuration.trackResources !== undefined
                    ? configuration.trackResources
                    : configuration.oldPlansBehavior && plan === 2 /* RumSessionPlan.WITH_SESSION_REPLAY */,
            };
        },
        expire: sessionManager.expire,
        expireObservable: sessionManager.expireObservable,
    };
}
exports.startRumSessionManager = startRumSessionManager;
/**
 * Start a tracked replay session stub
 */
function startRumSessionManagerStub() {
    var session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        plan: 1 /* RumSessionPlan.WITHOUT_SESSION_REPLAY */,
        sessionReplayAllowed: false,
        longTaskAllowed: true,
        resourceAllowed: true,
    };
    return {
        findTrackedSession: function () { return session; },
        expire: browser_core_1.noop,
        expireObservable: new browser_core_1.Observable(),
    };
}
exports.startRumSessionManagerStub = startRumSessionManagerStub;
function computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if (hasValidRumSession(rawTrackingType)) {
        trackingType = rawTrackingType;
    }
    else if (!(0, browser_core_1.performDraw)(configuration.sessionSampleRate)) {
        trackingType = "0" /* RumTrackingType.NOT_TRACKED */;
    }
    else if (!(0, browser_core_1.performDraw)(configuration.sessionReplaySampleRate)) {
        trackingType = "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */;
    }
    else {
        trackingType = "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */;
    }
    return {
        trackingType: trackingType,
        isTracked: isTypeTracked(trackingType),
    };
}
function hasValidRumSession(trackingType) {
    return (trackingType === "0" /* RumTrackingType.NOT_TRACKED */ ||
        trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ||
        trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */);
}
function isTypeTracked(rumSessionType) {
    return (rumSessionType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ||
        rumSessionType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */);
}
//# sourceMappingURL=rumSessionManager.js.map
},{"@datadog/browser-core":56}],133:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startCustomerDataTelemetry = exports.MEASURES_PERIOD_DURATION = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.MEASURES_PERIOD_DURATION = 10 * browser_core_1.ONE_SECOND;
var currentPeriodMeasures;
var currentBatchMeasures;
var batchHasRumEvent;
function startCustomerDataTelemetry(configuration, telemetry, lifeCycle, globalContextManager, userContextManager, featureFlagContexts, batchFlushObservable) {
    var customerDataTelemetryEnabled = telemetry.enabled && (0, browser_core_1.performDraw)(configuration.customerDataTelemetrySampleRate);
    if (!customerDataTelemetryEnabled) {
        return;
    }
    initCurrentPeriodMeasures();
    initCurrentBatchMeasures();
    // We measure the data of every view updates even if there could only be one per batch due to the upsert
    // It means that contexts bytes count sums can be higher than it really is
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
        batchHasRumEvent = true;
        updateMeasure(currentBatchMeasures.globalContextBytes, !(0, browser_core_1.isEmptyObject)(globalContextManager.get()) ? globalContextManager.getBytesCount() : 0);
        updateMeasure(currentBatchMeasures.userContextBytes, !(0, browser_core_1.isEmptyObject)(userContextManager.get()) ? userContextManager.getBytesCount() : 0);
        var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations();
        var hasFeatureFlagContext = (0, browser_core_1.includes)(["view" /* RumEventType.VIEW */, "error" /* RumEventType.ERROR */], event.type) &&
            featureFlagContext &&
            !(0, browser_core_1.isEmptyObject)(featureFlagContext);
        updateMeasure(currentBatchMeasures.featureFlagBytes, hasFeatureFlagContext ? featureFlagContexts.getFeatureFlagBytesCount() : 0);
    });
    batchFlushObservable.subscribe(function (_a) {
        var bytesCount = _a.bytesCount, messagesCount = _a.messagesCount;
        // Don't measure batch that only contains telemetry events to avoid batch sending loop
        // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
        if (!batchHasRumEvent) {
            return;
        }
        currentPeriodMeasures.batchCount += 1;
        updateMeasure(currentPeriodMeasures.batchBytesCount, bytesCount);
        updateMeasure(currentPeriodMeasures.batchMessagesCount, messagesCount);
        mergeMeasure(currentPeriodMeasures.globalContextBytes, currentBatchMeasures.globalContextBytes);
        mergeMeasure(currentPeriodMeasures.userContextBytes, currentBatchMeasures.userContextBytes);
        mergeMeasure(currentPeriodMeasures.featureFlagBytes, currentBatchMeasures.featureFlagBytes);
        initCurrentBatchMeasures();
    });
    (0, browser_core_1.setInterval)(sendCurrentPeriodMeasures, exports.MEASURES_PERIOD_DURATION);
}
exports.startCustomerDataTelemetry = startCustomerDataTelemetry;
function sendCurrentPeriodMeasures() {
    if (currentPeriodMeasures.batchCount === 0) {
        return;
    }
    (0, browser_core_1.addTelemetryDebug)('Customer data measures', currentPeriodMeasures);
    initCurrentPeriodMeasures();
}
function createMeasure() {
    return { min: Infinity, max: 0, sum: 0 };
}
function updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function mergeMeasure(target, source) {
    target.sum += source.sum;
    target.min = Math.min(target.min, source.min);
    target.max = Math.max(target.max, source.max);
}
function initCurrentPeriodMeasures() {
    currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: createMeasure(),
        batchMessagesCount: createMeasure(),
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
function initCurrentBatchMeasures() {
    batchHasRumEvent = false;
    currentBatchMeasures = {
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
//# sourceMappingURL=startCustomerDataTelemetry.js.map
},{"@datadog/browser-core":56}],134:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findTraceComment = exports.createDocumentTraceData = exports.getDocumentTraceDataFromComment = exports.getDocumentTraceDataFromMeta = exports.getDocumentTraceId = exports.INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = void 0;
var browser_core_1 = require("@datadog/browser-core");
var htmlDomUtils_1 = require("../../browser/htmlDomUtils");
exports.INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * browser_core_1.ONE_MINUTE;
function getDocumentTraceId(document) {
    var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
    if (!data || data.traceTime <= (0, browser_core_1.dateNow)() - exports.INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
        return undefined;
    }
    return data.traceId;
}
exports.getDocumentTraceId = getDocumentTraceId;
function getDocumentTraceDataFromMeta(document) {
    var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
exports.getDocumentTraceDataFromMeta = getDocumentTraceDataFromMeta;
function getDocumentTraceDataFromComment(document) {
    var comment = findTraceComment(document);
    if (!comment) {
        return undefined;
    }
    return createDocumentTraceData((0, browser_core_1.findCommaSeparatedValue)(comment, 'trace-id'), (0, browser_core_1.findCommaSeparatedValue)(comment, 'trace-time'));
}
exports.getDocumentTraceDataFromComment = getDocumentTraceDataFromComment;
function createDocumentTraceData(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) {
        return undefined;
    }
    return {
        traceId: traceId,
        traceTime: traceTime,
    };
}
exports.createDocumentTraceData = createDocumentTraceData;
function findTraceComment(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    for (var i = 0; i < document.childNodes.length; i += 1) {
        var comment = getTraceCommentFromNode(document.childNodes[i]);
        if (comment) {
            return comment;
        }
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) {
        for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
            var node = document.body.childNodes[i];
            var comment = getTraceCommentFromNode(node);
            if (comment) {
                return comment;
            }
            if (!(0, htmlDomUtils_1.isTextNode)(node)) {
                break;
            }
        }
    }
}
exports.findTraceComment = findTraceComment;
function getTraceCommentFromNode(node) {
    if (node && (0, htmlDomUtils_1.isCommentNode)(node)) {
        var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) {
            return match[1];
        }
    }
}
//# sourceMappingURL=getDocumentTraceId.js.map
},{"../../browser/htmlDomUtils":97,"@datadog/browser-core":56}],135:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraceIdentifier = exports.isTracingSupported = exports.startTracer = exports.clearTracingIfNeeded = exports.isTracingOption = void 0;
var browser_core_1 = require("@datadog/browser-core");
function isTracingOption(item) {
    var expectedItem = item;
    return ((0, browser_core_1.getType)(expectedItem) === 'object' &&
        (0, browser_core_1.isMatchOption)(expectedItem.match) &&
        Array.isArray(expectedItem.propagatorTypes));
}
exports.isTracingOption = isTracingOption;
/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */
function clearTracingIfNeeded(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
exports.clearTracingIfNeeded = clearTracingIfNeeded;
function startTracer(configuration, sessionManager) {
    return {
        clearTracingIfNeeded: clearTracingIfNeeded,
        traceFetch: function (context) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach(function (key) {
                        ;
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                }
                else {
                    context.init = (0, browser_core_1.shallowClone)(context.init);
                    var headers_1 = [];
                    if (context.init.headers instanceof Headers) {
                        context.init.headers.forEach(function (value, key) {
                            headers_1.push([key, value]);
                        });
                    }
                    else if (Array.isArray(context.init.headers)) {
                        context.init.headers.forEach(function (header) {
                            headers_1.push(header);
                        });
                    }
                    else if (context.init.headers) {
                        Object.keys(context.init.headers).forEach(function (key) {
                            headers_1.push([key, context.init.headers[key]]);
                        });
                    }
                    context.init.headers = headers_1.concat((0, browser_core_1.objectEntries)(tracingHeaders));
                }
            });
        },
        traceXhr: function (context, xhr) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function (name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        },
    };
}
exports.startTracer = startTracer;
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
    if (!isTracingSupported() || !sessionManager.findTrackedSession()) {
        return;
    }
    var tracingOption = (0, browser_core_1.find)(configuration.allowedTracingUrls, function (tracingOption) {
        return (0, browser_core_1.matchList)([tracingOption.match], context.url, true);
    });
    if (!tracingOption) {
        return;
    }
    context.traceId = new TraceIdentifier();
    context.spanId = new TraceIdentifier();
    context.traceSampled = !(0, browser_core_1.isNumber)(configuration.traceSampleRate) || (0, browser_core_1.performDraw)(configuration.traceSampleRate);
    inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, tracingOption.propagatorTypes));
}
function isTracingSupported() {
    return getCrypto() !== undefined;
}
exports.isTracingSupported = isTracingSupported;
function getCrypto() {
    return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */
function makeTracingHeaders(traceId, spanId, traceSampled, propagatorTypes) {
    var tracingHeaders = {};
    propagatorTypes.forEach(function (propagatorType) {
        switch (propagatorType) {
            case 'datadog': {
                (0, browser_core_1.assign)(tracingHeaders, {
                    'x-datadog-origin': 'rum',
                    'x-datadog-parent-id': spanId.toDecimalString(),
                    'x-datadog-sampling-priority': traceSampled ? '1' : '0',
                    'x-datadog-trace-id': traceId.toDecimalString(),
                });
                break;
            }
            // https://www.w3.org/TR/trace-context/
            case 'tracecontext': {
                (0, browser_core_1.assign)(tracingHeaders, {
                    traceparent: "00-0000000000000000".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-0").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            // https://github.com/openzipkin/b3-propagation
            case 'b3': {
                (0, browser_core_1.assign)(tracingHeaders, {
                    b3: "".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            case 'b3multi': {
                (0, browser_core_1.assign)(tracingHeaders, {
                    'X-B3-TraceId': traceId.toPaddedHexadecimalString(),
                    'X-B3-SpanId': spanId.toPaddedHexadecimalString(),
                    'X-B3-Sampled': traceSampled ? '1' : '0',
                });
                break;
            }
        }
    });
    return tracingHeaders;
}
/* eslint-disable no-bitwise */
var TraceIdentifier = /** @class */ (function () {
    function TraceIdentifier() {
        this.buffer = new Uint8Array(8);
        getCrypto().getRandomValues(this.buffer);
        this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
    }
    TraceIdentifier.prototype.toString = function (radix) {
        var high = this.readInt32(0);
        var low = this.readInt32(4);
        var str = '';
        do {
            var mod = (high % radix) * 4294967296 + low;
            high = Math.floor(high / radix);
            low = Math.floor(mod / radix);
            str = (mod % radix).toString(radix) + str;
        } while (high || low);
        return str;
    };
    /**
     * Format used everywhere except the trace intake
     */
    TraceIdentifier.prototype.toDecimalString = function () {
        return this.toString(10);
    };
    /**
     * Format used by OTel headers
     */
    TraceIdentifier.prototype.toPaddedHexadecimalString = function () {
        var traceId = this.toString(16);
        return Array(17 - traceId.length).join('0') + traceId;
    };
    TraceIdentifier.prototype.readInt32 = function (offset) {
        return (this.buffer[offset] * 16777216 +
            (this.buffer[offset + 1] << 16) +
            (this.buffer[offset + 2] << 8) +
            this.buffer[offset + 3]);
    };
    return TraceIdentifier;
}());
exports.TraceIdentifier = TraceIdentifier;
/* eslint-enable no-bitwise */
//# sourceMappingURL=tracer.js.map
},{"@datadog/browser-core":56}],136:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEventCounts = void 0;
var browser_core_1 = require("@datadog/browser-core");
function trackEventCounts(_a) {
    var lifeCycle = _a.lifeCycle, isChildEvent = _a.isChildEvent, _b = _a.onChange, callback = _b === void 0 ? browser_core_1.noop : _b;
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0,
    };
    var subscription = lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
        var _a;
        if (event.type === 'view' || !isChildEvent(event)) {
            return;
        }
        switch (event.type) {
            case "error" /* RumEventType.ERROR */:
                eventCounts.errorCount += 1;
                callback();
                break;
            case "action" /* RumEventType.ACTION */:
                eventCounts.actionCount += 1;
                if (event.action.frustration) {
                    eventCounts.frustrationCount += event.action.frustration.type.length;
                }
                callback();
                break;
            case "long_task" /* RumEventType.LONG_TASK */:
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case "resource" /* RumEventType.RESOURCE */:
                if (!((_a = event._dd) === null || _a === void 0 ? void 0 : _a.discarded)) {
                    eventCounts.resourceCount += 1;
                    callback();
                }
                break;
        }
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
        eventCounts: eventCounts,
    };
}
exports.trackEventCounts = trackEventCounts;
//# sourceMappingURL=trackEventCounts.js.map
},{"@datadog/browser-core":56}],137:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackViewEventCounts = void 0;
var trackEventCounts_1 = require("../trackEventCounts");
function trackViewEventCounts(lifeCycle, viewId, onChange) {
    var _a = (0, trackEventCounts_1.trackEventCounts)({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) { return event.view.id === viewId; },
        onChange: onChange,
    }), stop = _a.stop, eventCounts = _a.eventCounts;
    return {
        stop: stop,
        eventCounts: eventCounts,
    };
}
exports.trackViewEventCounts = trackViewEventCounts;
//# sourceMappingURL=trackViewEventCounts.js.map
},{"../trackEventCounts":136}],138:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackViews = exports.KEEP_TRACKING_AFTER_VIEW_DELAY = exports.SESSION_KEEP_ALIVE_INTERVAL = exports.THROTTLE_VIEW_UPDATE_PERIOD = void 0;
var browser_core_1 = require("@datadog/browser-core");
var trackViewEventCounts_1 = require("./trackViewEventCounts");
var trackInitialViewMetrics_1 = require("./viewMetrics/trackInitialViewMetrics");
var trackCommonViewMetrics_1 = require("./viewMetrics/trackCommonViewMetrics");
exports.THROTTLE_VIEW_UPDATE_PERIOD = 3000;
exports.SESSION_KEEP_ALIVE_INTERVAL = 5 * browser_core_1.ONE_MINUTE;
// Some events or metrics can be captured after the end of the view. To avoid missing those;
// an arbitrary delay is added for stopping their tracking after the view ends.
//
// Ideally, we would not stop and keep tracking events or metrics until the end of the session.
// But this might have a small performance impact if there are many many views.
// So let's have a fairly short delay improving the situation in most cases and avoid impacting performances too much.
exports.KEEP_TRACKING_AFTER_VIEW_DELAY = 5 * browser_core_1.ONE_MINUTE;
function trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    var activeViews = new Set();
    var currentView = startNewView("initial_load" /* ViewLoadingType.INITIAL_LOAD */, (0, browser_core_1.clocksOrigin)(), initialViewOptions);
    startViewLifeCycle();
    var locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
    }
    function startNewView(loadingType, startClocks, viewOptions) {
        var newlyCreatedView = newView(lifeCycle, domMutationObservable, configuration, location, loadingType, startClocks, viewOptions);
        activeViews.add(newlyCreatedView);
        newlyCreatedView.stopObservable.subscribe(function () {
            activeViews.delete(newlyCreatedView);
        });
        return newlyCreatedView;
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
            // Renew view on session renewal
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
            });
        });
        lifeCycle.subscribe(7 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
            currentView.end({ sessionIsActive: false });
        });
        // End the current view on page unload
        lifeCycle.subscribe(9 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
            if (pageExitEvent.reason === browser_core_1.PageExitReason.UNLOADING || pageExitEvent.reason === browser_core_1.PageExitReason.PAGEHIDE) {
                currentView.end();
            }
        });
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(function (_a) {
            var oldLocation = _a.oldLocation, newLocation = _a.newLocation;
            if (areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */);
            }
        });
    }
    return {
        addTiming: function (name, time) {
            if (time === void 0) { time = (0, browser_core_1.timeStampNow)(); }
            currentView.addTiming(name, time);
        },
        startView: function (options, startClocks) {
            currentView.end({ endClocks: startClocks });
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, startClocks, options);
        },
        stop: function () {
            locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
            currentView.end();
            activeViews.forEach(function (view) { return view.stop(); });
        },
    };
}
exports.trackViews = trackViews;
function newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
    if (startClocks === void 0) { startClocks = (0, browser_core_1.clocksNow)(); }
    // Setup initial values
    var id = (0, browser_core_1.generateUUID)();
    var stopObservable = new browser_core_1.Observable();
    var customTimings = {};
    var documentVersion = 0;
    var endClocks;
    var location = (0, browser_core_1.shallowClone)(initialLocation);
    var sessionIsActive = true;
    var name;
    var service;
    var version;
    if (viewOptions) {
        name = viewOptions.name;
        service = viewOptions.service;
        version = viewOptions.version;
    }
    lifeCycle.notify(2 /* LifeCycleEventType.VIEW_CREATED */, {
        id: id,
        name: name,
        startClocks: startClocks,
        service: service,
        version: version,
    });
    // Update the view every time the measures are changing
    var _a = (0, browser_core_1.throttle)(triggerViewUpdate, exports.THROTTLE_VIEW_UPDATE_PERIOD, {
        leading: false,
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var _b = (0, trackCommonViewMetrics_1.trackCommonViewMetrics)(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks), setLoadEvent = _b.setLoadEvent, stopCommonViewMetricsTracking = _b.stop, getCommonViewMetrics = _b.getCommonViewMetrics;
    var _c = loadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */
        ? (0, trackInitialViewMetrics_1.trackInitialViewMetrics)(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate)
        : { stop: browser_core_1.noop, initialViewMetrics: {} }, stopInitialViewMetricsTracking = _c.stop, initialViewMetrics = _c.initialViewMetrics;
    var _d = (0, trackViewEventCounts_1.trackViewEventCounts)(lifeCycle, id, scheduleViewUpdate), stopEventCountsTracking = _d.stop, eventCounts = _d.eventCounts;
    // Session keep alive
    var keepAliveIntervalId = (0, browser_core_1.setInterval)(triggerViewUpdate, exports.SESSION_KEEP_ALIVE_INTERVAL);
    // Initial view update
    triggerViewUpdate();
    function triggerViewUpdate() {
        cancelScheduleViewUpdate();
        documentVersion += 1;
        var currentEnd = endClocks === undefined ? (0, browser_core_1.timeStampNow)() : endClocks.timeStamp;
        lifeCycle.notify(3 /* LifeCycleEventType.VIEW_UPDATED */, {
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            commonViewMetrics: getCommonViewMetrics(),
            initialViewMetrics: initialViewMetrics,
            duration: (0, browser_core_1.elapsed)(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
            sessionIsActive: sessionIsActive,
            eventCounts: eventCounts,
        });
    }
    return {
        name: name,
        service: service,
        version: version,
        stopObservable: stopObservable,
        end: function (options) {
            var _this = this;
            var _a, _b;
            if (options === void 0) { options = {}; }
            if (endClocks) {
                // view already ended
                return;
            }
            endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : (0, browser_core_1.clocksNow)();
            sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
            lifeCycle.notify(4 /* LifeCycleEventType.VIEW_ENDED */, { endClocks: endClocks });
            (0, browser_core_1.clearInterval)(keepAliveIntervalId);
            stopCommonViewMetricsTracking();
            triggerViewUpdate();
            (0, browser_core_1.setTimeout)(function () {
                _this.stop();
            }, exports.KEEP_TRACKING_AFTER_VIEW_DELAY);
        },
        stop: function () {
            stopInitialViewMetricsTracking();
            stopEventCountsTracking();
            stopObservable.notify();
        },
        addTiming: function (name, time) {
            if (endClocks) {
                return;
            }
            var relativeTime = (0, browser_core_1.looksLikeRelativeTime)(time) ? time : (0, browser_core_1.elapsed)(startClocks.timeStamp, time);
            customTimings[sanitizeTiming(name)] = relativeTime;
            scheduleViewUpdate();
        },
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
    var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) {
        browser_core_1.display.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
    }
    return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
    return (currentLocation.pathname !== otherLocation.pathname ||
        (!isHashAnAnchor(otherLocation.hash) &&
            getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash)));
}
function isHashAnAnchor(hash) {
    var correspondingId = hash.substr(1);
    return !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
    var index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}
//# sourceMappingURL=trackViews.js.map
},{"./trackViewEventCounts":137,"./viewMetrics/trackCommonViewMetrics":141,"./viewMetrics/trackInitialViewMetrics":146,"@datadog/browser-core":56}],139:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startViewCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var foregroundContexts_1 = require("../contexts/foregroundContexts");
var trackViews_1 = require("./trackViews");
function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions) {
    lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_UPDATED */, function (view) {
        return lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory));
    });
    return (0, trackViews_1.trackViews)(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
exports.startViewCollection = startViewCollection;
function processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var replayStats = recorderApi.getReplayStats(view.id);
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(view.startClocks.relative);
    var pageStatesEnabled = (0, browser_core_1.isExperimentalFeatureEnabled)(browser_core_1.ExperimentalFeature.PAGE_STATES);
    var pageStates = pageStateHistory.findAll(view.startClocks.relative, view.duration);
    var viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
            page_states: pageStatesEnabled ? pageStates : undefined,
        },
        date: view.startClocks.timeStamp,
        type: "view" /* RumEventType.VIEW */,
        view: {
            action: {
                count: view.eventCounts.actionCount,
            },
            frustration: {
                count: view.eventCounts.frustrationCount,
            },
            cumulative_layout_shift: (_a = view.commonViewMetrics.cumulativeLayoutShift) === null || _a === void 0 ? void 0 : _a.value,
            cumulative_layout_shift_target_selector: (_b = view.commonViewMetrics.cumulativeLayoutShift) === null || _b === void 0 ? void 0 : _b.targetSelector,
            first_byte: (0, browser_core_1.toServerDuration)((_c = view.initialViewMetrics.navigationTimings) === null || _c === void 0 ? void 0 : _c.firstByte),
            dom_complete: (0, browser_core_1.toServerDuration)((_d = view.initialViewMetrics.navigationTimings) === null || _d === void 0 ? void 0 : _d.domComplete),
            dom_content_loaded: (0, browser_core_1.toServerDuration)((_e = view.initialViewMetrics.navigationTimings) === null || _e === void 0 ? void 0 : _e.domContentLoaded),
            dom_interactive: (0, browser_core_1.toServerDuration)((_f = view.initialViewMetrics.navigationTimings) === null || _f === void 0 ? void 0 : _f.domInteractive),
            error: {
                count: view.eventCounts.errorCount,
            },
            first_contentful_paint: (0, browser_core_1.toServerDuration)(view.initialViewMetrics.firstContentfulPaint),
            first_input_delay: (0, browser_core_1.toServerDuration)((_g = view.initialViewMetrics.firstInput) === null || _g === void 0 ? void 0 : _g.delay),
            first_input_time: (0, browser_core_1.toServerDuration)((_h = view.initialViewMetrics.firstInput) === null || _h === void 0 ? void 0 : _h.time),
            first_input_target_selector: (_j = view.initialViewMetrics.firstInput) === null || _j === void 0 ? void 0 : _j.targetSelector,
            interaction_to_next_paint: (0, browser_core_1.toServerDuration)((_k = view.commonViewMetrics.interactionToNextPaint) === null || _k === void 0 ? void 0 : _k.value),
            interaction_to_next_paint_target_selector: (_l = view.commonViewMetrics.interactionToNextPaint) === null || _l === void 0 ? void 0 : _l.targetSelector,
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: (0, browser_core_1.toServerDuration)((_m = view.initialViewMetrics.largestContentfulPaint) === null || _m === void 0 ? void 0 : _m.value),
            largest_contentful_paint_target_selector: (_o = view.initialViewMetrics.largestContentfulPaint) === null || _o === void 0 ? void 0 : _o.targetSelector,
            load_event: (0, browser_core_1.toServerDuration)((_p = view.initialViewMetrics.navigationTimings) === null || _p === void 0 ? void 0 : _p.loadEvent),
            loading_time: discardNegativeDuration((0, browser_core_1.toServerDuration)(view.commonViewMetrics.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount,
            },
            resource: {
                count: view.eventCounts.resourceCount,
            },
            time_spent: (0, browser_core_1.toServerDuration)(view.duration),
            in_foreground_periods: !pageStatesEnabled && pageStates ? (0, foregroundContexts_1.mapToForegroundPeriods)(pageStates, view.duration) : undefined, // Todo: Remove in the next major release
        },
        feature_flags: featureFlagContext && !(0, browser_core_1.isEmptyObject)(featureFlagContext) ? featureFlagContext : undefined,
        display: view.commonViewMetrics.scroll
            ? {
                scroll: {
                    max_depth: view.commonViewMetrics.scroll.maxDepth,
                    max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
                    max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
                    max_scroll_height_time: (0, browser_core_1.toServerDuration)(view.commonViewMetrics.scroll.maxScrollHeightTime),
                },
            }
            : undefined,
        session: {
            has_replay: replayStats ? true : undefined,
            is_active: view.sessionIsActive ? undefined : false,
        },
        privacy: {
            replay_level: configuration.defaultPrivacyLevel,
        },
    };
    if (!(0, browser_core_1.isEmptyObject)(view.customTimings)) {
        viewEvent.view.custom_timings = (0, browser_core_1.mapValues)(view.customTimings, browser_core_1.toServerDuration);
    }
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        domainContext: {
            location: view.location,
        },
    };
}
function discardNegativeDuration(duration) {
    return (0, browser_core_1.isNumber)(duration) && duration < 0 ? undefined : duration;
}
//# sourceMappingURL=viewCollection.js.map
},{"../contexts/foregroundContexts":114,"./trackViews":138,"@datadog/browser-core":56}],140:[function(require,module,exports){
"use strict";
/**
 * performance.interactionCount polyfill
 *
 * The interactionCount is an integer which counts the total number of distinct user interactions,
 * for which there was a unique interactionId.
 *
 * The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
 * This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
 * Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
 *
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInteractionCount = exports.initInteractionCountPolyfill = void 0;
var browser_core_1 = require("@datadog/browser-core");
var observer;
var interactionCountEstimate = 0;
var minKnownInteractionId = Infinity;
var maxKnownInteractionId = 0;
function initInteractionCountPolyfill() {
    if ('interactionCount' in performance || observer) {
        return;
    }
    observer = new window.PerformanceObserver((0, browser_core_1.monitor)(function (entries) {
        entries.getEntries().forEach(function (e) {
            var entry = e;
            if (entry.interactionId) {
                minKnownInteractionId = Math.min(minKnownInteractionId, entry.interactionId);
                maxKnownInteractionId = Math.max(maxKnownInteractionId, entry.interactionId);
                interactionCountEstimate = (maxKnownInteractionId - minKnownInteractionId) / 7 + 1;
            }
        });
    }));
    observer.observe({ type: 'event', buffered: true, durationThreshold: 0 });
}
exports.initInteractionCountPolyfill = initInteractionCountPolyfill;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */
var getInteractionCount = function () {
    return observer ? interactionCountEstimate : window.performance.interactionCount || 0;
};
exports.getInteractionCount = getInteractionCount;
//# sourceMappingURL=interactionCountPolyfill.js.map
},{"@datadog/browser-core":56}],141:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCommonViewMetrics = void 0;
var trackCumulativeLayoutShift_1 = require("./trackCumulativeLayoutShift");
var trackInteractionToNextPaint_1 = require("./trackInteractionToNextPaint");
var trackLoadingTime_1 = require("./trackLoadingTime");
var trackScrollMetrics_1 = require("./trackScrollMetrics");
function trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    var commonViewMetrics = {};
    var _a = (0, trackLoadingTime_1.trackLoadingTime)(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
        commonViewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    }), stopLoadingTimeTracking = _a.stop, setLoadEvent = _a.setLoadEvent;
    var stopScrollMetricsTracking = (0, trackScrollMetrics_1.trackScrollMetrics)(configuration, viewStart, function (newScrollMetrics) {
        commonViewMetrics.scroll = newScrollMetrics;
    }).stop;
    var stopCLSTracking = (0, trackCumulativeLayoutShift_1.trackCumulativeLayoutShift)(configuration, lifeCycle, function (cumulativeLayoutShift) {
        commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
        scheduleViewUpdate();
    }).stop;
    var _b = (0, trackInteractionToNextPaint_1.trackInteractionToNextPaint)(configuration, viewStart, loadingType, lifeCycle), stopINPTracking = _b.stop, getInteractionToNextPaint = _b.getInteractionToNextPaint;
    return {
        stop: function () {
            stopLoadingTimeTracking();
            stopCLSTracking();
            stopScrollMetricsTracking();
            stopINPTracking();
        },
        setLoadEvent: setLoadEvent,
        getCommonViewMetrics: function () {
            commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
            return commonViewMetrics;
        },
    };
}
exports.trackCommonViewMetrics = trackCommonViewMetrics;
//# sourceMappingURL=trackCommonViewMetrics.js.map
},{"./trackCumulativeLayoutShift":142,"./trackInteractionToNextPaint":147,"./trackLoadingTime":149,"./trackScrollMetrics":151}],142:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLayoutShiftSupported = exports.trackCumulativeLayoutShift = void 0;
var browser_core_1 = require("@datadog/browser-core");
var htmlDomUtils_1 = require("../../../browser/htmlDomUtils");
var performanceCollection_1 = require("../../../browser/performanceCollection");
var getSelectorFromElement_1 = require("../../getSelectorFromElement");
/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(configuration, lifeCycle, callback) {
    if (!isLayoutShiftSupported()) {
        return {
            stop: browser_core_1.noop,
        };
    }
    var maxClsValue = 0;
    // if no layout shift happen the value should be reported as 0
    callback({
        value: 0,
    });
    var window = slidingSessionWindow();
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === performanceCollection_1.RumPerformanceEntryType.LAYOUT_SHIFT && !entry.hadRecentInput) {
                window.update(entry);
                if (window.value() > maxClsValue) {
                    maxClsValue = window.value();
                    var cls = (0, browser_core_1.round)(maxClsValue, 4);
                    var clsTarget = window.largestLayoutShiftTarget();
                    var cslTargetSelector = void 0;
                    if ((0, browser_core_1.isExperimentalFeatureEnabled)(browser_core_1.ExperimentalFeature.WEB_VITALS_ATTRIBUTION) && clsTarget) {
                        cslTargetSelector = (0, getSelectorFromElement_1.getSelectorFromElement)(clsTarget, configuration.actionNameAttribute);
                    }
                    callback({
                        value: cls,
                        targetSelector: cslTargetSelector,
                    });
                }
            }
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
exports.trackCumulativeLayoutShift = trackCumulativeLayoutShift;
function slidingSessionWindow() {
    var value = 0;
    var startTime;
    var endTime;
    var largestLayoutShift = 0;
    var largestLayoutShiftTarget;
    var largestLayoutShiftTime;
    return {
        update: function (entry) {
            var _a, _b;
            var shouldCreateNewWindow = startTime === undefined ||
                entry.startTime - endTime >= browser_core_1.ONE_SECOND ||
                entry.startTime - startTime >= 5 * browser_core_1.ONE_SECOND;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                value = entry.value;
                largestLayoutShift = 0;
                largestLayoutShiftTarget = undefined;
            }
            else {
                value += entry.value;
                endTime = entry.startTime;
            }
            if (entry.value > largestLayoutShift) {
                largestLayoutShift = entry.value;
                largestLayoutShiftTime = entry.startTime;
                if ((_a = entry.sources) === null || _a === void 0 ? void 0 : _a.length) {
                    largestLayoutShiftTarget = (_b = (0, browser_core_1.find)(entry.sources, function (s) { return !!s.node && (0, htmlDomUtils_1.isElementNode)(s.node); })) === null || _b === void 0 ? void 0 : _b.node;
                }
                else {
                    largestLayoutShiftTarget = undefined;
                }
            }
        },
        value: function () { return value; },
        largestLayoutShiftTarget: function () { return largestLayoutShiftTarget; },
        largestLayoutShiftTime: function () { return largestLayoutShiftTime; },
    };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
    return (0, performanceCollection_1.supportPerformanceTimingEvent)(performanceCollection_1.RumPerformanceEntryType.LAYOUT_SHIFT);
}
exports.isLayoutShiftSupported = isLayoutShiftSupported;
//# sourceMappingURL=trackCumulativeLayoutShift.js.map
},{"../../../browser/htmlDomUtils":97,"../../../browser/performanceCollection":99,"../../getSelectorFromElement":123,"@datadog/browser-core":56}],143:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFirstContentfulPaint = exports.FCP_MAXIMUM_DELAY = void 0;
var browser_core_1 = require("@datadog/browser-core");
var performanceCollection_1 = require("../../../browser/performanceCollection");
// Discard FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
exports.FCP_MAXIMUM_DELAY = 10 * browser_core_1.ONE_MINUTE;
function trackFirstContentfulPaint(lifeCycle, firstHidden, callback) {
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var fcpEntry = (0, browser_core_1.find)(entries, function (entry) {
            return entry.entryType === performanceCollection_1.RumPerformanceEntryType.PAINT &&
                entry.name === 'first-contentful-paint' &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < exports.FCP_MAXIMUM_DELAY;
        });
        if (fcpEntry) {
            callback(fcpEntry.startTime);
        }
    }).unsubscribe;
    return {
        stop: unsubscribeLifeCycle,
    };
}
exports.trackFirstContentfulPaint = trackFirstContentfulPaint;
//# sourceMappingURL=trackFirstContentfulPaint.js.map
},{"../../../browser/performanceCollection":99,"@datadog/browser-core":56}],144:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFirstHidden = void 0;
var browser_core_1 = require("@datadog/browser-core");
function trackFirstHidden(configuration, eventTarget) {
    if (eventTarget === void 0) { eventTarget = window; }
    var timeStamp;
    var stopListeners;
    if (document.visibilityState === 'hidden') {
        timeStamp = 0;
    }
    else {
        timeStamp = Infinity;
        (stopListeners = (0, browser_core_1.addEventListeners)(configuration, eventTarget, ["pagehide" /* DOM_EVENT.PAGE_HIDE */, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */], function (event) {
            if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */ || document.visibilityState === 'hidden') {
                timeStamp = event.timeStamp;
                stopListeners();
            }
        }, { capture: true }).stop);
    }
    return {
        get timeStamp() {
            return timeStamp;
        },
        stop: function () {
            stopListeners === null || stopListeners === void 0 ? void 0 : stopListeners();
        },
    };
}
exports.trackFirstHidden = trackFirstHidden;
//# sourceMappingURL=trackFirstHidden.js.map
},{"@datadog/browser-core":56}],145:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFirstInput = void 0;
var browser_core_1 = require("@datadog/browser-core");
var htmlDomUtils_1 = require("../../../browser/htmlDomUtils");
var performanceCollection_1 = require("../../../browser/performanceCollection");
var getSelectorFromElement_1 = require("../../getSelectorFromElement");
/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInput(lifeCycle, configuration, firstHidden, callback) {
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var firstInputEntry = (0, browser_core_1.find)(entries, function (entry) {
            return entry.entryType === performanceCollection_1.RumPerformanceEntryType.FIRST_INPUT && entry.startTime < firstHidden.timeStamp;
        });
        if (firstInputEntry) {
            var firstInputDelay = (0, browser_core_1.elapsed)(firstInputEntry.startTime, firstInputEntry.processingStart);
            var firstInputTargetSelector = void 0;
            if ((0, browser_core_1.isExperimentalFeatureEnabled)(browser_core_1.ExperimentalFeature.WEB_VITALS_ATTRIBUTION) &&
                firstInputEntry.target &&
                (0, htmlDomUtils_1.isElementNode)(firstInputEntry.target)) {
                firstInputTargetSelector = (0, getSelectorFromElement_1.getSelectorFromElement)(firstInputEntry.target, configuration.actionNameAttribute);
            }
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                delay: firstInputDelay >= 0 ? firstInputDelay : 0,
                time: firstInputEntry.startTime,
                targetSelector: firstInputTargetSelector,
            });
        }
    }).unsubscribe;
    return {
        stop: unsubscribeLifeCycle,
    };
}
exports.trackFirstInput = trackFirstInput;
//# sourceMappingURL=trackFirstInput.js.map
},{"../../../browser/htmlDomUtils":97,"../../../browser/performanceCollection":99,"../../getSelectorFromElement":123,"@datadog/browser-core":56}],146:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackInitialViewMetrics = void 0;
var trackFirstContentfulPaint_1 = require("./trackFirstContentfulPaint");
var trackFirstInput_1 = require("./trackFirstInput");
var trackNavigationTimings_1 = require("./trackNavigationTimings");
var trackLargestContentfulPaint_1 = require("./trackLargestContentfulPaint");
var trackFirstHidden_1 = require("./trackFirstHidden");
function trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate) {
    var initialViewMetrics = {};
    var stopNavigationTracking = (0, trackNavigationTimings_1.trackNavigationTimings)(lifeCycle, function (navigationTimings) {
        setLoadEvent(navigationTimings.loadEvent);
        initialViewMetrics.navigationTimings = navigationTimings;
        scheduleViewUpdate();
    }).stop;
    var firstHidden = (0, trackFirstHidden_1.trackFirstHidden)(configuration);
    var stopFCPTracking = (0, trackFirstContentfulPaint_1.trackFirstContentfulPaint)(lifeCycle, firstHidden, function (firstContentfulPaint) {
        initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
        scheduleViewUpdate();
    }).stop;
    var stopLCPTracking = (0, trackLargestContentfulPaint_1.trackLargestContentfulPaint)(lifeCycle, configuration, firstHidden, window, function (largestContentfulPaint) {
        initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
        scheduleViewUpdate();
    }).stop;
    var stopFIDTracking = (0, trackFirstInput_1.trackFirstInput)(lifeCycle, configuration, firstHidden, function (firstInput) {
        initialViewMetrics.firstInput = firstInput;
        scheduleViewUpdate();
    }).stop;
    function stop() {
        stopNavigationTracking();
        stopFCPTracking();
        stopLCPTracking();
        stopFIDTracking();
        firstHidden.stop();
    }
    return {
        stop: stop,
        initialViewMetrics: initialViewMetrics,
    };
}
exports.trackInitialViewMetrics = trackInitialViewMetrics;
//# sourceMappingURL=trackInitialViewMetrics.js.map
},{"./trackFirstContentfulPaint":143,"./trackFirstHidden":144,"./trackFirstInput":145,"./trackLargestContentfulPaint":148,"./trackNavigationTimings":150}],147:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInteractionToNextPaintSupported = exports.trackViewInteractionCount = exports.trackInteractionToNextPaint = void 0;
var browser_core_1 = require("@datadog/browser-core");
var performanceCollection_1 = require("../../../browser/performanceCollection");
var getSelectorFromElement_1 = require("../../getSelectorFromElement");
var htmlDomUtils_1 = require("../../../browser/htmlDomUtils");
var interactionCountPolyfill_1 = require("./interactionCountPolyfill");
// Arbitrary value to prevent unnecessary memory usage on views with lots of interactions.
var MAX_INTERACTION_ENTRIES = 10;
/**
 * Track the interaction to next paint (INP).
 * To avoid outliers, return the p98 worst interaction of the view.
 * Documentation: https://web.dev/inp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/onINP.ts
 */
function trackInteractionToNextPaint(configuration, viewStart, viewLoadingType, lifeCycle) {
    if (!isInteractionToNextPaintSupported() ||
        !(0, browser_core_1.isExperimentalFeatureEnabled)(browser_core_1.ExperimentalFeature.INTERACTION_TO_NEXT_PAINT)) {
        return {
            getInteractionToNextPaint: function () { return undefined; },
            stop: browser_core_1.noop,
        };
    }
    var getViewInteractionCount = trackViewInteractionCount(viewLoadingType).getViewInteractionCount;
    var longestInteractions = trackLongestInteractions(getViewInteractionCount);
    var interactionToNextPaint = -1;
    var interactionToNextPaintTargetSelector;
    var telemetryCollected = false;
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var _a;
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if ((entry.entryType === performanceCollection_1.RumPerformanceEntryType.EVENT ||
                entry.entryType === performanceCollection_1.RumPerformanceEntryType.FIRST_INPUT) &&
                entry.interactionId) {
                longestInteractions.process(entry);
            }
        }
        var newInteraction = longestInteractions.estimateP98Interaction();
        if (newInteraction) {
            interactionToNextPaint = newInteraction.duration;
            if (interactionToNextPaint > 10 * browser_core_1.ONE_MINUTE && !telemetryCollected) {
                telemetryCollected = true;
                (0, browser_core_1.addTelemetryDebug)('INP outlier', {
                    inp: interactionToNextPaint,
                    interaction: {
                        timeFromViewStart: (0, browser_core_1.elapsed)(viewStart.relative, newInteraction.startTime),
                        duration: newInteraction.duration,
                        startTime: newInteraction.startTime,
                        processingStart: newInteraction.processingStart,
                        processingEnd: newInteraction.processingEnd,
                        interactionId: newInteraction.interactionId,
                        name: newInteraction.name,
                        targetNodeName: (_a = newInteraction.target) === null || _a === void 0 ? void 0 : _a.nodeName,
                    },
                });
            }
            if ((0, browser_core_1.isExperimentalFeatureEnabled)(browser_core_1.ExperimentalFeature.WEB_VITALS_ATTRIBUTION) &&
                newInteraction.target &&
                (0, htmlDomUtils_1.isElementNode)(newInteraction.target)) {
                interactionToNextPaintTargetSelector = (0, getSelectorFromElement_1.getSelectorFromElement)(newInteraction.target, configuration.actionNameAttribute);
            }
            else {
                interactionToNextPaintTargetSelector = undefined;
            }
        }
    }).unsubscribe;
    return {
        getInteractionToNextPaint: function () {
            // If no INP duration where captured because of the performanceObserver 40ms threshold
            // but the view interaction count > 0 then report 0
            if (interactionToNextPaint >= 0) {
                return {
                    value: interactionToNextPaint,
                    targetSelector: interactionToNextPaintTargetSelector,
                };
            }
            else if (getViewInteractionCount()) {
                return {
                    value: 0,
                };
            }
        },
        stop: stop,
    };
}
exports.trackInteractionToNextPaint = trackInteractionToNextPaint;
function trackLongestInteractions(getViewInteractionCount) {
    var longestInteractions = [];
    function sortAndTrimLongestInteractions() {
        longestInteractions.sort(function (a, b) { return b.duration - a.duration; }).splice(MAX_INTERACTION_ENTRIES);
    }
    return {
        /**
         * Process the performance entry:
         * - if its duration is long enough, add the performance entry to the list of worst interactions
         * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
         */
        process: function (entry) {
            var interactionIndex = longestInteractions.findIndex(function (interaction) { return entry.interactionId === interaction.interactionId; });
            var minLongestInteraction = longestInteractions[longestInteractions.length - 1];
            if (interactionIndex !== -1) {
                if (entry.duration > longestInteractions[interactionIndex].duration) {
                    longestInteractions[interactionIndex] = entry;
                    sortAndTrimLongestInteractions();
                }
            }
            else if (longestInteractions.length < MAX_INTERACTION_ENTRIES ||
                entry.duration > minLongestInteraction.duration) {
                longestInteractions.push(entry);
                sortAndTrimLongestInteractions();
            }
        },
        /**
         * Compute the p98 longest interaction.
         * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
         */
        estimateP98Interaction: function () {
            var interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
            return longestInteractions[interactionIndex];
        },
    };
}
function trackViewInteractionCount(viewLoadingType) {
    (0, interactionCountPolyfill_1.initInteractionCountPolyfill)();
    var previousInteractionCount = viewLoadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */ ? 0 : (0, interactionCountPolyfill_1.getInteractionCount)();
    return {
        getViewInteractionCount: function () { return (0, interactionCountPolyfill_1.getInteractionCount)() - previousInteractionCount; },
    };
}
exports.trackViewInteractionCount = trackViewInteractionCount;
function isInteractionToNextPaintSupported() {
    return ((0, performanceCollection_1.supportPerformanceTimingEvent)(performanceCollection_1.RumPerformanceEntryType.EVENT) &&
        window.PerformanceEventTiming &&
        'interactionId' in PerformanceEventTiming.prototype);
}
exports.isInteractionToNextPaintSupported = isInteractionToNextPaintSupported;
//# sourceMappingURL=trackInteractionToNextPaint.js.map
},{"../../../browser/htmlDomUtils":97,"../../../browser/performanceCollection":99,"../../getSelectorFromElement":123,"./interactionCountPolyfill":140,"@datadog/browser-core":56}],148:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackLargestContentfulPaint = exports.LCP_MAXIMUM_DELAY = void 0;
var browser_core_1 = require("@datadog/browser-core");
var performanceCollection_1 = require("../../../browser/performanceCollection");
var getSelectorFromElement_1 = require("../../getSelectorFromElement");
// Discard LCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
exports.LCP_MAXIMUM_DELAY = 10 * browser_core_1.ONE_MINUTE;
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/onLCP.ts
 */
function trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, eventTarget, callback) {
    // Ignore entries that come after the first user interaction.  According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = (0, browser_core_1.addEventListeners)(configuration, eventTarget, ["pointerdown" /* DOM_EVENT.POINTER_DOWN */, "keydown" /* DOM_EVENT.KEY_DOWN */], function (event) {
        firstInteractionTimestamp = event.timeStamp;
    }, { capture: true, once: true }).stop;
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var lcpEntry = (0, browser_core_1.findLast)(entries, function (entry) {
            return entry.entryType === performanceCollection_1.RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT &&
                entry.startTime < firstInteractionTimestamp &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < exports.LCP_MAXIMUM_DELAY;
        });
        if (lcpEntry) {
            var lcpTargetSelector = void 0;
            if ((0, browser_core_1.isExperimentalFeatureEnabled)(browser_core_1.ExperimentalFeature.WEB_VITALS_ATTRIBUTION) && lcpEntry.element) {
                lcpTargetSelector = (0, getSelectorFromElement_1.getSelectorFromElement)(lcpEntry.element, configuration.actionNameAttribute);
            }
            callback({
                value: lcpEntry.startTime,
                targetSelector: lcpTargetSelector,
            });
        }
    }).unsubscribe;
    return {
        stop: function () {
            stopEventListener();
            unsubscribeLifeCycle();
        },
    };
}
exports.trackLargestContentfulPaint = trackLargestContentfulPaint;
//# sourceMappingURL=trackLargestContentfulPaint.js.map
},{"../../../browser/performanceCollection":99,"../../getSelectorFromElement":123,"@datadog/browser-core":56}],149:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackLoadingTime = void 0;
var browser_core_1 = require("@datadog/browser-core");
var waitPageActivityEnd_1 = require("../../waitPageActivityEnd");
function trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
    var isWaitingForLoadEvent = loadType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            callback(Math.max.apply(Math, loadingTimeCandidates));
        }
    }
    var stop = (0, waitPageActivityEnd_1.waitPageActivityEnd)(lifeCycle, domMutationObservable, configuration, function (event) {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) {
                loadingTimeCandidates.push((0, browser_core_1.elapsed)(viewStart.timeStamp, event.end));
            }
            invokeCallbackIfAllCandidatesAreReceived();
        }
    }).stop;
    return {
        stop: stop,
        setLoadEvent: function (loadEvent) {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        },
    };
}
exports.trackLoadingTime = trackLoadingTime;
//# sourceMappingURL=trackLoadingTime.js.map
},{"../../waitPageActivityEnd":152,"@datadog/browser-core":56}],150:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackNavigationTimings = void 0;
var browser_core_1 = require("@datadog/browser-core");
var performanceCollection_1 = require("../../../browser/performanceCollection");
function trackNavigationTimings(lifeCycle, callback) {
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === performanceCollection_1.RumPerformanceEntryType.NAVIGATION) {
                callback({
                    domComplete: entry.domComplete,
                    domContentLoaded: entry.domContentLoadedEventEnd,
                    domInteractive: entry.domInteractive,
                    loadEvent: entry.loadEventEnd,
                    // In some cases the value reported is negative or is larger
                    // than the current page time. Ignore these cases:
                    // https://github.com/GoogleChrome/web-vitals/issues/137
                    // https://github.com/GoogleChrome/web-vitals/issues/162
                    firstByte: entry.responseStart >= 0 && entry.responseStart <= (0, browser_core_1.relativeNow)() ? entry.responseStart : undefined,
                });
            }
        }
    }).unsubscribe;
    return { stop: stop };
}
exports.trackNavigationTimings = trackNavigationTimings;
//# sourceMappingURL=trackNavigationTimings.js.map
},{"../../../browser/performanceCollection":99,"@datadog/browser-core":56}],151:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createScrollValuesObservable = exports.computeScrollValues = exports.trackScrollMetrics = exports.THROTTLE_SCROLL_DURATION = void 0;
var browser_core_1 = require("@datadog/browser-core");
var scroll_1 = require("../../../browser/scroll");
var viewportObservable_1 = require("../../../browser/viewportObservable");
/** Arbitrary scroll throttle duration */
exports.THROTTLE_SCROLL_DURATION = browser_core_1.ONE_SECOND;
function trackScrollMetrics(configuration, viewStart, callback, scrollValues) {
    if (scrollValues === void 0) { scrollValues = createScrollValuesObservable(configuration); }
    var maxScrollDepth = 0;
    var maxScrollHeight = 0;
    var maxScrollHeightTime = 0;
    var subscription = scrollValues.subscribe(function (_a) {
        var scrollDepth = _a.scrollDepth, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight;
        var shouldUpdate = false;
        if (scrollDepth > maxScrollDepth) {
            maxScrollDepth = scrollDepth;
            shouldUpdate = true;
        }
        if (scrollHeight > maxScrollHeight) {
            maxScrollHeight = scrollHeight;
            var now = (0, browser_core_1.relativeNow)();
            maxScrollHeightTime = (0, browser_core_1.elapsed)(viewStart.relative, now);
            shouldUpdate = true;
        }
        if (shouldUpdate) {
            callback({
                maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
                maxDepthScrollTop: scrollTop,
                maxScrollHeight: maxScrollHeight,
                maxScrollHeightTime: maxScrollHeightTime,
            });
        }
    });
    return {
        stop: function () { return subscription.unsubscribe(); },
    };
}
exports.trackScrollMetrics = trackScrollMetrics;
function computeScrollValues() {
    var scrollTop = (0, scroll_1.getScrollY)();
    var height = (0, viewportObservable_1.getViewportDimension)().height;
    var scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
    var scrollDepth = Math.round(height + scrollTop);
    return {
        scrollHeight: scrollHeight,
        scrollDepth: scrollDepth,
        scrollTop: scrollTop,
    };
}
exports.computeScrollValues = computeScrollValues;
function createScrollValuesObservable(configuration, throttleDuration) {
    if (throttleDuration === void 0) { throttleDuration = exports.THROTTLE_SCROLL_DURATION; }
    var observable = new browser_core_1.Observable(function () {
        function notify() {
            observable.notify(computeScrollValues());
        }
        if (window.ResizeObserver) {
            var throttledNotify_1 = (0, browser_core_1.throttle)(notify, throttleDuration, {
                leading: false,
                trailing: true,
            });
            var observerTarget_1 = document.scrollingElement || document.documentElement;
            var resizeObserver_1 = new ResizeObserver((0, browser_core_1.monitor)(throttledNotify_1.throttled));
            resizeObserver_1.observe(observerTarget_1);
            var eventListener_1 = (0, browser_core_1.addEventListener)(configuration, window, "scroll" /* DOM_EVENT.SCROLL */, throttledNotify_1.throttled, {
                passive: true,
            });
            return function () {
                throttledNotify_1.cancel();
                resizeObserver_1.unobserve(observerTarget_1);
                eventListener_1.stop();
            };
        }
    });
    return observable;
}
exports.createScrollValuesObservable = createScrollValuesObservable;
//# sourceMappingURL=trackScrollMetrics.js.map
},{"../../../browser/scroll":100,"../../../browser/viewportObservable":101,"@datadog/browser-core":56}],152:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPageActivityObservable = exports.doWaitPageActivityEnd = exports.waitPageActivityEnd = exports.PAGE_ACTIVITY_END_DELAY = exports.PAGE_ACTIVITY_VALIDATION_DELAY = void 0;
var browser_core_1 = require("@datadog/browser-core");
var performanceCollection_1 = require("../browser/performanceCollection");
// Delay to wait for a page activity to validate the tracking process
exports.PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
exports.PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
    var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, configuration);
    return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
exports.waitPageActivityEnd = waitPageActivityEnd;
function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
    var pageActivityEndTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = (0, browser_core_1.setTimeout)((0, browser_core_1.monitor)(function () { return complete({ hadActivity: false }); }), exports.PAGE_ACTIVITY_VALIDATION_DELAY);
    var maxDurationTimeoutId = maxDuration !== undefined
        ? (0, browser_core_1.setTimeout)((0, browser_core_1.monitor)(function () { return complete({ hadActivity: true, end: (0, browser_core_1.timeStampNow)() }); }), maxDuration)
        : undefined;
    var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
        var isBusy = _a.isBusy;
        (0, browser_core_1.clearTimeout)(validationTimeoutId);
        (0, browser_core_1.clearTimeout)(pageActivityEndTimeoutId);
        var lastChangeTime = (0, browser_core_1.timeStampNow)();
        if (!isBusy) {
            pageActivityEndTimeoutId = (0, browser_core_1.setTimeout)((0, browser_core_1.monitor)(function () { return complete({ hadActivity: true, end: lastChangeTime }); }), exports.PAGE_ACTIVITY_END_DELAY);
        }
    });
    var stop = function () {
        hasCompleted = true;
        (0, browser_core_1.clearTimeout)(validationTimeoutId);
        (0, browser_core_1.clearTimeout)(pageActivityEndTimeoutId);
        (0, browser_core_1.clearTimeout)(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) {
            return;
        }
        stop();
        pageActivityEndCallback(event);
    }
    return { stop: stop };
}
exports.doWaitPageActivityEnd = doWaitPageActivityEnd;
function createPageActivityObservable(lifeCycle, domMutationObservable, configuration) {
    var observable = new browser_core_1.Observable(function () {
        var subscriptions = [];
        var firstRequestIndex;
        var pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
            if (entries.some(function (entry) { return entry.entryType === performanceCollection_1.RumPerformanceEntryType.RESOURCE && !isExcludedUrl(configuration, entry.name); })) {
                notifyPageActivity();
            }
        }), lifeCycle.subscribe(5 /* LifeCycleEventType.REQUEST_STARTED */, function (startEvent) {
            if (isExcludedUrl(configuration, startEvent.url)) {
                return;
            }
            if (firstRequestIndex === undefined) {
                firstRequestIndex = startEvent.requestIndex;
            }
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(6 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
            if (isExcludedUrl(configuration, request.url) ||
                firstRequestIndex === undefined ||
                // If the request started before the tracking start, ignore it
                request.requestIndex < firstRequestIndex) {
                return;
            }
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        var stopTrackingWindowOpen = trackWindowOpen(notifyPageActivity).stop;
        return function () {
            stopTrackingWindowOpen();
            subscriptions.forEach(function (s) { return s.unsubscribe(); });
        };
        function notifyPageActivity() {
            observable.notify({ isBusy: pendingRequestsCount > 0 });
        }
    });
    return observable;
}
exports.createPageActivityObservable = createPageActivityObservable;
function isExcludedUrl(configuration, requestUrl) {
    return (0, browser_core_1.matchList)(configuration.excludedActivityUrls, requestUrl);
}
function trackWindowOpen(callback) {
    return (0, browser_core_1.instrumentMethodAndCallOriginal)(window, 'open', { before: callback });
}
//# sourceMappingURL=waitPageActivityEnd.js.map
},{"../browser/performanceCollection":99,"@datadog/browser-core":56}],153:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionReplayUrl = exports.STABLE_ATTRIBUTES = exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = exports.getScrollY = exports.getScrollX = exports.getViewportDimension = exports.initViewportObservable = exports.getMutationObserverConstructor = exports.LifeCycle = exports.startRum = exports.makeRumPublicApi = void 0;
var rumPublicApi_1 = require("./boot/rumPublicApi");
Object.defineProperty(exports, "makeRumPublicApi", { enumerable: true, get: function () { return rumPublicApi_1.makeRumPublicApi; } });
var startRum_1 = require("./boot/startRum");
Object.defineProperty(exports, "startRum", { enumerable: true, get: function () { return startRum_1.startRum; } });
var lifeCycle_1 = require("./domain/lifeCycle");
Object.defineProperty(exports, "LifeCycle", { enumerable: true, get: function () { return lifeCycle_1.LifeCycle; } });
var domMutationObservable_1 = require("./browser/domMutationObservable");
Object.defineProperty(exports, "getMutationObserverConstructor", { enumerable: true, get: function () { return domMutationObservable_1.getMutationObserverConstructor; } });
var viewportObservable_1 = require("./browser/viewportObservable");
Object.defineProperty(exports, "initViewportObservable", { enumerable: true, get: function () { return viewportObservable_1.initViewportObservable; } });
Object.defineProperty(exports, "getViewportDimension", { enumerable: true, get: function () { return viewportObservable_1.getViewportDimension; } });
var scroll_1 = require("./browser/scroll");
Object.defineProperty(exports, "getScrollX", { enumerable: true, get: function () { return scroll_1.getScrollX; } });
Object.defineProperty(exports, "getScrollY", { enumerable: true, get: function () { return scroll_1.getScrollY; } });
var getActionNameFromElement_1 = require("./domain/action/getActionNameFromElement");
Object.defineProperty(exports, "DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE", { enumerable: true, get: function () { return getActionNameFromElement_1.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE; } });
var getSelectorFromElement_1 = require("./domain/getSelectorFromElement");
Object.defineProperty(exports, "STABLE_ATTRIBUTES", { enumerable: true, get: function () { return getSelectorFromElement_1.STABLE_ATTRIBUTES; } });
__exportStar(require("./browser/htmlDomUtils"), exports);
var getSessionReplayUrl_1 = require("./domain/getSessionReplayUrl");
Object.defineProperty(exports, "getSessionReplayUrl", { enumerable: true, get: function () { return getSessionReplayUrl_1.getSessionReplayUrl; } });
//# sourceMappingURL=index.js.map
},{"./boot/rumPublicApi":94,"./boot/startRum":95,"./browser/domMutationObservable":96,"./browser/htmlDomUtils":97,"./browser/scroll":100,"./browser/viewportObservable":101,"./domain/action/getActionNameFromElement":105,"./domain/getSelectorFromElement":123,"./domain/getSessionReplayUrl":124,"./domain/lifeCycle":125}],154:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRumBatch = void 0;
var browser_core_1 = require("@datadog/browser-core");
function startRumBatch(configuration, lifeCycle, telemetryEventObservable, reportError, pageExitObservable, sessionExpireObservable) {
    var replica = configuration.replica;
    var batch = (0, browser_core_1.startBatchWithReplica)(configuration, {
        endpoint: configuration.rumEndpointBuilder,
    }, replica && {
        endpoint: replica.rumEndpointBuilder,
        transformMessage: function (message) { return (0, browser_core_1.combine)(message, { application: { id: replica.applicationId } }); },
    }, reportError, pageExitObservable, sessionExpireObservable);
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        if (serverRumEvent.type === "view" /* RumEventType.VIEW */) {
            batch.upsert(serverRumEvent, serverRumEvent.view.id);
        }
        else {
            batch.add(serverRumEvent);
        }
    });
    telemetryEventObservable.subscribe(function (event) { return batch.add(event, (0, browser_core_1.isTelemetryReplicationAllowed)(configuration)); });
    return batch;
}
exports.startRumBatch = startRumBatch;
//# sourceMappingURL=startRumBatch.js.map
},{"@datadog/browser-core":56}],155:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRumEventBridge = void 0;
var browser_core_1 = require("@datadog/browser-core");
function startRumEventBridge(lifeCycle) {
    var bridge = (0, browser_core_1.getEventBridge)();
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        bridge.send('rum', serverRumEvent);
    });
}
exports.startRumEventBridge = startRumEventBridge;
//# sourceMappingURL=startRumEventBridge.js.map
},{"@datadog/browser-core":56}],156:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowserSupported = void 0;
/**
 * Test for Browser features used while recording
 */
function isBrowserSupported() {
    return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' &&
        typeof CSSSupportsRule === 'function' &&
        typeof URL.createObjectURL === 'function' &&
        'forEach' in NodeList.prototype);
}
exports.isBrowserSupported = isBrowserSupported;
//# sourceMappingURL=isBrowserSupported.js.map
},{}],157:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRecorderApi = void 0;
var browser_core_1 = require("@datadog/browser-core");
var replayStats_1 = require("../domain/replayStats");
var getSessionReplayLink_1 = require("../domain/getSessionReplayLink");
var deflate_1 = require("../domain/deflate");
var isBrowserSupported_1 = require("./isBrowserSupported");
function makeRecorderApi(startRecordingImpl, createDeflateWorkerImpl) {
    if ((0, browser_core_1.canUseEventBridge)() || !(0, isBrowserSupported_1.isBrowserSupported)()) {
        return {
            start: browser_core_1.noop,
            stop: browser_core_1.noop,
            getReplayStats: function () { return undefined; },
            onRumStart: browser_core_1.noop,
            isRecording: function () { return false; },
            getSessionReplayLink: function () { return undefined; },
        };
    }
    var state = {
        status: 0 /* RecorderStatus.Stopped */,
    };
    var startStrategy = function () {
        state = { status: 1 /* RecorderStatus.IntentToStart */ };
    };
    var stopStrategy = function () {
        state = { status: 0 /* RecorderStatus.Stopped */ };
    };
    return {
        start: function () { return startStrategy(); },
        stop: function () { return stopStrategy(); },
        getSessionReplayLink: function (configuration, sessionManager, viewContexts) {
            return (0, getSessionReplayLink_1.getSessionReplayLink)(configuration, sessionManager, viewContexts, state.status !== 0 /* RecorderStatus.Stopped */);
        },
        onRumStart: function (lifeCycle, configuration, sessionManager, viewContexts) {
            lifeCycle.subscribe(7 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
                if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
                    stopStrategy();
                    state = { status: 1 /* RecorderStatus.IntentToStart */ };
                }
            });
            lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
                if (state.status === 1 /* RecorderStatus.IntentToStart */) {
                    startStrategy();
                }
            });
            startStrategy = function () {
                var session = sessionManager.findTrackedSession();
                if (!session || !session.sessionReplayAllowed) {
                    state = { status: 1 /* RecorderStatus.IntentToStart */ };
                    return;
                }
                if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
                    return;
                }
                state = { status: 2 /* RecorderStatus.Starting */ };
                (0, browser_core_1.runOnReadyState)(configuration, 'interactive', function () {
                    if (state.status !== 2 /* RecorderStatus.Starting */) {
                        return;
                    }
                    var worker = (0, deflate_1.startDeflateWorker)(configuration, 'Datadog Session Replay', function () {
                        stopStrategy();
                    }, createDeflateWorkerImpl);
                    if (!worker) {
                        state = {
                            status: 0 /* RecorderStatus.Stopped */,
                        };
                        return;
                    }
                    var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, (0, deflate_1.createDeflateEncoder)(configuration, worker, 1 /* DeflateEncoderStreamId.REPLAY */)).stop;
                    state = {
                        status: 3 /* RecorderStatus.Started */,
                        stopRecording: stopRecording,
                    };
                });
            };
            stopStrategy = function () {
                if (state.status === 0 /* RecorderStatus.Stopped */) {
                    return;
                }
                if (state.status === 3 /* RecorderStatus.Started */) {
                    state.stopRecording();
                }
                state = {
                    status: 0 /* RecorderStatus.Stopped */,
                };
            };
            if (state.status === 1 /* RecorderStatus.IntentToStart */) {
                startStrategy();
            }
        },
        isRecording: function () {
            // The worker is started optimistically, meaning we could have started to record but its
            // initialization fails a bit later. This could happen when:
            // * the worker URL (blob or plain URL) is blocked by CSP in Firefox only (Chromium and Safari
            // throw an exception when instantiating the worker, and IE doesn't care about CSP)
            // * the browser fails to load the worker in case the workerUrl is used
            // * an unexpected error occurs in the Worker before initialization, ex:
            //   * a runtime exception collected by monitor()
            //   * a syntax error notified by the browser via an error event
            // * the worker is unresponsive for some reason and timeouts
            //
            // It is not expected to happen often. Nonetheless, the "replayable" status on RUM events is
            // an important part of the Datadog App:
            // * If we have a false positive (we set has_replay: true even if no replay data is present),
            // we might display broken links to the Session Replay player.
            // * If we have a false negative (we don't set has_replay: true even if replay data is
            // available), it is less noticeable because no link will be displayed.
            //
            // Thus, it is better to have false negative, so let's make sure the worker is correctly
            // initialized before advertizing that we are recording.
            //
            // In the future, when the compression worker will also be used for RUM data, this will be
            // less important since no RUM event will be sent when the worker fails to initialize.
            return (0, deflate_1.getDeflateWorkerStatus)() === 3 /* DeflateWorkerStatus.Initialized */ && state.status === 3 /* RecorderStatus.Started */;
        },
        getReplayStats: function (viewId) {
            return (0, deflate_1.getDeflateWorkerStatus)() === 3 /* DeflateWorkerStatus.Initialized */ ? (0, replayStats_1.getReplayStats)(viewId) : undefined;
        },
    };
}
exports.makeRecorderApi = makeRecorderApi;
//# sourceMappingURL=recorderApi.js.map
},{"../domain/deflate":162,"../domain/getSessionReplayLink":163,"../domain/replayStats":193,"./isBrowserSupported":156,"@datadog/browser-core":56}],158:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRecording = void 0;
var browser_core_1 = require("@datadog/browser-core");
var record_1 = require("../domain/record");
var segmentCollection_1 = require("../domain/segmentCollection");
var types_1 = require("../types");
function startRecording(lifeCycle, configuration, sessionManager, viewContexts, encoder, httpRequest) {
    var reportError = function (error) {
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error });
        (0, browser_core_1.addTelemetryDebug)('Error reported to customer', { 'error.message': error.message });
    };
    var replayRequest = httpRequest ||
        (0, browser_core_1.createHttpRequest)(configuration, configuration.sessionReplayEndpointBuilder, segmentCollection_1.SEGMENT_BYTES_LIMIT, reportError);
    var _a = (0, segmentCollection_1.startSegmentCollection)(lifeCycle, configuration, sessionManager, viewContexts, replayRequest, encoder), addRecord = _a.addRecord, stopSegmentCollection = _a.stop;
    var _b = (0, record_1.record)({
        emit: addRecord,
        configuration: configuration,
        lifeCycle: lifeCycle,
    }), stopRecording = _b.stop, takeSubsequentFullSnapshot = _b.takeSubsequentFullSnapshot, flushMutations = _b.flushMutations;
    var unsubscribeViewEnded = lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function () {
        flushMutations();
        addRecord({
            timestamp: (0, browser_core_1.timeStampNow)(),
            type: types_1.RecordType.ViewEnd,
        });
    }).unsubscribe;
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
        takeSubsequentFullSnapshot(view.startClocks.timeStamp);
    }).unsubscribe;
    return {
        stop: function () {
            unsubscribeViewEnded();
            unsubscribeViewCreated();
            stopRecording();
            stopSegmentCollection();
        },
    };
}
exports.startRecording = startRecording;
//# sourceMappingURL=startRecording.js.map
},{"../domain/record":167,"../domain/segmentCollection":195,"../types":199,"@datadog/browser-core":56}],159:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORM_PRIVATE_TAG_NAMES = exports.CENSORED_IMG_MARK = exports.CENSORED_STRING_MARK = exports.PRIVACY_CLASS_HIDDEN = exports.PRIVACY_CLASS_MASK_USER_INPUT = exports.PRIVACY_CLASS_MASK = exports.PRIVACY_CLASS_ALLOW = exports.PRIVACY_ATTR_VALUE_HIDDEN = exports.PRIVACY_ATTR_VALUE_MASK_USER_INPUT = exports.PRIVACY_ATTR_VALUE_MASK = exports.PRIVACY_ATTR_VALUE_ALLOW = exports.PRIVACY_ATTR_NAME = exports.NodePrivacyLevel = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.NodePrivacyLevel = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: browser_core_1.DefaultPrivacyLevel.ALLOW,
    MASK: browser_core_1.DefaultPrivacyLevel.MASK,
    MASK_USER_INPUT: browser_core_1.DefaultPrivacyLevel.MASK_USER_INPUT,
};
exports.PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Privacy Attrs
exports.PRIVACY_ATTR_VALUE_ALLOW = 'allow';
exports.PRIVACY_ATTR_VALUE_MASK = 'mask';
exports.PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
exports.PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
exports.PRIVACY_CLASS_ALLOW = 'dd-privacy-allow';
exports.PRIVACY_CLASS_MASK = 'dd-privacy-mask';
exports.PRIVACY_CLASS_MASK_USER_INPUT = 'dd-privacy-mask-user-input';
exports.PRIVACY_CLASS_HIDDEN = 'dd-privacy-hidden';
// Private Replacement Templates
exports.CENSORED_STRING_MARK = '***';
exports.CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
exports.FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};
//# sourceMappingURL=constants.js.map
},{"@datadog/browser-core":56}],160:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDeflateEncoder = void 0;
var browser_core_1 = require("@datadog/browser-core");
function createDeflateEncoder(configuration, worker, streamId) {
    var rawBytesCount = 0;
    var compressedData = [];
    var compressedDataTrailer;
    var nextWriteActionId = 0;
    var pendingWriteActions = [];
    var removeMessageListener = (0, browser_core_1.addEventListener)(configuration, worker, 'message', function (_a) {
        var data = _a.data;
        if (data.type !== 'wrote' || data.streamId !== streamId) {
            return;
        }
        var nextPendingAction = pendingWriteActions.shift();
        if (nextPendingAction && nextPendingAction.id === data.id) {
            if (data.id === 0) {
                // Initial state
                rawBytesCount = data.additionalBytesCount;
                compressedData = [data.result];
            }
            else {
                rawBytesCount += data.additionalBytesCount;
                compressedData.push(data.result);
            }
            compressedDataTrailer = data.trailer;
            nextPendingAction.callback();
        }
        else {
            removeMessageListener();
            (0, browser_core_1.addTelemetryDebug)('Worker responses received out of order.');
        }
    }).stop;
    return {
        get encodedBytes() {
            if (!compressedData.length) {
                return new Uint8Array(0);
            }
            return (0, browser_core_1.concatBuffers)(compressedData.concat(compressedDataTrailer));
        },
        get encodedBytesCount() {
            if (!compressedData.length) {
                return 0;
            }
            return compressedData.reduce(function (total, buffer) { return total + buffer.length; }, 0) + compressedDataTrailer.length;
        },
        get rawBytesCount() {
            return rawBytesCount;
        },
        write: function (data, callback) {
            worker.postMessage({
                action: 'write',
                id: nextWriteActionId,
                data: data,
                streamId: streamId,
            });
            pendingWriteActions.push({
                id: nextWriteActionId,
                callback: callback,
            });
            nextWriteActionId += 1;
        },
        reset: function () {
            worker.postMessage({
                action: 'reset',
                streamId: streamId,
            });
            nextWriteActionId = 0;
        },
        stop: function () {
            removeMessageListener();
        },
    };
}
exports.createDeflateEncoder = createDeflateEncoder;
//# sourceMappingURL=deflateEncoder.js.map
},{"@datadog/browser-core":56}],161:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doStartDeflateWorker = exports.getDeflateWorkerStatus = exports.resetDeflateWorkerState = exports.startDeflateWorker = exports.INITIALIZATION_TIME_OUT_DELAY = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.INITIALIZATION_TIME_OUT_DELAY = 10 * browser_core_1.ONE_SECOND;
function createDeflateWorker(configuration) {
    return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob(["!function(){\"use strict\";function t(t){for(var e=t.reduce((function(t,e){return t+e.length}),0),a=new Uint8Array(e),n=0,r=0,i=t;r<i.length;r++){var s=i[r];a.set(s,n),n+=s.length}return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,n=286,r=30,i=15,s=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),_=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),h=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),l=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),o=new Array(576);e(o);var d=new Array(60);e(d);var u=new Array(512);e(u);var f=new Array(256);e(f);var c=new Array(29);e(c);var p,g,w,v=new Array(r);function b(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function m(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(v);var y=function(t){return t<256?u[t]:u[256+(t>>>7)]},k=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},z=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,k(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},x=function(t,e,a){z(t,a[2*e],a[2*e+1])},A=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},E=function(t,e,a){var n,r,s=new Array(16),_=0;for(n=1;n<=i;n++)s[n]=_=_+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=A(s[h]++,h))}},Z=function(t){var e;for(e=0;e<n;e++)t.dyn_ltree[2*e]=0;for(e=0;e<r;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},U=function(t){t.bi_valid>8?k(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},S=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},R=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&S(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!S(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},L=function(t,e,n){var r,i,h,l,o=0;if(0!==t.last_lit)do{r=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],i=t.pending_buf[t.l_buf+o],o++,0===r?x(t,i,e):(h=f[i],x(t,h+a+1,e),0!==(l=s[h])&&(i-=c[h],z(t,i,l)),r--,h=y(r),x(t,h,n),0!==(l=_[h])&&(r-=v[h],z(t,r,l)))}while(o<t.last_lit);x(t,256,e)},F=function(t,e){var a,n,r,s=e.dyn_tree,_=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,o=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==s[2*a]?(t.heap[++t.heap_len]=o=a,t.depth[a]=0):s[2*a+1]=0;for(;t.heap_len<2;)s[2*(r=t.heap[++t.heap_len]=o<2?++o:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=_[2*r+1]);for(e.max_code=o,a=t.heap_len>>1;a>=1;a--)R(t,s,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],R(t,s,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,s[2*r]=s[2*a]+s[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,s[2*a+1]=s[2*n+1]=r,t.heap[1]=r++,R(t,s,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,s,_,h,l=e.dyn_tree,o=e.max_code,d=e.stat_desc.static_tree,u=e.stat_desc.has_stree,f=e.stat_desc.extra_bits,c=e.stat_desc.extra_base,p=e.stat_desc.max_length,g=0;for(s=0;s<=i;s++)t.bl_count[s]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(s=l[2*l[2*(n=t.heap[a])+1]+1]+1)>p&&(s=p,g++),l[2*n+1]=s,n>o||(t.bl_count[s]++,_=0,n>=c&&(_=f[n-c]),h=l[2*n],t.opt_len+=h*(s+_),u&&(t.static_len+=h*(d[2*n+1]+_)));if(0!==g){do{for(s=p-1;0===t.bl_count[s];)s--;t.bl_count[s]--,t.bl_count[s+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(s=p;0!==s;s--)for(n=t.bl_count[s];0!==n;)(r=t.heap[--a])>o||(l[2*r+1]!==s&&(t.opt_len+=(s-l[2*r+1])*l[2*r],l[2*r+1]=s),n--)}}(t,e),E(s,o,t.bl_count)},T=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++_<h&&r===s||(_<l?t.bl_tree[2*r]+=_:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):_<=10?t.bl_tree[34]++:t.bl_tree[36]++,_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4))},I=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++_<h&&r===s)){if(_<l)do{x(t,r,t.bl_tree)}while(0!=--_);else 0!==r?(r!==i&&(x(t,r,t.bl_tree),_--),x(t,16,t.bl_tree),z(t,_-3,2)):_<=10?(x(t,17,t.bl_tree),z(t,_-3,3)):(x(t,18,t.bl_tree),z(t,_-11,7));_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4)}},N=!1,O=function(t,e,a,n){z(t,0+(n?1:0),3),function(t,e,a,n){U(t),n&&(k(t,a),k(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a,!0)},D=function(t,e,n,r){var i,s,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,n=4093624447;for(e=0;e<=31;e++,n>>>=1)if(1&n&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),F(t,t.l_desc),F(t,t.d_desc),_=function(t){var e;for(T(t,t.dyn_ltree,t.l_desc.max_code),T(t,t.dyn_dtree,t.d_desc.max_code),F(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*l[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(s=t.static_len+3+7>>>3)<=i&&(i=s)):i=s=n+5,n+4<=i&&-1!==e?O(t,e,n,r):4===t.strategy||s===i?(z(t,2+(r?1:0),3),L(t,o,d)):(z(t,4+(r?1:0),3),function(t,e,a,n){var r;for(z(t,e-257,5),z(t,a-1,5),z(t,n-4,4),r=0;r<n;r++)z(t,t.bl_tree[2*l[r]+1],3);I(t,t.dyn_ltree,e-1),I(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),L(t,t.dyn_ltree,t.dyn_dtree)),Z(t),r&&U(t)},B={_tr_init:function(t){N||(!function(){var t,e,a,l,m,y=new Array(16);for(a=0,l=0;l<28;l++)for(c[l]=a,t=0;t<1<<s[l];t++)f[a++]=l;for(f[a-1]=l,m=0,l=0;l<16;l++)for(v[l]=m,t=0;t<1<<_[l];t++)u[m++]=l;for(m>>=7;l<r;l++)for(v[l]=m<<7,t=0;t<1<<_[l]-7;t++)u[256+m++]=l;for(e=0;e<=i;e++)y[e]=0;for(t=0;t<=143;)o[2*t+1]=8,t++,y[8]++;for(;t<=255;)o[2*t+1]=9,t++,y[9]++;for(;t<=279;)o[2*t+1]=7,t++,y[7]++;for(;t<=287;)o[2*t+1]=8,t++,y[8]++;for(E(o,287,y),t=0;t<r;t++)d[2*t+1]=5,d[2*t]=A(t,5);p=new b(o,s,257,n,i),g=new b(d,_,0,r,i),w=new b(new Array(0),h,0,19,7)}(),N=!0),t.l_desc=new m(t.dyn_ltree,p),t.d_desc=new m(t.dyn_dtree,g),t.bl_desc=new m(t.bl_tree,w),t.bi_buf=0,t.bi_valid=0,Z(t)},_tr_stored_block:O,_tr_flush_block:D,_tr_tally:function(t,e,n){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&n,t.last_lit++,0===e?t.dyn_ltree[2*n]++:(t.matches++,e--,t.dyn_ltree[2*(f[n]+a+1)]++,t.dyn_dtree[2*y(e)]++),t.last_lit===t.lit_bufsize-1},_tr_align:function(t){z(t,2,3),x(t,256,o),function(t){16===t.bi_valid?(k(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},C=function(t,e,a,n){for(var r=65535&t|0,i=t>>>16&65535|0,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16|0},H=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),M=function(t,e,a,n){var r=H,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},Y={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"},K={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8},P=B._tr_init,j=B._tr_stored_block,G=B._tr_flush_block,X=B._tr_tally,W=B._tr_align,q=K.Z_NO_FLUSH,J=K.Z_PARTIAL_FLUSH,Q=K.Z_FULL_FLUSH,V=K.Z_FINISH,$=K.Z_BLOCK,tt=K.Z_OK,et=K.Z_STREAM_END,at=K.Z_STREAM_ERROR,nt=K.Z_DATA_ERROR,rt=K.Z_BUF_ERROR,it=K.Z_DEFAULT_COMPRESSION,st=K.Z_FILTERED,_t=K.Z_HUFFMAN_ONLY,ht=K.Z_RLE,lt=K.Z_FIXED,ot=K.Z_DEFAULT_STRATEGY,dt=K.Z_UNKNOWN,ut=K.Z_DEFLATED,ft=258,ct=262,pt=103,gt=113,wt=666,vt=function(t,e){return t.msg=Y[e],e},bt=function(t){return(t<<1)-(t>4?9:0)},mt=function(t){for(var e=t.length;--e>=0;)t[e]=0},yt=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},kt=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},zt=function(t,e){G(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,kt(t.strm)},xt=function(t,e){t.pending_buf[t.pending++]=e},At=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},Et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,_=t.nice_match,h=t.strstart>t.w_size-ct?t.strstart-(t.w_size-ct):0,l=t.window,o=t.w_mask,d=t.prev,u=t.strstart+ft,f=l[i+s-1],c=l[i+s];t.prev_length>=t.good_match&&(r>>=2),_>t.lookahead&&(_=t.lookahead);do{if(l[(a=e)+s]===c&&l[a+s-1]===f&&l[a]===l[i]&&l[++a]===l[i+1]){i+=2,a++;do{}while(l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&i<u);if(n=ft-(u-i),i=u-ft,n>s){if(t.match_start=e,s=n,n>=_)break;f=l[i+s-1],c=l[i+s]}}}while((e=d[e&o])>h&&0!=--r);return s<=t.lookahead?s:t.lookahead},Zt=function(t){var e,a,n,r,i,s,_,h,l,o,d=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=d+(d-ct)){t.window.set(t.window.subarray(d,d+d),0),t.match_start-=d,t.strstart-=d,t.block_start-=d,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=d?n-d:0}while(--a);e=a=d;do{n=t.prev[--e],t.prev[e]=n>=d?n-d:0}while(--a);r+=d}if(0===t.strm.avail_in)break;if(s=t.strm,_=t.window,h=t.strstart+t.lookahead,l=r,o=void 0,(o=s.avail_in)>l&&(o=l),a=0===o?0:(s.avail_in-=o,_.set(s.input.subarray(s.next_in,s.next_in+o),h),1===s.state.wrap?s.adler=C(s.adler,_,o,h):2===s.state.wrap&&(s.adler=M(s.adler,_,o,h)),s.next_in+=o,s.total_in+=o,o),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=yt(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=yt(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<ct&&0!==t.strm.avail_in)},Ut=function(t,e){for(var a,n;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a)),t.match_length>=3)if(n=X(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=yt(t,t.ins_h,t.window[t.strstart+1]);else n=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2},St=function(t,e){for(var a,n,r;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a),t.match_length<=5&&(t.strategy===st||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=X(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(zt(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=X(t,0,t.window[t.strstart-1]))&&zt(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=X(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2};function Rt(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var Lt=[new Rt(0,0,0,0,(function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Zt(t),0===t.lookahead&&e===q)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,zt(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-ct&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(zt(t,!1),t.strm.avail_out),1)})),new Rt(4,4,8,4,Ut),new Rt(4,5,16,8,Ut),new Rt(4,6,32,32,Ut),new Rt(4,4,16,16,St),new Rt(8,16,32,32,St),new Rt(8,16,128,128,St),new Rt(8,32,128,256,St),new Rt(32,128,258,1024,St),new Rt(32,258,258,4096,St)];function Ft(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ut,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),mt(this.dyn_ltree),mt(this.dyn_dtree),mt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),mt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),mt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}var Tt=function(t){if(!t||!t.state)return vt(t,at);t.total_in=t.total_out=0,t.data_type=dt;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:gt,t.adler=2===e.wrap?0:1,e.last_flush=q,P(e),tt},It=function(t){var e,a=Tt(t);return a===tt&&((e=t.state).window_size=2*e.w_size,mt(e.head),e.max_lazy_match=Lt[e.level].max_lazy,e.good_match=Lt[e.level].good_length,e.nice_match=Lt[e.level].nice_length,e.max_chain_length=Lt[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),a},Nt=function(t,e,a,n,r,i){if(!t)return at;var s=1;if(e===it&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||a!==ut||n<8||n>15||e<0||e>9||i<0||i>lt)return vt(t,at);8===n&&(n=9);var _=new Ft;return t.state=_,_.strm=t,_.wrap=s,_.gzhead=null,_.w_bits=n,_.w_size=1<<_.w_bits,_.w_mask=_.w_size-1,_.hash_bits=r+7,_.hash_size=1<<_.hash_bits,_.hash_mask=_.hash_size-1,_.hash_shift=~~((_.hash_bits+3-1)/3),_.window=new Uint8Array(2*_.w_size),_.head=new Uint16Array(_.hash_size),_.prev=new Uint16Array(_.w_size),_.lit_bufsize=1<<r+6,_.pending_buf_size=4*_.lit_bufsize,_.pending_buf=new Uint8Array(_.pending_buf_size),_.d_buf=1*_.lit_bufsize,_.l_buf=3*_.lit_bufsize,_.level=e,_.strategy=i,_.method=a,It(t)},Ot={deflateInit:function(t,e){return Nt(t,e,ut,15,8,ot)},deflateInit2:Nt,deflateReset:It,deflateResetKeep:Tt,deflateSetHeader:function(t,e){return t&&t.state?2!==t.state.wrap?at:(t.state.gzhead=e,tt):at},deflate:function(t,e){var a,n;if(!t||!t.state||e>$||e<0)return t?vt(t,at):at;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===wt&&e!==V)return vt(t,0===t.avail_out?rt:at);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,xt(r,31),xt(r,139),xt(r,8),r.gzhead?(xt(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),xt(r,255&r.gzhead.time),xt(r,r.gzhead.time>>8&255),xt(r,r.gzhead.time>>16&255),xt(r,r.gzhead.time>>24&255),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(xt(r,255&r.gzhead.extra.length),xt(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=M(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,3),r.status=gt);else{var s=ut+(r.w_bits-8<<4)<<8;s|=(r.strategy>=_t||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(s|=32),s+=31-s%31,r.status=gt,At(r,s),0!==r.strstart&&(At(r,t.adler>>>16),At(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending!==r.pending_buf_size));)xt(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=pt)}else r.status=pt;if(r.status===pt&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&kt(t),r.pending+2<=r.pending_buf_size&&(xt(r,255&t.adler),xt(r,t.adler>>8&255),t.adler=0,r.status=gt)):r.status=gt),0!==r.pending){if(kt(t),0===t.avail_out)return r.last_flush=-1,tt}else if(0===t.avail_in&&bt(e)<=bt(i)&&e!==V)return vt(t,rt);if(r.status===wt&&0!==t.avail_in)return vt(t,rt);if(0!==t.avail_in||0!==r.lookahead||e!==q&&r.status!==wt){var _=r.strategy===_t?function(t,e){for(var a;;){if(0===t.lookahead&&(Zt(t),0===t.lookahead)){if(e===q)return 1;break}if(t.match_length=0,a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):r.strategy===ht?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=ft){if(Zt(t),t.lookahead<=ft&&e===q)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+ft;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=ft-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=X(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):Lt[r.level].func(r,e);if(3!==_&&4!==_||(r.status=wt),1===_||3===_)return 0===t.avail_out&&(r.last_flush=-1),tt;if(2===_&&(e===J?W(r):e!==$&&(j(r,0,0,!1),e===Q&&(mt(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),kt(t),0===t.avail_out))return r.last_flush=-1,tt}return e!==V?tt:r.wrap<=0?et:(2===r.wrap?(xt(r,255&t.adler),xt(r,t.adler>>8&255),xt(r,t.adler>>16&255),xt(r,t.adler>>24&255),xt(r,255&t.total_in),xt(r,t.total_in>>8&255),xt(r,t.total_in>>16&255),xt(r,t.total_in>>24&255)):(At(r,t.adler>>>16),At(r,65535&t.adler)),kt(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?tt:et)},deflateEnd:function(t){if(!t||!t.state)return at;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==pt&&e!==gt&&e!==wt?vt(t,at):(t.state=null,e===gt?vt(t,nt):tt)},deflateSetDictionary:function(t,e){var a=e.length;if(!t||!t.state)return at;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return at;if(1===r&&(t.adler=C(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(mt(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,_=t.next_in,h=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Zt(n);n.lookahead>=3;){var l=n.strstart,o=n.lookahead-2;do{n.ins_h=yt(n,n.ins_h,n.window[l+3-1]),n.prev[l&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=l,l++}while(--o);n.strstart=l,n.lookahead=2,Zt(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=_,t.input=h,t.avail_in=s,n.wrap=r,tt},deflateInfo:\"pako deflate (from Nodeca project)\"};for(var Dt=new Uint8Array(256),Bt=0;Bt<256;Bt++)Dt[Bt]=Bt>=252?6:Bt>=248?5:Bt>=240?4:Bt>=224?3:Bt>=192?2:1;Dt[254]=Dt[254]=1;var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0},Ht=Object.prototype.toString,Mt=K.Z_NO_FLUSH,Yt=K.Z_SYNC_FLUSH,Kt=K.Z_FULL_FLUSH,Pt=K.Z_FINISH,jt=K.Z_OK,Gt=K.Z_STREAM_END,Xt=K.Z_DEFAULT_COMPRESSION,Wt=K.Z_DEFAULT_STRATEGY,qt=K.Z_DEFLATED;function Jt(){this.options={level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;var e=Ot.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(e!==jt)throw new Error(Y[e]);if(t.header&&Ot.deflateSetHeader(this.strm,t.header),t.dictionary){var a;if(a=\"[object ArrayBuffer]\"===Ht.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(e=Ot.deflateSetDictionary(this.strm,a))!==jt)throw new Error(Y[e]);this._dict_set=!0}}function Qt(t,e,a){try{t.postMessage({type:\"errored\",error:e,streamId:a})}catch(n){t.postMessage({type:\"errored\",error:String(e),streamId:a})}}function Vt(t){var e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}Jt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?Pt:Mt,\"[object ArrayBuffer]\"===Ht.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(n===Yt||n===Kt)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if((a=Ot.deflate(r,n))===Gt)return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=Ot.deflateEnd(this.strm),this.onEnd(a),this.ended=!0,a===jt;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===jt&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,_=t.length;i<_;i++){var h=t[i];r.set(h,s),s+=h.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e){void 0===e&&(e=self);try{var a=new Map;e.addEventListener(\"message\",(function(n){try{var r=function(e,a){switch(a.action){case\"init\":return{type:\"initialized\",version:\"4.50.1\"};case\"write\":var n=e.get(a.streamId);n||(n=new Jt,e.set(a.streamId,n));var r=n.chunks.length,i=function(t){if(\"function\"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);var e,a,n,r,i,s=t.length,_=0;for(r=0;r<s;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),_+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(_),i=0,r=0;i<_;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,K.Z_SYNC_FLUSH),{type:\"wrote\",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:Vt(n),additionalBytesCount:i.length};case\"reset\":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){Qt(e,t,n.data&&\"streamId\"in n.data?n.data.streamId:void 0)}}))}catch(t){Qt(e,t)}}()}();"])));
}
var state = { status: 0 /* DeflateWorkerStatus.Nil */ };
function startDeflateWorker(configuration, source, onInitializationFailure, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    if (state.status === 0 /* DeflateWorkerStatus.Nil */) {
        // doStartDeflateWorker updates the state to "loading" or "error"
        doStartDeflateWorker(configuration, source, createDeflateWorkerImpl);
    }
    switch (state.status) {
        case 1 /* DeflateWorkerStatus.Loading */:
            state.initializationFailureCallbacks.push(onInitializationFailure);
            return state.worker;
        case 3 /* DeflateWorkerStatus.Initialized */:
            return state.worker;
    }
}
exports.startDeflateWorker = startDeflateWorker;
function resetDeflateWorkerState() {
    if (state.status === 3 /* DeflateWorkerStatus.Initialized */ || state.status === 1 /* DeflateWorkerStatus.Loading */) {
        state.stop();
    }
    state = { status: 0 /* DeflateWorkerStatus.Nil */ };
}
exports.resetDeflateWorkerState = resetDeflateWorkerState;
function getDeflateWorkerStatus() {
    return state.status;
}
exports.getDeflateWorkerStatus = getDeflateWorkerStatus;
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(configuration, source, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    try {
        var worker = createDeflateWorkerImpl(configuration);
        var removeErrorListener_1 = (0, browser_core_1.addEventListener)(configuration, worker, 'error', function (error) {
            onError(configuration, source, error);
        }).stop;
        var removeMessageListener_1 = (0, browser_core_1.addEventListener)(configuration, worker, 'message', function (_a) {
            var data = _a.data;
            if (data.type === 'errored') {
                onError(configuration, source, data.error, data.streamId);
            }
            else if (data.type === 'initialized') {
                onInitialized(data.version);
            }
        }).stop;
        worker.postMessage({ action: 'init' });
        (0, browser_core_1.setTimeout)(function () { return onTimeout(source); }, exports.INITIALIZATION_TIME_OUT_DELAY);
        var stop_1 = function () {
            removeErrorListener_1();
            removeMessageListener_1();
        };
        state = { status: 1 /* DeflateWorkerStatus.Loading */, worker: worker, stop: stop_1, initializationFailureCallbacks: [] };
    }
    catch (error) {
        onError(configuration, source, error);
    }
}
exports.doStartDeflateWorker = doStartDeflateWorker;
function onTimeout(source) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        browser_core_1.display.error("".concat(source, " failed to start: a timeout occurred while initializing the Worker"));
        state.initializationFailureCallbacks.forEach(function (callback) { return callback(); });
        state = { status: 2 /* DeflateWorkerStatus.Error */ };
    }
}
function onInitialized(version) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        state = { status: 3 /* DeflateWorkerStatus.Initialized */, worker: state.worker, stop: state.stop, version: version };
    }
}
function onError(configuration, source, error, streamId) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */ || state.status === 0 /* DeflateWorkerStatus.Nil */) {
        browser_core_1.display.error("".concat(source, " failed to start: an error occurred while creating the Worker:"), error);
        if (error instanceof Event || (error instanceof Error && isMessageCspRelated(error.message))) {
            var baseMessage = void 0;
            if (configuration.workerUrl) {
                baseMessage = "Please make sure the Worker URL ".concat(configuration.workerUrl, " is correct and CSP is correctly configured.");
            }
            else {
                baseMessage = 'Please make sure CSP is correctly configured.';
            }
            browser_core_1.display.error("".concat(baseMessage, " See documentation at https://docs.datadoghq.com/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay"));
        }
        else {
            (0, browser_core_1.addTelemetryError)(error);
        }
        if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
            state.initializationFailureCallbacks.forEach(function (callback) { return callback(); });
        }
        state = { status: 2 /* DeflateWorkerStatus.Error */ };
    }
    else {
        (0, browser_core_1.addTelemetryError)(error, {
            worker_version: state.status === 3 /* DeflateWorkerStatus.Initialized */ && state.version,
            stream_id: streamId,
        });
    }
}
function isMessageCspRelated(message) {
    return ((0, browser_core_1.includes)(message, 'Content Security Policy') ||
        // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
        (0, browser_core_1.includes)(message, "requires 'TrustedScriptURL'"));
}
//# sourceMappingURL=deflateWorker.js.map
},{"@datadog/browser-core":56}],162:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetDeflateWorkerState = exports.getDeflateWorkerStatus = exports.startDeflateWorker = exports.createDeflateEncoder = void 0;
var deflateEncoder_1 = require("./deflateEncoder");
Object.defineProperty(exports, "createDeflateEncoder", { enumerable: true, get: function () { return deflateEncoder_1.createDeflateEncoder; } });
var deflateWorker_1 = require("./deflateWorker");
Object.defineProperty(exports, "startDeflateWorker", { enumerable: true, get: function () { return deflateWorker_1.startDeflateWorker; } });
Object.defineProperty(exports, "getDeflateWorkerStatus", { enumerable: true, get: function () { return deflateWorker_1.getDeflateWorkerStatus; } });
Object.defineProperty(exports, "resetDeflateWorkerState", { enumerable: true, get: function () { return deflateWorker_1.resetDeflateWorkerState; } });
//# sourceMappingURL=index.js.map
},{"./deflateEncoder":160,"./deflateWorker":161}],163:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionReplayLink = void 0;
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var isBrowserSupported_1 = require("../boot/isBrowserSupported");
function getSessionReplayLink(configuration, sessionManager, viewContexts, isRecordingStarted) {
    var session = sessionManager.findTrackedSession();
    var errorType = getErrorType(session, isRecordingStarted);
    var viewContext = viewContexts.findView();
    return (0, browser_rum_core_1.getSessionReplayUrl)(configuration, {
        viewContext: viewContext,
        errorType: errorType,
        session: session,
    });
}
exports.getSessionReplayLink = getSessionReplayLink;
function getErrorType(session, isRecordingStarted) {
    if (!(0, isBrowserSupported_1.isBrowserSupported)()) {
        return 'browser-not-supported';
    }
    if (!session) {
        // possibilities:
        // - rum sampled out
        // - session expired (edge case)
        return 'rum-not-tracked';
    }
    if (!session.sessionReplayAllowed) {
        // possibilities
        // - replay sampled out
        return 'incorrect-session-plan';
    }
    if (!isRecordingStarted) {
        return 'replay-not-started';
    }
}
//# sourceMappingURL=getSessionReplayLink.js.map
},{"../boot/isBrowserSupported":156,"@datadog/browser-rum-core":153}],164:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assembleIncrementalSnapshot = void 0;
var browser_core_1 = require("@datadog/browser-core");
var types_1 = require("../../types");
function assembleIncrementalSnapshot(source, data) {
    return {
        data: (0, browser_core_1.assign)({
            source: source,
        }, data),
        type: types_1.RecordType.IncrementalSnapshot,
        timestamp: (0, browser_core_1.timeStampNow)(),
    };
}
exports.assembleIncrementalSnapshot = assembleIncrementalSnapshot;
//# sourceMappingURL=assembly.js.map
},{"../../types":199,"@datadog/browser-core":56}],165:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createElementsScrollPositions = void 0;
function createElementsScrollPositions() {
    var scrollPositionsByElement = new WeakMap();
    return {
        set: function (element, scrollPositions) {
            if (element === document && !document.scrollingElement) {
                // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
                // in some cases scrolling elements can not be defined, we don't support those for now
                return;
            }
            scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
        },
        get: function (element) {
            return scrollPositionsByElement.get(element);
        },
        has: function (element) {
            return scrollPositionsByElement.has(element);
        },
    };
}
exports.createElementsScrollPositions = createElementsScrollPositions;
//# sourceMappingURL=elementsScrollPositions.js.map
},{}],166:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventTarget = exports.isTouchEvent = void 0;
var browser_rum_core_1 = require("@datadog/browser-rum-core");
function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
exports.isTouchEvent = isTouchEvent;
function getEventTarget(event) {
    if (event.composed === true && (0, browser_rum_core_1.isNodeShadowHost)(event.target)) {
        return event.composedPath()[0];
    }
    return event.target;
}
exports.getEventTarget = getEventTarget;
//# sourceMappingURL=eventsUtils.js.map
},{"@datadog/browser-rum-core":153}],167:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createElementsScrollPositions = exports.serializeDocument = exports.serializeNodeWithId = exports.record = void 0;
var record_1 = require("./record");
Object.defineProperty(exports, "record", { enumerable: true, get: function () { return record_1.record; } });
var serialization_1 = require("./serialization");
Object.defineProperty(exports, "serializeNodeWithId", { enumerable: true, get: function () { return serialization_1.serializeNodeWithId; } });
Object.defineProperty(exports, "serializeDocument", { enumerable: true, get: function () { return serialization_1.serializeDocument; } });
var elementsScrollPositions_1 = require("./elementsScrollPositions");
Object.defineProperty(exports, "createElementsScrollPositions", { enumerable: true, get: function () { return elementsScrollPositions_1.createElementsScrollPositions; } });
//# sourceMappingURL=index.js.map
},{"./elementsScrollPositions":165,"./record":183,"./serialization":184}],168:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMutationBatch = void 0;
var browser_core_1 = require("@datadog/browser-core");
/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
function createMutationBatch(processMutationBatch) {
    var cancelScheduledFlush = browser_core_1.noop;
    var pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    return {
        addMutations: function (mutations) {
            if (pendingMutations.length === 0) {
                cancelScheduledFlush = requestIdleCallback(flush, { timeout: MUTATION_PROCESS_MAX_DELAY });
            }
            pendingMutations.push.apply(pendingMutations, mutations);
        },
        flush: flush,
        stop: function () {
            cancelScheduledFlush();
        },
    };
}
exports.createMutationBatch = createMutationBatch;
/**
 * Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
 * browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
 * fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
 * browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes efficiently.
 *
 * Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
 */
function requestIdleCallback(callback, opts) {
    if (window.requestIdleCallback && window.cancelIdleCallback) {
        var id_1 = window.requestIdleCallback((0, browser_core_1.monitor)(callback), opts);
        return function () { return window.cancelIdleCallback(id_1); };
    }
    var id = window.requestAnimationFrame((0, browser_core_1.monitor)(callback));
    return function () { return window.cancelAnimationFrame(id); };
}
//# sourceMappingURL=mutationBatch.js.map
},{"@datadog/browser-core":56}],169:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFocusObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
function initFocusObserver(configuration, focusCb) {
    return (0, browser_core_1.addEventListeners)(configuration, window, ["focus" /* DOM_EVENT.FOCUS */, "blur" /* DOM_EVENT.BLUR */], function () {
        focusCb({ has_focus: document.hasFocus() });
    }).stop;
}
exports.initFocusObserver = initFocusObserver;
//# sourceMappingURL=focusObserver.js.map
},{"@datadog/browser-core":56}],170:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFrustrationObserver = void 0;
var types_1 = require("../../../types");
function initFrustrationObserver(lifeCycle, frustrationCb, recordIds) {
    return lifeCycle.subscribe(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (data) {
        var _a, _b, _c;
        if (data.rawRumEvent.type === "action" /* RumEventType.ACTION */ &&
            data.rawRumEvent.action.type === "click" /* ActionType.CLICK */ &&
            ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) &&
            'events' in data.domainContext &&
            ((_c = data.domainContext.events) === null || _c === void 0 ? void 0 : _c.length)) {
            frustrationCb({
                timestamp: data.rawRumEvent.date,
                type: types_1.RecordType.FrustrationRecord,
                data: {
                    frustrationTypes: data.rawRumEvent.action.frustration.type,
                    recordIds: data.domainContext.events.map(function (e) { return recordIds.getIdForEvent(e); }),
                },
            });
        }
    }).unsubscribe;
}
exports.initFrustrationObserver = initFrustrationObserver;
//# sourceMappingURL=frustrationObserver.js.map
},{"../../../types":199}],171:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMutationObserver = exports.initInputObserver = exports.initObservers = void 0;
var observers_1 = require("./observers");
Object.defineProperty(exports, "initObservers", { enumerable: true, get: function () { return observers_1.initObservers; } });
var inputObserver_1 = require("./inputObserver");
Object.defineProperty(exports, "initInputObserver", { enumerable: true, get: function () { return inputObserver_1.initInputObserver; } });
var mutationObserver_1 = require("./mutationObserver");
Object.defineProperty(exports, "initMutationObserver", { enumerable: true, get: function () { return mutationObserver_1.initMutationObserver; } });
//# sourceMappingURL=index.js.map
},{"./inputObserver":172,"./mutationObserver":176,"./observers":177}],172:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initInputObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var constants_1 = require("../../../constants");
var eventsUtils_1 = require("../eventsUtils");
var privacy_1 = require("../privacy");
var serialization_1 = require("../serialization");
function initInputObserver(configuration, cb, target) {
    if (target === void 0) { target = document; }
    var defaultPrivacyLevel = configuration.defaultPrivacyLevel;
    var lastInputStateMap = new WeakMap();
    var isShadowRoot = target !== document;
    var stopEventListeners = (0, browser_core_1.addEventListeners)(configuration, target, 
    // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
    // roots since it will be handled by the event listener that we did add to the document. Only
    // the 'change' event is blocked and needs to be handled on shadow roots.
    isShadowRoot ? ["change" /* DOM_EVENT.CHANGE */] : ["input" /* DOM_EVENT.INPUT */, "change" /* DOM_EVENT.CHANGE */], function (event) {
        var target = (0, eventsUtils_1.getEventTarget)(event);
        if (target instanceof HTMLInputElement ||
            target instanceof HTMLTextAreaElement ||
            target instanceof HTMLSelectElement) {
            onElementChange(target);
        }
    }, {
        capture: true,
        passive: true,
    }).stop;
    var stopPropertySetterInstrumentation;
    if (!isShadowRoot) {
        var instrumentationStoppers_1 = [
            (0, browser_core_1.instrumentSetter)(HTMLInputElement.prototype, 'value', onElementChange),
            (0, browser_core_1.instrumentSetter)(HTMLInputElement.prototype, 'checked', onElementChange),
            (0, browser_core_1.instrumentSetter)(HTMLSelectElement.prototype, 'value', onElementChange),
            (0, browser_core_1.instrumentSetter)(HTMLTextAreaElement.prototype, 'value', onElementChange),
            (0, browser_core_1.instrumentSetter)(HTMLSelectElement.prototype, 'selectedIndex', onElementChange),
        ];
        stopPropertySetterInstrumentation = function () {
            instrumentationStoppers_1.forEach(function (stopper) { return stopper.stop(); });
        };
    }
    else {
        stopPropertySetterInstrumentation = browser_core_1.noop;
    }
    return function () {
        stopPropertySetterInstrumentation();
        stopEventListeners();
    };
    function onElementChange(target) {
        var nodePrivacyLevel = (0, privacy_1.getNodePrivacyLevel)(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
            return;
        }
        var type = target.type;
        var inputState;
        if (type === 'radio' || type === 'checkbox') {
            if ((0, privacy_1.shouldMaskNode)(target, nodePrivacyLevel)) {
                return;
            }
            inputState = { isChecked: target.checked };
        }
        else {
            var value = (0, serialization_1.getElementInputValue)(target, nodePrivacyLevel);
            if (value === undefined) {
                return;
            }
            inputState = { text: value };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        var name = target.name;
        if (type === 'radio' && name && target.checked) {
            (0, browser_core_1.forEach)(document.querySelectorAll("input[type=\"radio\"][name=\"".concat((0, browser_core_1.cssEscape)(name), "\"]")), function (el) {
                if (el !== target) {
                    // TODO: Consider the privacy implications for various differing input privacy levels
                    cbWithDedup(el, { isChecked: false });
                }
            });
        }
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */
    function cbWithDedup(target, inputState) {
        if (!(0, serialization_1.hasSerializedNode)(target)) {
            return;
        }
        var lastInputState = lastInputStateMap.get(target);
        if (!lastInputState ||
            lastInputState.text !== inputState.text ||
            lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            cb((0, browser_core_1.assign)({
                id: (0, serialization_1.getSerializedNodeId)(target),
            }, inputState));
        }
    }
}
exports.initInputObserver = initInputObserver;
//# sourceMappingURL=inputObserver.js.map
},{"../../../constants":159,"../eventsUtils":166,"../privacy":182,"../serialization":184,"@datadog/browser-core":56}],173:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMediaInteractionObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var constants_1 = require("../../../constants");
var types_1 = require("../../../types");
var eventsUtils_1 = require("../eventsUtils");
var privacy_1 = require("../privacy");
var serialization_1 = require("../serialization");
function initMediaInteractionObserver(configuration, mediaInteractionCb, defaultPrivacyLevel) {
    return (0, browser_core_1.addEventListeners)(configuration, document, ["play" /* DOM_EVENT.PLAY */, "pause" /* DOM_EVENT.PAUSE */], function (event) {
        var target = (0, eventsUtils_1.getEventTarget)(event);
        if (!target ||
            (0, privacy_1.getNodePrivacyLevel)(target, defaultPrivacyLevel) === constants_1.NodePrivacyLevel.HIDDEN ||
            !(0, serialization_1.hasSerializedNode)(target)) {
            return;
        }
        mediaInteractionCb({
            id: (0, serialization_1.getSerializedNodeId)(target),
            type: event.type === "play" /* DOM_EVENT.PLAY */ ? types_1.MediaInteractionType.Play : types_1.MediaInteractionType.Pause,
        });
    }, {
        capture: true,
        passive: true,
    }).stop;
}
exports.initMediaInteractionObserver = initMediaInteractionObserver;
//# sourceMappingURL=mediaInteractionObserver.js.map
},{"../../../constants":159,"../../../types":199,"../eventsUtils":166,"../privacy":182,"../serialization":184,"@datadog/browser-core":56}],174:[function(require,module,exports){
"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMouseInteractionObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var constants_1 = require("../../../constants");
var types_1 = require("../../../types");
var assembly_1 = require("../assembly");
var eventsUtils_1 = require("../eventsUtils");
var privacy_1 = require("../privacy");
var serialization_1 = require("../serialization");
var moveObserver_1 = require("./moveObserver");
var eventTypeToMouseInteraction = (_a = {},
    // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
    // allows to reference such records from Frustration records.
    //
    // In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
    // used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
    // `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
    // convey such interaction. This would cleanly solve the issue since we would have
    // `PointerInteraction/Up` records that we could reference from `Frustration` records.
    _a["pointerup" /* DOM_EVENT.POINTER_UP */] = types_1.MouseInteractionType.MouseUp,
    _a["mousedown" /* DOM_EVENT.MOUSE_DOWN */] = types_1.MouseInteractionType.MouseDown,
    _a["click" /* DOM_EVENT.CLICK */] = types_1.MouseInteractionType.Click,
    _a["contextmenu" /* DOM_EVENT.CONTEXT_MENU */] = types_1.MouseInteractionType.ContextMenu,
    _a["dblclick" /* DOM_EVENT.DBL_CLICK */] = types_1.MouseInteractionType.DblClick,
    _a["focus" /* DOM_EVENT.FOCUS */] = types_1.MouseInteractionType.Focus,
    _a["blur" /* DOM_EVENT.BLUR */] = types_1.MouseInteractionType.Blur,
    _a["touchstart" /* DOM_EVENT.TOUCH_START */] = types_1.MouseInteractionType.TouchStart,
    _a["touchend" /* DOM_EVENT.TOUCH_END */] = types_1.MouseInteractionType.TouchEnd,
    _a);
function initMouseInteractionObserver(configuration, cb, recordIds) {
    var handler = function (event) {
        var target = (0, eventsUtils_1.getEventTarget)(event);
        if ((0, privacy_1.getNodePrivacyLevel)(target, configuration.defaultPrivacyLevel) === constants_1.NodePrivacyLevel.HIDDEN ||
            !(0, serialization_1.hasSerializedNode)(target)) {
            return;
        }
        var id = (0, serialization_1.getSerializedNodeId)(target);
        var type = eventTypeToMouseInteraction[event.type];
        var interaction;
        if (type !== types_1.MouseInteractionType.Blur && type !== types_1.MouseInteractionType.Focus) {
            var coordinates = (0, moveObserver_1.tryToComputeCoordinates)(event);
            if (!coordinates) {
                return;
            }
            interaction = { id: id, type: type, x: coordinates.x, y: coordinates.y };
        }
        else {
            interaction = { id: id, type: type };
        }
        var record = (0, browser_core_1.assign)({ id: recordIds.getIdForEvent(event) }, (0, assembly_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.MouseInteraction, interaction));
        cb(record);
    };
    return (0, browser_core_1.addEventListeners)(configuration, document, Object.keys(eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true,
    }).stop;
}
exports.initMouseInteractionObserver = initMouseInteractionObserver;
//# sourceMappingURL=mouseInteractionObserver.js.map
},{"../../../constants":159,"../../../types":199,"../assembly":164,"../eventsUtils":166,"../privacy":182,"../serialization":184,"./moveObserver":175,"@datadog/browser-core":56}],175:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryToComputeCoordinates = exports.initMoveObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var serialization_1 = require("../serialization");
var types_1 = require("../../../types");
var eventsUtils_1 = require("../eventsUtils");
var viewports_1 = require("../viewports");
var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function initMoveObserver(configuration, cb) {
    var updatePosition = (0, browser_core_1.throttle)(function (event) {
        var target = (0, eventsUtils_1.getEventTarget)(event);
        if ((0, serialization_1.hasSerializedNode)(target)) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            var position = {
                id: (0, serialization_1.getSerializedNodeId)(target),
                timeOffset: 0,
                x: coordinates.x,
                y: coordinates.y,
            };
            cb([position], (0, eventsUtils_1.isTouchEvent)(event) ? types_1.IncrementalSource.TouchMove : types_1.IncrementalSource.MouseMove);
        }
    }, MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false,
    }).throttled;
    return (0, browser_core_1.addEventListeners)(configuration, document, ["mousemove" /* DOM_EVENT.MOUSE_MOVE */, "touchmove" /* DOM_EVENT.TOUCH_MOVE */], updatePosition, {
        capture: true,
        passive: true,
    }).stop;
}
exports.initMoveObserver = initMoveObserver;
function tryToComputeCoordinates(event) {
    var _a = (0, eventsUtils_1.isTouchEvent)(event) ? event.changedTouches[0] : event, x = _a.clientX, y = _a.clientY;
    if (window.visualViewport) {
        var _b = (0, viewports_1.convertMouseEventToLayoutCoordinates)(x, y), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
        x = visualViewportX;
        y = visualViewportY;
    }
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
        if (event.isTrusted) {
            (0, browser_core_1.addTelemetryDebug)('mouse/touch event without x/y');
        }
        return undefined;
    }
    return { x: x, y: y };
}
exports.tryToComputeCoordinates = tryToComputeCoordinates;
//# sourceMappingURL=moveObserver.js.map
},{"../../../types":199,"../eventsUtils":166,"../serialization":184,"../viewports":192,"@datadog/browser-core":56}],176:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortAddedAndMovedNodes = exports.initMutationObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var constants_1 = require("../../../constants");
var privacy_1 = require("../privacy");
var serialization_1 = require("../serialization");
var mutationBatch_1 = require("../mutationBatch");
/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function initMutationObserver(mutationCallback, configuration, shadowRootsController, target) {
    var MutationObserver = (0, browser_rum_core_1.getMutationObserverConstructor)();
    if (!MutationObserver) {
        return { stop: browser_core_1.noop, flush: browser_core_1.noop };
    }
    var mutationBatch = (0, mutationBatch_1.createMutationBatch)(function (mutations) {
        processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController);
    });
    var observer = new MutationObserver((0, browser_core_1.monitor)(mutationBatch.addMutations));
    observer.observe(target, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    return {
        stop: function () {
            observer.disconnect();
            mutationBatch.stop();
        },
        flush: function () {
            mutationBatch.flush();
        },
    };
}
exports.initMutationObserver = initMutationObserver;
function processMutations(mutations, mutationCallback, configuration, shadowRootsController) {
    mutations
        .filter(function (mutation) { return mutation.type === 'childList'; })
        .forEach(function (mutation) {
        mutation.removedNodes.forEach(function (removedNode) {
            traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
        });
    });
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    var filteredMutations = mutations.filter(function (mutation) {
        return mutation.target.isConnected &&
            (0, serialization_1.nodeAndAncestorsHaveSerializedNode)(mutation.target) &&
            (0, privacy_1.getNodePrivacyLevel)(mutation.target, configuration.defaultPrivacyLevel) !== constants_1.NodePrivacyLevel.HIDDEN;
    });
    var _a = processChildListMutations(filteredMutations.filter(function (mutation) { return mutation.type === 'childList'; }), configuration, shadowRootsController), adds = _a.adds, removes = _a.removes, hasBeenSerialized = _a.hasBeenSerialized;
    var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
    }), configuration);
    var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
    }), configuration);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) {
        return;
    }
    mutationCallback({
        adds: adds,
        removes: removes,
        texts: texts,
        attributes: attributes,
    });
}
function processChildListMutations(mutations, configuration, shadowRootsController) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    var addedAndMovedNodes = new Set();
    var removedNodes = new Map();
    var _loop_1 = function (mutation) {
        mutation.addedNodes.forEach(function (node) {
            addedAndMovedNodes.add(node);
        });
        mutation.removedNodes.forEach(function (node) {
            if (!addedAndMovedNodes.has(node)) {
                removedNodes.set(node, mutation.target);
            }
            addedAndMovedNodes.delete(node);
        });
    };
    for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
        var mutation = mutations_1[_i];
        _loop_1(mutation);
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    var serializedNodeIds = new Set();
    var addedNodeMutations = [];
    for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
        var node = sortedAddedAndMovedNodes_1[_a];
        if (hasBeenSerialized(node)) {
            continue;
        }
        var parentNodePrivacyLevel = (0, privacy_1.getNodePrivacyLevel)(node.parentNode, configuration.defaultPrivacyLevel);
        if (parentNodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === constants_1.NodePrivacyLevel.IGNORE) {
            continue;
        }
        var serializedNode = (0, serialization_1.serializeNodeWithId)(node, {
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
            serializationContext: { status: 2 /* SerializationContextStatus.MUTATION */, shadowRootsController: shadowRootsController },
            configuration: configuration,
        });
        if (!serializedNode) {
            continue;
        }
        var parentNode = (0, browser_rum_core_1.getParentNode)(node);
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: (0, serialization_1.getSerializedNodeId)(parentNode),
            node: serializedNode,
        });
    }
    // Finally, we emit remove mutations.
    var removedNodeMutations = [];
    removedNodes.forEach(function (parent, node) {
        if ((0, serialization_1.hasSerializedNode)(node)) {
            removedNodeMutations.push({
                parentId: (0, serialization_1.getSerializedNodeId)(parent),
                id: (0, serialization_1.getSerializedNodeId)(node),
            });
        }
    });
    return { adds: addedNodeMutations, removes: removedNodeMutations, hasBeenSerialized: hasBeenSerialized };
    function hasBeenSerialized(node) {
        return (0, serialization_1.hasSerializedNode)(node) && serializedNodeIds.has((0, serialization_1.getSerializedNodeId)(node));
    }
    function getNextSibling(node) {
        var nextSibling = node.nextSibling;
        while (nextSibling) {
            if ((0, serialization_1.hasSerializedNode)(nextSibling)) {
                return (0, serialization_1.getSerializedNodeId)(nextSibling);
            }
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function processCharacterDataMutations(mutations, configuration) {
    var _a;
    var textMutations = [];
    // Deduplicate mutations based on their target node
    var handledNodes = new Set();
    var filteredMutations = mutations.filter(function (mutation) {
        if (handledNodes.has(mutation.target)) {
            return false;
        }
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
        var mutation = filteredMutations_1[_i];
        var value = mutation.target.textContent;
        if (value === mutation.oldValue) {
            continue;
        }
        var parentNodePrivacyLevel = (0, privacy_1.getNodePrivacyLevel)((0, browser_rum_core_1.getParentNode)(mutation.target), configuration.defaultPrivacyLevel);
        if (parentNodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === constants_1.NodePrivacyLevel.IGNORE) {
            continue;
        }
        textMutations.push({
            id: (0, serialization_1.getSerializedNodeId)(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = (0, privacy_1.getTextContent)(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null,
        });
    }
    return textMutations;
}
function processAttributesMutations(mutations, configuration) {
    var attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    var handledElements = new Map();
    var filteredMutations = mutations.filter(function (mutation) {
        var handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
            return false;
        }
        if (!handledAttributes) {
            handledElements.set(mutation.target, new Set([mutation.attributeName]));
        }
        else {
            handledAttributes.add(mutation.attributeName);
        }
        return true;
    });
    // Emit mutations
    var emittedMutations = new Map();
    for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
        var mutation = filteredMutations_2[_i];
        var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) {
            continue;
        }
        var privacyLevel = (0, privacy_1.getNodePrivacyLevel)(mutation.target, configuration.defaultPrivacyLevel);
        var attributeValue = (0, serialization_1.serializeAttribute)(mutation.target, privacyLevel, mutation.attributeName, configuration);
        var transformedValue = void 0;
        if (mutation.attributeName === 'value') {
            var inputValue = (0, serialization_1.getElementInputValue)(mutation.target, privacyLevel);
            if (inputValue === undefined) {
                continue;
            }
            transformedValue = inputValue;
        }
        else if (typeof attributeValue === 'string') {
            transformedValue = attributeValue;
        }
        else {
            transformedValue = null;
        }
        var emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: (0, serialization_1.getSerializedNodeId)(mutation.target),
                attributes: {},
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
    nodes.sort(function (a, b) {
        var position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */
        if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return -1;
        }
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return -1;
        }
        /* eslint-enable no-bitwise */
        return 0;
    });
}
exports.sortAddedAndMovedNodes = sortAddedAndMovedNodes;
function traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
    if ((0, browser_rum_core_1.isNodeShadowHost)(removedNode)) {
        shadowDomRemovedCallback(removedNode.shadowRoot);
    }
    (0, browser_rum_core_1.forEachChildNodes)(removedNode, function (childNode) { return traverseRemovedShadowDom(childNode, shadowDomRemovedCallback); });
}
//# sourceMappingURL=mutationObserver.js.map
},{"../../../constants":159,"../mutationBatch":168,"../privacy":182,"../serialization":184,"@datadog/browser-core":56,"@datadog/browser-rum-core":153}],177:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initObservers = void 0;
var moveObserver_1 = require("./moveObserver");
var scrollObserver_1 = require("./scrollObserver");
var mouseInteractionObserver_1 = require("./mouseInteractionObserver");
var inputObserver_1 = require("./inputObserver");
var styleSheetObserver_1 = require("./styleSheetObserver");
var mediaInteractionObserver_1 = require("./mediaInteractionObserver");
var frustrationObserver_1 = require("./frustrationObserver");
var viewportResizeObserver_1 = require("./viewportResizeObserver");
var mutationObserver_1 = require("./mutationObserver");
var focusObserver_1 = require("./focusObserver");
var recordIds_1 = require("./recordIds");
function initObservers(configuration, o) {
    var recordIds = (0, recordIds_1.initRecordIds)();
    var mutationHandler = (0, mutationObserver_1.initMutationObserver)(o.mutationCb, o.configuration, o.shadowRootsController, document);
    var mousemoveHandler = (0, moveObserver_1.initMoveObserver)(configuration, o.mousemoveCb);
    var mouseInteractionHandler = (0, mouseInteractionObserver_1.initMouseInteractionObserver)(configuration, o.mouseInteractionCb, recordIds);
    var scrollHandler = (0, scrollObserver_1.initScrollObserver)(configuration, o.scrollCb, o.configuration.defaultPrivacyLevel, o.elementsScrollPositions);
    var viewportResizeHandler = (0, viewportResizeObserver_1.initViewportResizeObserver)(configuration, o.viewportResizeCb);
    var inputHandler = (0, inputObserver_1.initInputObserver)(configuration, o.inputCb);
    var mediaInteractionHandler = (0, mediaInteractionObserver_1.initMediaInteractionObserver)(configuration, o.mediaInteractionCb, o.configuration.defaultPrivacyLevel);
    var styleSheetObserver = (0, styleSheetObserver_1.initStyleSheetObserver)(o.styleSheetCb);
    var focusHandler = (0, focusObserver_1.initFocusObserver)(configuration, o.focusCb);
    var visualViewportResizeHandler = (0, viewportResizeObserver_1.initVisualViewportResizeObserver)(configuration, o.visualViewportResizeCb);
    var frustrationHandler = (0, frustrationObserver_1.initFrustrationObserver)(o.lifeCycle, o.frustrationCb, recordIds);
    return {
        flush: function () {
            mutationHandler.flush();
        },
        stop: function () {
            mutationHandler.stop();
            mousemoveHandler();
            mouseInteractionHandler();
            scrollHandler();
            viewportResizeHandler();
            inputHandler();
            mediaInteractionHandler();
            styleSheetObserver();
            focusHandler();
            visualViewportResizeHandler();
            frustrationHandler();
        },
    };
}
exports.initObservers = initObservers;
//# sourceMappingURL=observers.js.map
},{"./focusObserver":169,"./frustrationObserver":170,"./inputObserver":172,"./mediaInteractionObserver":173,"./mouseInteractionObserver":174,"./moveObserver":175,"./mutationObserver":176,"./recordIds":178,"./scrollObserver":179,"./styleSheetObserver":180,"./viewportResizeObserver":181}],178:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initRecordIds = void 0;
function initRecordIds() {
    var recordIds = new WeakMap();
    var nextId = 1;
    return {
        getIdForEvent: function (event) {
            if (!recordIds.has(event)) {
                recordIds.set(event, nextId++);
            }
            return recordIds.get(event);
        },
    };
}
exports.initRecordIds = initRecordIds;
//# sourceMappingURL=recordIds.js.map
},{}],179:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initScrollObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var eventsUtils_1 = require("../eventsUtils");
var privacy_1 = require("../privacy");
var serialization_1 = require("../serialization");
var constants_1 = require("../../../constants");
var SCROLL_OBSERVER_THRESHOLD = 100;
function initScrollObserver(configuration, cb, defaultPrivacyLevel, elementsScrollPositions) {
    var updatePosition = (0, browser_core_1.throttle)(function (event) {
        var target = (0, eventsUtils_1.getEventTarget)(event);
        if (!target ||
            (0, privacy_1.getNodePrivacyLevel)(target, defaultPrivacyLevel) === constants_1.NodePrivacyLevel.HIDDEN ||
            !(0, serialization_1.hasSerializedNode)(target)) {
            return;
        }
        var id = (0, serialization_1.getSerializedNodeId)(target);
        var scrollPositions = target === document
            ? {
                scrollTop: (0, browser_rum_core_1.getScrollY)(),
                scrollLeft: (0, browser_rum_core_1.getScrollX)(),
            }
            : {
                scrollTop: Math.round(target.scrollTop),
                scrollLeft: Math.round(target.scrollLeft),
            };
        elementsScrollPositions.set(target, scrollPositions);
        cb({
            id: id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop,
        });
    }, SCROLL_OBSERVER_THRESHOLD).throttled;
    return (0, browser_core_1.addEventListener)(configuration, document, "scroll" /* DOM_EVENT.SCROLL */, updatePosition, { capture: true, passive: true })
        .stop;
}
exports.initScrollObserver = initScrollObserver;
//# sourceMappingURL=scrollObserver.js.map
},{"../../../constants":159,"../eventsUtils":166,"../privacy":182,"../serialization":184,"@datadog/browser-core":56,"@datadog/browser-rum-core":153}],180:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathToNestedCSSRule = exports.initStyleSheetObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var serialization_1 = require("../serialization");
function initStyleSheetObserver(cb) {
    function checkStyleSheetAndCallback(styleSheet, callback) {
        if (styleSheet && (0, serialization_1.hasSerializedNode)(styleSheet.ownerNode)) {
            callback((0, serialization_1.getSerializedNodeId)(styleSheet.ownerNode));
        }
    }
    var instrumentationStoppers = [
        (0, browser_core_1.instrumentMethodAndCallOriginal)(CSSStyleSheet.prototype, 'insertRule', {
            before: function (rule, index) {
                checkStyleSheetAndCallback(this, function (id) { return cb({ id: id, adds: [{ rule: rule, index: index }] }); });
            },
        }),
        (0, browser_core_1.instrumentMethodAndCallOriginal)(CSSStyleSheet.prototype, 'deleteRule', {
            before: function (index) {
                checkStyleSheetAndCallback(this, function (id) { return cb({ id: id, removes: [{ index: index }] }); });
            },
        }),
    ];
    if (typeof CSSGroupingRule !== 'undefined') {
        instrumentGroupingCSSRuleClass(CSSGroupingRule);
    }
    else {
        instrumentGroupingCSSRuleClass(CSSMediaRule);
        instrumentGroupingCSSRuleClass(CSSSupportsRule);
    }
    function instrumentGroupingCSSRuleClass(cls) {
        instrumentationStoppers.push((0, browser_core_1.instrumentMethodAndCallOriginal)(cls.prototype, 'insertRule', {
            before: function (rule, index) {
                var _this = this;
                checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
                    var path = getPathToNestedCSSRule(_this);
                    if (path) {
                        path.push(index || 0);
                        cb({ id: id, adds: [{ rule: rule, index: path }] });
                    }
                });
            },
        }), (0, browser_core_1.instrumentMethodAndCallOriginal)(cls.prototype, 'deleteRule', {
            before: function (index) {
                var _this = this;
                checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
                    var path = getPathToNestedCSSRule(_this);
                    if (path) {
                        path.push(index);
                        cb({ id: id, removes: [{ index: path }] });
                    }
                });
            },
        }));
    }
    return function () { return instrumentationStoppers.forEach(function (stopper) { return stopper.stop(); }); };
}
exports.initStyleSheetObserver = initStyleSheetObserver;
function getPathToNestedCSSRule(rule) {
    var path = [];
    var currentRule = rule;
    while (currentRule.parentRule) {
        var rules_1 = Array.from(currentRule.parentRule.cssRules);
        var index_1 = rules_1.indexOf(currentRule);
        path.unshift(index_1);
        currentRule = currentRule.parentRule;
    }
    // A rule may not be attached to a stylesheet
    if (!currentRule.parentStyleSheet) {
        return;
    }
    var rules = Array.from(currentRule.parentStyleSheet.cssRules);
    var index = rules.indexOf(currentRule);
    path.unshift(index);
    return path;
}
exports.getPathToNestedCSSRule = getPathToNestedCSSRule;
//# sourceMappingURL=styleSheetObserver.js.map
},{"../serialization":184,"@datadog/browser-core":56}],181:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initVisualViewportResizeObserver = exports.initViewportResizeObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var viewports_1 = require("../viewports");
var VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function initViewportResizeObserver(configuration, cb) {
    return (0, browser_rum_core_1.initViewportObservable)(configuration).subscribe(cb).unsubscribe;
}
exports.initViewportResizeObserver = initViewportResizeObserver;
function initVisualViewportResizeObserver(configuration, cb) {
    var visualViewport = window.visualViewport;
    if (!visualViewport) {
        return browser_core_1.noop;
    }
    var _a = (0, browser_core_1.throttle)(function () {
        cb((0, viewports_1.getVisualViewport)(visualViewport));
    }, VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false,
    }), updateDimension = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = (0, browser_core_1.addEventListeners)(configuration, visualViewport, ["resize" /* DOM_EVENT.RESIZE */, "scroll" /* DOM_EVENT.SCROLL */], updateDimension, {
        capture: true,
        passive: true,
    }).stop;
    return function stop() {
        removeListener();
        cancelThrottle();
    };
}
exports.initVisualViewportResizeObserver = initVisualViewportResizeObserver;
//# sourceMappingURL=viewportResizeObserver.js.map
},{"../viewports":192,"@datadog/browser-core":56,"@datadog/browser-rum-core":153}],182:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldIgnoreElement = exports.getTextContent = exports.censorText = exports.shouldMaskNode = exports.getNodeSelfPrivacyLevel = exports.reducePrivacyLevel = exports.getNodePrivacyLevel = exports.MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = void 0;
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var constants_1 = require("../../constants");
exports.MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 100000;
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel) {
    var parentNode = (0, browser_rum_core_1.getParentNode)(node);
    var parentNodePrivacyLevel = parentNode ? getNodePrivacyLevel(parentNode, defaultPrivacyLevel) : defaultPrivacyLevel;
    var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
    return reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
}
exports.getNodePrivacyLevel = getNodePrivacyLevel;
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
    switch (parentNodePrivacyLevel) {
        // These values cannot be overridden
        case constants_1.NodePrivacyLevel.HIDDEN:
        case constants_1.NodePrivacyLevel.IGNORE:
            return parentNodePrivacyLevel;
    }
    switch (childPrivacyLevel) {
        case constants_1.NodePrivacyLevel.ALLOW:
        case constants_1.NodePrivacyLevel.MASK:
        case constants_1.NodePrivacyLevel.MASK_USER_INPUT:
        case constants_1.NodePrivacyLevel.HIDDEN:
        case constants_1.NodePrivacyLevel.IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
exports.reducePrivacyLevel = reducePrivacyLevel;
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
    // Only Element types can have a privacy level set
    if (!(0, browser_rum_core_1.isElementNode)(node)) {
        return;
    }
    var privAttr = node.getAttribute(constants_1.PRIVACY_ATTR_NAME);
    // Overrules for replay purpose
    if (node.tagName === 'BASE') {
        return constants_1.NodePrivacyLevel.ALLOW;
    }
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        var inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
            return constants_1.NodePrivacyLevel.MASK;
        }
        if (inputElement.type === 'hidden') {
            return constants_1.NodePrivacyLevel.MASK;
        }
        var autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
        if (autocomplete && autocomplete.indexOf('cc-') === 0) {
            return constants_1.NodePrivacyLevel.MASK;
        }
    }
    // Check HTML privacy attributes and classes
    if (privAttr === constants_1.PRIVACY_ATTR_VALUE_HIDDEN || node.classList.contains(constants_1.PRIVACY_CLASS_HIDDEN)) {
        return constants_1.NodePrivacyLevel.HIDDEN;
    }
    if (privAttr === constants_1.PRIVACY_ATTR_VALUE_MASK || node.classList.contains(constants_1.PRIVACY_CLASS_MASK)) {
        return constants_1.NodePrivacyLevel.MASK;
    }
    if (privAttr === constants_1.PRIVACY_ATTR_VALUE_MASK_USER_INPUT || node.classList.contains(constants_1.PRIVACY_CLASS_MASK_USER_INPUT)) {
        return constants_1.NodePrivacyLevel.MASK_USER_INPUT;
    }
    if (privAttr === constants_1.PRIVACY_ATTR_VALUE_ALLOW || node.classList.contains(constants_1.PRIVACY_CLASS_ALLOW)) {
        return constants_1.NodePrivacyLevel.ALLOW;
    }
    if (shouldIgnoreElement(node)) {
        return constants_1.NodePrivacyLevel.IGNORE;
    }
}
exports.getNodeSelfPrivacyLevel = getNodeSelfPrivacyLevel;
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
    switch (privacyLevel) {
        case constants_1.NodePrivacyLevel.MASK:
        case constants_1.NodePrivacyLevel.HIDDEN:
        case constants_1.NodePrivacyLevel.IGNORE:
            return true;
        case constants_1.NodePrivacyLevel.MASK_USER_INPUT:
            return (0, browser_rum_core_1.isTextNode)(node) ? isFormElement(node.parentNode) : isFormElement(node);
        default:
            return false;
    }
}
exports.shouldMaskNode = shouldMaskNode;
function isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) {
        return false;
    }
    var element = node;
    if (element.tagName === 'INPUT') {
        switch (element.type) {
            case 'button':
            case 'color':
            case 'reset':
            case 'submit':
                return false;
        }
    }
    return !!constants_1.FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) { return text.replace(/\S/g, TEXT_MASKING_CHAR); };
exports.censorText = censorText;
function getTextContent(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = textNode.textContent || '';
    if (ignoreWhiteSpace && !textContent.trim()) {
        return;
    }
    var nodePrivacyLevel = parentNodePrivacyLevel;
    var isScript = parentTagName === 'SCRIPT';
    if (isScript) {
        // For perf reasons, we don't record script (heuristic)
        textContent = constants_1.CENSORED_STRING_MARK;
    }
    else if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
        // Should never occur, but just in case, we set to CENSORED_MARK.
        textContent = constants_1.CENSORED_STRING_MARK;
    }
    else if (shouldMaskNode(textNode, nodePrivacyLevel)) {
        if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' ||
            parentTagName === 'SELECT' ||
            parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) {
                return;
            }
        }
        else if (parentTagName === 'OPTION') {
            // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
            textContent = constants_1.CENSORED_STRING_MARK;
        }
        else {
            textContent = (0, exports.censorText)(textContent);
        }
    }
    return textContent;
}
exports.getTextContent = getTextContent;
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
    if (element.nodeName === 'SCRIPT') {
        return true;
    }
    if (element.nodeName === 'LINK') {
        var relAttribute = getLowerCaseAttribute('rel');
        return (
        // Link as script - Ignore only when rel=preload, modulepreload or prefetch
        (/preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script') ||
            // Favicons
            relAttribute === 'shortcut icon' ||
            relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        var nameAttribute = getLowerCaseAttribute('name');
        var relAttribute = getLowerCaseAttribute('rel');
        var propertyAttribute = getLowerCaseAttribute('property');
        return (
        // Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) ||
            nameAttribute === 'application-name' ||
            relAttribute === 'icon' ||
            relAttribute === 'apple-touch-icon' ||
            relAttribute === 'shortcut icon' ||
            // Description
            nameAttribute === 'keywords' ||
            nameAttribute === 'description' ||
            // Social
            /^(og|twitter|fb):/.test(propertyAttribute) ||
            /^(og|twitter):/.test(nameAttribute) ||
            nameAttribute === 'pinterest' ||
            // Robots
            nameAttribute === 'robots' ||
            nameAttribute === 'googlebot' ||
            nameAttribute === 'bingbot' ||
            // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
            // X-Translated-By
            element.hasAttribute('http-equiv') ||
            // Authorship
            nameAttribute === 'author' ||
            nameAttribute === 'generator' ||
            nameAttribute === 'framework' ||
            nameAttribute === 'publisher' ||
            nameAttribute === 'progid' ||
            /^article:/.test(propertyAttribute) ||
            /^product:/.test(propertyAttribute) ||
            // Verification
            nameAttribute === 'google-site-verification' ||
            nameAttribute === 'yandex-verification' ||
            nameAttribute === 'csrf-token' ||
            nameAttribute === 'p:domain_verify' ||
            nameAttribute === 'verify-v1' ||
            nameAttribute === 'verification' ||
            nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
exports.shouldIgnoreElement = shouldIgnoreElement;
//# sourceMappingURL=privacy.js.map
},{"../../constants":159,"@datadog/browser-rum-core":153}],183:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.record = void 0;
var browser_core_1 = require("@datadog/browser-core");
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var types_1 = require("../../types");
var assembly_1 = require("./assembly");
var serialization_1 = require("./serialization");
var observers_1 = require("./observers");
var viewports_1 = require("./viewports");
var elementsScrollPositions_1 = require("./elementsScrollPositions");
var shadowRootsController_1 = require("./shadowRootsController");
function record(options) {
    var emit = options.emit, configuration = options.configuration;
    // runtime checks for user options
    if (!emit) {
        throw new Error('emit function is required');
    }
    var elementsScrollPositions = (0, elementsScrollPositions_1.createElementsScrollPositions)();
    var mutationCb = function (mutation) {
        emit((0, assembly_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.Mutation, mutation));
    };
    var inputCb = function (s) { return emit((0, assembly_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.Input, s)); };
    var shadowRootsController = (0, shadowRootsController_1.initShadowRootsController)(configuration, { mutationCb: mutationCb, inputCb: inputCb });
    var takeFullSnapshot = function (timestamp, serializationContext) {
        if (timestamp === void 0) { timestamp = (0, browser_core_1.timeStampNow)(); }
        if (serializationContext === void 0) { serializationContext = {
            status: 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */,
            elementsScrollPositions: elementsScrollPositions,
            shadowRootsController: shadowRootsController,
        }; }
        var _a = (0, browser_rum_core_1.getViewportDimension)(), width = _a.width, height = _a.height;
        emit({
            data: {
                height: height,
                href: window.location.href,
                width: width,
            },
            type: types_1.RecordType.Meta,
            timestamp: timestamp,
        });
        emit({
            data: {
                has_focus: document.hasFocus(),
            },
            type: types_1.RecordType.Focus,
            timestamp: timestamp,
        });
        emit({
            data: {
                node: (0, serialization_1.serializeDocument)(document, configuration, serializationContext),
                initialOffset: {
                    left: (0, browser_rum_core_1.getScrollX)(),
                    top: (0, browser_rum_core_1.getScrollY)(),
                },
            },
            type: types_1.RecordType.FullSnapshot,
            timestamp: timestamp,
        });
        if (window.visualViewport) {
            emit({
                data: (0, viewports_1.getVisualViewport)(window.visualViewport),
                type: types_1.RecordType.VisualViewport,
                timestamp: timestamp,
            });
        }
    };
    takeFullSnapshot();
    var _a = (0, observers_1.initObservers)(configuration, {
        lifeCycle: options.lifeCycle,
        configuration: configuration,
        elementsScrollPositions: elementsScrollPositions,
        inputCb: inputCb,
        mediaInteractionCb: function (p) {
            return emit((0, assembly_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.MediaInteraction, p));
        },
        mouseInteractionCb: function (mouseInteractionRecord) { return emit(mouseInteractionRecord); },
        mousemoveCb: function (positions, source) { return emit((0, assembly_1.assembleIncrementalSnapshot)(source, { positions: positions })); },
        mutationCb: mutationCb,
        scrollCb: function (p) { return emit((0, assembly_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.Scroll, p)); },
        styleSheetCb: function (r) { return emit((0, assembly_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.StyleSheetRule, r)); },
        viewportResizeCb: function (d) { return emit((0, assembly_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.ViewportResize, d)); },
        frustrationCb: function (frustrationRecord) { return emit(frustrationRecord); },
        focusCb: function (data) {
            return emit({
                data: data,
                type: types_1.RecordType.Focus,
                timestamp: (0, browser_core_1.timeStampNow)(),
            });
        },
        visualViewportResizeCb: function (data) {
            emit({
                data: data,
                type: types_1.RecordType.VisualViewport,
                timestamp: (0, browser_core_1.timeStampNow)(),
            });
        },
        shadowRootsController: shadowRootsController,
    }), stopObservers = _a.stop, flushMutationsFromObservers = _a.flush;
    function flushMutations() {
        shadowRootsController.flush();
        flushMutationsFromObservers();
    }
    return {
        stop: function () {
            shadowRootsController.stop();
            stopObservers();
        },
        takeSubsequentFullSnapshot: function (timestamp) {
            flushMutations();
            takeFullSnapshot(timestamp, {
                shadowRootsController: shadowRootsController,
                status: 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */,
                elementsScrollPositions: elementsScrollPositions,
            });
        },
        flushMutations: flushMutations,
        shadowRootsController: shadowRootsController,
    };
}
exports.record = record;
//# sourceMappingURL=record.js.map
},{"../../types":199,"./assembly":164,"./elementsScrollPositions":165,"./observers":171,"./serialization":184,"./shadowRootsController":191,"./viewports":192,"@datadog/browser-core":56,"@datadog/browser-rum-core":153}],184:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeAttribute = exports.serializeNodeWithId = exports.serializeDocument = exports.nodeAndAncestorsHaveSerializedNode = exports.hasSerializedNode = exports.getSerializedNodeId = exports.getElementInputValue = void 0;
var serializationUtils_1 = require("./serializationUtils");
Object.defineProperty(exports, "getElementInputValue", { enumerable: true, get: function () { return serializationUtils_1.getElementInputValue; } });
Object.defineProperty(exports, "getSerializedNodeId", { enumerable: true, get: function () { return serializationUtils_1.getSerializedNodeId; } });
Object.defineProperty(exports, "hasSerializedNode", { enumerable: true, get: function () { return serializationUtils_1.hasSerializedNode; } });
Object.defineProperty(exports, "nodeAndAncestorsHaveSerializedNode", { enumerable: true, get: function () { return serializationUtils_1.nodeAndAncestorsHaveSerializedNode; } });
var serializeDocument_1 = require("./serializeDocument");
Object.defineProperty(exports, "serializeDocument", { enumerable: true, get: function () { return serializeDocument_1.serializeDocument; } });
var serializeNode_1 = require("./serializeNode");
Object.defineProperty(exports, "serializeNodeWithId", { enumerable: true, get: function () { return serializeNode_1.serializeNodeWithId; } });
var serializeAttribute_1 = require("./serializeAttribute");
Object.defineProperty(exports, "serializeAttribute", { enumerable: true, get: function () { return serializeAttribute_1.serializeAttribute; } });
//# sourceMappingURL=index.js.map
},{"./serializationUtils":185,"./serializeAttribute":186,"./serializeDocument":188,"./serializeNode":189}],185:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidTagName = exports.makeUrlAbsolute = exports.switchToAbsoluteUrl = exports.DATA_URI = exports.ABSOLUTE_URL = exports.URL_IN_CSS_REF = exports.getElementInputValue = exports.setSerializedNodeId = exports.getSerializedNodeId = exports.nodeAndAncestorsHaveSerializedNode = exports.hasSerializedNode = void 0;
var browser_core_1 = require("@datadog/browser-core");
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var constants_1 = require("../../../constants");
var privacy_1 = require("../privacy");
var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
    return serializedNodeIds.has(node);
}
exports.hasSerializedNode = hasSerializedNode;
function nodeAndAncestorsHaveSerializedNode(node) {
    var current = node;
    while (current) {
        if (!hasSerializedNode(current) && !(0, browser_rum_core_1.isNodeShadowRoot)(current)) {
            return false;
        }
        current = (0, browser_rum_core_1.getParentNode)(current);
    }
    return true;
}
exports.nodeAndAncestorsHaveSerializedNode = nodeAndAncestorsHaveSerializedNode;
function getSerializedNodeId(node) {
    return serializedNodeIds.get(node);
}
exports.getSerializedNodeId = getSerializedNodeId;
function setSerializedNodeId(node, serializeNodeId) {
    serializedNodeIds.set(node, serializeNodeId);
}
exports.setSerializedNodeId = setSerializedNodeId;
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */
    var tagName = element.tagName;
    var value = element.value;
    if ((0, privacy_1.shouldMaskNode)(element, nodePrivacyLevel)) {
        var type = element.type;
        if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
            // Overrule `MASK` privacy level for button-like element values, as they are used during replay
            // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
            return value;
        }
        else if (!value || tagName === 'OPTION') {
            // <Option> value provides no benefit
            return;
        }
        return constants_1.CENSORED_STRING_MARK;
    }
    if (tagName === 'OPTION' || tagName === 'SELECT') {
        return element.value;
    }
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
        return;
    }
    return value;
}
exports.getElementInputValue = getElementInputValue;
exports.URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
exports.ABSOLUTE_URL = /^[A-Za-z]+:|^\/\//;
exports.DATA_URI = /^data:.*,/i;
function switchToAbsoluteUrl(cssText, cssHref) {
    return cssText.replace(exports.URL_IN_CSS_REF, function (matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) {
        var url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
        if (!cssHref || !url || exports.ABSOLUTE_URL.test(url) || exports.DATA_URI.test(url)) {
            return matchingSubstring;
        }
        var quote = singleQuote || doubleQuote || '';
        return "url(".concat(quote).concat(makeUrlAbsolute(url, cssHref)).concat(quote, ")");
    });
}
exports.switchToAbsoluteUrl = switchToAbsoluteUrl;
function makeUrlAbsolute(url, baseUrl) {
    try {
        return (0, browser_core_1.buildUrl)(url, baseUrl).href;
    }
    catch (_) {
        return url;
    }
}
exports.makeUrlAbsolute = makeUrlAbsolute;
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
    var processedTagName = tagName.toLowerCase().trim();
    if (TAG_NAME_REGEX.test(processedTagName)) {
        // if the tag name is odd and we cannot extract
        // anything from the string, then we return a
        // generic div
        return 'div';
    }
    return processedTagName;
}
exports.getValidTagName = getValidTagName;
//# sourceMappingURL=serializationUtils.js.map
},{"../../../constants":159,"../privacy":182,"@datadog/browser-core":56,"@datadog/browser-rum-core":153}],186:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeAttribute = void 0;
var browser_core_1 = require("@datadog/browser-core");
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var constants_1 = require("../../../constants");
var privacy_1 = require("../privacy");
function serializeAttribute(element, nodePrivacyLevel, attributeName, configuration) {
    if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
        // dup condition for direct access case
        return null;
    }
    var attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === constants_1.NodePrivacyLevel.MASK &&
        attributeName !== constants_1.PRIVACY_ATTR_NAME &&
        !browser_rum_core_1.STABLE_ATTRIBUTES.includes(attributeName) &&
        attributeName !== configuration.actionNameAttribute) {
        var tagName = element.tagName;
        switch (attributeName) {
            // Mask Attribute text content
            case 'title':
            case 'alt':
            case 'placeholder':
                return constants_1.CENSORED_STRING_MARK;
        }
        // mask image URLs
        if (tagName === 'IMG' || tagName === 'SOURCE') {
            if (attributeName === 'src' || attributeName === 'srcset') {
                return constants_1.CENSORED_IMG_MARK;
            }
        }
        // mask <a> URLs
        if (tagName === 'A' && attributeName === 'href') {
            return constants_1.CENSORED_STRING_MARK;
        }
        // mask data-* attributes
        if (attributeValue && (0, browser_core_1.startsWith)(attributeName, 'data-')) {
            // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
            return constants_1.CENSORED_STRING_MARK;
        }
    }
    if (!attributeValue || typeof attributeValue !== 'string') {
        return attributeValue;
    }
    // Minimum Fix for customer.
    if (attributeValue.length > privacy_1.MAX_ATTRIBUTE_VALUE_CHAR_LENGTH && attributeValue.slice(0, 5) === 'data:') {
        return 'data:truncated';
    }
    return attributeValue;
}
exports.serializeAttribute = serializeAttribute;
//# sourceMappingURL=serializeAttribute.js.map
},{"../../../constants":159,"../privacy":182,"@datadog/browser-core":56,"@datadog/browser-rum-core":153}],187:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCssRulesString = exports.serializeAttributes = void 0;
var browser_core_1 = require("@datadog/browser-core");
var constants_1 = require("../../../constants");
var privacy_1 = require("../privacy");
var serializationUtils_1 = require("./serializationUtils");
var serializeAttribute_1 = require("./serializeAttribute");
function serializeAttributes(element, nodePrivacyLevel, options) {
    var _a;
    if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
        return {};
    }
    var safeAttrs = {};
    var tagName = (0, serializationUtils_1.getValidTagName)(element.tagName);
    var doc = element.ownerDocument;
    for (var i = 0; i < element.attributes.length; i += 1) {
        var attribute = element.attributes.item(i);
        var attributeName = attribute.name;
        var attributeValue = (0, serializeAttribute_1.serializeAttribute)(element, nodePrivacyLevel, attributeName, options.configuration);
        if (attributeValue !== null) {
            safeAttrs[attributeName] = attributeValue;
        }
    }
    if (element.value &&
        (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
        var formValue = (0, serializationUtils_1.getElementInputValue)(element, nodePrivacyLevel);
        if (formValue !== undefined) {
            safeAttrs.value = formValue;
        }
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */
    if (tagName === 'option' && nodePrivacyLevel === constants_1.NodePrivacyLevel.ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        var optionElement = element;
        if (optionElement.selected) {
            safeAttrs.selected = optionElement.selected;
        }
    }
    // remote css
    if (tagName === 'link') {
        var stylesheet = Array.from(doc.styleSheets).find(function (s) { return s.href === element.href; });
        var cssText = getCssRulesString(stylesheet);
        if (cssText && stylesheet && !(0, browser_core_1.isExperimentalFeatureEnabled)(browser_core_1.ExperimentalFeature.DISABLE_REPLAY_INLINE_CSS)) {
            safeAttrs._cssText = cssText;
        }
    }
    // dynamic stylesheet
    if (tagName === 'style' && element.sheet) {
        var cssText = getCssRulesString(element.sheet);
        if (cssText) {
            safeAttrs._cssText = cssText;
        }
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */
    var inputElement = element;
    if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
        if (nodePrivacyLevel === constants_1.NodePrivacyLevel.ALLOW) {
            safeAttrs.checked = !!inputElement.checked;
        }
        else if ((0, privacy_1.shouldMaskNode)(inputElement, nodePrivacyLevel)) {
            delete safeAttrs.checked;
        }
    }
    /**
     * Serialize the media playback state
     */
    if (tagName === 'audio' || tagName === 'video') {
        var mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
    }
    /**
     * Serialize the scroll state for each element only for full snapshot
     */
    var scrollTop;
    var scrollLeft;
    var serializationContext = options.serializationContext;
    switch (serializationContext.status) {
        case 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */:
            scrollTop = Math.round(element.scrollTop);
            scrollLeft = Math.round(element.scrollLeft);
            if (scrollTop || scrollLeft) {
                serializationContext.elementsScrollPositions.set(element, { scrollTop: scrollTop, scrollLeft: scrollLeft });
            }
            break;
        case 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */:
            if (serializationContext.elementsScrollPositions.has(element)) {
                ;
                (_a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft);
            }
            break;
    }
    if (scrollLeft) {
        safeAttrs.rr_scrollLeft = scrollLeft;
    }
    if (scrollTop) {
        safeAttrs.rr_scrollTop = scrollTop;
    }
    return safeAttrs;
}
exports.serializeAttributes = serializeAttributes;
function getCssRulesString(cssStyleSheet) {
    if (!cssStyleSheet) {
        return null;
    }
    var rules;
    try {
        rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
    }
    catch (_a) {
        // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
    }
    if (!rules) {
        return null;
    }
    var styleSheetCssText = Array.from(rules, (0, browser_core_1.isSafari)() ? getCssRuleStringForSafari : getCssRuleString).join('');
    return (0, serializationUtils_1.switchToAbsoluteUrl)(styleSheetCssText, cssStyleSheet.href);
}
exports.getCssRulesString = getCssRulesString;
function getCssRuleStringForSafari(rule) {
    // Safari does not escape attribute selectors containing : properly
    // https://bugs.webkit.org/show_bug.cgi?id=184604
    if (isCSSStyleRule(rule) && rule.selectorText.includes(':')) {
        // This regex replaces [foo:bar] by [foo\\:bar]
        var escapeColon = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
        return rule.cssText.replace(escapeColon, '$1\\$2');
    }
    return getCssRuleString(rule);
}
function getCssRuleString(rule) {
    // If it's an @import rule, try to inline sub-rules recursively with `getCssRulesString`. This
    // operation can fail if the imported stylesheet is protected by CORS, in which case we fallback
    // to the @import rule CSS text.
    return (isCSSImportRule(rule) && getCssRulesString(rule.styleSheet)) || rule.cssText;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
//# sourceMappingURL=serializeAttributes.js.map
},{"../../../constants":159,"../privacy":182,"./serializationUtils":185,"./serializeAttribute":186,"@datadog/browser-core":56}],188:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeDocument = void 0;
var serializeNode_1 = require("./serializeNode");
function serializeDocument(document, configuration, serializationContext) {
    // We are sure that Documents are never ignored, so this function never returns null
    return (0, serializeNode_1.serializeNodeWithId)(document, {
        serializationContext: serializationContext,
        parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
        configuration: configuration,
    });
}
exports.serializeDocument = serializeDocument;
//# sourceMappingURL=serializeDocument.js.map
},{"./serializeNode":189}],189:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeDocumentNode = exports.serializeChildNodes = exports.generateNextId = exports.serializeNodeWithId = void 0;
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var browser_core_1 = require("@datadog/browser-core");
var types_1 = require("../../../types");
var constants_1 = require("../../../constants");
var privacy_1 = require("../privacy");
var serializationUtils_1 = require("./serializationUtils");
var serializeStyleSheets_1 = require("./serializeStyleSheets");
var serializeAttributes_1 = require("./serializeAttributes");
function serializeNodeWithId(node, options) {
    var serializedNode = serializeNode(node, options);
    if (!serializedNode) {
        return null;
    }
    // Try to reuse the previous id
    var id = (0, serializationUtils_1.getSerializedNodeId)(node) || generateNextId();
    var serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    (0, serializationUtils_1.setSerializedNodeId)(node, id);
    if (options.serializedNodeIds) {
        options.serializedNodeIds.add(id);
    }
    return serializedNodeWithId;
}
exports.serializeNodeWithId = serializeNodeWithId;
var _nextId = 1;
function generateNextId() {
    return _nextId++;
}
exports.generateNextId = generateNextId;
function serializeChildNodes(node, options) {
    var result = [];
    (0, browser_rum_core_1.forEachChildNodes)(node, function (childNode) {
        var serializedChildNode = serializeNodeWithId(childNode, options);
        if (serializedChildNode) {
            result.push(serializedChildNode);
        }
    });
    return result;
}
exports.serializeChildNodes = serializeChildNodes;
function serializeNode(node, options) {
    switch (node.nodeType) {
        case node.DOCUMENT_NODE:
            return serializeDocumentNode(node, options);
        case node.DOCUMENT_FRAGMENT_NODE:
            return serializeDocumentFragmentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return serializeElementNode(node, options);
        case node.TEXT_NODE:
            return serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return serializeCDataNode();
    }
}
function serializeDocumentNode(document, options) {
    return {
        type: types_1.NodeType.Document,
        childNodes: serializeChildNodes(document, options),
        adoptedStyleSheets: (0, serializeStyleSheets_1.serializeStyleSheets)(document.adoptedStyleSheets),
    };
}
exports.serializeDocumentNode = serializeDocumentNode;
function serializeDocumentFragmentNode(element, options) {
    var isShadowRoot = (0, browser_rum_core_1.isNodeShadowRoot)(element);
    if (isShadowRoot) {
        options.serializationContext.shadowRootsController.addShadowRoot(element);
    }
    return {
        type: types_1.NodeType.DocumentFragment,
        childNodes: serializeChildNodes(element, options),
        isShadowRoot: isShadowRoot,
        adoptedStyleSheets: isShadowRoot ? (0, serializeStyleSheets_1.serializeStyleSheets)(element.adoptedStyleSheets) : undefined,
    };
}
function serializeDocumentTypeNode(documentType) {
    return {
        type: types_1.NodeType.DocumentType,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId,
    };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
    var _a;
    var tagName = (0, serializationUtils_1.getValidTagName)(element.tagName);
    var isSVG = isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    var nodePrivacyLevel = (0, privacy_1.reducePrivacyLevel)((0, privacy_1.getNodeSelfPrivacyLevel)(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
        var _b = element.getBoundingClientRect(), width = _b.width, height = _b.height;
        return {
            type: types_1.NodeType.Element,
            tagName: tagName,
            attributes: (_a = {
                    rr_width: "".concat(width, "px"),
                    rr_height: "".concat(height, "px")
                },
                _a[constants_1.PRIVACY_ATTR_NAME] = constants_1.PRIVACY_ATTR_VALUE_HIDDEN,
                _a),
            childNodes: [],
            isSVG: isSVG,
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === constants_1.NodePrivacyLevel.IGNORE) {
        return;
    }
    var attributes = (0, serializeAttributes_1.serializeAttributes)(element, nodePrivacyLevel, options);
    var childNodes = [];
    if ((0, browser_rum_core_1.hasChildNodes)(element) &&
        // Do not serialize style children as the css rules are already in the _cssText attribute
        tagName !== 'style') {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        var childNodesSerializationOptions = void 0;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
            childNodesSerializationOptions = options;
        }
        else {
            childNodesSerializationOptions = (0, browser_core_1.assign)({}, options, {
                parentNodePrivacyLevel: nodePrivacyLevel,
                ignoreWhiteSpace: tagName === 'head',
            });
        }
        childNodes = serializeChildNodes(element, childNodesSerializationOptions);
    }
    return {
        type: types_1.NodeType.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG,
    };
}
function isSVGElement(el) {
    return el.tagName === 'svg' || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
    var textContent = (0, privacy_1.getTextContent)(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (textContent === undefined) {
        return;
    }
    return {
        type: types_1.NodeType.Text,
        textContent: textContent,
    };
}
function serializeCDataNode() {
    return {
        type: types_1.NodeType.CDATA,
        textContent: '',
    };
}
//# sourceMappingURL=serializeNode.js.map
},{"../../../constants":159,"../../../types":199,"../privacy":182,"./serializationUtils":185,"./serializeAttributes":187,"./serializeStyleSheets":190,"@datadog/browser-core":56,"@datadog/browser-rum-core":153}],190:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeStyleSheets = void 0;
function serializeStyleSheets(cssStyleSheets) {
    if (cssStyleSheets === undefined || cssStyleSheets.length === 0) {
        return undefined;
    }
    return cssStyleSheets.map(function (cssStyleSheet) {
        var rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
        var cssRules = Array.from(rules, function (cssRule) { return cssRule.cssText; });
        var styleSheet = {
            cssRules: cssRules,
            disabled: cssStyleSheet.disabled || undefined,
            media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined,
        };
        return styleSheet;
    });
}
exports.serializeStyleSheets = serializeStyleSheets;
//# sourceMappingURL=serializeStyleSheets.js.map
},{}],191:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initShadowRootsController = void 0;
var observers_1 = require("./observers");
var initShadowRootsController = function (configuration, _a) {
    var mutationCb = _a.mutationCb, inputCb = _a.inputCb;
    var controllerByShadowRoot = new Map();
    var shadowRootsController = {
        addShadowRoot: function (shadowRoot) {
            var _a = (0, observers_1.initMutationObserver)(mutationCb, configuration, shadowRootsController, shadowRoot), stopMutationObserver = _a.stop, flush = _a.flush;
            // the change event no do bubble up across the shadow root, we have to listen on the shadow root
            var stopInputObserver = (0, observers_1.initInputObserver)(configuration, inputCb, shadowRoot);
            controllerByShadowRoot.set(shadowRoot, {
                flush: flush,
                stop: function () {
                    stopMutationObserver();
                    stopInputObserver();
                },
            });
        },
        removeShadowRoot: function (shadowRoot) {
            var entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) {
                // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
                return;
            }
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var stop = _a.stop;
                return stop();
            });
        },
        flush: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var flush = _a.flush;
                return flush();
            });
        },
    };
    return shadowRootsController;
};
exports.initShadowRootsController = initShadowRootsController;
//# sourceMappingURL=shadowRootsController.js.map
},{"./observers":171}],192:[function(require,module,exports){
"use strict";
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVisualViewport = exports.convertMouseEventToLayoutCoordinates = void 0;
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn(visualViewport) {
    return (Math.abs(visualViewport.pageTop - visualViewport.offsetTop - window.scrollY) > TOLERANCE ||
        Math.abs(visualViewport.pageLeft - visualViewport.offsetLeft - window.scrollX) > TOLERANCE);
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
    var visualViewport = window.visualViewport;
    var normalized = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY,
    };
    if (!visualViewport) {
        // On old browsers, we cannot normalize, so fallback to clientX/Y
        return normalized;
    }
    else if (isVisualViewportFactoredIn(visualViewport)) {
        // Typically Mobile Devices
        normalized.layoutViewportX = Math.round(clientX + visualViewport.offsetLeft);
        normalized.layoutViewportY = Math.round(clientY + visualViewport.offsetTop);
    }
    else {
        // Typically Desktop Devices
        normalized.visualViewportX = Math.round(clientX - visualViewport.offsetLeft);
        normalized.visualViewportY = Math.round(clientY - visualViewport.offsetTop);
    }
    return normalized;
};
exports.convertMouseEventToLayoutCoordinates = convertMouseEventToLayoutCoordinates;
var getVisualViewport = function (visualViewport) { return ({
    scale: visualViewport.scale,
    offsetLeft: visualViewport.offsetLeft,
    offsetTop: visualViewport.offsetTop,
    pageLeft: visualViewport.pageLeft,
    pageTop: visualViewport.pageTop,
    height: visualViewport.height,
    width: visualViewport.width,
}); };
exports.getVisualViewport = getVisualViewport;
//# sourceMappingURL=viewports.js.map
},{}],193:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetReplayStats = exports.getReplayStats = exports.addWroteData = exports.addRecord = exports.addSegment = exports.getSegmentsCount = exports.MAX_STATS_HISTORY = void 0;
exports.MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
    return getOrCreateReplayStats(viewId).segments_count;
}
exports.getSegmentsCount = getSegmentsCount;
function addSegment(viewId) {
    getOrCreateReplayStats(viewId).segments_count += 1;
}
exports.addSegment = addSegment;
function addRecord(viewId) {
    getOrCreateReplayStats(viewId).records_count += 1;
}
exports.addRecord = addRecord;
function addWroteData(viewId, additionalBytesCount) {
    getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
exports.addWroteData = addWroteData;
function getReplayStats(viewId) {
    return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
exports.getReplayStats = getReplayStats;
function resetReplayStats() {
    statsPerView = undefined;
}
exports.resetReplayStats = resetReplayStats;
function getOrCreateReplayStats(viewId) {
    if (!statsPerView) {
        statsPerView = new Map();
    }
    var replayStats;
    if (statsPerView.has(viewId)) {
        replayStats = statsPerView.get(viewId);
    }
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0,
        };
        statsPerView.set(viewId, replayStats);
        if (statsPerView.size > exports.MAX_STATS_HISTORY) {
            deleteOldestStats();
        }
    }
    return replayStats;
}
function deleteOldestStats() {
    if (!statsPerView) {
        return;
    }
    if (statsPerView.keys) {
        statsPerView.delete(statsPerView.keys().next().value);
    }
    else {
        // IE11 doesn't support map.keys
        var isFirst_1 = true;
        statsPerView.forEach(function (_value, key) {
            if (isFirst_1) {
                statsPerView.delete(key);
                isFirst_1 = false;
            }
        });
    }
}
//# sourceMappingURL=replayStats.js.map
},{}],194:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildReplayPayload = void 0;
var browser_core_1 = require("@datadog/browser-core");
function buildReplayPayload(data, metadata, rawSegmentBytesCount) {
    var formData = new FormData();
    formData.append('segment', new Blob([data], {
        type: 'application/octet-stream',
    }), "".concat(metadata.session.id, "-").concat(metadata.start));
    var metadataAndSegmentSizes = (0, browser_core_1.assign)({
        raw_segment_size: rawSegmentBytesCount,
        compressed_segment_size: data.byteLength,
    }, metadata);
    var serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
    formData.append('event', new Blob([serializedMetadataAndSegmentSizes], { type: 'application/json' }));
    return { data: formData, bytesCount: data.byteLength };
}
exports.buildReplayPayload = buildReplayPayload;
//# sourceMappingURL=buildReplayPayload.js.map
},{"@datadog/browser-core":56}],195:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEGMENT_BYTES_LIMIT = exports.setSegmentBytesLimit = exports.startSegmentCollection = void 0;
var segmentCollection_1 = require("./segmentCollection");
Object.defineProperty(exports, "startSegmentCollection", { enumerable: true, get: function () { return segmentCollection_1.startSegmentCollection; } });
Object.defineProperty(exports, "setSegmentBytesLimit", { enumerable: true, get: function () { return segmentCollection_1.setSegmentBytesLimit; } });
var segmentCollection_2 = require("./segmentCollection");
Object.defineProperty(exports, "SEGMENT_BYTES_LIMIT", { enumerable: true, get: function () { return segmentCollection_2.SEGMENT_BYTES_LIMIT; } });
//# sourceMappingURL=index.js.map
},{"./segmentCollection":197}],196:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Segment = void 0;
var browser_core_1 = require("@datadog/browser-core");
var types_1 = require("../../types");
var replayStats = __importStar(require("../replayStats"));
var Segment = /** @class */ (function () {
    function Segment(encoder, context, creationReason) {
        this.encoder = encoder;
        var viewId = context.view.id;
        this.metadata = (0, browser_core_1.assign)({
            start: Infinity,
            end: -Infinity,
            creation_reason: creationReason,
            records_count: 0,
            has_full_snapshot: false,
            index_in_view: replayStats.getSegmentsCount(viewId),
            source: 'browser',
        }, context);
        replayStats.addSegment(viewId);
    }
    Segment.prototype.addRecord = function (record, callback) {
        var _a;
        this.metadata.start = Math.min(this.metadata.start, record.timestamp);
        this.metadata.end = Math.max(this.metadata.end, record.timestamp);
        this.metadata.records_count += 1;
        (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === types_1.RecordType.FullSnapshot);
        (0, browser_core_1.sendToExtension)('record', { record: record, segment: this.metadata });
        replayStats.addRecord(this.metadata.view.id);
        var prefix = this.metadata.records_count === 1 ? '{"records":[' : ',';
        this.encoder.write(prefix + JSON.stringify(record), callback);
    };
    Segment.prototype.flush = function (callback) {
        var _this = this;
        if (this.metadata.records_count === 0) {
            throw new Error('Empty segment flushed');
        }
        this.encoder.write("],".concat(JSON.stringify(this.metadata).slice(1), "\n"), function () {
            replayStats.addWroteData(_this.metadata.view.id, _this.encoder.rawBytesCount);
            callback(_this.metadata);
        });
        this.encoder.reset();
    };
    return Segment;
}());
exports.Segment = Segment;
//# sourceMappingURL=segment.js.map
},{"../../types":199,"../replayStats":193,"@datadog/browser-core":56}],197:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSegmentBytesLimit = exports.computeSegmentContext = exports.doStartSegmentCollection = exports.startSegmentCollection = exports.SEGMENT_BYTES_LIMIT = exports.SEGMENT_DURATION_LIMIT = void 0;
var browser_core_1 = require("@datadog/browser-core");
var buildReplayPayload_1 = require("./buildReplayPayload");
var segment_1 = require("./segment");
exports.SEGMENT_DURATION_LIMIT = 30 * browser_core_1.ONE_SECOND;
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
exports.SEGMENT_BYTES_LIMIT = 60000;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as many records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment bytes count reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, httpRequest, encoder) {
    return doStartSegmentCollection(lifeCycle, function () { return computeSegmentContext(configuration.applicationId, sessionManager, viewContexts); }, httpRequest, encoder);
}
exports.startSegmentCollection = startSegmentCollection;
function doStartSegmentCollection(lifeCycle, getSegmentContext, httpRequest, encoder) {
    var state = {
        status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
        nextSegmentCreationReason: 'init',
    };
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function () {
        flushSegment('view_change');
    }).unsubscribe;
    var unsubscribePageExited = lifeCycle.subscribe(9 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
        flushSegment(pageExitEvent.reason);
    }).unsubscribe;
    function flushSegment(flushReason) {
        if (state.status === 1 /* SegmentCollectionStatus.SegmentPending */) {
            state.segment.flush(function (metadata) {
                var payload = (0, buildReplayPayload_1.buildReplayPayload)(encoder.encodedBytes, metadata, encoder.rawBytesCount);
                if ((0, browser_core_1.isPageExitReason)(flushReason)) {
                    httpRequest.sendOnExit(payload);
                }
                else {
                    httpRequest.send(payload);
                }
            });
            (0, browser_core_1.clearTimeout)(state.expirationTimeoutId);
        }
        if (flushReason !== 'stop') {
            state = {
                status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
                nextSegmentCreationReason: flushReason,
            };
        }
        else {
            state = {
                status: 2 /* SegmentCollectionStatus.Stopped */,
            };
        }
    }
    return {
        addRecord: function (record) {
            if (state.status === 2 /* SegmentCollectionStatus.Stopped */) {
                return;
            }
            if (state.status === 0 /* SegmentCollectionStatus.WaitingForInitialRecord */) {
                var context = getSegmentContext();
                if (!context) {
                    return;
                }
                state = {
                    status: 1 /* SegmentCollectionStatus.SegmentPending */,
                    segment: new segment_1.Segment(encoder, context, state.nextSegmentCreationReason),
                    expirationTimeoutId: (0, browser_core_1.setTimeout)(function () {
                        flushSegment('segment_duration_limit');
                    }, exports.SEGMENT_DURATION_LIMIT),
                };
            }
            var segment = state.segment;
            segment.addRecord(record, function () {
                if (
                // the written segment is still pending
                state.status === 1 /* SegmentCollectionStatus.SegmentPending */ &&
                    state.segment === segment &&
                    encoder.encodedBytesCount > exports.SEGMENT_BYTES_LIMIT) {
                    flushSegment('segment_bytes_limit');
                }
            });
        },
        stop: function () {
            flushSegment('stop');
            unsubscribeViewCreated();
            unsubscribePageExited();
        },
    };
}
exports.doStartSegmentCollection = doStartSegmentCollection;
function computeSegmentContext(applicationId, sessionManager, viewContexts) {
    var session = sessionManager.findTrackedSession();
    var viewContext = viewContexts.findView();
    if (!session || !viewContext) {
        return undefined;
    }
    return {
        application: {
            id: applicationId,
        },
        session: {
            id: session.id,
        },
        view: {
            id: viewContext.id,
        },
    };
}
exports.computeSegmentContext = computeSegmentContext;
function setSegmentBytesLimit(newSegmentBytesLimit) {
    if (newSegmentBytesLimit === void 0) { newSegmentBytesLimit = 60000; }
    exports.SEGMENT_BYTES_LIMIT = newSegmentBytesLimit;
}
exports.setSegmentBytesLimit = setSegmentBytesLimit;
//# sourceMappingURL=segmentCollection.js.map
},{"./buildReplayPayload":194,"./segment":196,"@datadog/browser-core":56}],198:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datadogRum = exports.DefaultPrivacyLevel = void 0;
// Keep the following in sync with packages/rum-slim/src/entries/main.ts
var browser_core_1 = require("@datadog/browser-core");
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var startRecording_1 = require("../boot/startRecording");
var recorderApi_1 = require("../boot/recorderApi");
var browser_core_2 = require("@datadog/browser-core");
Object.defineProperty(exports, "DefaultPrivacyLevel", { enumerable: true, get: function () { return browser_core_2.DefaultPrivacyLevel; } });
var recorderApi = (0, recorderApi_1.makeRecorderApi)(startRecording_1.startRecording);
exports.datadogRum = (0, browser_rum_core_1.makeRumPublicApi)(browser_rum_core_1.startRum, recorderApi);
(0, browser_core_1.defineGlobal)((0, browser_core_1.getGlobalObject)(), 'DD_RUM', exports.datadogRum);
//# sourceMappingURL=main.js.map
},{"../boot/recorderApi":157,"../boot/startRecording":158,"@datadog/browser-core":56,"@datadog/browser-rum-core":153}],199:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./sessionReplay"), exports);
__exportStar(require("./sessionReplayConstants"), exports);
//# sourceMappingURL=index.js.map
},{"./sessionReplay":200,"./sessionReplayConstants":201}],200:[function(require,module,exports){
"use strict";
/* eslint-disable */
/**
 * DO NOT MODIFY IT BY HAND. Run `yarn rum-events-format:sync` instead.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=sessionReplay.js.map
},{}],201:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaInteractionType = exports.MouseInteractionType = exports.IncrementalSource = exports.NodeType = exports.RecordType = void 0;
exports.RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
    FrustrationRecord: 9,
};
exports.NodeType = {
    Document: 0,
    DocumentType: 1,
    Element: 2,
    Text: 3,
    CDATA: 4,
    DocumentFragment: 11,
};
exports.IncrementalSource = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8,
    // CanvasMutation : 9,
    // Font : 10,
};
exports.MouseInteractionType = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9,
};
exports.MediaInteractionType = {
    Play: 0,
    Pause: 1,
};
//# sourceMappingURL=sessionReplayConstants.js.map
},{}],202:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Cookies = _interopDefault(require('js-cookie'));
var browserRum = require('@datadog/browser-rum');
var _get = _interopDefault(require('lodash.get'));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var config = {};
/**
 * convenience method to extend the config object.
 * @param defaults
 * @param options
 */
function mergeGlobalOptions(options) {
    if (options.apiBaseUrl) {
        var url = new URL(options.apiBaseUrl);
        options.apiBaseUrl = url.origin + '/v3/';
    }
    return (config = __assign(__assign({}, config), options));
}
var configure = mergeGlobalOptions;

var defaultHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
};
var RequestTypes;
(function (RequestTypes) {
    RequestTypes["Get"] = "GET";
    RequestTypes["Post"] = "POST";
    RequestTypes["Put"] = "PUT";
    RequestTypes["Patch"] = "PATCH";
    RequestTypes["Delete"] = "DELETE";
})(RequestTypes || (RequestTypes = {}));
function addAuthHeader(authToken) {
    defaultHeaders = __assign(__assign({}, defaultHeaders), {
        Authorization: "token " + authToken,
    });
}
function tryGetAuthTokenFromCookie() {
    var authToken = Cookies.get('mako_auth_token');
    return authToken;
}
function setHeaders() {
    if (!defaultHeaders.Authorization) {
        var token = tryGetAuthTokenFromCookie();
        if (token) {
            addAuthHeader(token);
        }
    }
    return defaultHeaders;
}
function buildRequest(requestType, body, requestOptions) {
    var request = {};
    var headers = setHeaders();
    if (requestOptions) {
        if (requestOptions.headers) {
            headers = __assign(__assign({}, headers), requestOptions.headers);
        }
        request = __assign({}, requestOptions);
    }
    request.headers = headers;
    request.method = requestType;
    if (body) {
        request.body = JSON.stringify(body);
    }
    return request;
}
function makeRequest(baseUri, uri, request) {
    if (baseUri === void 0) { baseUri = config.apiBaseUrl; }
    var url = "" + baseUri + uri;
    return fetch(url, request);
}
/**
 * Wrapper for the HTTP GET method
 * Requires the Return Type as the generic parameter
 * @param apiEndpoint - API Endpoint to hit
 * @param requestOptions - request options to override
 * @param baseUrl - optional parameter to change the root of the API being hit, defaults to MAKO API
 */
function get(apiEndpoint, requestOptions, baseUrl) {
    var request = buildRequest(RequestTypes.Get, undefined, requestOptions);
    return makeRequest(baseUrl, apiEndpoint, request);
}
/**
 * Wrapper for the HTTP POST method
 * Requires the Return Type as the generic parameter
 * @param apiEndpoint - API Endpoint to hit
 * @param body - json body to post
 * @param requestOptions - request options to override
 * @param baseUrl - optional parameter to change the root of the API being hit, defaults to MAKO API
 */
function post(apiEndpoint, body, requestOptions, baseUrl) {
    var request = buildRequest(RequestTypes.Post, body, requestOptions);
    return makeRequest(baseUrl, apiEndpoint, request);
}
/**
 * Wrapper for the HTTP PUT method
 * Requires the Return Type as the generic parameter
 * @param apiEndpoint - API Endpoint to hit
 * @param body - json body to post
 * @param requestOptions - request options to override
 * @param baseUrl - optional parameter to change the root of the API being hit, defaults to MAKO API
 */
function put(apiEndpoint, body, requestOptions, baseUrl) {
    var request = buildRequest(RequestTypes.Put, body, requestOptions);
    return makeRequest(baseUrl, apiEndpoint, request);
}
/**
 * Wrapper for the HTTP DELETE method
 * Requires the Return Type as the generic parameter
 * @param apiEndpoint - API Endpoint to hit
 * @param body - json body to post
 * @param requestOptions - request options to override
 * @param baseUrl - optional parameter to change the root of the API being hit, defaults to MAKO API
 */
function del(apiEndpoint, body, requestOptions, baseUrl) {
    var request = buildRequest(RequestTypes.Delete, body, requestOptions);
    return makeRequest(baseUrl, apiEndpoint, request);
}
/**
 * Wrapper for the MOCK HTTP method
 * Requires the Return Type as the generic parameter
 * @param apiEndpoint - API Endpoint to hit
 * @param body - json body to post
 * @param baseUrl - optional parameter to change the root of the API being hit, defaults to MAKO API
 */
function mock(apiEndpoint, body, baseUri) {
    var mockPromise = Promise.resolve({
        json: function () { return Promise.resolve({}); },
    });
    return mockPromise;
}
var http = {
    get: get,
    post: post,
    put: put,
    del: del,
    mock: mock,
    addAuthHeader: addAuthHeader,
};

function getUserAccount() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('user/account')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load user profile');
            }
        });
    });
}
function getUsername() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('user/username')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load username');
            }
        });
    });
}
function getFeatureToggles() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('feature_toggles')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load feature toggles');
            }
        });
    });
}
function getSignupStatus() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('s2s/signup/status')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load sign up status');
            }
        });
    });
}
function getUserPackage() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('user/package')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load user package');
            }
        });
    });
}
function getScopes() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('scopes')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load scopes');
            }
        });
    });
}
function getOesAccount() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('accounts/offerings?_show&_pricing&_offerings')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load OES account');
            }
        });
    });
}
function getApiKeys() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('api_keys')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load api keys');
            }
        });
    });
}
function getApiKey(apiKeyId) {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get("api_keys/" + apiKeyId)];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load api key');
            }
        });
    });
}
var api = {
    getUserAccount: getUserAccount,
    getUsername: getUsername,
    getFeatureToggles: getFeatureToggles,
    getSignupStatus: getSignupStatus,
    getUserPackage: getUserPackage,
    getScopes: getScopes,
    getOesAccount: getOesAccount,
    getApiKeys: getApiKeys,
    getApiKey: getApiKey,
};

var ProductId;
(function (ProductId) {
    ProductId["SG_DISCOUNT_COMMDEV_TIER_1_V1"] = "sg.discount.commdev-tier-1.v1";
    ProductId["SG_DISCOUNT_COMMDEV_TIER_2_V1"] = "sg.discount.commdev-tier-2.v1";
    ProductId["SG_DISCOUNT_COMMDEV_TIER_3_V1"] = "sg.discount.commdev-tier-3.v1";
    ProductId["SG_EI_BRONZE_V1"] = "sg.ei.bronze.v1";
    ProductId["SG_EI_ESSENTIALS_100K_V1"] = "sg.ei.essentials-100k.v1";
    ProductId["SG_EI_ESSENTIALS_100K_V2"] = "sg.ei.essentials-100k.v2";
    ProductId["SG_EI_ESSENTIALS_40K_V1"] = "sg.ei.essentials-40k.v1";
    ProductId["SG_EI_ESSENTIALS_40K_V2"] = "sg.ei.essentials-40k.v2";
    ProductId["SG_EI_ESSENTIALS_SUMMARY_V1"] = "sg.ei.essentials-summary.v1";
    ProductId["SG_EI_FREE_100_V1"] = "sg.ei.free-100.v1";
    ProductId["SG_EI_FREE_12K_V1"] = "sg.ei.free-12k.v1";
    ProductId["SG_EI_FREE_SUMMARY_V1"] = "sg.ei.free-summary.v1";
    ProductId["SG_EI_GOLD_V1"] = "sg.ei.gold.v1";
    ProductId["SG_EI_LITE_V1"] = "sg.ei.lite.v1";
    ProductId["SG_EI_MC_CLASSIC_ADDON_V1"] = "sg.ei.mc-classic-addon.v1";
    ProductId["SG_EI_PLATINUM_V1"] = "sg.ei.platinum.v1";
    ProductId["SG_EI_PREMIER_100M_V1"] = "sg.ei.premier-100m.v1";
    ProductId["SG_EI_PREMIER_100M_V2"] = "sg.ei.premier-100m.v2";
    ProductId["SG_EI_PREMIER_10M_V1"] = "sg.ei.premier-10m.v1";
    ProductId["SG_EI_PREMIER_10M_V2"] = "sg.ei.premier-10m.v2";
    ProductId["SG_EI_PREMIER_15M_V1"] = "sg.ei.premier-15m.v1";
    ProductId["SG_EI_PREMIER_15M_V2"] = "sg.ei.premier-15m.v2";
    ProductId["SG_EI_PREMIER_200M_V1"] = "sg.ei.premier-200m.v1";
    ProductId["SG_EI_PREMIER_200M_V2"] = "sg.ei.premier-200m.v2";
    ProductId["SG_EI_PREMIER_20M_V1"] = "sg.ei.premier-20m.v1";
    ProductId["SG_EI_PREMIER_20M_V2"] = "sg.ei.premier-20m.v2";
    ProductId["SG_EI_PREMIER_25M_V1"] = "sg.ei.premier-25m.v1";
    ProductId["SG_EI_PREMIER_25M_V2"] = "sg.ei.premier-25m.v2";
    ProductId["SG_EI_PREMIER_2P5M_V1"] = "sg.ei.premier-2p5m.v1";
    ProductId["SG_EI_PREMIER_300M_V1"] = "sg.ei.premier-300m.v1";
    ProductId["SG_EI_PREMIER_300M_V2"] = "sg.ei.premier-300m.v2";
    ProductId["SG_EI_PREMIER_3M_V1"] = "sg.ei.premier-3m.v1";
    ProductId["SG_EI_PREMIER_400M_V1"] = "sg.ei.premier-400m.v1";
    ProductId["SG_EI_PREMIER_400M_V2"] = "sg.ei.premier-400m.v2";
    ProductId["SG_EI_PREMIER_500M_V1"] = "sg.ei.premier-500m.v1";
    ProductId["SG_EI_PREMIER_500M_V2"] = "sg.ei.premier-500m.v2";
    ProductId["SG_EI_PREMIER_50M_V1"] = "sg.ei.premier-50m.v1";
    ProductId["SG_EI_PREMIER_50M_V2"] = "sg.ei.premier-50m.v2";
    ProductId["SG_EI_PREMIER_5M_V1"] = "sg.ei.premier-5m.v1";
    ProductId["SG_EI_PREMIER_5M_V2"] = "sg.ei.premier-5m.v2";
    ProductId["SG_EI_PREMIER_600M_V1"] = "sg.ei.premier-600m.v1";
    ProductId["SG_EI_PREMIER_600M_V2"] = "sg.ei.premier-600m.v2";
    ProductId["SG_EI_PREMIER_7P5M_V1"] = "sg.ei.premier-7p5m.v1";
    ProductId["SG_EI_PREMIER_7P5M_V2"] = "sg.ei.premier-7p5m.v2";
    ProductId["SG_EI_PREMIER_SUMMARY_V1"] = "sg.ei.premier-summary.v1";
    ProductId["SG_EI_PRO_100K_V1"] = "sg.ei.pro-100k.v1";
    ProductId["SG_EI_PRO_100K_V2"] = "sg.ei.pro-100k.v2";
    ProductId["SG_EI_PRO_1P5M_V1"] = "sg.ei.pro-1p5m.v1";
    ProductId["SG_EI_PRO_1P5M_V2"] = "sg.ei.pro-1p5m.v2";
    ProductId["SG_EI_PRO_2P5M_V1"] = "sg.ei.pro-2p5m.v1";
    ProductId["SG_EI_PRO_2P5M_V2"] = "sg.ei.pro-2p5m.v2";
    ProductId["SG_EI_PRO_2P5M_V3"] = "sg.ei.pro-2p5m.v3";
    ProductId["SG_EI_PRO_300K_V1"] = "sg.ei.pro-300k.v1";
    ProductId["SG_EI_PRO_300K_V2"] = "sg.ei.pro-300k.v2";
    ProductId["SG_EI_PRO_700K_V1"] = "sg.ei.pro-700k.v1";
    ProductId["SG_EI_PRO_700K_V2"] = "sg.ei.pro-700k.v2";
    ProductId["SG_EI_PRO_SUMMARY_V1"] = "sg.ei.pro-summary.v1";
    ProductId["SG_EI_SILVER_V1"] = "sg.ei.silver.v1";
    ProductId["SG_EI_TRIAL_40K_V1"] = "sg.ei.trial-40k.v1";
    ProductId["SG_LVS_BOOTCAMP_V1"] = "sg.lvs.bootcamp.v1";
    ProductId["SG_LVS_IMPLEMENTATION_V1"] = "sg.lvs.implementation.v1";
    ProductId["SG_LVS_PREMIER_INSIGHTS_V1"] = "sg.lvs.premier.insights.v1";
    ProductId["SG_LVS_PRO_INSIGHTS_V1"] = "sg.lvs.pro.insights.v1";
    ProductId["SG_MC_ADVANCED_100K_V1"] = "sg.mc.advanced-100k.v1";
    ProductId["SG_MC_ADVANCED_10K_V1"] = "sg.mc.advanced-10k.v1";
    ProductId["SG_MC_ADVANCED_10M_V1"] = "sg.mc.advanced-10m.v1";
    ProductId["SG_MC_ADVANCED_1M_V1"] = "sg.mc.advanced-1m.v1";
    ProductId["SG_MC_ADVANCED_200K_V1"] = "sg.mc.advanced-200k.v1";
    ProductId["SG_MC_ADVANCED_20K_V1"] = "sg.mc.advanced-20k.v1";
    ProductId["SG_MC_ADVANCED_500K_V1"] = "sg.mc.advanced-500k.v1";
    ProductId["SG_MC_ADVANCED_50K_V1"] = "sg.mc.advanced-50k.v1";
    ProductId["SG_MC_ADVANCED_5M_V1"] = "sg.mc.advanced-5m.v1";
    ProductId["SG_MC_BASIC_100K_V1"] = "sg.mc.basic-100k.v1";
    ProductId["SG_MC_BASIC_10K_V1"] = "sg.mc.basic-10k.v1";
    ProductId["SG_MC_BASIC_10M_V1"] = "sg.mc.basic-10m.v1";
    ProductId["SG_MC_BASIC_1M_V1"] = "sg.mc.basic-1m.v1";
    ProductId["SG_MC_BASIC_200K_V1"] = "sg.mc.basic-200k.v1";
    ProductId["SG_MC_BASIC_20K_V1"] = "sg.mc.basic-20k.v1";
    ProductId["SG_MC_BASIC_500K_V1"] = "sg.mc.basic-500k.v1";
    ProductId["SG_MC_BASIC_50K_V1"] = "sg.mc.basic-50k.v1";
    ProductId["SG_MC_BASIC_5K_V1"] = "sg.mc.basic-5k.v1";
    ProductId["SG_MC_BASIC_5M_V1"] = "sg.mc.basic-5m.v1";
    ProductId["SG_MC_FREE_V1"] = "sg.mc.free.v1";
    ProductId["SG_X_EASE_30_BRONZE_V1"] = "sg.x.ease-30-bronze.v1";
    ProductId["SG_X_EASE_30_ESSENTIALS_100K_V1"] = "sg.x.ease-30-essentials-100k.v1";
    ProductId["SG_X_EASE_30_ESSENTIALS_40K_V1"] = "sg.x.ease-30-essentials-40k.v1";
    ProductId["SG_X_EASE_30_GOLD_V1"] = "sg.x.ease-30-gold.v1";
    ProductId["SG_X_EASE_30_PLATINUM_V1"] = "sg.x.ease-30-platinum.v1";
    ProductId["SG_X_EASE_30_PREMIER_10M_V1"] = "sg.x.ease-30-premier-10m.v1";
    ProductId["SG_X_EASE_30_PREMIER_15M_V1"] = "sg.x.ease-30-premier-15m.v1";
    ProductId["SG_X_EASE_30_PREMIER_20M_V1"] = "sg.x.ease-30-premier-20m.v1";
    ProductId["SG_X_EASE_30_PREMIER_25M_V1"] = "sg.x.ease-30-premier-25m.v1";
    ProductId["SG_X_EASE_30_PREMIER_2P5M_V1"] = "sg.x.ease-30-premier-2p5m.v1";
    ProductId["SG_X_EASE_30_PREMIER_50M_V1"] = "sg.x.ease-30-premier-50m.v1";
    ProductId["SG_X_EASE_30_PREMIER_5M_V1"] = "sg.x.ease-30-premier-5m.v1";
    ProductId["SG_X_EASE_30_PREMIER_7P5M_V1"] = "sg.x.ease-30-premier-7p5m.v1";
    ProductId["SG_X_EASE_30_PRO_100K_V1"] = "sg.x.ease-30-pro-100k.v1";
    ProductId["SG_X_EASE_30_PRO_1P5M_V1"] = "sg.x.ease-30-pro-1p5m.v1";
    ProductId["SG_X_EASE_30_PRO_2P5M_V1"] = "sg.x.ease-30-pro-2p5m.v1";
    ProductId["SG_X_EASE_30_PRO_300K_V1"] = "sg.x.ease-30-pro-300k.v1";
    ProductId["SG_X_EASE_30_PRO_700K_V1"] = "sg.x.ease-30-pro-700k.v1";
    ProductId["SG_X_EASE_30_SILVER_V1"] = "sg.x.ease-30-silver.v1";
    ProductId["SG_X_EMAIL_TESTING_100_V1"] = "sg.x.email-testing-100.v1";
    ProductId["SG_X_EMAIL_TESTING_30_V1"] = "sg.x.email-testing-30.v1";
    ProductId["SG_X_EMAIL_TESTING_60_V1"] = "sg.x.email-testing-60.v1";
    ProductId["SG_X_IP_V1"] = "sg.x.ip.v1";
    ProductId["SG_X_IP_V2"] = "sg.x.ip.v2";
    ProductId["SG_X_PLACEHOLDER_V1"] = "sg.x.placeholder.v1";
    ProductId["SG_MC_CUSTOM_PRICING_V1"] = "sg.mc.custom-pricing.v1";
    ProductId["SG_EI_CUSTOM_PRICING_V1"] = "sg.ei.custom-pricing.v1";
    ProductId["SG_EI_PRO_2P5MLEGACY_V1"] = "sg.ei.pro-2p5mlegacy.v1";
    ProductId["SG_X_EMAIL_TESTING_0_V1"] = "no-additional-email-testing-credits";
    ProductId["SG_MC_CLASSIC_TRIAL_DISCOUNT_V1"] = "sg.mc.classic-trial-discount.v1";
})(ProductId || (ProductId = {}));

function isAccountVerified(signupStatus) {
    // Defaulting to true because we only want isVerified to be false if we 100% know it is false.
    // Without data, we can't know. We don't want to send messaging about account verification
    // unless we know they are unverified
    if (!signupStatus) {
        return true;
    }
    var email_complete = signupStatus.email_complete, email_required = signupStatus.email_required, mfa_complete = signupStatus.mfa_complete, mfa_required = signupStatus.mfa_required, whitelabel_complete = signupStatus.whitelabel_complete, whitelabel_required = signupStatus.whitelabel_required;
    if (email_required && !email_complete) {
        return false;
    }
    if (mfa_required && !mfa_complete) {
        return false;
    }
    if (whitelabel_required && !whitelabel_complete) {
        return false;
    }
    return true;
}
function mapScopesToTraits(scopes) {
    var hasTneAccess = (scopes && scopes.scopes && scopes.scopes.includes('marketing.read')) ||
        false;
    return {
        hasTneAccess: hasTneAccess,
    };
}
function mapSignupStatusToTraits(signupStatus) {
    var isVerified = isAccountVerified(signupStatus);
    return {
        isVerified: isVerified,
    };
}
function mapOesAccountToTraits(oesAccountDto) {
    var traits = {
        eiPlan: null,
        mcPlan: null,
        legacyMcPlan: null,
        legacyMCDiscountEligible: false,
        legacyMCDiscountActive: false,
    };
    if (!oesAccountDto) {
        return traits;
    }
    var offerings = oesAccountDto.offerings, entitlements = oesAccountDto.entitlements;
    var eiPlanName = /^sg\.ei\..+\.v\d+$/i;
    var mcPlanName = /^sg\.mc\..+\.v\d+$/i;
    offerings.forEach(function (offering) {
        if (offering.name === ProductId.SG_MC_CLASSIC_TRIAL_DISCOUNT_V1) {
            var endDate = new Date(offering.end_date);
            var dateFormatOptions = {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            };
            var formattedEndDate = endDate.toLocaleDateString('en-US', dateFormatOptions);
            traits.legacyMCDiscountActive = true;
            traits.legacyMCDiscountEndDate = offering.end_date;
            traits.legacyMCDiscountEndDateFormatted = formattedEndDate;
            return;
        }
        if (offering.name === ProductId.SG_EI_MC_CLASSIC_ADDON_V1) {
            traits.legacyMcPlan = offering.name;
            return;
        }
        if (eiPlanName.test(offering.name) && offering.type === 'package') {
            traits.eiPlan = offering.name;
            return;
        }
        if (mcPlanName.test(offering.name) && offering.type === 'package') {
            traits.mcPlan = offering.name;
            return;
        }
    });
    traits.legacyMCDiscountEligible =
        entitlements.compat_mc_classic_trial_eligible || false;
    return traits;
}
function mapAccountToTraits(account) {
    if (!account) {
        return {};
    }
    return {
        accountType: account.type,
        isResellerCustomer: account.is_reseller_customer,
    };
}
function mapUsernameToTraits(username) {
    if (!username) {
        return {};
    }
    return {
        userId: username.user_id,
    };
}
function mapPackageToTraits(userPackage) {
    if (!userPackage) {
        return {};
    }
    return {
        package: userPackage.name,
    };
}
function mapFeatureTogglesToTraits(featureToggles) {
    if (!featureToggles) {
        return {};
    }
    var featureTogglesCsv = featureToggles
        .map(function (ft) { return ft.app_name + "-" + ft.feature_name; })
        .join(',');
    return {
        featureToggles: featureTogglesCsv,
    };
}

function fetchUserTraits(authToken) {
    return __awaiter(this, void 0, Promise, function () {
        var usernamePromise, accountPromise, featureTogglesPromise, signupStatusPromise, userPackagePromise, scopesPromise, oesAccountPromise, username, account, featureToggles, signupStatus, userPackage, scopes, oesAccount, usernameTraits, featureTogglesTraits, packageTraits, accountTraits, traitsFromSignupStatus, traitsFromScopes, traitsFromOesAccount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    http.addAuthHeader(authToken);
                    usernamePromise = api.getUsername().catch(function () { return undefined; });
                    accountPromise = api.getUserAccount().catch(function () { return undefined; });
                    featureTogglesPromise = api.getFeatureToggles().catch(function () { return undefined; });
                    signupStatusPromise = api.getSignupStatus().catch(function () { return undefined; });
                    userPackagePromise = api.getUserPackage().catch(function () { return undefined; });
                    scopesPromise = api.getScopes().catch(function () { return undefined; });
                    oesAccountPromise = api.getOesAccount().catch(function () { return undefined; });
                    return [4 /*yield*/, usernamePromise];
                case 1:
                    username = _a.sent();
                    return [4 /*yield*/, accountPromise];
                case 2:
                    account = _a.sent();
                    return [4 /*yield*/, featureTogglesPromise];
                case 3:
                    featureToggles = _a.sent();
                    return [4 /*yield*/, signupStatusPromise];
                case 4:
                    signupStatus = _a.sent();
                    return [4 /*yield*/, userPackagePromise];
                case 5:
                    userPackage = _a.sent();
                    return [4 /*yield*/, scopesPromise];
                case 6:
                    scopes = _a.sent();
                    return [4 /*yield*/, oesAccountPromise];
                case 7:
                    oesAccount = _a.sent();
                    usernameTraits = mapUsernameToTraits(username);
                    featureTogglesTraits = mapFeatureTogglesToTraits(featureToggles);
                    packageTraits = mapPackageToTraits(userPackage);
                    accountTraits = mapAccountToTraits(account);
                    traitsFromSignupStatus = mapSignupStatusToTraits(signupStatus);
                    traitsFromScopes = mapScopesToTraits(scopes);
                    traitsFromOesAccount = mapOesAccountToTraits(oesAccount);
                    return [2 /*return*/, __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, featureTogglesTraits), packageTraits), usernameTraits), accountTraits), traitsFromSignupStatus), traitsFromScopes), traitsFromOesAccount)];
            }
        });
    });
}

function identify(identity) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, Promise, function () {
        var authToken, traits, baseTraits, userId, allTraits_1, error_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    authToken = identity.authToken, traits = identity.traits;
                    if (!authToken) {
                        // If no auth token was passed, perform an anonymous identify.
                        // Segment will generate an anonymousId to track the session.
                        (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.identify(traits);
                        (_b = window.DD_RUM) === null || _b === void 0 ? void 0 : _b.setUser(__assign({}, traits));
                        return [2 /*return*/];
                    }
                    validate();
                    return [4 /*yield*/, fetchUserTraits(authToken)];
                case 1:
                    baseTraits = _e.sent();
                    userId = baseTraits.userId;
                    setOptimizelyCustomAttributes(baseTraits);
                    // We have to know who the user is for authed identify to behave
                    // as expected. Don't send anything if we don't have a user Id.
                    // We could send the traits we were able to pull anonymously
                    // but in most scenarios if we are unable to load the user Id,
                    // the other calls will have failed as well.
                    if (!userId) {
                        return [2 /*return*/];
                    }
                    allTraits_1 = __assign(__assign({}, baseTraits), traits);
                    // Don't send any null or undefined traits to segment
                    Object.keys(allTraits_1).forEach(function (key) {
                        var value = allTraits_1[key];
                        if (value === null || value === undefined) {
                            delete allTraits_1[key];
                        }
                    });
                    (_c = window.analytics) === null || _c === void 0 ? void 0 : _c.identify(userId.toString(), allTraits_1);
                    (_d = window.DD_RUM) === null || _d === void 0 ? void 0 : _d.setUser(__assign({ id: userId.toString() }, allTraits_1));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _e.sent();
                    console.error('Failed to identify user', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function validate() {
    if (!config || !config.apiBaseUrl) {
        throw new Error("Cannot make auth'd calls without an apiBaseUrl. You'll need to re-init the analtyics config.");
    }
}
// This is a temporary home for setting Optimizely custom attributes
// for CL-182 since we haven't built out the experimentation module yet.
// It was coincidence that we were able to use traits to build the
// attributes for this experiement, but may not be a pattern to
// follow going forward. Traits can be sent verbatim as attributes,
// but we'll probably avoid *deriving* attributes from traits.
function setOptimizelyCustomAttributes(userTraits) {
    // CL-182 -- set Optimizely Custom Attributes for the User
    var eiPlan = userTraits.eiPlan, mcPlan = userTraits.mcPlan;
    var attributes = {
        isFreeMC: mcPlan && mcPlan.includes('free'),
        isFreeEI: eiPlan && (eiPlan.includes('free') || eiPlan.includes('trial')),
    };
    window.optimizely = window.optimizely || [];
    window.optimizely.push({
        type: 'user',
        attributes: attributes,
    });
}

/** Add filters to this list to enable them. */
var eventFilters = [];
var shouldDiscardEvent = function (event) {
    return eventFilters.some(function (filter) { return filter(event); });
};

var apiKeyRegex = /SG(\.[^.]+){2,}/g;
var ipRegex = /(\d{1,3}\.(?:\d{1,3}|\*(?=\.\*))\.(?:\d{1,3}|\*(?=\.\*))\.(?:\d{1,3}|\*)(?:\/\d{1,2})?(?:\[.*?\])?)/g;
var IP_REDACTED = 'IP_REDACTED';
var API_KEY_REDACTED = 'API_KEY_REDACTED';
/*
 * Add more redactions here and they'll run against all editable event fields.
 */
var redactions = [
    {
        searchValue: apiKeyRegex,
        replaceValue: API_KEY_REDACTED,
    },
    {
        searchValue: ipRegex,
        replaceValue: IP_REDACTED,
    },
];
var redactData = function (sourceString, searchValue, replaceValue) {
    if (!sourceString) {
        return sourceString;
    }
    return sourceString.replace(searchValue, replaceValue);
};
/** Redacts sensitive data from all editable fields of a RUM event.
 * https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#modify-the-content-of-a-rum-event
 */
var redactSensitiveData = function (event) {
    redactions.forEach(function (redaction) {
        var _a, _b;
        var searchValue = redaction.searchValue, replaceValue = redaction.replaceValue;
        event.view.url = redactData(event.view.url, searchValue, replaceValue);
        if (event.view.referrer) {
            event.view.referrer = redactData(event.view.referrer, searchValue, replaceValue);
        }
        if (event.type === 'error') {
            var error = event.error;
            error.message = redactData(error.message, searchValue, replaceValue);
            if (error.stack) {
                error.stack = redactData(error.stack, searchValue, replaceValue);
            }
            if (error.resource) {
                error.resource.url = redactData(error.resource.url, searchValue, replaceValue);
            }
        }
        if (event.type === 'resource') {
            event.resource.url = redactData(event.resource.url, searchValue, replaceValue);
        }
        if (event.type === 'action') {
            if ((_b = (_a = event.action) === null || _a === void 0 ? void 0 : _a.target) === null || _b === void 0 ? void 0 : _b.name) {
                event.action.target.name = redactData(event.action.target.name, searchValue, replaceValue);
            }
        }
    });
};

var REDACTED_PATH_PARAM = ':REDACTED';
var sendgridApiHosts = [
    'api.sendgrid.com',
    'api.staging.sendgrid.com',
];
var httpResourceTypes = ['xhr', 'fetch'];

var numberRegex = /(?<=\/)(\d+)(?=\/|\?|$)/g;
var emailRegex = /(?<=\/)(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]+@[A-Z0-9][A-Z0-9\-]*(\.[A-Z]{2,})+)(?=\/|\?|$)/gi;
var uuidv4Regex = /(?<=\/)([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?=\/|\?|$)/gi;
var redactApiKeyRegex = /(?<=\/api_keys\/)[^\/]*/;
var redactBillingInvoiceRegex = /(?<=\/billing\/invoice\/)[^\/]*/;
var redactVerifySenderRegex = /(?<=\/verified_senders\/verify\/)[^\/]*/;
var redactTeammateRegex = /(?<=\/teammates\/)[^\/]*/;
var redactSubusersRegex = /(?<=\/subusers\/)[^\/]*/;
var redactOfferingsRegex = /(?<=\/offerings\/)[^\/]*/;
var redactDynamicTemplateRegex = /(?<=\/dynamic_templates\/ui\/)[^\/]*/;
var redactPaymentRegex = /(?<=\/dashboard\/payment\/)([^\/]*)\/([^\/]*)/;

var redactPathParams = function (urlString) {
    var url = new URL(urlString);
    url.pathname = url.pathname
        .replace(numberRegex, REDACTED_PATH_PARAM)
        .replace(emailRegex, REDACTED_PATH_PARAM)
        .replace(uuidv4Regex, REDACTED_PATH_PARAM);
    return url.toString();
};
var redactSpecificAPIPathParams = function (urlString) {
    var url = new URL(urlString);
    url.pathname = url.pathname
        .replace(redactApiKeyRegex, REDACTED_PATH_PARAM)
        .replace(redactBillingInvoiceRegex, REDACTED_PATH_PARAM)
        .replace(redactVerifySenderRegex, REDACTED_PATH_PARAM)
        .replace(redactTeammateRegex, REDACTED_PATH_PARAM)
        .replace(redactSubusersRegex, REDACTED_PATH_PARAM)
        .replace(redactOfferingsRegex, REDACTED_PATH_PARAM);
    return url.toString();
};
var redactSpecificViewPathParams = function (urlString) {
    var url = new URL(urlString);
    url.pathname = url.pathname
        .replace(redactDynamicTemplateRegex, REDACTED_PATH_PARAM)
        .replace(redactPaymentRegex, REDACTED_PATH_PARAM + "/" + REDACTED_PATH_PARAM);
    return url.toString();
};
var redactUrlPathParams = function (event) {
    if (event.type === 'resource') {
        var host = new URL(event.resource.url).host;
        var shouldRedactPathParams = httpResourceTypes.includes(event.resource.type) &&
            sendgridApiHosts.includes(host);
        if (shouldRedactPathParams) {
            event.resource.url = redactPathParams(event.resource.url);
            event.resource.url = redactSpecificAPIPathParams(event.resource.url);
        }
    }
    if (event.type === 'view') {
        event.view.url = redactPathParams(event.view.url);
        event.view.url = redactSpecificViewPathParams(event.view.url);
    }
};

var REDACTED_PARAM = 'REDACTED';
/** Redacts search params from a URL
 * A query string is a place we can leak sensitive info. Some examples are:
 * One time use tokens (password reset, 2FA setup links, etc)
 * Filter/search parameters (email activity advanced search)
 */
var redactSearchParams = function (url) {
    try {
        var outputUrl_1 = new URL(url);
        outputUrl_1.searchParams.forEach(function (_, key) {
            outputUrl_1.searchParams.set(key, REDACTED_PARAM);
        });
        return outputUrl_1.toString();
    }
    catch (_a) {
        return '';
    }
};
/** Redacts search param values from all editable URLs of a RUM event.
 * https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#modify-the-content-of-a-rum-event
 */
var redactUrlSearchParams = function (event) {
    var _a;
    event.view.url = redactSearchParams(event.view.url);
    if (event.view.referrer) {
        event.view.referrer = redactSearchParams(event.view.referrer);
    }
    if (event.type === 'resource') {
        event.resource.url = redactSearchParams(event.resource.url);
    }
    if (event.type === 'error' && ((_a = event.error.resource) === null || _a === void 0 ? void 0 : _a.url)) {
        event.error.resource.url = redactSearchParams(event.error.resource.url);
    }
};

/** Add event processors to this list to enable them. */
var eventProcessors = [
    redactSensitiveData,
    redactUrlSearchParams,
    redactUrlPathParams,
];
var processEvent = function (event) {
    eventProcessors.forEach(function (processor) { return processor(event); });
};

/**
 * Executes the client's beforeSend function followed by internal
 * event processing if the event was not discarded.
 * @param clientBeforeSend beforeSend function provided by client during initialization
 * @returns The final beforeSend function used to initialize Datadog RUM
 */
function composeBeforeSend(clientBeforeSend) {
    var composedBeforeSend = function (event, context) {
        try {
            var isBeforeSendFunction = typeof clientBeforeSend === 'function';
            var isEventDiscardedByClient = isBeforeSendFunction && clientBeforeSend(event, context) === false;
            var isEventDiscarded = isEventDiscardedByClient || shouldDiscardEvent(event);
            if (isEventDiscarded) {
                return false;
            }
            processEvent(event);
        }
        catch (_a) {
            return false;
        }
    };
    return composedBeforeSend;
}

function initializeDatadogRum(options) {
    browserRum.datadogRum.init(__assign(__assign({}, options), { beforeSend: composeBeforeSend(options.beforeSend) }));
}

// This snippet is adapted from the segment documentation and is the
// recommended approach for bootstrapping.
// https://segment.com/docs/sources/website/analytics.js/quickstart/
function loadSegment(writeKey, options) {
    // Create a queue, but don't obliterate an existing one!
    var analytics = (window.analytics = window.analytics || []);
    // If the real analytics.js is already on the page return.
    if (analytics.initialize) {
        return;
    }
    // If the snippet was invoked already show an error.
    if (analytics.invoked) {
        if (window.console && console.error) {
            console.error('Segment snippet included twice.');
        }
        return;
    }
    // Invoked flag, to make sure the snippet
    // is never invoked twice.
    analytics.invoked = true;
    // A list of the methods in Analytics.js to stub.
    analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
    ];
    // Define a factory to create stubs. These are placeholders
    // for methods in Analytics.js so that you never have to wait
    // for it to load to actually record data. The `method` is
    // stored as the first argument, so we can replay the data.
    analytics.factory = function (method) {
        return function () {
            var args = Array.prototype.slice.call(arguments);
            args.unshift(method);
            if (analytics.push) {
                analytics.push(args);
            }
            return analytics;
        };
    };
    // For each of our methods, generate a queueing stub.
    for (var i = 0; i < analytics.methods.length; i++) {
        var key = analytics.methods[i];
        analytics[key] = analytics.factory(key);
    }
    // Define a method to load Analytics.js from our CDN,
    // and that will be sure to only ever load it once.
    analytics.load = function (key, options) {
        // Create an async script element based on your key.
        var script = document.createElement('script');
        script.id = 'segment-analytics-js';
        script.type = 'text/javascript';
        script.async = true;
        script.src =
            'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js';
        // Insert our script next to the first script element.
        var first = document.getElementsByTagName('script')[0];
        first.parentNode.insertBefore(script, first);
        analytics._loadOptions = options;
    };
    // Add a version to keep track of what's in the wild.
    analytics.SNIPPET_VERSION = '4.1.0';
    // Load Analytics.js with your key, which will automatically
    // load the tools you've enabled for your account. Boosh!
    analytics.load(writeKey, options);
}

function init(options) {
    try {
        validateAnalytics(options);
        mergeGlobalOptions(options);
        loadSegment(options.segmentApiKey);
        if (options.datadogRum) {
            initializeDatadogRum(options.datadogRum);
        }
    }
    catch (error) {
        console.error('Failed to initialize analytics', error);
    }
}
/**
 * validates the required defaults for Bloodhound and defaults particular to analytics
 * @param options
 */
function validateAnalytics(options) {
    if (!options || !options.segmentApiKey) {
        throw new Error("segmentApiKey is required");
    }
}

function getUserTraits() {
    if (!window.analytics ||
        !window.analytics.user ||
        !window.analytics.user().traits) {
        return {};
    }
    var userTraits = window.analytics.user().traits() || {};
    return Object.keys(userTraits).reduce(function (acc, trait) {
        var key = "trait_" + trait;
        acc[key] = userTraits[trait];
        return acc;
    }, {});
}

function page(data) {
    if (data === void 0) { data = {}; }
    var _a;
    try {
        var userTraits = getUserTraits();
        var optionalProperties = data.properties ? data.properties : {};
        var combinedProperties = __assign(__assign({}, userTraits), optionalProperties);
        (_a = window === null || window === void 0 ? void 0 : window.analytics) === null || _a === void 0 ? void 0 : _a.page(data.name, combinedProperties);
    }
    catch (error) {
        console.error('Failed to track page event.', error);
    }
}

/**
 * Use this function to reset a user’s identity to an anonymous state after they have logged out.
 */
function resetIdentity() {
    var _a, _b;
    try {
        (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.reset();
        (_b = window.DD_RUM) === null || _b === void 0 ? void 0 : _b.clearUser();
    }
    catch (_c) {
        console.warn('Failed to reset analytics identity');
    }
}

function track(data) {
    var _a, _b;
    var defaultProperties = {
        page: null,
        location: null,
        section: null,
        subsection: null,
        eventType: null,
        elementType: null,
    };
    try {
        if (!data) {
            console.warn('Data must be passed to the track event');
            return;
        }
        if (!data.event) {
            console.warn('Event name is required');
            return;
        }
        var userTraits = getUserTraits();
        var optionalProperties = data.properties ? data.properties : {};
        var combinedProperties = __assign(__assign(__assign({}, defaultProperties), userTraits), optionalProperties);
        (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.track(data.event, combinedProperties);
        (_b = window.DD_RUM) === null || _b === void 0 ? void 0 : _b.addAction(data.event, data.properties);
    }
    catch (error) {
        console.log('Failed to track event', error);
    }
    finally {
        // Generally used to give the browser time to make outbound requests
        // (send the events) before a redirect. We want to run this even if
        // tracking fails because tracking is non critical behavior.
        if (data.callback) {
            window.setTimeout(function () { return data.callback(); }, 300);
        }
    }
}

function trackLink(data) {
    var _a, _b;
    var defaultProperties = {
        page: null,
        location: null,
        section: null,
        subsection: null,
        eventType: null,
        elementType: null,
    };
    try {
        if (!data) {
            console.warn('Data must be passed to the trackLink event');
            return;
        }
        if (!data.event) {
            console.warn('Event name is required for trackLink');
            return;
        }
        if (!data.element) {
            console.warn('An element is required for trackLink');
            return;
        }
        var userTraits = getUserTraits();
        var optionalProperties = data.properties ? data.properties : {};
        var combinedProperties = __assign(__assign(__assign({}, defaultProperties), userTraits), optionalProperties);
        (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.trackLink(data.element, data.event, combinedProperties);
        (_b = window.DD_RUM) === null || _b === void 0 ? void 0 : _b.addAction(data.event, data.properties);
    }
    catch (error) {
        console.log('Failed to track event', error);
    }
}

var analytics = {
    identify: identify,
    init: init,
    page: page,
    track: track,
    trackLink: trackLink,
    configure: configure,
    resetIdentity: resetIdentity,
};

/**
 * Get ExperimentState object from optimizely
 *   - https://developers.optimizely.com/x/solutions/javascript/reference/index.html#function_getexperimentstates
 * @param {string} experimentId Optimizely Experiment Id
 * @returns {ExperimentState|Object} Optimizely Experiment state, or an empty object if there is none
 */
function getExperimentState(experimentId) {
    try {
        var optimizely = window.optimizely;
        if (!optimizely) {
            return {};
        }
        var state = optimizely.get('state');
        var experimentStates = state && state.getExperimentStates();
        return _get(experimentStates, experimentId, {});
    }
    catch (error) {
        console.error('Error getting experiment state', error);
    }
}

/**
 * Given an experiment and variation, is the user in the supplied variation?
 * @param {string} experimentId Optimizely Experiment Id
 * @param {string} variationId Optimizely Experiment Variation Id
 * @returns {boolean} is the user bucketed into the variation supplied?
 */
var isUserInVariation = function (experimentId, variationId) {
    return !experimentId || !variationId
        ? false
        : _get(getExperimentState(experimentId), 'variation.id', '') ===
            variationId;
};

var getEmailValidationKey = function (apiKeys) {
    return !!apiKeys.find(function (apiKey) {
        var subScope = 'validations.email';
        return (!!apiKey.scopes &&
            !!apiKey.scopes.find(function (scope) { return scope.indexOf(subScope) !== -1; }));
    });
};
var getEmailApiPlan = function (oesAccount) {
    return oesAccount.offerings.find(function (offering) {
        var eiPlanName = /^sg\.ei\..+\.v\d+$/i;
        return eiPlanName.test(offering.name) && offering.type === 'package';
    });
};

var _a;
var notificationExperimentPlans = (_a = {},
    _a[ProductId.SG_EI_SILVER_V1] = ProductId.SG_EI_SILVER_V1,
    _a[ProductId.SG_EI_GOLD_V1] = ProductId.SG_EI_GOLD_V1,
    _a[ProductId.SG_EI_PLATINUM_V1] = ProductId.SG_EI_PLATINUM_V1,
    _a[ProductId.SG_EI_PREMIER_2P5M_V1] = ProductId.SG_EI_PREMIER_2P5M_V1,
    _a[ProductId.SG_EI_PREMIER_3M_V1] = ProductId.SG_EI_PREMIER_3M_V1,
    _a[ProductId.SG_EI_PREMIER_5M_V1] = ProductId.SG_EI_PREMIER_5M_V1,
    _a[ProductId.SG_EI_PREMIER_5M_V2] = ProductId.SG_EI_PREMIER_5M_V2,
    _a[ProductId.SG_EI_PREMIER_7P5M_V1] = ProductId.SG_EI_PREMIER_7P5M_V1,
    _a[ProductId.SG_EI_PREMIER_7P5M_V2] = ProductId.SG_EI_PREMIER_7P5M_V2,
    _a[ProductId.SG_EI_PREMIER_10M_V1] = ProductId.SG_EI_PREMIER_10M_V1,
    _a[ProductId.SG_EI_PREMIER_10M_V2] = ProductId.SG_EI_PREMIER_10M_V2,
    _a[ProductId.SG_EI_PREMIER_15M_V1] = ProductId.SG_EI_PREMIER_15M_V1,
    _a[ProductId.SG_EI_PREMIER_15M_V2] = ProductId.SG_EI_PREMIER_15M_V2,
    _a[ProductId.SG_EI_PREMIER_20M_V1] = ProductId.SG_EI_PREMIER_20M_V1,
    _a[ProductId.SG_EI_PREMIER_20M_V2] = ProductId.SG_EI_PREMIER_20M_V2,
    _a[ProductId.SG_EI_PREMIER_25M_V1] = ProductId.SG_EI_PREMIER_25M_V1,
    _a[ProductId.SG_EI_PREMIER_25M_V2] = ProductId.SG_EI_PREMIER_25M_V2,
    _a[ProductId.SG_EI_PREMIER_50M_V1] = ProductId.SG_EI_PREMIER_50M_V1,
    _a[ProductId.SG_EI_PREMIER_50M_V2] = ProductId.SG_EI_PREMIER_50M_V2,
    _a[ProductId.SG_EI_PREMIER_100M_V1] = ProductId.SG_EI_PREMIER_100M_V1,
    _a[ProductId.SG_EI_PREMIER_100M_V2] = ProductId.SG_EI_PREMIER_100M_V2,
    _a[ProductId.SG_EI_PREMIER_200M_V1] = ProductId.SG_EI_PREMIER_200M_V1,
    _a[ProductId.SG_EI_PREMIER_200M_V2] = ProductId.SG_EI_PREMIER_200M_V2,
    _a[ProductId.SG_EI_PREMIER_300M_V1] = ProductId.SG_EI_PREMIER_300M_V1,
    _a[ProductId.SG_EI_PREMIER_300M_V2] = ProductId.SG_EI_PREMIER_300M_V2,
    _a[ProductId.SG_EI_PREMIER_400M_V1] = ProductId.SG_EI_PREMIER_400M_V1,
    _a[ProductId.SG_EI_PREMIER_400M_V2] = ProductId.SG_EI_PREMIER_400M_V2,
    _a[ProductId.SG_EI_PREMIER_500M_V1] = ProductId.SG_EI_PREMIER_500M_V1,
    _a[ProductId.SG_EI_PREMIER_500M_V2] = ProductId.SG_EI_PREMIER_500M_V2,
    _a[ProductId.SG_EI_PREMIER_600M_V1] = ProductId.SG_EI_PREMIER_600M_V1,
    _a[ProductId.SG_EI_PREMIER_600M_V2] = ProductId.SG_EI_PREMIER_600M_V2,
    _a[ProductId.SG_EI_PRO_100K_V1] = ProductId.SG_EI_PRO_100K_V1,
    _a[ProductId.SG_EI_PRO_100K_V2] = ProductId.SG_EI_PRO_100K_V2,
    _a[ProductId.SG_EI_PRO_300K_V1] = ProductId.SG_EI_PRO_300K_V1,
    _a[ProductId.SG_EI_PRO_300K_V2] = ProductId.SG_EI_PRO_300K_V2,
    _a[ProductId.SG_EI_PRO_700K_V1] = ProductId.SG_EI_PRO_700K_V1,
    _a[ProductId.SG_EI_PRO_700K_V2] = ProductId.SG_EI_PRO_700K_V2,
    _a[ProductId.SG_EI_PRO_1P5M_V1] = ProductId.SG_EI_PRO_1P5M_V1,
    _a[ProductId.SG_EI_PRO_1P5M_V2] = ProductId.SG_EI_PRO_1P5M_V2,
    _a[ProductId.SG_EI_PRO_2P5M_V1] = ProductId.SG_EI_PRO_2P5M_V1,
    _a[ProductId.SG_EI_PRO_2P5M_V2] = ProductId.SG_EI_PRO_2P5M_V2,
    _a[ProductId.SG_EI_PRO_2P5M_V3] = ProductId.SG_EI_PRO_2P5M_V3,
    _a[ProductId.SG_EI_PRO_2P5MLEGACY_V1] = ProductId.SG_EI_PRO_2P5MLEGACY_V1,
    _a);

function shouldDisplayNCExperimentAsync() {
    return __awaiter(this, void 0, void 0, function () {
        var getApiKeysPromise, getEIPlanPromise, _a, apiKeys, oesAccount, hasEmailValidationApiKey_1, emailApiPlan_1, ncExperimentPromise, err_1;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    getApiKeysPromise = (function () { return __awaiter(_this, void 0, void 0, function () {
                        var apiKeysData, apiKeyScopesData;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, getApiKeys()];
                                case 1:
                                    apiKeysData = _a.sent();
                                    apiKeyScopesData = apiKeysData.result.map(function (apiKey) {
                                        return getApiKey(apiKey.api_key_id);
                                    });
                                    return [2 /*return*/, Promise.all(apiKeyScopesData)];
                            }
                        });
                    }); })();
                    getEIPlanPromise = getOesAccount();
                    return [4 /*yield*/, Promise.all([
                            getApiKeysPromise,
                            getEIPlanPromise,
                        ])];
                case 1:
                    _a = _b.sent(), apiKeys = _a[0], oesAccount = _a[1];
                    hasEmailValidationApiKey_1 = getEmailValidationKey(apiKeys);
                    emailApiPlan_1 = getEmailApiPlan(oesAccount);
                    ncExperimentPromise = new Promise(function (resolve, reject) {
                        var counter = 0;
                        var appcuesInterval = setInterval(function () { return checkForAppcues(); }, 300);
                        var checkForAppcues = function () {
                            counter++;
                            if (window.Appcues &&
                                window.optimizely &&
                                window.AppcuesWidget) {
                                var isEligibleForNotificationCenter = emailApiPlan_1 &&
                                    !!notificationExperimentPlans[emailApiPlan_1.name] &&
                                    !hasEmailValidationApiKey_1;
                                window.optimizely.push({
                                    type: 'user',
                                    attributes: {
                                        isEligibleForNotificationCenter: isEligibleForNotificationCenter,
                                    },
                                });
                                resolve(isEligibleForNotificationCenter);
                                return clearInterval(appcuesInterval);
                            }
                            if (counter > 90) {
                                // If appcues, optimizely, or appcuesWidget fails we want to clear the interval to prevent it from running indefinitely
                                resolve(false);
                                return clearInterval(appcuesInterval);
                            }
                        };
                    });
                    return [2 /*return*/, ncExperimentPromise];
                case 2:
                    err_1 = _b.sent();
                    console.error('Failed to determine if user is in experiment', err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}

var experiments = {
    isUserInVariation: isUserInVariation,
    getExperimentState: getExperimentState,
    shouldDisplayNCExperimentAsync: shouldDisplayNCExperimentAsync,
};

exports.analytics = analytics;
exports.experiments = experiments;

},{"@datadog/browser-rum":198,"js-cookie":203,"lodash.get":205}],203:[function(require,module,exports){
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

},{}],204:[function(require,module,exports){
/*! js-cookie v3.0.5 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  })());
})(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (name, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      name = encodeURIComponent(name)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        name + '=' + converter.write(value, name) + stringifiedAttributes)
    }

    function get (name) {
      if (typeof document === 'undefined' || (arguments.length && !name)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var found = decodeURIComponent(parts[0]);
          jar[found] = converter.read(value, found);

          if (name === found) {
            break
          }
        } catch (e) {}
      }

      return name ? jar[name] : jar
    }

    return Object.create(
      {
        set,
        get,
        remove: function (name, attributes) {
          set(
            name,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

}));

},{}],205:[function(require,module,exports){
(function (global){
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],206:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;

},{"./_getNative":294,"./_root":339}],207:[function(require,module,exports){
var hashClear = require('./_hashClear'),
    hashDelete = require('./_hashDelete'),
    hashGet = require('./_hashGet'),
    hashHas = require('./_hashHas'),
    hashSet = require('./_hashSet');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

},{"./_hashClear":302,"./_hashDelete":303,"./_hashGet":304,"./_hashHas":305,"./_hashSet":306}],208:[function(require,module,exports){
var listCacheClear = require('./_listCacheClear'),
    listCacheDelete = require('./_listCacheDelete'),
    listCacheGet = require('./_listCacheGet'),
    listCacheHas = require('./_listCacheHas'),
    listCacheSet = require('./_listCacheSet');

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

},{"./_listCacheClear":318,"./_listCacheDelete":319,"./_listCacheGet":320,"./_listCacheHas":321,"./_listCacheSet":322}],209:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

},{"./_getNative":294,"./_root":339}],210:[function(require,module,exports){
var mapCacheClear = require('./_mapCacheClear'),
    mapCacheDelete = require('./_mapCacheDelete'),
    mapCacheGet = require('./_mapCacheGet'),
    mapCacheHas = require('./_mapCacheHas'),
    mapCacheSet = require('./_mapCacheSet');

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

},{"./_mapCacheClear":323,"./_mapCacheDelete":324,"./_mapCacheGet":325,"./_mapCacheHas":326,"./_mapCacheSet":327}],211:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;

},{"./_getNative":294,"./_root":339}],212:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;

},{"./_getNative":294,"./_root":339}],213:[function(require,module,exports){
var MapCache = require('./_MapCache'),
    setCacheAdd = require('./_setCacheAdd'),
    setCacheHas = require('./_setCacheHas');

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;

},{"./_MapCache":210,"./_setCacheAdd":340,"./_setCacheHas":341}],214:[function(require,module,exports){
var ListCache = require('./_ListCache'),
    stackClear = require('./_stackClear'),
    stackDelete = require('./_stackDelete'),
    stackGet = require('./_stackGet'),
    stackHas = require('./_stackHas'),
    stackSet = require('./_stackSet');

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;

},{"./_ListCache":208,"./_stackClear":345,"./_stackDelete":346,"./_stackGet":347,"./_stackHas":348,"./_stackSet":349}],215:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;

},{"./_root":339}],216:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;

},{"./_root":339}],217:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;

},{"./_getNative":294,"./_root":339}],218:[function(require,module,exports){
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;

},{}],219:[function(require,module,exports){
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;

},{}],220:[function(require,module,exports){
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;

},{}],221:[function(require,module,exports){
var baseTimes = require('./_baseTimes'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray'),
    isBuffer = require('./isBuffer'),
    isIndex = require('./_isIndex'),
    isTypedArray = require('./isTypedArray');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

},{"./_baseTimes":261,"./_isIndex":311,"./isArguments":361,"./isArray":362,"./isBuffer":364,"./isTypedArray":373}],222:[function(require,module,exports){
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

},{}],223:[function(require,module,exports){
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;

},{}],224:[function(require,module,exports){
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;

},{}],225:[function(require,module,exports){
var baseAssignValue = require('./_baseAssignValue'),
    eq = require('./eq');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;

},{"./_baseAssignValue":229,"./eq":356}],226:[function(require,module,exports){
var eq = require('./eq');

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

},{"./eq":356}],227:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    keys = require('./keys');

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;

},{"./_copyObject":277,"./keys":374}],228:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    keysIn = require('./keysIn');

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;

},{"./_copyObject":277,"./keysIn":375}],229:[function(require,module,exports){
var defineProperty = require('./_defineProperty');

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;

},{"./_defineProperty":284}],230:[function(require,module,exports){
var Stack = require('./_Stack'),
    arrayEach = require('./_arrayEach'),
    assignValue = require('./_assignValue'),
    baseAssign = require('./_baseAssign'),
    baseAssignIn = require('./_baseAssignIn'),
    cloneBuffer = require('./_cloneBuffer'),
    copyArray = require('./_copyArray'),
    copySymbols = require('./_copySymbols'),
    copySymbolsIn = require('./_copySymbolsIn'),
    getAllKeys = require('./_getAllKeys'),
    getAllKeysIn = require('./_getAllKeysIn'),
    getTag = require('./_getTag'),
    initCloneArray = require('./_initCloneArray'),
    initCloneByTag = require('./_initCloneByTag'),
    initCloneObject = require('./_initCloneObject'),
    isArray = require('./isArray'),
    isBuffer = require('./isBuffer'),
    isMap = require('./isMap'),
    isObject = require('./isObject'),
    isSet = require('./isSet'),
    keys = require('./keys'),
    keysIn = require('./keysIn');

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;

},{"./_Stack":214,"./_arrayEach":219,"./_assignValue":225,"./_baseAssign":227,"./_baseAssignIn":228,"./_cloneBuffer":269,"./_copyArray":276,"./_copySymbols":278,"./_copySymbolsIn":279,"./_getAllKeys":290,"./_getAllKeysIn":291,"./_getTag":299,"./_initCloneArray":307,"./_initCloneByTag":308,"./_initCloneObject":309,"./isArray":362,"./isBuffer":364,"./isMap":367,"./isObject":368,"./isSet":371,"./keys":374,"./keysIn":375}],231:[function(require,module,exports){
var isObject = require('./isObject');

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;

},{"./isObject":368}],232:[function(require,module,exports){
var baseForOwn = require('./_baseForOwn'),
    createBaseEach = require('./_createBaseEach');

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;

},{"./_baseForOwn":235,"./_createBaseEach":281}],233:[function(require,module,exports){
var arrayPush = require('./_arrayPush'),
    isFlattenable = require('./_isFlattenable');

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;

},{"./_arrayPush":223,"./_isFlattenable":310}],234:[function(require,module,exports){
var createBaseFor = require('./_createBaseFor');

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;

},{"./_createBaseFor":282}],235:[function(require,module,exports){
var baseFor = require('./_baseFor'),
    keys = require('./keys');

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;

},{"./_baseFor":234,"./keys":374}],236:[function(require,module,exports){
var castPath = require('./_castPath'),
    toKey = require('./_toKey');

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;

},{"./_castPath":267,"./_toKey":351}],237:[function(require,module,exports){
var arrayPush = require('./_arrayPush'),
    isArray = require('./isArray');

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;

},{"./_arrayPush":223,"./isArray":362}],238:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    getRawTag = require('./_getRawTag'),
    objectToString = require('./_objectToString');

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;

},{"./_Symbol":215,"./_getRawTag":296,"./_objectToString":335}],239:[function(require,module,exports){
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;

},{}],240:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

},{"./_baseGetTag":238,"./isObjectLike":369}],241:[function(require,module,exports){
var baseIsEqualDeep = require('./_baseIsEqualDeep'),
    isObjectLike = require('./isObjectLike');

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;

},{"./_baseIsEqualDeep":242,"./isObjectLike":369}],242:[function(require,module,exports){
var Stack = require('./_Stack'),
    equalArrays = require('./_equalArrays'),
    equalByTag = require('./_equalByTag'),
    equalObjects = require('./_equalObjects'),
    getTag = require('./_getTag'),
    isArray = require('./isArray'),
    isBuffer = require('./isBuffer'),
    isTypedArray = require('./isTypedArray');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;

},{"./_Stack":214,"./_equalArrays":285,"./_equalByTag":286,"./_equalObjects":287,"./_getTag":299,"./isArray":362,"./isBuffer":364,"./isTypedArray":373}],243:[function(require,module,exports){
var getTag = require('./_getTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;

},{"./_getTag":299,"./isObjectLike":369}],244:[function(require,module,exports){
var Stack = require('./_Stack'),
    baseIsEqual = require('./_baseIsEqual');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;

},{"./_Stack":214,"./_baseIsEqual":241}],245:[function(require,module,exports){
var isFunction = require('./isFunction'),
    isMasked = require('./_isMasked'),
    isObject = require('./isObject'),
    toSource = require('./_toSource');

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

},{"./_isMasked":315,"./_toSource":352,"./isFunction":365,"./isObject":368}],246:[function(require,module,exports){
var getTag = require('./_getTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;

},{"./_getTag":299,"./isObjectLike":369}],247:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isLength = require('./isLength'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

},{"./_baseGetTag":238,"./isLength":366,"./isObjectLike":369}],248:[function(require,module,exports){
var baseMatches = require('./_baseMatches'),
    baseMatchesProperty = require('./_baseMatchesProperty'),
    identity = require('./identity'),
    isArray = require('./isArray'),
    property = require('./property');

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;

},{"./_baseMatches":252,"./_baseMatchesProperty":253,"./identity":360,"./isArray":362,"./property":380}],249:[function(require,module,exports){
var isPrototype = require('./_isPrototype'),
    nativeKeys = require('./_nativeKeys');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;

},{"./_isPrototype":316,"./_nativeKeys":332}],250:[function(require,module,exports){
var isObject = require('./isObject'),
    isPrototype = require('./_isPrototype'),
    nativeKeysIn = require('./_nativeKeysIn');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;

},{"./_isPrototype":316,"./_nativeKeysIn":333,"./isObject":368}],251:[function(require,module,exports){
var baseEach = require('./_baseEach'),
    isArrayLike = require('./isArrayLike');

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;

},{"./_baseEach":232,"./isArrayLike":363}],252:[function(require,module,exports){
var baseIsMatch = require('./_baseIsMatch'),
    getMatchData = require('./_getMatchData'),
    matchesStrictComparable = require('./_matchesStrictComparable');

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;

},{"./_baseIsMatch":244,"./_getMatchData":293,"./_matchesStrictComparable":329}],253:[function(require,module,exports){
var baseIsEqual = require('./_baseIsEqual'),
    get = require('./get'),
    hasIn = require('./hasIn'),
    isKey = require('./_isKey'),
    isStrictComparable = require('./_isStrictComparable'),
    matchesStrictComparable = require('./_matchesStrictComparable'),
    toKey = require('./_toKey');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;

},{"./_baseIsEqual":241,"./_isKey":313,"./_isStrictComparable":317,"./_matchesStrictComparable":329,"./_toKey":351,"./get":358,"./hasIn":359}],254:[function(require,module,exports){
var arrayMap = require('./_arrayMap'),
    baseGet = require('./_baseGet'),
    baseIteratee = require('./_baseIteratee'),
    baseMap = require('./_baseMap'),
    baseSortBy = require('./_baseSortBy'),
    baseUnary = require('./_baseUnary'),
    compareMultiple = require('./_compareMultiple'),
    identity = require('./identity'),
    isArray = require('./isArray');

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;

},{"./_arrayMap":222,"./_baseGet":236,"./_baseIteratee":248,"./_baseMap":251,"./_baseSortBy":260,"./_baseUnary":264,"./_compareMultiple":275,"./identity":360,"./isArray":362}],255:[function(require,module,exports){
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;

},{}],256:[function(require,module,exports){
var baseGet = require('./_baseGet');

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;

},{"./_baseGet":236}],257:[function(require,module,exports){
var identity = require('./identity'),
    overRest = require('./_overRest'),
    setToString = require('./_setToString');

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;

},{"./_overRest":337,"./_setToString":343,"./identity":360}],258:[function(require,module,exports){
var constant = require('./constant'),
    defineProperty = require('./_defineProperty'),
    identity = require('./identity');

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;

},{"./_defineProperty":284,"./constant":354,"./identity":360}],259:[function(require,module,exports){
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;

},{}],260:[function(require,module,exports){
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;

},{}],261:[function(require,module,exports){
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

},{}],262:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    arrayMap = require('./_arrayMap'),
    isArray = require('./isArray'),
    isSymbol = require('./isSymbol');

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;

},{"./_Symbol":215,"./_arrayMap":222,"./isArray":362,"./isSymbol":372}],263:[function(require,module,exports){
var trimmedEndIndex = require('./_trimmedEndIndex');

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;

},{"./_trimmedEndIndex":353}],264:[function(require,module,exports){
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;

},{}],265:[function(require,module,exports){
var castPath = require('./_castPath'),
    last = require('./last'),
    parent = require('./_parent'),
    toKey = require('./_toKey');

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;

},{"./_castPath":267,"./_parent":338,"./_toKey":351,"./last":376}],266:[function(require,module,exports){
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;

},{}],267:[function(require,module,exports){
var isArray = require('./isArray'),
    isKey = require('./_isKey'),
    stringToPath = require('./_stringToPath'),
    toString = require('./toString');

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;

},{"./_isKey":313,"./_stringToPath":350,"./isArray":362,"./toString":385}],268:[function(require,module,exports){
var Uint8Array = require('./_Uint8Array');

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;

},{"./_Uint8Array":216}],269:[function(require,module,exports){
var root = require('./_root');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

},{"./_root":339}],270:[function(require,module,exports){
var cloneArrayBuffer = require('./_cloneArrayBuffer');

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;

},{"./_cloneArrayBuffer":268}],271:[function(require,module,exports){
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;

},{}],272:[function(require,module,exports){
var Symbol = require('./_Symbol');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;

},{"./_Symbol":215}],273:[function(require,module,exports){
var cloneArrayBuffer = require('./_cloneArrayBuffer');

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;

},{"./_cloneArrayBuffer":268}],274:[function(require,module,exports){
var isSymbol = require('./isSymbol');

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;

},{"./isSymbol":372}],275:[function(require,module,exports){
var compareAscending = require('./_compareAscending');

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;

},{"./_compareAscending":274}],276:[function(require,module,exports){
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;

},{}],277:[function(require,module,exports){
var assignValue = require('./_assignValue'),
    baseAssignValue = require('./_baseAssignValue');

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;

},{"./_assignValue":225,"./_baseAssignValue":229}],278:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    getSymbols = require('./_getSymbols');

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;

},{"./_copyObject":277,"./_getSymbols":297}],279:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    getSymbolsIn = require('./_getSymbolsIn');

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;

},{"./_copyObject":277,"./_getSymbolsIn":298}],280:[function(require,module,exports){
var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

},{"./_root":339}],281:[function(require,module,exports){
var isArrayLike = require('./isArrayLike');

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;

},{"./isArrayLike":363}],282:[function(require,module,exports){
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;

},{}],283:[function(require,module,exports){
var isPlainObject = require('./isPlainObject');

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;

},{"./isPlainObject":370}],284:[function(require,module,exports){
var getNative = require('./_getNative');

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;

},{"./_getNative":294}],285:[function(require,module,exports){
var SetCache = require('./_SetCache'),
    arraySome = require('./_arraySome'),
    cacheHas = require('./_cacheHas');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;

},{"./_SetCache":213,"./_arraySome":224,"./_cacheHas":266}],286:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    Uint8Array = require('./_Uint8Array'),
    eq = require('./eq'),
    equalArrays = require('./_equalArrays'),
    mapToArray = require('./_mapToArray'),
    setToArray = require('./_setToArray');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;

},{"./_Symbol":215,"./_Uint8Array":216,"./_equalArrays":285,"./_mapToArray":328,"./_setToArray":342,"./eq":356}],287:[function(require,module,exports){
var getAllKeys = require('./_getAllKeys');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;

},{"./_getAllKeys":290}],288:[function(require,module,exports){
var flatten = require('./flatten'),
    overRest = require('./_overRest'),
    setToString = require('./_setToString');

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;

},{"./_overRest":337,"./_setToString":343,"./flatten":357}],289:[function(require,module,exports){
(function (global){
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],290:[function(require,module,exports){
var baseGetAllKeys = require('./_baseGetAllKeys'),
    getSymbols = require('./_getSymbols'),
    keys = require('./keys');

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;

},{"./_baseGetAllKeys":237,"./_getSymbols":297,"./keys":374}],291:[function(require,module,exports){
var baseGetAllKeys = require('./_baseGetAllKeys'),
    getSymbolsIn = require('./_getSymbolsIn'),
    keysIn = require('./keysIn');

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;

},{"./_baseGetAllKeys":237,"./_getSymbolsIn":298,"./keysIn":375}],292:[function(require,module,exports){
var isKeyable = require('./_isKeyable');

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;

},{"./_isKeyable":314}],293:[function(require,module,exports){
var isStrictComparable = require('./_isStrictComparable'),
    keys = require('./keys');

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;

},{"./_isStrictComparable":317,"./keys":374}],294:[function(require,module,exports){
var baseIsNative = require('./_baseIsNative'),
    getValue = require('./_getValue');

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

},{"./_baseIsNative":245,"./_getValue":300}],295:[function(require,module,exports){
var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;

},{"./_overArg":336}],296:[function(require,module,exports){
var Symbol = require('./_Symbol');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

},{"./_Symbol":215}],297:[function(require,module,exports){
var arrayFilter = require('./_arrayFilter'),
    stubArray = require('./stubArray');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;

},{"./_arrayFilter":220,"./stubArray":382}],298:[function(require,module,exports){
var arrayPush = require('./_arrayPush'),
    getPrototype = require('./_getPrototype'),
    getSymbols = require('./_getSymbols'),
    stubArray = require('./stubArray');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;

},{"./_arrayPush":223,"./_getPrototype":295,"./_getSymbols":297,"./stubArray":382}],299:[function(require,module,exports){
var DataView = require('./_DataView'),
    Map = require('./_Map'),
    Promise = require('./_Promise'),
    Set = require('./_Set'),
    WeakMap = require('./_WeakMap'),
    baseGetTag = require('./_baseGetTag'),
    toSource = require('./_toSource');

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;

},{"./_DataView":206,"./_Map":209,"./_Promise":211,"./_Set":212,"./_WeakMap":217,"./_baseGetTag":238,"./_toSource":352}],300:[function(require,module,exports){
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

},{}],301:[function(require,module,exports){
var castPath = require('./_castPath'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray'),
    isIndex = require('./_isIndex'),
    isLength = require('./isLength'),
    toKey = require('./_toKey');

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;

},{"./_castPath":267,"./_isIndex":311,"./_toKey":351,"./isArguments":361,"./isArray":362,"./isLength":366}],302:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

},{"./_nativeCreate":331}],303:[function(require,module,exports){
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

},{}],304:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

},{"./_nativeCreate":331}],305:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

},{"./_nativeCreate":331}],306:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

},{"./_nativeCreate":331}],307:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;

},{}],308:[function(require,module,exports){
var cloneArrayBuffer = require('./_cloneArrayBuffer'),
    cloneDataView = require('./_cloneDataView'),
    cloneRegExp = require('./_cloneRegExp'),
    cloneSymbol = require('./_cloneSymbol'),
    cloneTypedArray = require('./_cloneTypedArray');

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;

},{"./_cloneArrayBuffer":268,"./_cloneDataView":270,"./_cloneRegExp":271,"./_cloneSymbol":272,"./_cloneTypedArray":273}],309:[function(require,module,exports){
var baseCreate = require('./_baseCreate'),
    getPrototype = require('./_getPrototype'),
    isPrototype = require('./_isPrototype');

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;

},{"./_baseCreate":231,"./_getPrototype":295,"./_isPrototype":316}],310:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray');

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;

},{"./_Symbol":215,"./isArguments":361,"./isArray":362}],311:[function(require,module,exports){
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;

},{}],312:[function(require,module,exports){
var eq = require('./eq'),
    isArrayLike = require('./isArrayLike'),
    isIndex = require('./_isIndex'),
    isObject = require('./isObject');

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;

},{"./_isIndex":311,"./eq":356,"./isArrayLike":363,"./isObject":368}],313:[function(require,module,exports){
var isArray = require('./isArray'),
    isSymbol = require('./isSymbol');

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;

},{"./isArray":362,"./isSymbol":372}],314:[function(require,module,exports){
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;

},{}],315:[function(require,module,exports){
var coreJsData = require('./_coreJsData');

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;

},{"./_coreJsData":280}],316:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;

},{}],317:[function(require,module,exports){
var isObject = require('./isObject');

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;

},{"./isObject":368}],318:[function(require,module,exports){
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

},{}],319:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

},{"./_assocIndexOf":226}],320:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

},{"./_assocIndexOf":226}],321:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

},{"./_assocIndexOf":226}],322:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

},{"./_assocIndexOf":226}],323:[function(require,module,exports){
var Hash = require('./_Hash'),
    ListCache = require('./_ListCache'),
    Map = require('./_Map');

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;

},{"./_Hash":207,"./_ListCache":208,"./_Map":209}],324:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

},{"./_getMapData":292}],325:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

},{"./_getMapData":292}],326:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

},{"./_getMapData":292}],327:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

},{"./_getMapData":292}],328:[function(require,module,exports){
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;

},{}],329:[function(require,module,exports){
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;

},{}],330:[function(require,module,exports){
var memoize = require('./memoize');

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;

},{"./memoize":377}],331:[function(require,module,exports){
var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

},{"./_getNative":294}],332:[function(require,module,exports){
var overArg = require('./_overArg');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;

},{"./_overArg":336}],333:[function(require,module,exports){
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;

},{}],334:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

},{"./_freeGlobal":289}],335:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

},{}],336:[function(require,module,exports){
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

},{}],337:[function(require,module,exports){
var apply = require('./_apply');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;

},{"./_apply":218}],338:[function(require,module,exports){
var baseGet = require('./_baseGet'),
    baseSlice = require('./_baseSlice');

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;

},{"./_baseGet":236,"./_baseSlice":259}],339:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

},{"./_freeGlobal":289}],340:[function(require,module,exports){
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;

},{}],341:[function(require,module,exports){
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;

},{}],342:[function(require,module,exports){
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;

},{}],343:[function(require,module,exports){
var baseSetToString = require('./_baseSetToString'),
    shortOut = require('./_shortOut');

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;

},{"./_baseSetToString":258,"./_shortOut":344}],344:[function(require,module,exports){
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;

},{}],345:[function(require,module,exports){
var ListCache = require('./_ListCache');

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;

},{"./_ListCache":208}],346:[function(require,module,exports){
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;

},{}],347:[function(require,module,exports){
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

},{}],348:[function(require,module,exports){
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

},{}],349:[function(require,module,exports){
var ListCache = require('./_ListCache'),
    Map = require('./_Map'),
    MapCache = require('./_MapCache');

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

},{"./_ListCache":208,"./_Map":209,"./_MapCache":210}],350:[function(require,module,exports){
var memoizeCapped = require('./_memoizeCapped');

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;

},{"./_memoizeCapped":330}],351:[function(require,module,exports){
var isSymbol = require('./isSymbol');

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;

},{"./isSymbol":372}],352:[function(require,module,exports){
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

},{}],353:[function(require,module,exports){
/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;

},{}],354:[function(require,module,exports){
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;

},{}],355:[function(require,module,exports){
var isObject = require('./isObject'),
    now = require('./now'),
    toNumber = require('./toNumber');

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;

},{"./isObject":368,"./now":378,"./toNumber":384}],356:[function(require,module,exports){
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;

},{}],357:[function(require,module,exports){
var baseFlatten = require('./_baseFlatten');

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;

},{"./_baseFlatten":233}],358:[function(require,module,exports){
var baseGet = require('./_baseGet');

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

},{"./_baseGet":236}],359:[function(require,module,exports){
var baseHasIn = require('./_baseHasIn'),
    hasPath = require('./_hasPath');

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;

},{"./_baseHasIn":239,"./_hasPath":301}],360:[function(require,module,exports){
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

},{}],361:[function(require,module,exports){
var baseIsArguments = require('./_baseIsArguments'),
    isObjectLike = require('./isObjectLike');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

},{"./_baseIsArguments":240,"./isObjectLike":369}],362:[function(require,module,exports){
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

},{}],363:[function(require,module,exports){
var isFunction = require('./isFunction'),
    isLength = require('./isLength');

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

},{"./isFunction":365,"./isLength":366}],364:[function(require,module,exports){
var root = require('./_root'),
    stubFalse = require('./stubFalse');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

},{"./_root":339,"./stubFalse":383}],365:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObject = require('./isObject');

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

},{"./_baseGetTag":238,"./isObject":368}],366:[function(require,module,exports){
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

},{}],367:[function(require,module,exports){
var baseIsMap = require('./_baseIsMap'),
    baseUnary = require('./_baseUnary'),
    nodeUtil = require('./_nodeUtil');

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;

},{"./_baseIsMap":243,"./_baseUnary":264,"./_nodeUtil":334}],368:[function(require,module,exports){
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

},{}],369:[function(require,module,exports){
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

},{}],370:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    getPrototype = require('./_getPrototype'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;

},{"./_baseGetTag":238,"./_getPrototype":295,"./isObjectLike":369}],371:[function(require,module,exports){
var baseIsSet = require('./_baseIsSet'),
    baseUnary = require('./_baseUnary'),
    nodeUtil = require('./_nodeUtil');

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;

},{"./_baseIsSet":246,"./_baseUnary":264,"./_nodeUtil":334}],372:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;

},{"./_baseGetTag":238,"./isObjectLike":369}],373:[function(require,module,exports){
var baseIsTypedArray = require('./_baseIsTypedArray'),
    baseUnary = require('./_baseUnary'),
    nodeUtil = require('./_nodeUtil');

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

},{"./_baseIsTypedArray":247,"./_baseUnary":264,"./_nodeUtil":334}],374:[function(require,module,exports){
var arrayLikeKeys = require('./_arrayLikeKeys'),
    baseKeys = require('./_baseKeys'),
    isArrayLike = require('./isArrayLike');

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;

},{"./_arrayLikeKeys":221,"./_baseKeys":249,"./isArrayLike":363}],375:[function(require,module,exports){
var arrayLikeKeys = require('./_arrayLikeKeys'),
    baseKeysIn = require('./_baseKeysIn'),
    isArrayLike = require('./isArrayLike');

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;

},{"./_arrayLikeKeys":221,"./_baseKeysIn":250,"./isArrayLike":363}],376:[function(require,module,exports){
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;

},{}],377:[function(require,module,exports){
var MapCache = require('./_MapCache');

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;

},{"./_MapCache":210}],378:[function(require,module,exports){
var root = require('./_root');

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;

},{"./_root":339}],379:[function(require,module,exports){
var arrayMap = require('./_arrayMap'),
    baseClone = require('./_baseClone'),
    baseUnset = require('./_baseUnset'),
    castPath = require('./_castPath'),
    copyObject = require('./_copyObject'),
    customOmitClone = require('./_customOmitClone'),
    flatRest = require('./_flatRest'),
    getAllKeysIn = require('./_getAllKeysIn');

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;

},{"./_arrayMap":222,"./_baseClone":230,"./_baseUnset":265,"./_castPath":267,"./_copyObject":277,"./_customOmitClone":283,"./_flatRest":288,"./_getAllKeysIn":291}],380:[function(require,module,exports){
var baseProperty = require('./_baseProperty'),
    basePropertyDeep = require('./_basePropertyDeep'),
    isKey = require('./_isKey'),
    toKey = require('./_toKey');

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;

},{"./_baseProperty":255,"./_basePropertyDeep":256,"./_isKey":313,"./_toKey":351}],381:[function(require,module,exports){
var baseFlatten = require('./_baseFlatten'),
    baseOrderBy = require('./_baseOrderBy'),
    baseRest = require('./_baseRest'),
    isIterateeCall = require('./_isIterateeCall');

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;

},{"./_baseFlatten":233,"./_baseOrderBy":254,"./_baseRest":257,"./_isIterateeCall":312}],382:[function(require,module,exports){
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;

},{}],383:[function(require,module,exports){
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

},{}],384:[function(require,module,exports){
var baseTrim = require('./_baseTrim'),
    isObject = require('./isObject'),
    isSymbol = require('./isSymbol');

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;

},{"./_baseTrim":263,"./isObject":368,"./isSymbol":372}],385:[function(require,module,exports){
var baseToString = require('./_baseToString');

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

},{"./_baseToString":262}],386:[function(require,module,exports){
module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"30px\" height=\"30px\" viewBox=\"0 0 30 30\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 59 (86127) - https://sketch.com -->\n    <title>api</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"api\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-api\">\n            <rect id=\"bg-icon\" x=\"0\" y=\"0\" width=\"30\" height=\"30\"></rect>\n            <path d=\"M22.2098214,7.7537594 C23.3419813,7.7537594 24.2633929,8.65931855 24.2633929,9.78070175 L24.2633929,20.2192982 C24.2633929,21.3406814 23.3419813,22.2462406 22.2098214,22.2462406 L7.79017857,22.2462406 C6.65855619,22.2462406 5.73660714,21.3404661 5.73660714,20.2192982 L5.73660714,9.78070175 C5.73660714,8.6595339 6.65855619,7.7537594 7.79017857,7.7537594 L22.2098214,7.7537594 Z M22.2098214,8.82518797 L7.79017857,8.82518797 C7.24608667,8.82518797 6.80803571,9.25555382 6.80803571,9.78070175 L6.80803571,20.2192982 C6.80803571,20.7444462 7.24608667,21.174812 7.79017857,21.174812 L22.2098214,21.174812 C22.7543696,21.174812 23.1919643,20.7447459 23.1919643,20.2192982 L23.1919643,9.78070175 C23.1919643,9.25525406 22.7543696,8.82518797 22.2098214,8.82518797 Z\" id=\"Shape\" fill=\"#294661\" fill-rule=\"nonzero\"></path>\n            <path d=\"M6.27232143,11.5532581 L23.7276786,11.5532581 C24.0235454,11.5532581 24.2633929,11.3134107 24.2633929,11.0175439 C24.2633929,10.721677 24.0235454,10.4818296 23.7276786,10.4818296 L6.27232143,10.4818296 C5.9764546,10.4818296 5.73660714,10.721677 5.73660714,11.0175439 C5.73660714,11.3134107 5.9764546,11.5532581 6.27232143,11.5532581 Z\" id=\"Shape\" fill=\"#294661\" fill-rule=\"nonzero\"></path>\n            <path d=\"M11.199877,16.3997495 L9.69152406,17.8816401 C9.48047147,18.08899 9.47746986,18.4281722 9.68481977,18.6392248 C9.89216968,18.8502774 10.2313519,18.853279 10.4424045,18.6459291 L12.3397259,16.781894 C12.5534247,16.5719444 12.5534247,16.2275546 12.3397259,16.017605 L10.4424045,14.1535699 C10.2313519,13.94622 9.89216968,13.9492216 9.68481977,14.1602742 C9.47746986,14.3713268 9.48047147,14.710509 9.69152406,14.9178589 L11.199877,16.3997495 Z\" id=\"Shape\" fill=\"#18C96E\" fill-rule=\"nonzero\"></path>\n            <path d=\"M14.6205357,17.0714286 L17.65625,17.0714286 C17.9521168,17.0714286 18.1919643,16.8315811 18.1919643,16.5357143 C18.1919643,16.2398475 17.9521168,16 17.65625,16 L14.6205357,16 C14.3246689,16 14.0848214,16.2398475 14.0848214,16.5357143 C14.0848214,16.8315811 14.3246689,17.0714286 14.6205357,17.0714286 Z\" id=\"Path\" fill=\"#8AC24A\" fill-rule=\"nonzero\"></path>\n        </g>\n    </g>\n</svg>";

},{}],387:[function(require,module,exports){
module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\">\n      <path d=\"M19.475 14.27l4.814 4.815a1.25 1.25 0 0 1 0 1.767l-3.405 3.406a1.25 1.25 0 0 1-1.768 0L14.2 19.34a.417.417 0 0 1 .589-.59l4.917 4.918a.417.417 0 0 0 .589 0l3.405-3.406a.417.417 0 0 0 0-.589l-2.03-2.031-1.36 1.381a.417.417 0 0 1-.524.057l-.066-.052a.417.417 0 0 1-.004-.59l1.364-1.385-1.079-1.08-1.789 1.79a.417.417 0 0 1-.524.053l-.065-.053a.417.417 0 0 1-.054-.524l.054-.065 1.788-1.79-.525-.526a.417.417 0 1 1 .589-.589zm-8.59-8.59l4.896 4.896a.417.417 0 0 1-.59.59l-.593-.594-1.359 1.381a.417.417 0 0 1-.523.058l-.066-.053a.417.417 0 0 1-.057-.524l.052-.065 1.364-1.386-1.08-1.08-1.789 1.79a.417.417 0 0 1-.524.053l-.065-.053a.417.417 0 0 1-.053-.524l.053-.065 1.79-1.79-2.046-2.045a.417.417 0 0 0-.59 0L6.302 9.675a.417.417 0 0 0 0 .589l4.826 4.826a.417.417 0 0 1-.59.59l-4.826-4.827a1.25 1.25 0 0 1 0-1.768L9.116 5.68a1.25 1.25 0 0 1 1.768 0z\" fill=\"#294661\"/>\n      <path d=\"M19.433 6.413a.417.417 0 0 1 .589 0l3.535 3.536a.417.417 0 0 1 0 .589L11.016 23.08a.417.417 0 0 1-.59 0l-3.535-3.536a.417.417 0 0 1 0-.59l12.542-12.54zm.294.884L7.775 19.25l2.946 2.946 11.952-11.953-2.946-2.946z\" fill=\"#FF5722\"/>\n      <path d=\"M6.79 19.118L5.022 24.42a.417.417 0 0 0 .527.527l5.303-1.768a.417.417 0 0 0 .163-.69L7.48 18.955a.417.417 0 0 0-.69.163zm.577.903l2.582 2.582-3.873 1.29 1.291-3.872z\" fill=\"#294661\"/>\n      <path d=\"M23.557 10.537a.417.417 0 0 1-.59 0l-3.534-3.535a.417.417 0 0 1 0-.589l.594-.594a2.917 2.917 0 0 1 4.12 4.13l-.59.588zm-.005-1.173a2.083 2.083 0 0 0-2.94-2.95l-.295.294 2.945 2.945.29-.289z\" fill=\"#B71C1C\"/>\n    </g>\n  </svg>";

},{}],388:[function(require,module,exports){
module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg viewBox=\"0 0 30 30\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n  <defs></defs>\n    <g id=\"marketing-legacy\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n      <polygon id=\"bg-icon\" points=\"0 0 30 0 30 30 0 30\"></polygon>\n      <g id=\"icon\" transform=\"translate(5.000000, 7.000000)\" fill=\"#294661\">\n        <path d=\"M2.85714286,11.0568182 C2.85714286,13.0354239 4.04713916,14.6941676 5.99701104,15.5033334 C6.23732066,15.603058 6.51874741,15.5020787 6.62559526,15.2777897 C6.73244311,15.0535007 6.62425097,14.7908358 6.38394134,14.6911111 C4.77332618,14.0227315 3.80952381,12.679281 3.80952381,11.0568182 L3.80952381,6.20833333 C3.80952381,5.96287344 3.59632607,5.76388889 3.33333333,5.76388889 C3.0703406,5.76388889 2.85714286,5.96287344 2.85714286,6.20833333 L2.85714286,11.0568182 Z\" id=\"shape\" fill-rule=\"nonzero\"></path>\n        <path d=\"M13.3333333,8.77777778 C13.3333333,9.32977778 12.6933333,9.77777778 11.9047619,9.77777778 L11.4285714,9.77777778 L11.4285714,7.11111111 L11.9047619,7.11111111 C12.6933333,7.11111111 13.3333333,7.55911111 13.3333333,8.11111111 L13.3333333,8.77777778 L13.3333333,8.77777778 Z\" id=\"shape\"></path>\n        <path d=\"M11.4285714,3.63907953 C10.9988019,3.82337647 10.7717569,3.96029594 9.63477637,4.64556241 C7.91682636,5.68098344 6.39426328,6.09061127 2.85714286,6.22222222 L1.9047619,6.22222222 C1.33905288,6.22222222 0.952380952,6.54382273 0.952380952,7.11111111 L0.952380952,8.88888889 C0.952380952,9.47765559 1.3057109,9.77777778 1.9047619,9.77777778 L2.89530781,9.77849178 C6.36474308,9.90835873 7.83639843,10.5049676 9.74097892,12.0719629 C9.82079085,12.1376619 9.82079085,12.1376619 9.89942362,12.2022656 C10.507069,12.7007614 10.9216903,12.9935001 11.4285714,13.2386538 L11.4285714,13.6408116 L10.8840673,13.9732211 C10.740305,13.8999076 10.6048885,13.8244476 10.4761905,13.7473073 L10.4761905,3.1064406 C10.6019368,3.04113841 10.7340957,2.97548417 10.8741941,2.90963597 L11.4285714,3.24806679 L11.4285714,3.63907953 L11.4285714,3.63907953 Z M1.9047619,5.33333333 L1.9047619,5.33333333 L2.85714286,5.33333333 C8.79727891,5.11111111 8.43469388,3.88888889 11.4285714,2.66666667 L11.4285714,14.2222222 C8.42857143,12.9975556 8.79387755,10.8888889 2.85714286,10.6666667 L1.9047619,10.6666667 C0.892799014,10.6666667 0,10.0681667 0,8.88888889 L0,7.11111111 C0,5.93183333 0.952322824,5.33333333 1.9047619,5.33333333 L1.9047619,5.33333333 Z\" id=\"shape\" fill-rule=\"nonzero\"></path>\n        <path d=\"M12.8329253,3.89760301 C14.0754415,5.05728475 14.7858333,6.62437283 14.7858333,8.29711111 C14.7858333,9.96984939 14.0754415,11.5369375 12.8329253,12.6966192 C12.6469614,12.8701856 12.6469614,13.1515922 12.8329253,13.3251586 C13.0188893,13.4987249 13.3203964,13.4987249 13.5063604,13.3251586 C14.9256855,12.0004551 15.7382143,10.2080582 15.7382143,8.29711111 C15.7382143,6.38616403 14.9256855,4.59376712 13.5063604,3.26906365 C13.3203964,3.0954973 13.0188893,3.0954973 12.8329253,3.26906365 C12.6469614,3.44263 12.6469614,3.72403666 12.8329253,3.89760301 L12.8329253,3.89760301 Z\" id=\"shape\" fill-rule=\"nonzero\"></path>\n        <path d=\"M15.0353063,1.21704746 C16.9874787,3.03907501 18.1034524,5.50193669 18.1034524,8.13122222 C18.1034524,10.7605078 16.9874787,13.2233694 15.0353063,15.045397 C14.8493423,15.2189633 14.8493423,15.50037 15.0353063,15.6739363 C15.2212702,15.8475027 15.5227774,15.8475027 15.7087413,15.6739363 C17.8377594,13.6868528 19.0558333,10.9986644 19.0558333,8.13122222 C19.0558333,5.26378003 17.8377594,2.57559166 15.7087413,0.588508097 C15.5227774,0.414941745 15.2212702,0.414941745 15.0353063,0.588508097 C14.8493423,0.762074449 14.8493423,1.04348111 15.0353063,1.21704746 L15.0353063,1.21704746 Z\" id=\"shape\" fill-rule=\"nonzero\"></path>\n      </g>\n    </g>\n</svg>";

},{}],389:[function(require,module,exports){
module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg viewBox=\"0 0 30 30\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n  <defs></defs>\n  <g id=\"marketing-new\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <polygon id=\"bg-icon\" points=\"0 0 30 0 30 30 0 30\"></polygon>\n    <g id=\"icon\" transform=\"translate(5.000000, 7.000000)\">\n      <path d=\"M2.85714286,11.0568182 C2.85714286,13.0354239 4.04713916,14.6941676 5.99701104,15.5033334 C6.23732066,15.603058 6.51874741,15.5020787 6.62559526,15.2777897 C6.73244311,15.0535007 6.62425097,14.7908358 6.38394134,14.6911111 C4.77332618,14.0227315 3.80952381,12.679281 3.80952381,11.0568182 L3.80952381,6.20833333 C3.80952381,5.96287344 3.59632607,5.76388889 3.33333333,5.76388889 C3.0703406,5.76388889 2.85714286,5.96287344 2.85714286,6.20833333 L2.85714286,11.0568182 Z\" id=\"shape\" fill=\"#303F9F\" fill-rule=\"nonzero\"></path>\n      <path d=\"M13.3333333,8.77777778 C13.3333333,9.32977778 12.6933333,9.77777778 11.9047619,9.77777778 L11.4285714,9.77777778 L11.4285714,7.11111111 L11.9047619,7.11111111 C12.6933333,7.11111111 13.3333333,7.55911111 13.3333333,8.11111111 L13.3333333,8.77777778 L13.3333333,8.77777778 Z\" id=\"shape\" fill=\"#2196F3\"></path>\n      <path d=\"M11.4285714,3.63907953 C10.9988019,3.82337647 10.7717569,3.96029594 9.63477637,4.64556241 C7.91682636,5.68098344 6.39426328,6.09061127 2.85714286,6.22222222 L1.9047619,6.22222222 C1.33905288,6.22222222 0.952380952,6.54382273 0.952380952,7.11111111 L0.952380952,8.88888889 C0.952380952,9.47765559 1.3057109,9.77777778 1.9047619,9.77777778 L2.89530781,9.77849178 C6.36474308,9.90835873 7.83639843,10.5049676 9.74097892,12.0719629 C9.82079085,12.1376619 9.82079085,12.1376619 9.89942362,12.2022656 C10.507069,12.7007614 10.9216903,12.9935001 11.4285714,13.2386538 L11.4285714,13.6408116 L10.8840673,13.9732211 C10.740305,13.8999076 10.6048885,13.8244476 10.4761905,13.7473073 L10.4761905,3.1064406 C10.6019368,3.04113841 10.7340957,2.97548417 10.8741941,2.90963597 L11.4285714,3.24806679 L11.4285714,3.63907953 L11.4285714,3.63907953 Z M1.9047619,5.33333333 L1.9047619,5.33333333 L2.85714286,5.33333333 C8.79727891,5.11111111 8.43469388,3.88888889 11.4285714,2.66666667 L11.4285714,14.2222222 C8.42857143,12.9975556 8.79387755,10.8888889 2.85714286,10.6666667 L1.9047619,10.6666667 C0.892799014,10.6666667 0,10.0681667 0,8.88888889 L0,7.11111111 C0,5.93183333 0.952322824,5.33333333 1.9047619,5.33333333 L1.9047619,5.33333333 Z\" id=\"shape\" fill=\"#294661\" fill-rule=\"nonzero\"></path>\n      <path d=\"M12.8329253,3.89760301 C14.0754415,5.05728475 14.7858333,6.62437283 14.7858333,8.29711111 C14.7858333,9.96984939 14.0754415,11.5369375 12.8329253,12.6966192 C12.6469614,12.8701856 12.6469614,13.1515922 12.8329253,13.3251586 C13.0188893,13.4987249 13.3203964,13.4987249 13.5063604,13.3251586 C14.9256855,12.0004551 15.7382143,10.2080582 15.7382143,8.29711111 C15.7382143,6.38616403 14.9256855,4.59376712 13.5063604,3.26906365 C13.3203964,3.0954973 13.0188893,3.0954973 12.8329253,3.26906365 C12.6469614,3.44263 12.6469614,3.72403666 12.8329253,3.89760301 L12.8329253,3.89760301 Z\" id=\"shape\" fill=\"#00BCD4\" fill-rule=\"nonzero\"></path>\n      <path d=\"M15.0353063,1.21704746 C16.9874787,3.03907501 18.1034524,5.50193669 18.1034524,8.13122222 C18.1034524,10.7605078 16.9874787,13.2233694 15.0353063,15.045397 C14.8493423,15.2189633 14.8493423,15.50037 15.0353063,15.6739363 C15.2212702,15.8475027 15.5227774,15.8475027 15.7087413,15.6739363 C17.8377594,13.6868528 19.0558333,10.9986644 19.0558333,8.13122222 C19.0558333,5.26378003 17.8377594,2.57559166 15.7087413,0.588508097 C15.5227774,0.414941745 15.2212702,0.414941745 15.0353063,0.588508097 C14.8493423,0.762074449 14.8493423,1.04348111 15.0353063,1.21704746 L15.0353063,1.21704746 Z\" id=\"shape\" fill=\"#18C96E\" fill-rule=\"nonzero\"></path>\n    </g>\n  </g>\n</svg>";

},{}],390:[function(require,module,exports){
module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"30px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <title>validation</title>\n    <g id=\"validation\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M11.2992216,11.3598433 C10.525827,12.3445625 9.36236177,12.9698315 8.02416099,12.9698315 C5.60178175,12.9698315 3.64791916,10.9204267 3.64791916,8.3994378 C3.64791916,5.87921191 5.60212349,3.82904409 8.02416099,3.82904409 C9.33748387,3.82904409 10.4826611,4.43200588 11.2558958,5.38583218 L11.2558958,4.47226009 C11.2558958,4.18002753 11.4888109,3.94312623 11.7761262,3.94312623 C12.0634416,3.94312623 12.2963567,4.18002753 12.2963567,4.47226009 L12.2963567,10.6488189 C12.2963567,10.9207502 12.2963567,11.002262 12.2963567,11.002262 C12.3625732,11.2890695 12.7080416,11.3749206 13.402699,11.3749206 C15.0815187,11.3749206 16.1844119,9.29415757 15.6217355,6.53993387 C14.9548866,3.27580031 12.3205856,1.05826772 8.02416099,1.05826772 C4.17042392,1.05826772 1.04046095,4.34095917 1.04046095,8.4 C1.04046095,12.4590408 4.17042392,15.7417323 8.02416099,15.7417323 C8.40410523,15.7417323 9.43351785,15.7261611 10.1127653,15.2923434 C10.355948,15.1370289 10.6788268,15.2243904 10.8261599,15.4752758 C10.973493,15.7261611 10.9044563,16.0661648 10.6463057,16.2008797 C9.65836555,16.7164323 8.40410523,16.8 8.02416099,16.8 C3.58853027,16.8 3.55271368e-15,13.0363652 3.55271368e-15,8.4 C3.55271368e-15,3.76363483 3.58853027,0 8.02416099,0 C12.8173188,0 15.8740139,2.57310036 16.6404363,6.32463306 C17.3188066,9.64516215 15.7579501,12.4014771 13.402699,12.4014771 C12.2312995,12.4014771 11.5652807,12.1241089 11.3300952,11.460622 C11.3179764,11.4264334 11.3077855,11.3929976 11.2992216,11.3598433 Z M11.1518497,8.3994378 C11.1518497,6.57191992 9.74784062,5.09896535 8.02416099,5.09896535 C6.30048136,5.09896535 4.8964723,6.57191992 4.8964723,8.3994378 C4.8964723,10.2276646 6.30008263,11.6999102 8.02416099,11.6999102 C9.74823935,11.6999102 11.1518497,10.2276646 11.1518497,8.3994378 Z\" id=\"@\" fill=\"#294661\" fill-rule=\"nonzero\"></path>\n        <path d=\"M18,24 C14.6860211,24 12,21.3139789 12,18 C12,17.6610047 12.0281491,17.3253927 12.0837477,16.9956065 C12.5016612,14.5167298 14.4390924,12.5523924 16.9100616,12.0988093 C17.2672451,12.0332429 17.6316078,12 18,12 C21.3133605,12 24,14.6863303 24,18 C24,21.3136697 21.3133605,24 18,24 Z M18,23.132586 C20.8343233,23.132586 23.132586,20.8345879 23.132586,18 C23.132586,15.1654121 20.8343233,12.867414 18,12.867414 C17.6841968,12.867414 17.3722515,12.8958746 17.0666716,12.9519683 C14.9544015,13.3397069 13.2963347,15.0208001 12.9390913,17.1398088 C12.8915175,17.4219957 12.867414,17.7093734 12.867414,18 C12.867414,20.8349194 15.1650806,23.132586 18,23.132586 Z\" id=\"Circle\" fill=\"#18C96E\" fill-rule=\"nonzero\"></path>\n        <polygon id=\"Check\" fill=\"#18C96E\" fill-rule=\"nonzero\" points=\"15.5812106 17.4707051 14.92 18.1317841 17.4635857 20.6758761 21.0783959 15.8830074 20.3319056 15.32 17.3645547 19.254404\"></polygon>\n    </g>\n</svg>\n";

},{}],391:[function(require,module,exports){
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\n  <path fill=\"#e36a19\" fill-rule=\"evenodd\" d=\"M17.798 14.791L11.316 3.744c-.582-.992-2.05-.992-2.632 0L2.202 14.79C1.625 15.776 2.354 17 3.518 17h12.964c1.164 0 1.893-1.224 1.316-2.209zM9.99 8h.02c.611.007 1.073.592.978 1.244l-.428 2.238c-.04.296-.278.518-.557.518h-.006c-.279 0-.516-.222-.557-.518l-.428-2.238C8.917 8.592 9.386 8 9.99 8zm.01 7a1 1 0 100-2 1 1 0 000 2z\"/>\n</svg>\n";

},{}],392:[function(require,module,exports){
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\n  <path fill=\"#0263E0\" fill-rule=\"evenodd\" d=\"M5.00863786,9.90958826 L5.00174424,9.9599089 L5.00174424,9.9599089 L5.00174424,10.0405756 L5.00174424,10.0405756 L5.01287262,10.1108485 L5.01287262,10.1108485 L5.02198216,10.1388947 C5.05450847,10.2516628 5.12854142,10.3474927 5.2266767,10.4113748 L9.05903758,13.8548429 C9.27429575,14.0483857 9.6232982,14.0483857 9.83855637,13.8548429 C10.029897,13.6828048 10.051157,13.4157528 9.90233657,13.2226005 L9.83855637,13.1539624 L6.882,10.495 L14.4873192,10.4955974 C14.770465,10.4955974 15,10.2737109 15,10 C15,9.75670145 14.818639,9.55435055 14.5794742,9.51238736 L14.4873192,9.50440263 L6.883,9.504 L9.83855637,6.84603764 C10.029897,6.67399958 10.051157,6.40694753 9.90233657,6.21379525 L9.83855637,6.14515711 C9.64721578,5.97311905 9.35020069,5.95400371 9.13537687,6.08781109 L9.05903758,6.14515711 L5.2266767,9.5886252 C5.12854142,9.65250727 5.05450847,9.74833722 5.0205312,9.86069331 L5.00863786,9.90958826 L5.00863786,9.90958826 Z\"/>\n</svg>";

},{}],393:[function(require,module,exports){
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\n  <path fill=\"#707578\" fill-rule=\"evenodd\" d=\"M15.1597436,13.5144861 L11.6452575,10 L15.1597436,6.48551392 C15.6134188,6.03183869 15.6134188,5.29393166 15.1597436,4.84025642 C14.7060683,4.38658119 13.9681613,4.38658119 13.5144861,4.84025642 L10,8.35474251 L6.48551392,4.84025642 C6.03183869,4.38658119 5.29393166,4.38658119 4.84025642,4.84025642 C4.38658119,5.29393166 4.38658119,6.03183869 4.84025642,6.48551392 L8.35474251,10 L4.84025642,13.5144861 C4.38658119,13.9681613 4.38658119,14.7060683 4.84025642,15.1597436 C5.29393166,15.6134188 6.03183869,15.6134188 6.48551392,15.1597436 L10,11.6452575 L13.5144861,15.1597436 C13.9681613,15.6134188 14.7060683,15.6134188 15.1597436,15.1597436 C15.6134188,14.7060683 15.6134188,13.9681613 15.1597436,13.5144861 Z\"/>\n</svg>\n";

},{}],394:[function(require,module,exports){
module.exports = "<svg\n  role=\"img\"\n  xmlns=\"http://www.w3.org/2000/svg\"\n  width=\"100%\"\n  height=\"100%\"\n  viewBox=\"0 0 20 20\"\n>\n  <path\n    fill=\"currentColor\"\n    fillRule=\"evenodd\"\n    d=\"M8.4 4.5a.5.5 0 01.5.5v.1a.5.5 0 01-.5.5H5.6v8.8h8.8v-2.8a.5.5 0 01.41-.492l.09-.008h.1a.5.5 0 01.492.41l.008.09V15a.5.5 0 01-.41.492L15 15.5H5a.5.5 0 01-.492-.41L4.5 15V5a.5.5 0 01.41-.492L5 4.5h3.4zm6.6 0a.5.5 0 01.5.5v.1l-.001.01.001 3.29a.5.5 0 01-.5.5h-.1a.5.5 0 01-.5-.5l-.001-1.935-3.967 3.967a.611.611 0 01-.78.07l-.084-.07a.611.611 0 01-.07-.78l.07-.084L13.534 5.6H11.6a.5.5 0 01-.5-.5V5a.5.5 0 01.5-.5H15z\"\n  />\n</svg>\n";

},{}],395:[function(require,module,exports){
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\n  <path fill=\"#011489\" fill-rule=\"evenodd\" d=\"M10,2 C14.418278,2 18,5.581722 18,10 C18,14.418278 14.418278,18 10,18 C5.581722,18 2,14.418278 2,10 C2,5.581722 5.581722,2 10,2 Z M10.0000053,9.00061665 C9.74019301,9.01038552 9.47239432,9.0803986 9.29253079,9.23997113 C9.11466916,9.39791264 9.00075171,9.59492962 9.00075171,9.81473774 L9.00075171,9.81473774 L9.00075171,13.1852555 C9.00075171,13.3953034 9.11066537,13.6134632 9.29253079,13.7616358 C9.46639922,13.9016965 9.7501919,14.0091368 10.0000053,13.9993852 C10.259807,13.9911869 10.5276057,13.9211997 10.7074692,13.7616358 C10.8853308,13.6020719 10.9992483,13.4066946 10.9992483,13.1852555 L10.9992483,13.1852555 L10.9992483,9.81473774 C10.9992483,9.60632088 10.8893346,9.38813515 10.7074692,9.23997113 C10.5336008,9.09831394 10.2498081,8.99084779 10.0000053,9.00061665 Z M10,6.00073698 L9.73419791,6.03600271 C9.56432268,6.08302368 9.41643654,6.16727305 9.29253079,6.2887612 L9.29253079,6.2887612 L9.13664766,6.48664804 C9.0467106,6.63947657 9.00075171,6.80406036 9.00075171,6.98039938 L9.00075171,6.98039938 L9.00075171,7.01959044 C8.99475662,7.15478612 9.02473211,7.28017883 9.08668498,7.39774164 C9.12665936,7.51921941 9.19460733,7.62502697 9.29253079,7.71319129 C9.38246785,7.80724362 9.49037961,7.87582279 9.61428536,7.91500347 C9.73419791,7.97574235 9.86210745,8.00514084 10,7.99926322 C10.0879299,7.98750798 10.1778669,7.97574235 10.2658021,7.96398711 C10.4356773,7.91696614 10.5835635,7.83271677 10.7074692,7.71123901 L10.7074692,7.71123901 L10.8633523,7.51334179 C10.9532894,7.36051325 10.9992483,7.19592947 10.9992483,7.01959044 L10.9992483,7.01959044 L10.9992483,6.98039938 C11.0052434,6.8452037 10.9752679,6.71981099 10.913315,6.60224818 C10.8733406,6.48077041 10.8053927,6.37496285 10.7074692,6.28679853 C10.6175321,6.1927462 10.5096204,6.12417742 10.3857146,6.08498635 C10.2658021,6.02424747 10.1378925,5.99485936 10,6.00073698 L10,6.00073698 Z\"/>\n</svg>\n";

},{}],396:[function(require,module,exports){
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\n  <path fill=\"#606B85\" d=\"M10.3016131,10 C13.7800952,10.0039686 16.5989724,12.8228458 16.6029411,16.3014705 C16.6029411,16.6141611 16.3494553,16.867647 16.0367646,16.867647 C15.724074,16.867647 15.4705882,16.6141611 15.4705882,16.3014705 C15.4705882,13.4466457 13.1562954,11.1323529 10.3014705,11.1323529 C7.44664566,11.1323529 5.13235286,13.4466457 5.13235286,16.3014705 C5.13235286,16.6141611 4.87886702,16.867647 4.56617639,16.867647 C4.25348576,16.867647 4,16.6141611 4,16.3013279 C4.00388042,12.9001454 6.69895242,10.1295778 10.0704299,10.0044112 L10.3016131,10 Z M10.1470587,2 C12.0800554,2 13.6470587,3.56700338 13.6470587,5.5 C13.6470587,7.43299662 12.0800554,9 10.1469218,9 C8.21491711,8.99778964 6.6492691,7.43214163 6.64705874,5.5 C6.64705874,3.56700338 8.21406212,2 10.1470587,2 Z M10.1470587,3.08450704 C8.81368067,3.08596255 7.7330213,4.16662193 7.73156578,5.5 C7.73156578,6.83403992 8.81301882,7.91549296 10.1470587,7.91549296 C11.4810987,7.91549296 12.5625517,6.83403992 12.5625517,5.5 C12.5625517,4.16596008 11.4810987,3.08450704 10.1470587,3.08450704 Z\"/>\n</svg>";

},{}],397:[function(require,module,exports){
module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\"\r\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"-290 382 30 30\"\r\n\t style=\"enable-background:new -290 382 30 30;\" xml:space=\"preserve\">\r\n<g>\r\n\t<path style=\"fill:#FF9900\" d=\"M-264.8,405.2l-2.7-2.7c0.5-0.6,0.8-1.4,0.8-2.3c0-2.1-1.7-3.8-3.8-3.8c-2.1,0-3.8,1.7-3.8,3.8\r\n\t\ts1.7,3.8,3.8,3.8c0.9,0,1.6-0.3,2.3-0.8l2.7,2.7L-264.8,405.2z M-270.5,403c-1.5,0-2.8-1.2-2.8-2.8c0-1.5,1.2-2.8,2.8-2.8\r\n\t\tc1.5,0,2.8,1.2,2.8,2.8C-267.6,401.8-268.9,403-270.5,403z\"/>\r\n\t<path style=\"fill:#284661\" d=\"M-266.2,389.5v6.5h1v-6.5c0-0.7-0.8-1.5-1.5-1.5h-17c-0.7,0-1.5,0.8-1.5,1.5v11c0,0.7,0.8,1.5,1.5,1.5h7.5v-1\r\n\t\th-7.5c-0.1,0-0.5-0.4-0.5-0.5v-11l0,0l8.8,5.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1L-266.2,389.5L-266.2,389.5z\r\n\t\t M-275.1,393.8l-8-4.6h15.7L-275.1,393.8z\"/>\r\n</g>\r\n</svg>\r\n";

},{}],398:[function(require,module,exports){
module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\"\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 30 30\"\n\t style=\"enable-background:new 0 0 30 30;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:none;stroke:#294661;}\n\t.st1{opacity:0.5;fill:none;stroke:#880E4F;enable-background:new    ;}\n\t.st2{fill:none;stroke:#880E4F;}\n</style>\n<g id=\"Symbols\">\n\t<g id=\"nav_x2F_tiara\" transform=\"translate(-29.000000, -245.000000)\">\n\t\t<g id=\"items\" transform=\"translate(0.000000, 29.000000)\">\n\t\t\t<g id=\"group\" transform=\"translate(0.000000, 86.000000)\">\n\t\t\t\t<g id=\"Nav\">\n\t\t\t\t\t<g id=\"Ads\" transform=\"translate(0.000000, 120.000000)\">\n\t\t\t\t\t\t<g id=\"Icon\" transform=\"translate(20.000000, 0.000000)\">\n\t\t\t\t\t\t\t<g id=\"Group_1_\">\n\t\t\t\t\t\t\t\t<g id=\"Outline_Icons_1_\">\n\t\t\t\t\t\t\t\t\t<g id=\"Outline_Icons\">\n\t\t\t\t\t\t\t\t\t\t<g id=\"Group\" transform=\"translate(10.000000, 11.000000)\">\n\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Shape\" class=\"st0\" points=\"17.9,23.4 12.3,12.3 23.4,17.9 19,19 \t\t\t\t\t\t\t\t\t\t\t\"/>\n\t\t\t\t\t\t\t\t\t\t\t<path id=\"Shape_1_\" class=\"st1\" d=\"M13.6,20.1c-0.4,0.1-0.8,0.1-1.3,0.1c-4.4,0-7.9-3.5-7.9-7.9C4.4,8,8,4.4,12.3,4.4\n\t\t\t\t\t\t\t\t\t\t\t\ts7.9,3.5,7.9,7.9c0,0.4,0,0.9-0.1,1.3\"/>\n\t\t\t\t\t\t\t\t\t\t\t<path id=\"Shape_2_\" class=\"st2\" d=\"M12.3,16.9c-2.5,0-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6s4.6,2.1,4.6,4.6\"/>\n\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t</g>\n\t</g>\n</g>\n</svg>\n";

},{}],399:[function(require,module,exports){
module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\"\r\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"-290 382 30 30\"\r\n\t style=\"enable-background:new -290 382 30 30;\" xml:space=\"preserve\">\r\n<g id=\"Page-1\" sketch:type=\"MSPage\">\r\n\t<g id=\"Icon\" transform=\"translate(1.000000, 1.000000)\" sketch:type=\"MSLayerGroup\">\r\n\t\t<circle id=\"Oval\" sketch:type=\"MSShapeGroup\" style=\"fill:#1A82E2\" cx=\"-276\" cy=\"399\" r=\"1\"> </circle>\r\n\t\t<path style=\"fill:#284661;\" d=\"M-265.5,403.5h-21v-4.8c0-5.6,4.9-10.2,11-10.2c5.3,0,10,4.8,10,10.2V403.5z M-285.5,402.5h19v-3.8\r\n\t\t\tc0-4.9-4.2-9.2-9-9.2c-5.5,0-10,4.1-10,9.2V402.5z\"/>\r\n\t\t<path id=\"Rectangle\" sketch:type=\"MSShapeGroup\" style=\"fill:#FDD835\" d=\"M-283,399L-283,399c0.6,0,1,0.2,1,0.5l0,0c0,0.3-0.4,0.5-1,0.5\r\n\t\t\tl0,0c-0.6,0-1-0.2-1-0.5l0,0C-284,399.2-283.6,399-283,399z\"/>\r\n\t\t<path id=\"Rectangle_1_\" sketch:type=\"MSShapeGroup\" style=\"fill:#FDD835\" d=\"M-282.5,396L-282.5,396c0.3,0,0.5,0.2,0.5,0.5l0,0\r\n\t\t\tc0,0.3-0.2,0.5-0.5,0.5l0,0c-0.3,0-0.5-0.2-0.5-0.5l0,0C-283,396.2-282.8,396-282.5,396z\"/>\r\n\t\t<path id=\"Rectangle_2_\" sketch:type=\"MSShapeGroup\" style=\"fill:#FDD835\" d=\"M-280.5,394L-280.5,394c0.3,0,0.5,0.2,0.5,0.5l0,0\r\n\t\t\tc0,0.3-0.2,0.5-0.5,0.5l0,0c-0.3,0-0.5-0.2-0.5-0.5l0,0C-281,394.2-280.8,394-280.5,394z\"/>\r\n\t\t<path id=\"Rectangle_3_\" sketch:type=\"MSShapeGroup\" style=\"fill:#FDD835\" d=\"M-278.5,392L-278.5,392c0.3,0,0.5,0.2,0.5,0.5l0,0\r\n\t\t\tc0,0.3-0.2,0.5-0.5,0.5l0,0c-0.3,0-0.5-0.2-0.5-0.5l0,0C-279,392.2-278.8,392-278.5,392z\"/>\r\n\t\t<path id=\"Rectangle_4_\" sketch:type=\"MSShapeGroup\" style=\"fill:#FDD835\" d=\"M-273.5,392L-273.5,392c0.3,0,0.5,0.2,0.5,0.5l0,0\r\n\t\t\tc0,0.3-0.2,0.5-0.5,0.5l0,0c-0.3,0-0.5-0.2-0.5-0.5l0,0C-274,392.2-273.8,392-273.5,392z\"/>\r\n\t\t<path id=\"Rectangle_6_\" sketch:type=\"MSShapeGroup\" style=\"fill:#FDD835\" d=\"M-269.5,396L-269.5,396c0.3,0,0.5,0.2,0.5,0.5l0,0\r\n\t\t\tc0,0.3-0.2,0.5-0.5,0.5l0,0c-0.3,0-0.5-0.2-0.5-0.5l0,0C-270,396.2-269.8,396-269.5,396z\"/>\r\n\t\t<path id=\"Rectangle_7_\" sketch:type=\"MSShapeGroup\" style=\"fill:#FDD835\" d=\"M-269,399L-269,399c0.6,0,1,0.2,1,0.5l0,0c0,0.3-0.4,0.5-1,0.5\r\n\t\t\tl0,0c-0.6,0-1-0.2-1-0.5l0,0C-270,399.2-269.6,399-269,399z\"/>\r\n\t\t<path id=\"Rectangle_8_\" sketch:type=\"MSShapeGroup\" style=\"fill:#FDD835\" d=\"M-276,391L-276,391c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1l0,0\r\n\t\t\tc-0.6,0-1-0.4-1-1l0,0C-277,391.4-276.6,391-276,391z\"/>\r\n\t\t\r\n\t\t\t<rect x=\"-273.6\" y=\"393.1\" transform=\"matrix(-0.7069 -0.7074 0.7074 -0.7069 -746.2077 482.7252)\" style=\"fill:#FF5722\" width=\"1\" height=\"5.8\"/>\r\n\t</g>\r\n</g>\r\n</svg>\r\n";

},{}],400:[function(require,module,exports){
module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\"\r\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"-290 382 30 30\"\r\n\t style=\"enable-background:new -290 382 30 30;\" xml:space=\"preserve\">\r\n<g>\r\n\t<path style=\"fill:#E3471B\" d=\"M-269.6,395.9c-2.5,0-4.6,2.1-4.6,4.6s2.1,4.6,4.6,4.6s4.6-2.1,4.6-4.6S-267.1,395.9-269.6,395.9z\r\n\t\t M-273.2,400.5c0-2,1.6-3.6,3.6-3.6c0.8,0,1.5,0.3,2.1,0.7l-5,5C-272.9,402-273.2,401.3-273.2,400.5z M-269.6,404.1\r\n\t\tc-0.8,0-1.5-0.3-2.1-0.7l5-5c0.5,0.6,0.7,1.3,0.7,2.1C-266.1,402.5-267.8,404.1-269.6,404.1z\"/>\r\n\t<path style=\"fill:#284661\" d=\"M-266.5,388.9h-17c-0.7,0-1.5,0.8-1.5,1.5v11c0,0.7,0.8,1.5,1.5,1.5h7.5v-1h-7.5c-0.1,0-0.5-0.4-0.5-0.5v-11\r\n\t\tl0,0l8.8,5.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1l8.7-5.2l0,0v4.5h1v-4.5C-265,389.8-265.8,388.9-266.5,388.9z\r\n\t\t M-274.9,394.6l-8-4.6h15.7L-274.9,394.6z\"/>\r\n</g>\r\n</svg>\r\n";

},{}],401:[function(require,module,exports){
module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\"\r\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"-290 382 30 30\"\r\n\t style=\"enable-background:new -290 382 30 30;\" xml:space=\"preserve\">\r\n<g>\r\n\t<path style=\"fill:#284661\" d=\"M-266,387.5h-18c-0.3,0-0.5,0.2-0.5,0.5v18c0,0.3,0.2,0.5,0.5,0.5h18c0.3,0,0.5-0.2,0.5-0.5v-18\r\n\t\tC-265.5,387.7-265.7,387.5-266,387.5z M-266.5,405.5h-17v-17h17V405.5z\"/>\r\n\t<rect x=\"-270\" y=\"390\" style=\"fill:#284661\" width=\"1\" height=\"6\"/>\r\n\t<rect x=\"-270\" y=\"398\" style=\"fill:#284661\" width=\"1\" height=\"1\"/>\r\n\t<rect x=\"-280\" y=\"390\" style=\"fill:#284661\" width=\"1\" height=\"4\"/>\r\n\t<rect x=\"-280\" y=\"396\" style=\"fill:#284661\" width=\"1\" height=\"3\"/>\r\n\t<rect x=\"-275\" y=\"390\" style=\"fill:#284661\" width=\"1\" height=\"1\"/>\r\n\t<rect x=\"-275\" y=\"393\" style=\"fill:#284661\" width=\"1\" height=\"6\"/>\r\n\t<polygon style=\"fill:#4CB04F\" points=\"-279,396 -277,396 -277,394 -279,394 -280,394 -282,394 -282,396 -280,396 \t\"/>\r\n\t<polygon style=\"fill:#8AC24A\" points=\"-274,393 -272,393 -272,391 -274,391 -275,391 -277,391 -277,393 -275,393 \t\"/>\r\n\t<polygon style=\"fill:#CBDB39\" points=\"-272,396 -272,398 -270,398 -269,398 -267,398 -267,396 -269,396 -270,396 \t\"/>\r\n\t<path style=\"fill:#00BCD4\" d=\"M-269.4,401.1c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8S-268.4,401.1-269.4,401.1z M-269.4,403.7\r\n\t\tc-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8S-269,403.7-269.4,403.7z\"/>\r\n\t<path style=\"fill:#2196F3\" d=\"M-274.4,401.1c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.7-0.8,1.7-1.8S-273.5,401.1-274.4,401.1z M-274.4,403.7\r\n\t\tc-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.7,0.3,0.7,0.8S-274,403.7-274.4,403.7z\"/>\r\n\t<path style=\"fill:#303F9F\" d=\"M-279.4,401.1c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8S-278.5,401.1-279.4,401.1z M-279.4,403.7\r\n\t\tc-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8S-279,403.7-279.4,403.7z\"/>\r\n</g>\r\n</svg>\r\n";

},{}],402:[function(require,module,exports){
module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\"\r\n\t xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"-300 382 30 30\"\r\n\t style=\"enable-background:new -300 382 30 30;\" xml:space=\"preserve\">\r\n<g id=\"Barbershop-UI-Guide\" sketch:type=\"MSPage\">\r\n\t<g id=\"Nav_1_\" transform=\"translate(-30.000000, -475.000000)\" sketch:type=\"MSArtboardGroup\">\r\n\t\t<g id=\"Navbar\" sketch:type=\"MSLayerGroup\">\r\n\t\t\t<g id=\"Nav\" transform=\"translate(0.000000, 115.000000)\" sketch:type=\"MSShapeGroup\">\r\n\t\t\t\t<g id=\"Stats\" transform=\"translate(0.000000, 350.000000)\">\r\n\t\t\t\t\t<g id=\"Icon\" transform=\"translate(30.000000, 10.000000)\">\r\n\t\t\t\t\t\t<path id=\"Stroke\" style=\"fill:#FF4081\" d=\"M-292,402h-2v4h2V402z\"/>\r\n\t\t\t\t\t\t<path id=\"Stroke_1_\" style=\"fill:#DEA7E8\" d=\"M-287,398h-2v8h2V398z\"/>\r\n\t\t\t\t\t\t<path id=\"Stroke_2_\" style=\"fill:#7C4DFF\" d=\"M-282,400h-2v6h2V400z\"/>\r\n\t\t\t\t\t\t<path id=\"Stroke_3_\" style=\"fill:#7B1FA2\" d=\"M-277,394h-2v12h2V394z\"/>\r\n\t\t\t\t\t\t<rect id=\"Rectangle\" x=\"-295\" y=\"406\" style=\"fill:#284661\" width=\"20\" height=\"1\"/>\r\n\t\t\t\t\t\t<path id=\"Stroke_4_\" style=\"fill:#284561\" d=\"M-291,396c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1s0.4-1,1-1C-291.4,395-291,395.4-291,396\r\n\t\t\t\t\t\t\tL-291,396z\"/>\r\n\t\t\t\t\t\t<path id=\"Stroke_5_\" style=\"fill:#284561\" d=\"M-287,392c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1s0.4-1,1-1C-287.4,391-287,391.4-287,392\r\n\t\t\t\t\t\t\tL-287,392z\"/>\r\n\t\t\t\t\t\t<path id=\"Stroke_6_\" style=\"fill:#284561\" d=\"M-282,394c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1s0.4-1,1-1C-282.4,393-282,393.4-282,394\r\n\t\t\t\t\t\t\tL-282,394z\"/>\r\n\t\t\t\t\t\t<path id=\"Stroke_7_\" style=\"fill:#284561\" d=\"M-277,388c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1s0.4-1,1-1C-277.4,387-277,387.4-277,388\r\n\t\t\t\t\t\t\tL-277,388z\"/>\r\n\t\t\t\t\t</g>\r\n\t\t\t\t</g>\r\n\t\t\t</g>\r\n\t\t</g>\r\n\t</g>\r\n</g>\r\n</svg>\r\n";

},{}],403:[function(require,module,exports){
module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\n<svg width=\"40px\" height=\"40px\" viewBox=\"0 0 40 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 3.7.2 (28276) - http://www.bohemiancoding.com/sketch -->\n    <title>Tiara Logo</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"SendGrid\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Tiara-Logo\">\n            <g id=\"tiara-logo\" transform=\"translate(8.000000, 8.000000)\">\n                <rect id=\"99E1F4\" fill=\"#99E1F4\" x=\"8\" y=\"16\" width=\"8\" height=\"8\"></rect>\n                <rect id=\"99E1F4\" fill=\"#99E1F4\" x=\"0\" y=\"8\" width=\"8\" height=\"8\"></rect>\n                <rect id=\"009DD9\" fill=\"#009DD9\" x=\"8\" y=\"8\" width=\"8\" height=\"8\"></rect>\n                <rect id=\"00B3E3\" fill=\"#00B3E3\" x=\"16\" y=\"8\" width=\"8\" height=\"8\"></rect>\n                <rect id=\"00B3E3\" fill=\"#00B3E3\" x=\"8\" y=\"0\" width=\"8\" height=\"8\"></rect>\n                <rect id=\"1a82e2\" fill=\"#1A82E2\" x=\"0\" y=\"16\" width=\"8\" height=\"8\"></rect>\n                <rect id=\"1a82e2\" fill=\"#1A82E2\" x=\"16\" y=\"0\" width=\"8\" height=\"8\"></rect>\n            </g>\n        </g>\n    </g>\n</svg>";

},{}]},{},[3])